webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(884)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_state__ = __webpack_require__(162);







var Emma = function () {
	function Emma() {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Emma);

		var user = null;
		if (JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__store_state__["a" /* STORAGE_KEY */]))) {
			user = JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__store_state__["a" /* STORAGE_KEY */])).users;
			if (user) {
				this.refresh = user.refresh || null;
				this.token = user.token || null;
			}
		}
		this.root = "https://api-preprod.patrimoffice.com/";
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Emma, [{
		key: 'post',
		value: function post(url, data) {
			var _this = this;

			var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			var requestHeader = null;

			if (url !== 'api/login' && url.indexOf('api/resetting') === -1) {
				requestHeader = this.getHeader();
			}

			if (type) {
				requestHeader.headers['Content-Type'] = type;
			}

			if (false) {
				requestHeader = { headers: { HTTP_REFERER: this.getReferer() } };
			}

			console.log('[POST] // API CALL : ', url);
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this.root + url, data, requestHeader).then(function (result) {
					resolve(result);
				}).catch(function (error) {
					if (error.response && error.response.data && error.response.data.code === 403) {
						_this.refreshToken().then(function () {
							_this.post(url, data, type).then(function (result) {
								resolve(result);
							}).catch(function (error) {
								reject(error);
							});
						});
					} else {
						reject(error);
					}
				});
			});
		}
	}, {
		key: 'put',
		value: function put(url, data) {
			var _this2 = this;

			var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			var requestHeader = null;

			if (url !== 'api/login' && url.indexOf('api/resetting') === -1) {
				requestHeader = this.getHeader();
			}

			if (type) {
				requestHeader.headers['Content-Type'] = type;
			}

			if (false) {
				requestHeader = { headers: { HTTP_REFERER: this.getReferer() } };
			}

			console.log('[PUT] // API CALL : ', url);
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(_this2.root + url, data, requestHeader).then(function (result) {
					resolve(result);
				}).catch(function (error) {
					if (error.response && error.response.data && error.response.data.code === 403) {
						_this2.refreshToken().then(function () {
							_this2.post(url, data, type).then(function (result) {
								resolve(result);
							}).catch(function (error) {
								reject(error);
							});
						});
					} else {
						reject(error);
					}
				});
			});
		}
	}, {
		key: 'delete',
		value: function _delete(url) {
			var _this3 = this;

			console.log('[DELETE] // API CALL : ', url);
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(_this3.root + url, _this3.getHeader()).then(function (result) {
					resolve(result);
				}).catch(function (error) {
					if (error.response && error.response.data && error.response.data.code === 403) {
						_this3.refreshToken(url !== 'api/logout').then(function () {
							_this3.get(url).then(function (result) {
								resolve(result);
							}).catch(function (error) {
								reject(error);
							});
						});
					} else {
						reject(error);
					}
				});
			});
		}
	}, {
		key: 'get',
		value: function get(url) {
			var _this4 = this;

			var withToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			console.log('[GET] // API CALL : ', url);
			var header = withToken ? this.getHeader() : undefined;
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this4.root + url, header).then(function (result) {
					resolve(result);
				}).catch(function (error) {
					console.log('error', error);
					if (error.response.data.code === 403 && withToken) {
						_this4.refreshToken(url !== 'api/logout').then(function () {
							_this4.get(url).then(function (result) {
								resolve(result);
							}).catch(function (error) {
								reject(error);
							});
						});
					} else {
						reject(error);
					}
				});
			});
		}
	}, {
		key: 'refreshToken',
		value: function refreshToken() {
			var _this5 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				console.log('REFRESH TOKEN', _this5.refresh);
				if (_this5.refresh) {
					__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this5.root + 'api/token/refresh', {
						refresh_token: _this5.refresh
					}).then(function (result) {
						console.log('TOKEN REFRESH SUCCESS');
						_this5.refresh = result.data.refresh_token;
						_this5.token = result.data.token;
						__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('TOKEN', { user: result.data });
						resolve();
					}).catch(function (error) {
						reject(error);
						__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('LOGOUT');
						window.location = '/login';
					});
				}
			});
		}
	}, {
		key: 'getReferer',
		value: function getReferer() {
			return "https://cgpi-preprod.patrimoffice.com";
		}
	}, {
		key: 'setToken',
		value: function setToken(refreshToken, token) {
			this.refresh = refreshToken;
			this.token = token;
		}
	}, {
		key: 'getHeader',
		value: function getHeader() {
			if (this.token) {
				return {
					headers: {
						'X-Auth-Token': 'Bearer ' + this.token
					}
				};
			} else {
				return null;
			}
		}
	}]);

	return Emma;
}();

var emma = new Emma();

/* harmony default export */ __webpack_exports__["a"] = (emma);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(804)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(808)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1072),
  /* scopeId */
  "data-v-13d97761",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(890)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Currency = ['AED', 'AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'MAD', 'QAR', 'RUB', 'SAR', 'SGD', 'THB', 'USD', 'XAF'];

/* harmony default export */ __webpack_exports__["a"] = (Currency);

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_services_ResolveDate__ = __webpack_require__(115);




var UserResource = {
	login: function login(email, password) {
		var _this = this;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/login', {
				username: email,
				password: password
			}).then(function (result) {
				if (result.data.user.roles.indexOf('ROLE_ADVISOR') === -1) reject(new Error('Mauvais login/mot de passe'));
				__WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].setToken(result.data.refresh_token, result.data.token);
				_this.getUser().then(function (user) {
					result.data.user.firstname = user.data.user.first_name;
					result.data.user.lastname = user.data.user.last_name;
					result.data.user.id = user.data.user.id;
					if (user.data.user.media) {
						result.data.picture = user.data.user.media.file;
					}
					result.data.user.address = {
						line: user.data.user.address,
						zip: user.data.user.zipcode,
						city: user.data.user.city,
						country: user.data.user.country
					};
					result.data.user.phone = user.data.user.phone;
					resolve(result.data);
				}).catch(function (error) {
					reject(error);
				});
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	logout: function logout() {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/logout');
	},
	getUser: function getUser() {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/profile');
	},
	getProspectsForDashboard: function getProspectsForDashboard() {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/prospects-for-dashboard');
	},
	getClientsForDashboard: function getClientsForDashboard() {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/clients-for-dashboard');
	},
	getClients: function getClients() {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/clients');
	},
	getClient: function getClient(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/clients/' + id);
	},
	addClient: function addClient(client) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/clients', {
			first_name: client.firstname,
			last_name: client.lastname,
			email: client.email,
			phone: client.phone,
			source: client.origin,
			birthdate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_services_ResolveDate__["a" /* resolveDate */])(client.birthdate),
			tags: client.centerOfInterests.map(function (tag) {
				return tag.id;
			}),
			type: client.type === 'Client' ? 'client_subscriber' : 'client_lead',
			address: client.address.line,
			zipcode: client.address.zip,
			city: client.address.city,
			country: client.address.country
		}, 'application/json');
	},
	editClient: function editClient(client) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/update-client', {
			user_id: client.id,
			first_name: client.firstname,
			last_name: client.lastname,
			email: client.email,
			phone: client.phone,
			source: client.origin,
			tags: client.centerOfInterests.map(function (tag) {
				return tag.id;
			}),
			birthdate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_services_ResolveDate__["a" /* resolveDate */])(client.birthdate),
			type: client.type === 'Client' ? 'client_subscriber' : 'client_lead',
			address: client.address.line,
			zipcode: client.address.zip,
			city: client.address.city,
			country: client.address.country
		}, 'application/json');
	},
	updateProfilePicture: function updateProfilePicture(data, id) {
		var request = new FormData();
		request.append('img', data);
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/media/user_picture/' + id, request, 'application/x-www-form-urlencoded');
	},
	updateProfile: function updateProfile(data) {
		var request = new FormData();
		request.append('first_name', data.firstname);
		request.append('last_name', data.lastname);
		request.append('email', data.email);
		request.append('address', data.address.line);
		request.append('zipcode', data.address.zip);
		request.append('city', data.address.city);
		request.append('country', data.address.country);
		request.append('phone', data.phone);
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/profile', request);
	},
	editPassword: function editPassword(data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/change-password', data);
	},
	resetPassword: function resetPassword(email) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/resetting/request', { email: email });
	},
	postLCBCFT: function postLCBCFT(data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/lcbft', data, 'application/json');
	},
	postCheckPaysage: function postCheckPaysage(data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/estate/private/doc/sendmailcheckpaysage', data, 'application/json');
	},
	setAvailable: function setAvailable(data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/available', data);
	},
	createAppointment: function createAppointment(data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/appointments', data);
	},
	fetchAppointments: function fetchAppointments() {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/appointments');
	},
	fetchCalendar: function fetchCalendar(date) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/appointments?' + (date ? 'date=' + date : 'today=true'));
	},
	fetchAppointmentsForClient: function fetchAppointmentsForClient(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/appointments/' + id);
	},
	updateAppointment: function updateAppointment(id, data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].put('api/appointments/' + id, data);
	},
	deleteAppointment: function deleteAppointment(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/delete-appointment', { id: id });
	},
	fetchMissionsForClient: function fetchMissionsForClient(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/client-missions/' + id);
	},
	getCertificateLevel: function getCertificateLevel(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/universign/match-account/' + id);
	},
	createNote: function createNote(data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/note', data);
	},
	updateNote: function updateNote(id, data) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/note/' + id, data);
	},
	deleteNote: function deleteNote(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/delete-note/' + id);
	},
	fetchNotes: function fetchNotes(id) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/client-notes/' + id);
	},
	getInvestmentStats: function getInvestmentStats(userId) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/investment-stats?user_id=' + userId);
	},
	updateInscritPartenaire: function updateInscritPartenaire(userId, value) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/update-inscrit-partenaire', { user_id: userId, inscrit_partenaire: value }, 'application/json');
	},
	updateContractRenewal: function updateContractRenewal(userId) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/update-contract-renewal', { user_id: userId }, 'application/json');
	},
	searchClients: function searchClients(query) {
		return __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/search-clients', { query: query }, 'application/json');
	}
};

/* harmony default export */ __webpack_exports__["a"] = (UserResource);

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Users__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Loader__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_store_Investment__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_store_Notifications__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_store_PatrimonialEstate__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_store_Chat__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_store_Documents__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_store_News__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_store_Transactions__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_store_Subscriptions__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_store_Plans__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_store_Site__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__state__ = __webpack_require__(162);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
	strict: true,
	plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
		key: __WEBPACK_IMPORTED_MODULE_15__state__["a" /* STORAGE_KEY */]
	})],
	modules: {
		loader: __WEBPACK_IMPORTED_MODULE_4__modules_Loader__["a" /* default */],
		users: __WEBPACK_IMPORTED_MODULE_3__modules_Users__["a" /* default */],
		notifications: __WEBPACK_IMPORTED_MODULE_6__common_store_Notifications__["a" /* default */],
		estate: __WEBPACK_IMPORTED_MODULE_7__common_store_PatrimonialEstate__["a" /* default */],
		chat: __WEBPACK_IMPORTED_MODULE_8__common_store_Chat__["a" /* default */],
		documents: __WEBPACK_IMPORTED_MODULE_9__common_store_Documents__["a" /* default */],
		news: __WEBPACK_IMPORTED_MODULE_10__common_store_News__["a" /* default */],
		transactions: __WEBPACK_IMPORTED_MODULE_11__common_store_Transactions__["a" /* default */],
		subscriptions: __WEBPACK_IMPORTED_MODULE_12__common_store_Subscriptions__["a" /* default */],
		plans: __WEBPACK_IMPORTED_MODULE_13__common_store_Plans__["a" /* default */],
		Investment: __WEBPACK_IMPORTED_MODULE_5__common_store_Investment__["a" /* default */],
		Site: __WEBPACK_IMPORTED_MODULE_14__common_store_Site__["a" /* default */]
	}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Country = [{
	type: 'Afghanistan',
	'ISO2': 'AF',
	'E164': 93,
	'prefix': '93',
	'fr': 'Afghanistan'
}, {
	type: 'Albania',
	'ISO2': 'AL',
	'E164': 355,
	'prefix': '355',
	'fr': 'Albanie'
}, {
	type: 'Algeria',
	'ISO2': 'DZ',
	'E164': 213,
	'prefix': '213',
	'fr': 'Algérie'
}, {
	type: 'American Samoa',
	'ISO2': 'AS',
	'E164': 1,
	'prefix': '1-684',
	'fr': 'Samoa américaines'
}, {
	type: 'Andorra',
	'ISO2': 'AD',
	'E164': 376,
	'prefix': '376',
	'fr': 'Andorre'
}, {
	type: 'Angola',
	'ISO2': 'AO',
	'E164': 244,
	'prefix': '244',
	'fr': 'Angola'
}, {
	type: 'Anguilla',
	'ISO2': 'AI',
	'E164': 1,
	'prefix': '1-264',
	'fr': 'Anguilla'
}, {
	type: 'Antarctica',
	'ISO2': 'AQ',
	'E164': 672,
	'prefix': '672',
	'fr': 'Antarctique'
}, {
	type: 'Antigua and Barbuda',
	'ISO2': 'AG',
	'E164': 1,
	'prefix': '1-268',
	'fr': 'Antigua-et-Barbuda'
}, {
	type: 'Argentina',
	'ISO2': 'AR',
	'E164': 54,
	'prefix': '54',
	'fr': 'Argentine'
}, {
	type: 'Armenia',
	'ISO2': 'AM',
	'E164': 374,
	'prefix': '374',
	'fr': 'Arménie'
}, {
	type: 'Aruba',
	'ISO2': 'AW',
	'E164': 297,
	'prefix': '297',
	'fr': 'Aruba'
}, {
	type: 'Australia',
	'ISO2': 'AU',
	'E164': 61,
	'prefix': '61',
	'fr': 'Australie'
}, {
	type: 'Austria',
	'ISO2': 'AT',
	'E164': 43,
	'prefix': '43',
	'fr': 'Autriche'
}, {
	type: 'Azerbaijan',
	'ISO2': 'AZ',
	'E164': 994,
	'prefix': '994',
	'fr': 'Azerbaïdjan'
}, {
	type: 'Bahamas',
	'ISO2': 'BS',
	'E164': 1,
	'prefix': '1-242',
	'fr': 'Bahamas'
}, {
	type: 'Bahrain',
	'ISO2': 'BH',
	'E164': 973,
	'prefix': '973',
	'fr': 'Bahreïn'
}, {
	type: 'Bangladesh',
	'ISO2': 'BD',
	'E164': 880,
	'prefix': '880',
	'fr': 'Bangladesh'
}, {
	type: 'Barbados',
	'ISO2': 'BB',
	'E164': 1,
	'prefix': '1-246',
	'fr': 'Barbade'
}, {
	type: 'Belarus',
	'ISO2': 'BY',
	'E164': 375,
	'prefix': '375',
	'fr': 'Biélorussie'
}, {
	type: 'Belgium',
	'ISO2': 'BE',
	'E164': 32,
	'prefix': '32',
	'fr': 'Belgique'
}, {
	type: 'Belize',
	'ISO2': 'BZ',
	'E164': 501,
	'prefix': '501',
	'fr': 'Belize'
}, {
	type: 'Benin',
	'ISO2': 'BJ',
	'E164': 229,
	'prefix': '229',
	'fr': 'Bénin'
}, {
	type: 'Bermuda',
	'ISO2': 'BM',
	'E164': 1,
	'prefix': '1-441',
	'fr': 'Bermudes'
}, {
	type: 'Bhutan',
	'ISO2': 'BT',
	'E164': 975,
	'prefix': '975',
	'fr': 'Bhoutan'
}, {
	type: 'Bolivia',
	'ISO2': 'BO',
	'E164': 591,
	'prefix': '591',
	'fr': 'Bolivie'
}, {
	type: 'Bosnia and Herzegovina',
	'ISO2': 'BA',
	'E164': 387,
	'prefix': '387',
	'fr': 'Bosnie-Herzégovine'
}, {
	type: 'Botswana',
	'ISO2': 'BW',
	'E164': 267,
	'prefix': '267',
	'fr': 'Botswana'
}, {
	type: 'Brazil',
	'ISO2': 'BR',
	'E164': 55,
	'prefix': '55',
	'fr': 'Brésil'
}, {
	type: 'British Indian Ocean Territory',
	'ISO2': 'IO',
	'E164': 246,
	'prefix': '246',
	'fr': 'Territoire britannique de l\'océan Indien'
}, {
	type: 'British Virgin Islands',
	'ISO2': 'VG',
	'E164': 1,
	'prefix': '1-284',
	'fr': 'Îles Vierges britanniques'
}, {
	type: 'Brunei',
	'ISO2': 'BN',
	'E164': 673,
	'prefix': '673',
	'fr': 'Brunei'
}, {
	type: 'Bulgaria',
	'ISO2': 'BG',
	'E164': 359,
	'prefix': '359',
	'fr': 'Bulgarie'
}, {
	type: 'Burkina Faso',
	'ISO2': 'BF',
	'E164': 226,
	'prefix': '226',
	'fr': 'Burkina Faso'
}, {
	type: 'Burundi',
	'ISO2': 'BI',
	'E164': 257,
	'prefix': '257',
	'fr': 'Burundi'
}, {
	type: 'Cambodia',
	'ISO2': 'KH',
	'E164': 855,
	'prefix': '855',
	'fr': 'Cambodge'
}, {
	type: 'Cameroon',
	'ISO2': 'CM',
	'E164': 237,
	'prefix': '237',
	'fr': 'Cameroun'
}, {
	type: 'Canada',
	'ISO2': 'CA',
	'E164': 1,
	'prefix': '1',
	'fr': 'Canada'
}, {
	type: 'Cape Verde',
	'ISO2': 'CV',
	'E164': 238,
	'prefix': '238',
	'fr': 'Cap-Vert'
}, {
	type: 'Cayman Islands',
	'ISO2': 'KY',
	'E164': 1,
	'prefix': '1-345',
	'fr': 'Îles Caïmans'
}, {
	type: 'Central African Republic',
	'ISO2': 'CF',
	'E164': 236,
	'prefix': '236',
	'fr': 'République centrafricaine'
}, {
	type: 'Chad',
	'ISO2': 'TD',
	'E164': 235,
	'prefix': '235',
	'fr': 'Tchad'
}, {
	type: 'Chile',
	'ISO2': 'CL',
	'E164': 56,
	'prefix': '56',
	'fr': 'Chili'
}, {
	type: 'China',
	'ISO2': 'CN',
	'E164': 86,
	'prefix': '86',
	'fr': 'Chine'
}, {
	type: 'Christmas Island',
	'ISO2': 'CX',
	'E164': 61,
	'prefix': '61',
	'fr': 'Île Christmas'
}, {
	type: 'Cocos Islands',
	'ISO2': 'CC',
	'E164': 61,
	'prefix': '61',
	'fr': 'Îles Cocos'
}, {
	type: 'Colombia',
	'ISO2': 'CO',
	'E164': 57,
	'prefix': '57',
	'fr': 'Colombie'
}, {
	type: 'Comoros',
	'ISO2': 'KM',
	'E164': 269,
	'prefix': '269',
	'fr': 'Comores'
}, {
	type: 'Cook Islands',
	'ISO2': 'CK',
	'E164': 682,
	'prefix': '682',
	'fr': 'Îles Cook'
}, {
	type: 'Costa Rica',
	'ISO2': 'CR',
	'E164': 506,
	'prefix': '506',
	'fr': 'Costa Rica'
}, {
	type: 'Croatia',
	'ISO2': 'HR',
	'E164': 385,
	'prefix': '385',
	'fr': 'Croatie'
}, {
	type: 'Cuba',
	'ISO2': 'CU',
	'E164': 53,
	'prefix': '53',
	'fr': 'Cuba'
}, {
	type: 'Curacao',
	'ISO2': 'CW',
	'E164': 599,
	'prefix': '599',
	'fr': 'Curaçao'
}, {
	type: 'Cyprus',
	'ISO2': 'CY',
	'E164': 357,
	'prefix': '357',
	'fr': 'Chypre'
}, {
	type: 'Czech Republic',
	'ISO2': 'CZ',
	'E164': 420,
	'prefix': '420',
	'fr': 'République tchèque'
}, {
	type: 'Democratic Republic of the Congo',
	'ISO2': 'CD',
	'E164': 243,
	'prefix': '243',
	'fr': 'République démocratique du Congo'
}, {
	type: 'Denmark',
	'ISO2': 'DK',
	'E164': 45,
	'prefix': '45',
	'fr': 'Danemark'
}, {
	type: 'Djibouti',
	'ISO2': 'DJ',
	'E164': 253,
	'prefix': '253',
	'fr': 'Djibouti'
}, {
	type: 'Dominica',
	'ISO2': 'DM',
	'E164': 1,
	'prefix': '1-767',
	'fr': 'Dominique'
}, {
	type: 'Dominican Republic',
	'ISO2': 'DO',
	'E164': 1,
	'prefix': '1-809, 1-829, 1-849',
	'fr': 'République dominicaine'
}, {
	type: 'East Timor',
	'ISO2': 'TL',
	'E164': 670,
	'prefix': '670',
	'fr': 'Timor oriental'
}, {
	type: 'Ecuador',
	'ISO2': 'EC',
	'E164': 593,
	'prefix': '593',
	'fr': 'Équateur'
}, {
	type: 'Egypt',
	'ISO2': 'EG',
	'E164': 20,
	'prefix': '20',
	'fr': 'Égypte'
}, {
	type: 'El Salvador',
	'ISO2': 'SV',
	'E164': 503,
	'prefix': '503',
	'fr': 'Salvador'
}, {
	type: 'Equatorial Guinea',
	'ISO2': 'GQ',
	'E164': 240,
	'prefix': '240',
	'fr': 'Guinée équatoriale'
}, {
	type: 'Eritrea',
	'ISO2': 'ER',
	'E164': 291,
	'prefix': '291',
	'fr': 'Érythrée'
}, {
	type: 'Estonia',
	'ISO2': 'EE',
	'E164': 372,
	'prefix': '372',
	'fr': 'Estonie'
}, {
	type: 'Ethiopia',
	'ISO2': 'ET',
	'E164': 251,
	'prefix': '251',
	'fr': 'Éthiopie'
}, {
	type: 'Falkland Islands',
	'ISO2': 'FK',
	'E164': 500,
	'prefix': '500',
	'fr': 'Îles Malouines'
}, {
	type: 'Faroe Islands',
	'ISO2': 'FO',
	'E164': 298,
	'prefix': '298',
	'fr': 'Îles Féroé'
}, {
	type: 'Fiji',
	'ISO2': 'FJ',
	'E164': 679,
	'prefix': '679',
	'fr': 'Fidji'
}, {
	type: 'Finland',
	'ISO2': 'FI',
	'E164': 358,
	'prefix': '358',
	'fr': 'Finlande'
}, {
	type: 'France',
	'ISO2': 'FR',
	'E164': 33,
	'prefix': '33',
	'fr': 'France'
}, {
	type: 'French Polynesia',
	'ISO2': 'PF',
	'E164': 689,
	'prefix': '689',
	'fr': 'Polynésie française'
}, {
	type: 'Gabon',
	'ISO2': 'GA',
	'E164': 241,
	'prefix': '241',
	'fr': 'Gabon'
}, {
	type: 'Gambia',
	'ISO2': 'GM',
	'E164': 220,
	'prefix': '220',
	'fr': 'Gambie'
}, {
	type: 'Georgia',
	'ISO2': 'GE',
	'E164': 995,
	'prefix': '995',
	'fr': 'Géorgie'
}, {
	type: 'Germany',
	'ISO2': 'DE',
	'E164': 49,
	'prefix': '49',
	'fr': 'Allemagne'
}, {
	type: 'Ghana',
	'ISO2': 'GH',
	'E164': 233,
	'prefix': '233',
	'fr': 'Ghana'
}, {
	type: 'Gibraltar',
	'ISO2': 'GI',
	'E164': 350,
	'prefix': '350',
	'fr': 'Gibraltar'
}, {
	type: 'Greece',
	'ISO2': 'GR',
	'E164': 30,
	'prefix': '30',
	'fr': 'Grèce'
}, {
	type: 'Greenland',
	'ISO2': 'GL',
	'E164': 299,
	'prefix': '299',
	'fr': 'Groenland'
}, {
	type: 'Grenada',
	'ISO2': 'GD',
	'E164': 1,
	'prefix': '1-473',
	'fr': 'Grenade'
}, {
	type: 'Guam',
	'ISO2': 'GU',
	'E164': 1,
	'prefix': '1-671',
	'fr': 'Guam'
}, {
	type: 'Guatemala',
	'ISO2': 'GT',
	'E164': 502,
	'prefix': '502',
	'fr': 'Guatemala'
}, {
	type: 'Guernsey',
	'ISO2': 'GG',
	'E164': 44,
	'prefix': '44-1481',
	'fr': 'Guernesey'
}, {
	type: 'Guinea',
	'ISO2': 'GN',
	'E164': 224,
	'prefix': '224',
	'fr': 'Guinée'
}, {
	type: 'Guinea-Bissau',
	'ISO2': 'GW',
	'E164': 245,
	'prefix': '245',
	'fr': 'Guinée-Bissau'
}, {
	type: 'Guyana',
	'ISO2': 'GY',
	'E164': 592,
	'prefix': '592',
	'fr': 'Guyana'
}, {
	type: 'Haiti',
	'ISO2': 'HT',
	'E164': 509,
	'prefix': '509',
	'fr': 'Haïti'
}, {
	type: 'Honduras',
	'ISO2': 'HN',
	'E164': 504,
	'prefix': '504',
	'fr': 'Honduras'
}, {
	type: 'Hong Kong',
	'ISO2': 'HK',
	'E164': 852,
	'prefix': '852',
	'fr': 'Hong Kong'
}, {
	type: 'Hungary',
	'ISO2': 'HU',
	'E164': 36,
	'prefix': '36',
	'fr': 'Hongrie'
}, {
	type: 'Iceland',
	'ISO2': 'IS',
	'E164': 354,
	'prefix': '354',
	'fr': 'Islande'
}, {
	type: 'India',
	'ISO2': 'IN',
	'E164': 91,
	'prefix': '91',
	'fr': 'Inde'
}, {
	type: 'Indonesia',
	'ISO2': 'ID',
	'E164': 62,
	'prefix': '62',
	'fr': 'Indonésie'
}, {
	type: 'Iran',
	'ISO2': 'IR',
	'E164': 98,
	'prefix': '98',
	'fr': 'Iran'
}, {
	type: 'Iraq',
	'ISO2': 'IQ',
	'E164': 964,
	'prefix': '964',
	'fr': 'Irak'
}, {
	type: 'Ireland',
	'ISO2': 'IE',
	'E164': 353,
	'prefix': '353',
	'fr': 'Irlande'
}, {
	type: 'Isle of Man',
	'ISO2': 'IM',
	'E164': 44,
	'prefix': '44-1624',
	'fr': 'Île de Man'
}, {
	type: 'Israel',
	'ISO2': 'IL',
	'E164': 972,
	'prefix': '972',
	'fr': 'Israël'
}, {
	type: 'Italy',
	'ISO2': 'IT',
	'E164': 39,
	'prefix': '39',
	'fr': 'Italie'
}, {
	type: 'Ivory Coast',
	'ISO2': 'CI',
	'E164': 225,
	'prefix': '225',
	'fr': 'Côte d\'Ivoire'
}, {
	type: 'Jamaica',
	'ISO2': 'JM',
	'E164': 1,
	'prefix': '1-876',
	'fr': 'Jamaïque'
}, {
	type: 'Japan',
	'ISO2': 'JP',
	'E164': 81,
	'prefix': '81',
	'fr': 'Japon'
}, {
	type: 'Jersey',
	'ISO2': 'JE',
	'E164': 44,
	'prefix': '44-1534',
	'fr': 'Jersey'
}, {
	type: 'Jordan',
	'ISO2': 'JO',
	'E164': 962,
	'prefix': '962',
	'fr': 'Jordanie'
}, {
	type: 'Kazakhstan',
	'ISO2': 'KZ',
	'E164': 7,
	'prefix': '7',
	'fr': 'Kazakhstan'
}, {
	type: 'Kenya',
	'ISO2': 'KE',
	'E164': 254,
	'prefix': '254',
	'fr': 'Kenya'
}, {
	type: 'Kiribati',
	'ISO2': 'KI',
	'E164': 686,
	'prefix': '686',
	'fr': 'Kiribati'
}, {
	type: 'Kosovo',
	'ISO2': 'XK',
	'E164': 383,
	'prefix': '383',
	'fr': 'Kosovo'
}, {
	type: 'Kuwait',
	'ISO2': 'KW',
	'E164': 965,
	'prefix': '965',
	'fr': 'Koweït'
}, {
	type: 'Kyrgyzstan',
	'ISO2': 'KG',
	'E164': 996,
	'prefix': '996',
	'fr': 'Kirghizistan'
}, {
	type: 'Laos',
	'ISO2': 'LA',
	'E164': 856,
	'prefix': '856',
	'fr': 'Laos'
}, {
	type: 'Latvia',
	'ISO2': 'LV',
	'E164': 371,
	'prefix': '371',
	'fr': 'Lettonie'
}, {
	type: 'Lebanon',
	'ISO2': 'LB',
	'E164': 961,
	'prefix': '961',
	'fr': 'Liban'
}, {
	type: 'Lesotho',
	'ISO2': 'LS',
	'E164': 266,
	'prefix': '266',
	'fr': 'Lesotho'
}, {
	type: 'Liberia',
	'ISO2': 'LR',
	'E164': 231,
	'prefix': '231',
	'fr': 'Libéria'
}, {
	type: 'Libya',
	'ISO2': 'LY',
	'E164': 218,
	'prefix': '218',
	'fr': 'Libye'
}, {
	type: 'Liechtenstein',
	'ISO2': 'LI',
	'E164': 423,
	'prefix': '423',
	'fr': 'Liechtenstein'
}, {
	type: 'Lithuania',
	'ISO2': 'LT',
	'E164': 370,
	'prefix': '370',
	'fr': 'Lituanie'
}, {
	type: 'Luxembourg',
	'ISO2': 'LU',
	'E164': 352,
	'prefix': '352',
	'fr': 'Luxembourg'
}, {
	type: 'Macau',
	'ISO2': 'MO',
	'E164': 853,
	'prefix': '853',
	'fr': 'Macao'
}, {
	type: 'Macedonia',
	'ISO2': 'MK',
	'E164': 389,
	'prefix': '389',
	'fr': 'Macédoine'
}, {
	type: 'Madagascar',
	'ISO2': 'MG',
	'E164': 261,
	'prefix': '261',
	'fr': 'Madagascar'
}, {
	type: 'Malawi',
	'ISO2': 'MW',
	'E164': 265,
	'prefix': '265',
	'fr': 'Malawi'
}, {
	type: 'Malaysia',
	'ISO2': 'MY',
	'E164': 60,
	'prefix': '60',
	'fr': 'Malaisie'
}, {
	type: 'Maldives',
	'ISO2': 'MV',
	'E164': 960,
	'prefix': '960',
	'fr': 'Maldives'
}, {
	type: 'Mali',
	'ISO2': 'ML',
	'E164': 223,
	'prefix': '223',
	'fr': 'Mali'
}, {
	type: 'Malta',
	'ISO2': 'MT',
	'E164': 356,
	'prefix': '356',
	'fr': 'Malte'
}, {
	type: 'Marshall Islands',
	'ISO2': 'MH',
	'E164': 692,
	'prefix': '692',
	'fr': 'Îles Marshall'
}, {
	type: 'Mauritania',
	'ISO2': 'MR',
	'E164': 222,
	'prefix': '222',
	'fr': 'Mauritanie'
}, {
	type: 'Mauritius',
	'ISO2': 'MU',
	'E164': 230,
	'prefix': '230',
	'fr': 'Maurice'
}, {
	type: 'Mayotte',
	'ISO2': 'YT',
	'E164': 262,
	'prefix': '262',
	'fr': 'Mayotte'
}, {
	type: 'Mexico',
	'ISO2': 'MX',
	'E164': 52,
	'prefix': '52',
	'fr': 'Mexique'
}, {
	type: 'Micronesia',
	'ISO2': 'FM',
	'E164': 691,
	'prefix': '691',
	'fr': 'Micronésie'
}, {
	type: 'Moldova',
	'ISO2': 'MD',
	'E164': 373,
	'prefix': '373',
	'fr': 'Moldavie'
}, {
	type: 'Monaco',
	'ISO2': 'MC',
	'E164': 377,
	'prefix': '377',
	'fr': 'Monaco'
}, {
	type: 'Mongolia',
	'ISO2': 'MN',
	'E164': 976,
	'prefix': '976',
	'fr': 'Mongolie'
}, {
	type: 'Montenegro',
	'ISO2': 'ME',
	'E164': 382,
	'prefix': '382',
	'fr': 'Monténégro'
}, {
	type: 'Montserrat',
	'ISO2': 'MS',
	'E164': 1,
	'prefix': '1-664',
	'fr': 'Montserrat'
}, {
	type: 'Morocco',
	'ISO2': 'MA',
	'E164': 212,
	'prefix': '212',
	'fr': 'Maroc'
}, {
	type: 'Mozambique',
	'ISO2': 'MZ',
	'E164': 258,
	'prefix': '258',
	'fr': 'Mozambique'
}, {
	type: 'Myanmar',
	'ISO2': 'MM',
	'E164': 95,
	'prefix': '95',
	'fr': 'Myanmar'
}, {
	type: 'Namibia',
	'ISO2': 'NA',
	'E164': 264,
	'prefix': '264',
	'fr': 'Namibie'
}, {
	type: 'Nauru',
	'ISO2': 'NR',
	'E164': 674,
	'prefix': '674',
	'fr': 'Nauru'
}, {
	type: 'Nepal',
	'ISO2': 'NP',
	'E164': 977,
	'prefix': '977',
	'fr': 'Népal'
}, {
	type: 'Netherlands',
	'ISO2': 'NL',
	'E164': 31,
	'prefix': '31',
	'fr': 'Pays-Bas'
}, {
	type: 'Netherlands Antilles',
	'ISO2': 'AN',
	'E164': 599,
	'prefix': '599',
	'fr': 'Antilles néerlandaises'
}, {
	type: 'New Caledonia',
	'ISO2': 'NC',
	'E164': 687,
	'prefix': '687',
	'fr': 'Nouvelle-Calédonie'
}, {
	type: 'New Zealand',
	'ISO2': 'NZ',
	'E164': 64,
	'prefix': '64',
	'fr': 'Nouvelle-Zélande'
}, {
	type: 'Nicaragua',
	'ISO2': 'NI',
	'E164': 505,
	'prefix': '505',
	'fr': 'Nicaragua'
}, {
	type: 'Niger',
	'ISO2': 'NE',
	'E164': 227,
	'prefix': '227',
	'fr': 'Niger'
}, {
	type: 'Nigeria',
	'ISO2': 'NG',
	'E164': 234,
	'prefix': '234',
	'fr': 'Nigéria'
}, {
	type: 'Niue',
	'ISO2': 'NU',
	'E164': 683,
	'prefix': '683',
	'fr': 'Niue'
}, {
	type: 'North Korea',
	'ISO2': 'KP',
	'E164': 850,
	'prefix': '850',
	'fr': 'Corée du Nord'
}, {
	type: 'Northern Mariana Islands',
	'ISO2': 'MP',
	'E164': 1,
	'prefix': '1-670',
	'fr': 'Îles Mariannes du Nord'
}, {
	type: 'Norway',
	'ISO2': 'NO',
	'E164': 47,
	'prefix': '47',
	'fr': 'Norvège'
}, {
	type: 'Oman',
	'ISO2': 'OM',
	'E164': 968,
	'prefix': '968',
	'fr': 'Oman'
}, {
	type: 'Pakistan',
	'ISO2': 'PK',
	'E164': 92,
	'prefix': '92',
	'fr': 'Pakistan'
}, {
	type: 'Palau',
	'ISO2': 'PW',
	'E164': 680,
	'prefix': '680',
	'fr': 'Palaos'
}, {
	type: 'Palestine',
	'ISO2': 'PS',
	'E164': 970,
	'prefix': '970',
	'fr': 'Palestine'
}, {
	type: 'Panama',
	'ISO2': 'PA',
	'E164': 507,
	'prefix': '507',
	'fr': 'Panama'
}, {
	type: 'Papua New Guinea',
	'ISO2': 'PG',
	'E164': 675,
	'prefix': '675',
	'fr': 'Papouasie-Nouvelle-Guinée'
}, {
	type: 'Paraguay',
	'ISO2': 'PY',
	'E164': 595,
	'prefix': '595',
	'fr': 'Paraguay'
}, {
	type: 'Peru',
	'ISO2': 'PE',
	'E164': 51,
	'prefix': '51',
	'fr': 'Pérou'
}, {
	type: 'Philippines',
	'ISO2': 'PH',
	'E164': 63,
	'prefix': '63',
	'fr': 'Philippines'
}, {
	type: 'Pitcairn',
	'ISO2': 'PN',
	'E164': 64,
	'prefix': '64',
	'fr': 'Îles Pitcairn'
}, {
	type: 'Poland',
	'ISO2': 'PL',
	'E164': 48,
	'prefix': '48',
	'fr': 'Pologne'
}, {
	type: 'Portugal',
	'ISO2': 'PT',
	'E164': 351,
	'prefix': '351',
	'fr': 'Portugal'
}, {
	type: 'Puerto Rico',
	'ISO2': 'PR',
	'E164': 1,
	'prefix': '1-787, 1-939',
	'fr': 'Porto Rico'
}, {
	type: 'Qatar',
	'ISO2': 'QA',
	'E164': 974,
	'prefix': '974',
	'fr': 'Qatar'
}, {
	type: 'Republic of the Congo',
	'ISO2': 'CG',
	'E164': 242,
	'prefix': '242',
	'fr': 'République du Congo'
}, {
	type: 'Reunion',
	'ISO2': 'RE',
	'E164': 262,
	'prefix': '262',
	'fr': 'La Réunion'
}, {
	type: 'Romania',
	'ISO2': 'RO',
	'E164': 40,
	'prefix': '40',
	'fr': 'Roumanie'
}, {
	type: 'Russia',
	'ISO2': 'RU',
	'E164': 7,
	'prefix': '7',
	'fr': 'Russie'
}, {
	type: 'Rwanda',
	'ISO2': 'RW',
	'E164': 250,
	'prefix': '250',
	'fr': 'Rwanda'
}, {
	type: 'Saint Barthelemy',
	'ISO2': 'BL',
	'E164': 590,
	'prefix': '590',
	'fr': 'Saint-Barthélemy'
}, {
	type: 'Saint Helena',
	'ISO2': 'SH',
	'E164': 290,
	'prefix': '290',
	'fr': 'Sainte-Hélène'
}, {
	type: 'Saint Kitts and Nevis',
	'ISO2': 'KN',
	'E164': 1,
	'prefix': '1-869',
	'fr': 'Saint-Christophe-et-Niévès'
}, {
	type: 'Saint Lucia',
	'ISO2': 'LC',
	'E164': 1,
	'prefix': '1-758',
	'fr': 'Sainte-Lucie'
}, {
	type: 'Saint Martin',
	'ISO2': 'MF',
	'E164': 1,
	'prefix': '590',
	'fr': 'Saint-Martin'
}, {
	type: 'Saint Pierre and Miquelon',
	'ISO2': 'PM',
	'E164': 508,
	'prefix': '508',
	'fr': 'Saint-Pierre-et-Miquelon'
}, {
	type: 'Saint Vincent and the Grenadines',
	'ISO2': 'VC',
	'E164': 1,
	'prefix': '1-784',
	'fr': 'Saint-Vincent-et-les-Grenadines'
}, {
	type: 'Samoa',
	'ISO2': 'WS',
	'E164': 685,
	'prefix': '685',
	'fr': 'Samoa'
}, {
	type: 'San Marino',
	'ISO2': 'SM',
	'E164': 378,
	'prefix': '378',
	'fr': 'Saint-Marin'
}, {
	type: 'Sao Tome and Principe',
	'ISO2': 'ST',
	'E164': 239,
	'prefix': '239',
	'fr': 'Sao Tomé-et-Principe'
}, {
	type: 'Saudi Arabia',
	'ISO2': 'SA',
	'E164': 966,
	'prefix': '966',
	'fr': 'Arabie saoudite'
}, {
	type: 'Senegal',
	'ISO2': 'SN',
	'E164': 221,
	'prefix': '221',
	'fr': 'Sénégal'
}, {
	type: 'Serbia',
	'ISO2': 'RS',
	'E164': 381,
	'prefix': '381',
	'fr': 'Serbie'
}, {
	type: 'Seychelles',
	'ISO2': 'SC',
	'E164': 248,
	'prefix': '248',
	'fr': 'Seychelles'
}, {
	type: 'Sierra Leone',
	'ISO2': 'SL',
	'E164': 232,
	'prefix': '232',
	'fr': 'Sierra Leone'
}, {
	type: 'Singapore',
	'ISO2': 'SG',
	'E164': 65,
	'prefix': '65',
	'fr': 'Singapour'
}, {
	type: 'Sint Maarten',
	'ISO2': 'SX',
	'E164': 1,
	'prefix': '1-721',
	'fr': 'Saint-Martin'
}, {
	type: 'Slovakia',
	'ISO2': 'SK',
	'E164': 421,
	'prefix': '421',
	'fr': 'Slovaquie'
}, {
	type: 'Slovenia',
	'ISO2': 'SI',
	'E164': 386,
	'prefix': '386',
	'fr': 'Slovénie'
}, {
	type: 'Solomon Islands',
	'ISO2': 'SB',
	'E164': 677,
	'prefix': '677',
	'fr': 'Îles Salomon'
}, {
	type: 'Somalia',
	'ISO2': 'SO',
	'E164': 252,
	'prefix': '252',
	'fr': 'Somalie'
}, {
	type: 'South Africa',
	'ISO2': 'ZA',
	'E164': 27,
	'prefix': '27',
	'fr': 'Afrique du Sud'
}, {
	type: 'South Korea',
	'ISO2': 'KR',
	'E164': 82,
	'prefix': '82',
	'fr': 'Corée du Sud'
}, {
	type: 'South Sudan',
	'ISO2': 'SS',
	'E164': 211,
	'prefix': '211',
	'fr': 'Soudan du Sud'
}, {
	type: 'Spain',
	'ISO2': 'ES',
	'E164': 34,
	'prefix': '34',
	'fr': 'Espagne'
}, {
	type: 'Sri Lanka',
	'ISO2': 'LK',
	'E164': 94,
	'prefix': '94',
	'fr': 'Sri Lanka'
}, {
	type: 'Sudan',
	'ISO2': 'SD',
	'E164': 249,
	'prefix': '249',
	'fr': 'Soudan'
}, {
	type: 'Suriname',
	'ISO2': 'SR',
	'E164': 597,
	'prefix': '597',
	'fr': 'Suriname'
}, {
	type: 'Svalbard and Jan Mayen',
	'ISO2': 'SJ',
	'E164': 47,
	'prefix': '47',
	'fr': 'Svalbard et Jan Mayen'
}, {
	type: 'Swaziland',
	'ISO2': 'SZ',
	'E164': 268,
	'prefix': '268',
	'fr': 'Eswatini'
}, {
	type: 'Sweden',
	'ISO2': 'SE',
	'E164': 46,
	'prefix': '46',
	'fr': 'Suède'
}, {
	type: 'Switzerland',
	'ISO2': 'CH',
	'E164': 41,
	'prefix': '41',
	'fr': 'Suisse'
}, {
	type: 'Syria',
	'ISO2': 'SY',
	'E164': 963,
	'prefix': '963',
	'fr': 'Syrie'
}, {
	type: 'Taiwan',
	'ISO2': 'TW',
	'E164': 886,
	'prefix': '886',
	'fr': 'Taïwan'
}, {
	type: 'Tajikistan',
	'ISO2': 'TJ',
	'E164': 992,
	'prefix': '992',
	'fr': 'Tadjikistan'
}, {
	type: 'Tanzania',
	'ISO2': 'TZ',
	'E164': 255,
	'prefix': '255',
	'fr': 'Tanzanie'
}, {
	type: 'Thailand',
	'ISO2': 'TH',
	'E164': 66,
	'prefix': '66',
	'fr': 'Thaïlande'
}, {
	type: 'Togo',
	'ISO2': 'TG',
	'E164': 228,
	'prefix': '228',
	'fr': 'Togo'
}, {
	type: 'Tokelau',
	'ISO2': 'TK',
	'E164': 690,
	'prefix': '690',
	'fr': 'Tokelau'
}, {
	type: 'Tonga',
	'ISO2': 'TO',
	'E164': 676,
	'prefix': '676',
	'fr': 'Tonga'
}, {
	type: 'Trinidad and Tobago',
	'ISO2': 'TT',
	'E164': 1,
	'prefix': '1-868',
	'fr': 'Trinité-et-Tobago'
}, {
	type: 'Tunisia',
	'ISO2': 'TN',
	'E164': 216,
	'prefix': '216',
	'fr': 'Tunisie'
}, {
	type: 'Turkey',
	'ISO2': 'TR',
	'E164': 90,
	'prefix': '90',
	'fr': 'Turquie'
}, {
	type: 'Turkmenistan',
	'ISO2': 'TM',
	'E164': 993,
	'prefix': '993',
	'fr': 'Turkménistan'
}, {
	type: 'Turks and Caicos Islands',
	'ISO2': 'TC',
	'E164': 1,
	'prefix': '1-649',
	'fr': 'Îles Turques-et-Caïques'
}, {
	type: 'Tuvalu',
	'ISO2': 'TV',
	'E164': 688,
	'prefix': '688',
	'fr': 'Tuvalu'
}, {
	type: 'U.S. Virgin Islands',
	'ISO2': 'VI',
	'E164': 1,
	'prefix': '1-340',
	'fr': 'Îles Vierges des États-Unis'
}, {
	type: 'Uganda',
	'ISO2': 'UG',
	'E164': 256,
	'prefix': '256',
	'fr': 'Ouganda'
}, {
	type: 'Ukraine',
	'ISO2': 'UA',
	'E164': 380,
	'prefix': '380',
	'fr': 'Ukraine'
}, {
	type: 'United Arab Emirates',
	'ISO2': 'AE',
	'E164': 971,
	'prefix': '971',
	'fr': 'Émirats arabes unis'
}, {
	type: 'United Kingdom',
	'ISO2': 'GB',
	'E164': 44,
	'prefix': '44',
	'fr': 'Royaume-Uni'
}, {
	type: 'United States',
	'ISO2': 'US',
	'E164': 1,
	'prefix': '1',
	'fr': 'États-Unis'
}, {
	type: 'Uruguay',
	'ISO2': 'UY',
	'E164': 598,
	'prefix': '598',
	'fr': 'Uruguay'
}, {
	type: 'Uzbekistan',
	'ISO2': 'UZ',
	'E164': 998,
	'prefix': '998',
	'fr': 'Ouzbékistan'
}, {
	type: 'Vanuatu',
	'ISO2': 'VU',
	'E164': 678,
	'prefix': '678',
	'fr': 'Vanuatu'
}, {
	type: 'Vatican',
	'ISO2': 'VA',
	'E164': 39,
	'prefix': '379',
	'fr': 'Vatican'
}, {
	type: 'Venezuela',
	'ISO2': 'VE',
	'E164': 58,
	'prefix': '58',
	'fr': 'Venezuela'
}, {
	type: 'Vietnam',
	'ISO2': 'VN',
	'E164': 84,
	'prefix': '84',
	'fr': 'Viêt Nam'
}, {
	type: 'Wallis and Futuna',
	'ISO2': 'WF',
	'E164': 681,
	'prefix': '681',
	'fr': 'Wallis-et-Futuna'
}, {
	type: 'Western Sahara',
	'ISO2': 'EH',
	'E164': 212,
	'prefix': '212',
	'fr': 'Sahara occidental'
}, {
	type: 'Yemen',
	'ISO2': 'YE',
	'E164': 967,
	'prefix': '967',
	'fr': 'Yémen'
}, {
	type: 'Zambia',
	'ISO2': 'ZM',
	'E164': 260,
	'prefix': '260',
	'fr': 'Zambie'
}, {
	type: 'Zimbabwe',
	'ISO2': 'ZW',
	'E164': 263,
	'prefix': '263',
	'fr': 'Zimbabwe'
}];

/* harmony default export */ __webpack_exports__["a"] = (Country);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var UniversignResource = {
	signPersonalEstate: function signPersonalEstate(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/signature-request/personal-estate/' + id);
	},
	signMissionLetter: function signMissionLetter(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/signature-request/mission-letter/' + id);
	},
	signMissionReport: function signMissionReport(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/signature-request/mission-report/' + id);
	},
	signSubscriptionContract: function signSubscriptionContract(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/signature-request/subscription-contract/' + id);
	},
	signCompanyInformation: function signCompanyInformation(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/signature-request/company-information/' + id);
	},
	verify: function verify(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/transaction-info/' + id);
	},
	relaunchTransaction: function relaunchTransaction(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/relaunch-transaction/' + id);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (UniversignResource);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveDate; });
var resolveDate = function resolveDate(date) {
	var d = null;
	if (date === null) {
		return null;
	}

	if (date.indexOf('-') !== -1) {
		d = date.split('-');
	} else {
		d = date.split('/');
	}
	if (d.length === 3) {
		if (d[2].toString().length === 4) {
			return d.join('-');
		} else {
			return d.reverse().join('-');
		}
	} else {
		return null;
	}
};

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(798)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CURRENT_SITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_CURRENT_SITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CURRENT_SITE; });
var SET_CURRENT_SITE = 'SET_CURRENT_SITE';
var CLEAR_CURRENT_SITE = 'CLEAR_CURRENT_SITE';
var GET_CURRENT_SITE = 'GET_CURRENT_SITE';

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORAGE_KEY; });
var STORAGE_KEY = 'patrimoffice-cgpi';

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjQ0NDEgNy45NjAwNVY5LjQ2MDA1QzEwLjQ0NDYgOS41OTkzIDEwLjQxNjEgOS43MzcxMyAxMC4zNjAzIDkuODY0NzJDMTAuMzA0NSA5Ljk5MjMxIDEwLjIyMjcgMTAuMTA2OCAxMC4xMjAxIDEwLjIwMUMxMC4wMTc1IDEwLjI5NTEgOS44OTYzNSAxMC4zNjY4IDkuNzY0NDMgMTAuNDExNEM5LjYzMjUyIDEwLjQ1NiA5LjQ5Mjc0IDEwLjQ3MjYgOS4zNTQwNiAxMC40NkM3LjgxNTQ4IDEwLjI5MjkgNi4zMzc1NiA5Ljc2NzEyIDUuMDM5MDYgOC45MjUwNUMzLjgzMDk3IDguMTU3MzggMi44MDY3MyA3LjEzMzEzIDIuMDM5MDYgNS45MjUwNUMxLjE5NDA1IDQuNjIwNjUgMC42NjgxOCAzLjEzNTU1IDAuNTA0MDU4IDEuNTkwMDVDMC40OTE1NjQgMS40NTE3OCAwLjUwNzk5NiAxLjMxMjQzIDAuNTUyMzA5IDEuMTgwODZDMC41OTY2MjEgMS4wNDkyOSAwLjY2Nzg0NCAwLjkyODM5MyAwLjc2MTQ0MSAwLjgyNTg1OUMwLjg1NTAzOSAwLjcyMzMyNSAwLjk2ODk2MSAwLjY0MTQwMyAxLjA5NTk1IDAuNTg1MzA5QzEuMjIyOTUgMC41MjkyMTYgMS4zNjAyMyAwLjUwMDE3OSAxLjQ5OTA2IDAuNTAwMDQ4SDIuOTk5MDZDMy4yNDE3MSAwLjQ5NzY2IDMuNDc2OTUgMC41ODM1ODggMy42NjA5NCAwLjc0MTgxNUMzLjg0NDkyIDAuOTAwMDQyIDMuOTY1MSAxLjExOTc3IDMuOTk5MDYgMS4zNjAwNUM0LjA2MjM3IDEuODQwMDggNC4xNzk3OCAyLjMxMTQxIDQuMzQ5MDYgMi43NjUwNUM0LjQxNjMzIDIuOTQ0MDEgNC40MzA4OSAzLjEzODUxIDQuMzkxMDEgMy4zMjU0OUM0LjM1MTEzIDMuNTEyNDcgNC4yNTg0OSAzLjY4NDEgNC4xMjQwNiAzLjgyMDA1TDMuNDg5MDYgNC40NTUwNUM0LjIwMDg0IDUuNzA2ODIgNS4yMzcyOSA2Ljc0MzI3IDYuNDg5MDYgNy40NTUwNUw3LjEyNDA2IDYuODIwMDVDNy4yNiA2LjY4NTYyIDcuNDMxNjQgNi41OTI5NyA3LjYxODYyIDYuNTUzMUM3LjgwNTYgNi41MTMyMiA4LjAwMDEgNi41Mjc3OCA4LjE3OTA2IDYuNTk1MDVDOC42MzI2OSA2Ljc2NDMyIDkuMTA0MDMgNi44ODE3NCA5LjU4NDA2IDYuOTQ1MDVDOS44MjY5NCA2Ljk3OTMxIDEwLjA0ODggNy4xMDE2NSAxMC4yMDczIDcuMjg4OEMxMC4zNjU5IDcuNDc1OTQgMTAuNDUwMSA3LjcxNDg0IDEwLjQ0NDEgNy45NjAwNVoiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTYgOSI+CiAgICA8cGF0aCBmaWxsPSIjRkY0MDUyIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik05IDYuNGgzLjZMOSAyLjhsLTQgNEwuMyAyLjEgMS43LjcgNSA0bDQtNCA1IDVWMS40aDJ2N0g5eiIvPgo8L3N2Zz4K"

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiPgogICAgPHBhdGggZmlsbD0iIzAwQjkzNiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi41NDggMS4xMjNhMy44MzYgMy44MzYgMCAxIDEtNS40MjUgNS40MjUgMy44MzYgMy44MzYgMCAwIDEgNS40MjUtNS40MjV6bS0uOTMxLjkxNEwzLjA2OCA0LjU4NSAyLjA1NCAzLjU3MWEuMzc0LjM3NCAwIDEgMC0uNTI4LjUyOWwxLjI3OCAxLjI3OWEuMzc0LjM3NCAwIDAgMCAuNTI5IDBsMi44MTMtMi44MTNhLjM3NC4zNzQgMCAwIDAtLjUzLS41M3oiLz4KPC9zdmc+Cg=="

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTYgOSI+CiAgICA8cGF0aCBmaWxsPSIjMDBCOTM2IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik04LjcgMmgzLjZMOC43IDUuNmwtNC00TDAgNi4zbDEuNCAxLjQgMy4zLTMuMyA0IDQgNS01VjdoMlYwaC03eiIvPgo8L3N2Zz4K"

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MiIgaGVpZ2h0PSI2MSIgdmlld0JveD0iMCAwIDUyIDYxIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0JCOTI2NyIgZD0iTTQ5LjI4IDE4LjcwM0gzNC44NzZjLS43MjMgMC0xLjMxLS41ODMtMS4zMS0xLjMwNVYzLjY2NmMwLS4zNC4yNzctLjYxNi42MTctLjYxNkg2LjA3M2MtLjcyMSAwLTEuMzEuNTg0LTEuMzEgMS4zMDR2MjMuNDhIMi4xNDZWNC4zNTNjMC0yLjE1NyAxLjc2Mi0zLjkxMyAzLjkyOC0zLjkxM2gyOC44MDRjLjM0NyAwIC42ODEuMTM3LjkyNi4zODJsMTUuNzExIDE1LjY1M2MuMjQ2LjI0NC4zODQuNTc1LjM4NC45MjJWNTYuNTNjMCAyLjE1OC0xLjc2MiAzLjkxMy0zLjkyOCAzLjkxM0g2LjA3M2MtMi4xNjYgMC0zLjkyOC0xLjc1NS0zLjkyOC0zLjkxM1Y0NS4wODZoMi42MTlWNTYuNTNjMCAuNzIuNTg4IDEuMzA1IDEuMzA5IDEuMzA1SDQ3Ljk3Yy43MjEgMCAxLjMxLS41ODUgMS4zMS0xLjMwNVYxOC43MDN6TTM2LjE4NSA0Ljg5NHYxMS4yaDExLjI0MmwtMTEuMjQyLTExLjJ6IiBvcGFjaXR5PSIuOCIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNEY0RjQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIxLjIzMiIgZD0iTTQxLjk0IDQ2LjA5NUgyLjY0N2MtLjYzOCAwLTEuMTU2LS41ODMtMS4xNTYtMS4zMDRWMjcuODMzYzAtLjcyLjUxOC0xLjMwNCAxLjE1Ni0xLjMwNGgzOS4yOTVjLjYzOCAwIDEuMTU2LjU4MyAxLjE1NiAxLjMwNHYxNi45NThjMCAuNzIxLS41MTggMS4zMDQtMS4xNTYgMS4zMDR6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(902)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1179),
  /* scopeId */
  "data-v-dc8d1a0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PropertyTypes = ['Bien détenu en pleine propriété par vous-même', 'Bien détenu en pleine propriété par votre conjoint ou partenaire de PACS', 'Bien détenu en nue-propriété par vous-même', 'Bien détenu en nue-propriété par votre conjoint ou partenaire de PACS', 'Bien détenu en usufruit par vous-même', 'Bien détenu en usufruit par votre conjoint ou partenaire de PACS', 'Bien détenu en indivision', 'Autre'];

/* harmony default export */ __webpack_exports__["a"] = (PropertyTypes);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ResolveDate__ = __webpack_require__(115);






var EstateResource = {
  getPatrimonial: function getPatrimonial(dispatch, estate) {
    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].get("api/estate/private/" + (id || estate.idUser)).then(function (data) {
        dispatch("storePatrimonial", {
          name: "SET_ID",
          data: {
            id: id || estate.idUser
          },
          fromStart: true
        });
        if (data.status === 200 && data.statusText === "OK" && data.data.success) {
          var d = data.data.user;
          var summEstate = data.data.private_estate_totals;
          var details = data.data.private_estate_details;
          dispatch("storePatrimonial", {
            name: "UPDATED_AT",
            data: {
              updatedAt: details.updated_at,
              completedAt: details.completed_at
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "TOTAL",
            data: {
              incomes: summEstate.total_incomes,
              loans: summEstate.total_loans,
              savings: summEstate.total_savings,
              immobilier: summEstate.immobilier
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "YOUR_INFORMATIONS",
            data: {
              birthdate: d.birthdate ? d.birthdate.substring(0, 10) : null,
              job: d.job,
              csp: d.professional_category,
              maritalStatus: d.relationship_status
            },
            fromStart: true
          });
          var kids = d.kids.map(function (kid) {
            return {
              id: kid.id,
              type: kid.type,
              firstname: kid.firstname,
              lastname: kid.lastname,
              dateOfBirth: kid.birthdate.substring(0, 10)
            };
          });
          dispatch("storePatrimonial", {
            name: "YOUR_HOME",
            data: kids,
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "ANNUAL_RECIPE",
            data: {
              directIncome: {
                val: d.main_income,
                cur: d.main_income_currency
              },
              secondIncome: {
                val: d.unearned_income,
                cur: d.unearned_income_currency
              }
            },
            fromStart: true
          });
          var srs = d.secondary_residences.map(function (se) {
            return {
              id: se.id,
              ownership_type: se.ownership_type,
              cur: se.currency,
              value: se.value
            };
          });
          var rentalProperties = d.rental_properties.map(function (rp) {
            return {
              id: rp.id,
              ownership_type: rp.ownership_type,
              cur: rp.currency,
              value: rp.value
            };
          });
          dispatch("storePatrimonial", {
            name: "REAL_ESTATE",
            data: {
              mainEstate: {
                val: d.main_residence_value,
                cur: d.main_residence_value_currency,
                type: d.main_residence_ownership
              },
              secondaryEstates: srs,
              rentalProperties: rentalProperties,
              isSCPI: d.scpi_shares_owner,
              scpi: {
                value: d.scpi_shares_value,
                cur: d.scpi_shares_value_currency,
                type: d.scpi_shares_ownership
              }
            },
            fromStart: true
          });
          var savings = d.savings.map(function (saving) {
            var s = {
              type: null,
              fields: {}
            };
            s.type = saving.saving_type;
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(saving).map(function (key) {
              if (key !== "saving_type" && saving[key] !== null) {
                s.fields[key] = saving[key];
              }
            });
            return s;
          });
          dispatch("storePatrimonial", {
            name: "SAVINGS",
            data: savings,
            fromStart: true
          });

          dispatch("storePatrimonial", {
            name: "SPENDING_NO_TAXES",
            data: {
              spending: {
                value: d.expenses_amount,
                cur: d.expenses_amount_currency
              },
              periodicity: d.expenses_frequency
            },
            fromStart: true
          });
          var loans = d.loan.map(function (l) {
            return {
              id: l.id,
              type: l.loan_type,
              value: l.value,
              currency: l.currency,
              monthlyPayment: l.monthly_payment
            };
          });
          console.log("before dispatch credits", d);
          dispatch("storePatrimonial", {
            name: "CREDITS",
            data: {
              loans: loans,
              overallDebtPercentage: d.overall_debt_percentage
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "TAXES",
            data: {
              value: d.income_tax,
              cur: d.income_tax_currency,
              nbFiscalParts: d.isf_household_share,
              countryForTaxes: d.isf_affiliated_country
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "ISF",
            data: {
              amount: d.isf_tax,
              cur: d.isf_tax_currency
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "RETREAT",
            data: {
              month: d.retirement_month,
              year: d.retirement_year,
              hasRetirement: d.has_retirement,
              PERP: d.perp_type
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "INFLUENCE",
            data: {
              motivation: d.profile_influence_description,
              conselors: d.profile_influence_persons
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "FOLLOWING",
            data: {
              rate: d.profile_follow_advice,
              nbContractCounselor: d.profile_follow_contract_persons,
              nbPatrimonialCounselor: d.profile_follow_asset_persons
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "KNOWLEDGE",
            data: {
              diploma: d.profile_knowledge_diploma,
              level: d.profile_knowledge_level,
              age: d.profile_knowledge_age,
              country: d.profile_knowledge_country,
              products: d.profile_knowledge_product,
              investedProducts: d.profile_knowledge_invested_product,
              managements: d.profile_knowledge_management
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "ESG",
            data: {
              interestedBySustainability: d.interested_by_sustainability,
              acceptLowerPerformance: d.durability_perf,
              durabilite: d.durability
            },
            fromStart: true
          });
          dispatch("storePatrimonial", {
            name: "PERSPECTIVE",
            data: {
              perspective: d.profile_investment_perspectives,
              objective: d.profile_investment_objectives,
              riskDegree: d.profile_risk_degree,
              risingMarket: d.profile_rising_market,
              assetsEstimate: d.profile_assets_estimate,
              investmentsEstimate: d.profile_investment_estimate
            },
            fromStart: true
          });
          console.log("before dispatch advisor_check", d);
          dispatch("storePatrimonial", {
            name: "ADVISOR_CHECK",
            data: {
              advisorConsistencyCheck: d.advisor_consistency_check,
              advisorCompletenessCheck: d.advisor_completeness_check,
              advisorWarningSentToClient: d.advisor_warning_sent_to_client
            },
            fromStart: true
          });
        }
        resolve();
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  savePatrimonial: function savePatrimonial(dispatch, estate, id) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.saveMainPatrimonial(estate).then(function () {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.saveKids(estate), _this.saveSecondaryEstates(estate), _this.saveRentalProperties(estate), _this.saveSavings(estate), _this.saveLoans(estate), _this.savePatrimonialArray(estate)]);
      }).then(function () {
        return _this.getPatrimonial(dispatch, estate, id);
      }).then(function () {
        resolve();
      }).catch(function (error) {
        console.warn(error);
        reject(error);
      });
    });
  },
  saveMainPatrimonial: function saveMainPatrimonial(data) {
    var u = data;
    var d = new FormData();
    if (u.birthdate) {
      d.append("birthdate", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_ResolveDate__["a" /* resolveDate */])(u.birthdate));
    }
    d.append("job", u.job);
    d.append("professional_category", u.csp);
    d.append("relationship_status", u.maritalStatus);
    d.append("main_income", u.directIncome.val);
    d.append("main_income_currency", u.directIncome.cur);
    d.append("unearned_income", u.secondIncome.val);
    d.append("unearned_income_currency", u.secondIncome.cur);
    d.append("main_residence_owner", u.mainEstate.val > 0);
    d.append("main_residence_value", u.mainEstate.val);
    d.append("main_residence_value_currency", u.mainEstate.cur);
    d.append("main_residence_ownership", u.mainEstate.type);
    d.append("scpi_shares_owner", u.isSCPI ? 1 : 0);
    d.append("scpi_shares_value", u.scpi.value);
    d.append("scpi_shares_value_currency", u.scpi.cur);
    d.append("scpi_shares_ownership", u.scpi.type);

    d.append("expenses_amount", u.spendingNoTaxes.value);
    d.append("expenses_amount_currency", u.spendingNoTaxes.cur);
    d.append("expenses_frequency", u.periodicity);
    d.append("income_tax", u.taxes.value);
    d.append("income_tax_currency", u.taxes.cur);
    d.append("income_tax_document", null);
    d.append("isf_tax", u.isf.amount);
    d.append("isf_tax_currency", u.isf.cur);
    d.append("isf_document", null);
    d.append("isf_household_share", u.taxes.nbFiscalParts ? parseFloat(u.taxes.nbFiscalParts) : 1);
    d.append("isf_affiliated_country", u.taxes.countryForTaxes);
    d.append("retirement_month", u.retreat.month);
    d.append("retirement_year", u.retreat.year ? parseInt(u.retreat.year) : null);
    d.append("has_retirement", u.retreat.hasRetirement);
    d.append("perp_own", u.retreat.PERP.length > 0);
    d.append("profile_influence_description", u.influence.motivation || null);
    d.append("profile_follow_advice", u.follow.rate || null);
    d.append("profile_follow_contract_persons", u.follow.nbContractCounselor || null);
    d.append("profile_follow_asset_persons", u.follow.nbPatrimonialCounselor || null);
    d.append("profile_knowledge_diploma", u.knowledge.diploma || null);
    d.append("profile_knowledge_level", u.knowledge.level || null);
    d.append("profile_knowledge_age", u.knowledge.age || null);
    d.append("profile_knowledge_country", u.knowledge.country || null);

    d.append("profile_knowledge_euro", false);
    d.append("profile_investment_perspectives", u.perspective.perspective || null);
    d.append("profile_risk_degree", u.perspective.riskDegree || null);
    d.append("profile_rising_market", u.perspective.risingMarket || null);
    d.append("profile_assets_estimate", u.perspective.assetsEstimate || null);
    d.append("profile_investment_estimate", u.perspective.investmentsEstimate || null);
    d.append("interested_by_sustainability", u.esg.interestedBySustainability || false);
    d.append("durability_perf", u.esg.acceptLowerPerformance || false);
    d.append("optin_completion", false);
    d.append("completed", false);
    d.append("overall_debt_percentage", u.overallDebtPercentage);
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/" + u.idUser, d);
  },
  saveKids: function saveKids(u) {
    var data = null;
    if (u.childs.length > 0) {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        kids: u.childs.map(function (kid) {
          return {
            id: kid.id,
            type: kid.type,
            firstname: kid.firstname,
            lastname: kid.lastname,
            birthdate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_ResolveDate__["a" /* resolveDate */])(kid.dateOfBirth)
          };
        })
      });
    } else {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ kids: [] });
    }
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/kids/" + u.idUser, data, "application/json");
  },
  saveSecondaryEstates: function saveSecondaryEstates(u) {
    var data = null;
    if (u.secondaryEstates.length > 0) {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        secondary_residences: u.secondaryEstates.map(function (se) {
          return {
            id: se.id,
            value: se.value,
            currency: se.cur,
            ownership_type: se.ownership_type
          };
        })
      });
    } else {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ secondary_residences: [] });
    }
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/residences/" + u.idUser, data, "application/json");
  },
  saveRentalProperties: function saveRentalProperties(u) {
    var data = null;
    if (u.rentalProperties.length > 0) {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        rental_properties: u.rentalProperties.map(function (rp) {
          return {
            id: rp.id,
            value: rp.value,
            currency: rp.cur,
            ownership_type: rp.ownership_type
          };
        })
      });
    } else {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ rental_properties: [] });
    }
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/rentals/" + u.idUser, data, "application/json");
  },
  saveSavings: function saveSavings(u) {
    var data = null;
    if (u.savings.length > 0) {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        savings: u.savings.map(function (saving) {
          var sav = {};
          sav["saving_type"] = saving.type;
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(saving.fields).forEach(function (key) {
            if (key === "opening_date") {
              if (saving.fields[key].includes(" ")) {
                saving.fields[key] = saving.fields[key].split(" ")[0];
              }
              sav[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_ResolveDate__["a" /* resolveDate */])(saving.fields[key]);
            } else {
              sav[key] = saving.fields[key];
            }
          });

          return sav;
        })
      });
    } else {
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ savings: [] });
    }
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/savings/" + u.idUser, data, "application/json");
  },
  saveLoans: function saveLoans(u) {
    var data = null;
    if (u.credits.length > 0) {
      data = u.credits.map(function (loan) {
        return {
          id: loan.id,
          loan_type: loan.type,
          value: loan.value,
          currency: loan.currency,
          monthly_payment: loan.monthlyPayment
        };
      });
    } else {
      data = [];
    }
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ loan: data });
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/loans/" + u.idUser, data, "application/json");
  },
  savePatrimonialArray: function savePatrimonialArray(u) {
    var data = {
      perp_type: u.retreat.PERP,
      profile_influence_persons: u.influence.conselors,
      profile_knowledge_product: u.knowledge.products,
      profile_knowledge_invested_product: u.knowledge.investedProducts,
      profile_knowledge_management: u.knowledge.managements,
      profile_investment_objectives: u.perspective.objective,
      durability: u.esg.durabilite
    };
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].post("api/estate/private/" + u.idUser, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), "application/json");
  },
  getInvestisorProfil: function getInvestisorProfil(id) {
    return __WEBPACK_IMPORTED_MODULE_3__services_Emma__["a" /* default */].get("api/investor-profile/" + id);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (EstateResource);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var InvestmentResource = {
	getClientInvestmentProducts: function getClientInvestmentProducts(userId) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/investment-product?user_id=' + userId);
	},
	getInvestmentProduct: function getInvestmentProduct(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/investment-product/' + id);
	},
	getCountriesInvestmentProducts: function getCountriesInvestmentProducts(userId) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/clients/' + userId + '/countries-placement');
	},
	updateInvestmentProduct: function updateInvestmentProduct(id, data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/investment-product/' + id, data);
	},
	addInvestmentProduct: function addInvestmentProduct(userId, data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/investment-product?user_id=' + userId, data);
	},
	deleteInvestmentProducts: function deleteInvestmentProducts(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/investment-product/' + id + '/delete');
	}
};

/* harmony default export */ __webpack_exports__["a"] = (InvestmentResource);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NEW_THREAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NEW_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_THREAD; });
var NEW_THREAD = 'NEW_THREAD';
var NEW_MESSAGE = 'NEW_MESSAGE';
var CLEAR_THREAD = 'CLEAR_THREAD';

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_DOCUMENT; });
/* unused harmony export UPLOAD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_DOCUMENTS; });

var ADD_DOCUMENT = 'FETCH';
var UPLOAD = 'UPLOAD';
var CLEAR_DOCUMENTS = 'CLEAR_DOCUMENTS';

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_INVESTMENT_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_INVESTMENT_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_INVESTMENT_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_INVESTMENT_PRODUCT; });
var SET_INVESTMENT_PRODUCTS = 'SET_INVESTMENT_PRODUCTS';
var SET_INVESTMENT_PRODUCT = 'SET_INVESTMENT_PRODUCT';
var ADD_INVESTMENT_PRODUCT = 'ADD_INVESTMENT_PRODUCT';
var DELETE_INVESTMENT_PRODUCT = 'DELETE_INVESTMENT_PRODUCT';

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ARTICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_GENERAL_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_USER_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_BANQUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_MY_NEWS; });
var ADD_ARTICLE = 'ADD_ARTICLE';
var CLEAR_ARTICLES = 'CLEAR_ARTICLES';
var CLEAR_TAGS = 'CLEAR_TAGS';
var ADD_GENERAL_TAG = 'ADD_GENERAL_TAG';
var ADD_USER_TAG = 'ADD_USER_TAG';
var ADD_BANQUE = 'ADD_BANQUE';
var ADD_MY_NEWS = 'ADD_MY_NEWS';

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export READ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_NOTIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_NOTIF; });

var READ = 'READ';
var FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
var OPEN_NOTIF = 'OPEN_NOTIF';
var CLOSE_NOTIF = 'CLOSE_NOTIF';

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  idUser: null,
  updatedAt: null,
  completedAt: null,

  validation: [{ name: "YOUR_INFORMATIONS", status: false }, { name: "YOUR_HOME", status: false }, { name: "ANNUAL_RECIPE", status: false }, { name: "REAL_ESTATE", status: false }, { name: "SAVINGS", status: false }, { name: "SPENDING_NO_TAXES", status: false }, { name: "CREDITS", status: false }, { name: "TAXES", status: false }, { name: "ISF", status: false }, { name: "RETREAT", status: false }, { name: "INFLUENCE", status: false }, { name: "FOLLOWING", status: false }, { name: "KNOWLEDGE", status: false }, { name: "PERSPECTIVE", status: false }, { name: "ESG", status: false }],

  birthdate: "",
  job: "",
  csp: "",
  maritalStatus: "",

  childs: [],

  directIncome: { val: null, cur: "EUR" },
  secondIncome: { val: null, cur: "EUR" },

  mainEstate: { val: null, cur: "EUR", type: null },
  secondaryEstates: [],
  rentalProperties: [],
  isSCPI: false,
  scpi: { value: null, cur: "EUR", type: null },

  savings: [],

  gfr: {
    nbObjects: null,
    isMetals: null,
    isReceivables: null,
    isOtherEstates: null
  },

  spendingNoTaxes: { value: null, cur: "EUR" },
  periodicity: null,

  credits: [],
  overallDebtPercentage: "",

  taxes: {
    value: null,
    cur: "EUR",
    nbFiscalParts: 1,
    countryForTaxes: "France"
  },

  isf: {
    amount: null,
    cur: "EUR"
  },

  retreat: {
    month: null,
    year: null,
    PERP: []
  },

  influence: {
    motivation: null,
    conselors: []
  },

  follow: {
    rate: null,
    nbContractCounselor: 0,
    nbPatrimonialCounselor: 0
  },

  knowledge: {
    diploma: null,
    level: null,
    age: null,
    country: null,
    products: [],
    investedProducts: [],
    managements: []
  },

  perspective: {
    perspective: null,
    objective: [],
    riskDegree: null,
    risingMarket: null,
    assetsEstimate: null,
    investmentsEstimate: null
  },

  esg: {
    interestedBySustainability: false,
    acceptLowerPerformance: false,
    durabilite: []
  },

  total: {
    incomes: null,
    loans: null,
    savings: null,
    immobilier: null
  },

  advisorCheck: {
    advisorConsistencyCheck: null,
    advisorCompletenessCheck: null,
    advisorWarningSentToClient: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ID", function() { return SET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATED_AT", function() { return UPDATED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUR_INFORMATIONS", function() { return YOUR_INFORMATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUR_HOME", function() { return YOUR_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANNUAL_RECIPE", function() { return ANNUAL_RECIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REAL_ESTATE", function() { return REAL_ESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVINGS", function() { return SAVINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GFR", function() { return GFR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPENDING_NO_TAXES", function() { return SPENDING_NO_TAXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREDITS", function() { return CREDITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAXES", function() { return TAXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ISF", function() { return ISF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RETREAT", function() { return RETREAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INFLUENCE", function() { return INFLUENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLLOWING", function() { return FOLLOWING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KNOWLEDGE", function() { return KNOWLEDGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERSPECTIVE", function() { return PERSPECTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ESG", function() { return ESG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOTAL", function() { return TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR", function() { return CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VALIDATION", function() { return VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADVISOR_CHECK", function() { return ADVISOR_CHECK; });

var SET_ID = "SET_ID";
var UPDATED_AT = "UPDATED_AT";
var YOUR_INFORMATIONS = "YOUR_INFORMATIONS";
var YOUR_HOME = "YOUR_HOME";
var ANNUAL_RECIPE = "ANNUAL_RECIPE";
var REAL_ESTATE = "REAL_ESTATE";
var SAVINGS = "SAVINGS";
var GFR = "GFR";
var SPENDING_NO_TAXES = "SPENDING_NO_TAXES";
var CREDITS = "CREDITS";
var TAXES = "TAXES";
var ISF = "ISF";
var RETREAT = "RETREAT";
var INFLUENCE = "INFLUENCE";
var FOLLOWING = "FOLLOWING";
var KNOWLEDGE = "KNOWLEDGE";
var PERSPECTIVE = "PERSPECTIVE";
var ESG = "ESG";
var TOTAL = "TOTAL";
var CLEAR = "CLEAR";
var VALIDATION = "VALIDATION";
var ADVISOR_CHECK = "ADVISOR_CHECK";

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPLACE_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_PLANS; });
var ADD_PLAN = 'ADD_PLAN';
var REPLACE_PLAN = 'REPLACE_PLAN';
var CLEAR_PLANS = 'CLEAR_PLANS';

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPLACE_SUBSCRIPTION; });
/* unused harmony export CANCEL_SUBSCRIPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LAST_PAYMENT_FAIL_INFO; });
var ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
var REPLACE_SUBSCRIPTION = 'REPLACE_SUBSCRIPTION';
var CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
var CLEAR_SUBSCRIPTIONS = 'CLEAR_SUBSCRIPTIONS';
var LAST_PAYMENT_FAIL_INFO = 'LAST_PAYMENT_FAIL_INFO';

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_OPERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPLACE_OPERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_OPERATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_CONTRACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_PRODUCT_TO_CONTRACT; });
/* unused harmony export CLEAR_PRODUCTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_PRODUCT_TO_OPERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EDIT_PRODUCT_FROM_MISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REMOVE_PRODUCT_FROM_OPERATION; });
var ADD_OPERATION = 'ADD_OPERATION';
var REPLACE_OPERATION = 'REPLACE_OPERATION';
var CLEAR_OPERATIONS = 'CLEAR_OPERATIONS';
var ADD_CONTRACT = 'ADD_CONTRACT';
var CLEAR_CONTRACTS = 'CLEAR_CONTRACT';
var ADD_PRODUCT_TO_CONTRACT = 'ADD_PRODUCT_TO_CONTRACT';
var CLEAR_PRODUCTS = 'CLEAR_PRODUCT';
var ADD_PRODUCT_TO_OPERATION = 'ADD_PRODUCT_TO_OPERATION';
var EDIT_PRODUCT_FROM_MISSION = 'EDIT_PRODUCT_FROM_MISSION';
var REMOVE_PRODUCT_FROM_OPERATION = 'REMOVE_PRODUCT_FROM_OPERATION';

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var CurrencyHelper = function () {
	function CurrencyHelper() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CurrencyHelper);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CurrencyHelper, null, [{
		key: 'formatCurrency',
		value: function formatCurrency(number) {
			var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (number) {
				var formatedNumber = number.toString();
				formatedNumber = formatedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

				if (symbol) {
					return formatedNumber + ' ' + symbol;
				}

				return formatedNumber;
			}

			return '0';
		}
	}]);

	return CurrencyHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (CurrencyHelper);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	id: null,
	role: null,
	firstname: null,
	lastname: null,
	email: null,
	picture: null,
	token: null,
	refresh: null,
	token_duration: null,
	phone: null,
	address: {
		line: null,
		zip: null,
		city: null,
		country: null
	},
	clients: [],
	available: null,
	investment_stats: null
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROFIL_PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_CLIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADD_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EDIT_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADD_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DELETE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FILL_ESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ADD_LCBCFT_TO_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ADD_CHECK_PAYSAGE; });
/* unused harmony export GET_INVESTMENT_STATS */

var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var UPDATE_PROFILE = 'UPDATE_PROFILE';
var PROFIL_PICTURE = 'PROFIL_PICTURE';
var TOKEN = 'TOKEN';

var SET_AVAILABLE = 'SET_AVAILABLE';

var GET_CLIENTS = 'GET_CLIENTS';
var UPDATE_CLIENT = 'UPDATE_CLIENT';
var ADD_CLIENT = 'ADD_CLIENT';
var EDIT_CLIENT = 'EDIT_CLIENT';

var ADD_NOTE = 'ADD_NOTE';
var UPDATE_NOTE = 'UPDATE_NOTE';
var DELETE_NOTE = 'DELETE_NOTE';

var FILL_ESTATE = 'FILL_ESTATE';
var ADD_LCBCFT_TO_CLIENT = 'ADD_LCBCFT_TO_CLIENT';
var ADD_CHECK_PAYSAGE = 'ADD_CHECK_PAYSAGE';

var GET_INVESTMENT_STATS = 'GET_INVESTMENT_STATS';

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMjA4MzcgMC41VjIuNjY2NjciIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjU0MTYzIDAuNVYyLjY2NjY3IiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS4xNjY2NyAxLjU4MzI1SDEuNTgzMzNDMC45ODUwMjUgMS41ODMyNSAwLjUgMi4wNjgyOCAwLjUgMi42NjY1OVYxMC4yNDk5QzAuNSAxMC44NDgyIDAuOTg1MDI1IDExLjMzMzMgMS41ODMzMyAxMS4zMzMzSDkuMTY2NjdDOS43NjQ5OCAxMS4zMzMzIDEwLjI1IDEwLjg0ODIgMTAuMjUgMTAuMjQ5OVYyLjY2NjU5QzEwLjI1IDIuMDY4MjggOS43NjQ5OCAxLjU4MzI1IDkuMTY2NjcgMS41ODMyNVoiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0wLjUgNC44MzMyNUgxMC4yNSIgc3Ryb2tlPSIjOTc5Nzk3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk5OTYgMS4zMzMzN0gzLjk5OTk2QzMuNjQ2MzQgMS4zMzMzNyAzLjMwNzIgMS40NzM4NSAzLjA1NzE1IDEuNzIzOUMyLjgwNzEgMS45NzM5NSAyLjY2NjYzIDIuMzEzMDkgMi42NjY2MyAyLjY2NjcxVjEzLjMzMzRDMi42NjY2MyAxMy42ODcgMi44MDcxIDE0LjAyNjEgMy4wNTcxNSAxNC4yNzYyQzMuMzA3MiAxNC41MjYyIDMuNjQ2MzQgMTQuNjY2NyAzLjk5OTk2IDE0LjY2NjdIMTJDMTIuMzUzNiAxNC42NjY3IDEyLjY5MjcgMTQuNTI2MiAxMi45NDI4IDE0LjI3NjJDMTMuMTkyOCAxNC4wMjYxIDEzLjMzMzMgMTMuNjg3IDEzLjMzMzMgMTMuMzMzNFY0LjY2NjcxTDkuOTk5OTYgMS4zMzMzN1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS4zMzMzNyAxLjMzMzM3VjQuMDAwMDRDOS4zMzMzNyA0LjM1MzY2IDkuNDczODUgNC42OTI4IDkuNzIzOSA0Ljk0Mjg1QzkuOTczOTUgNS4xOTI5IDEwLjMxMzEgNS4zMzMzNyAxMC42NjY3IDUuMzMzMzdIMTMuMzMzNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjY2NjcxIDZINS4zMzMzNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC42NjY3IDguNjY2NjNINS4zMzMzNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC42NjY3IDExLjMzMzRINS4zMzMzNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDExIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjUwMDEyIDAuNUgxLjUwMDEyQzAuOTQ3ODM3IDAuNSAwLjUwMDEyMiAwLjk0NzcxNSAwLjUwMDEyMiAxLjVWNy41QzAuNTAwMTIyIDguMDUyMjggMC45NDc4MzcgOC41IDEuNTAwMTIgOC41SDkuNTAwMTJDMTAuMDUyNCA4LjUgMTAuNTAwMSA4LjA1MjI4IDEwLjUwMDEgNy41VjEuNUMxMC41MDAxIDAuOTQ3NzE1IDEwLjA1MjQgMC41IDkuNTAwMTIgMC41WiIgc3Ryb2tlPSIjOTc5Nzk3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjUwMDEgMkw2LjAxNTEyIDQuODVDNS44NjA3NiA0Ljk0NjcxIDUuNjgyMjggNC45OTgwMSA1LjUwMDEyIDQuOTk4MDFDNS4zMTc5NiA0Ljk5ODAxIDUuMTM5NDkgNC45NDY3MSA0Ljk4NTEyIDQuODVMMC41MDAxMjIgMiIgc3Ryb2tlPSIjOTc5Nzk3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMSAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNyAxMi4zMjg1VjExLjAxNDJDOS43IDEwLjMxNzEgOS40MjMwNiA5LjY0ODQ2IDguOTMwMTEgOS4xNTU1MUM4LjQzNzE2IDguNjYyNTYgNy43Njg1NyA4LjM4NTYyIDcuMDcxNDMgOC4zODU2MkgzLjEyODU3QzIuNDMxNDMgOC4zODU2MiAxLjc2Mjg0IDguNjYyNTYgMS4yNjk4OSA5LjE1NTUxQzAuNzc2OTM4IDkuNjQ4NDYgMC41IDEwLjMxNzEgMC41IDExLjAxNDJWMTIuMzI4NSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjEwMDI1IDUuNzU3MTRDNi41NTE5NyA1Ljc1NzE0IDcuNzI4ODIgNC41ODAyOSA3LjcyODgyIDMuMTI4NTdDNy43Mjg4MiAxLjY3Njg1IDYuNTUxOTcgMC41IDUuMTAwMjUgMC41QzMuNjQ4NTMgMC41IDIuNDcxNjggMS42NzY4NSAyLjQ3MTY4IDMuMTI4NTdDMi40NzE2OCA0LjU4MDI5IDMuNjQ4NTMgNS43NTcxNCA1LjEwMDI1IDUuNzU3MTRaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(886)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(842)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(880)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1151),
  /* scopeId */
  "data-v-76f16fb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(904)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(851)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(802)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(844)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(817)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(807)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1071),
  /* scopeId */
  "data-v-129347b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(822)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  "data-v-2596c04d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Vue = void 0;

function extend(Vue) {
	Vue.directive('img-detect', function (el) {
		var img = el;
		if (img.src !== '') {
			var tmp = new Image();
			tmp.addEventListener('load', function () {
				el.classList.add(tmp.width > tmp.height ? 'landscape' : 'portrait');
				el.classList.remove(tmp.width > tmp.height ? 'portrait' : 'landscape');
			});
			tmp.src = img.src;
		}
	});
}

function _install(_Vue) {
	Vue = _Vue;
	extend(Vue);
}

var ImageDetect = function ImageDetect() {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ImageDetect);
};

ImageDetect.install = _install;
ImageDetect.version = '0.0.1';

/* harmony default export */ __webpack_exports__["a"] = (ImageDetect);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Vue = void 0;

function extend(Vue) {
	Vue.directive('inputUI', {
		inserted: function inserted(el) {
			var input = el.querySelector('input, textarea');
			var label = el.querySelector('label');

			if (!input || !label) return;

			if (input.value && input.value.trim() !== '') {
				label.classList.add('active');
			}

			if (input.tagName === 'INPUT' && input.type === 'date') {
				label.classList.add('active');
			}

			input.addEventListener('focus', function () {
				label.classList.add('active');
			});

			input.addEventListener('blur', function () {
				if (!input.value || input.value.trim() === '') {
					label.classList.remove('active');
				}

				if (input.tagName === 'INPUT' && input.type === 'date') {
					label.classList.add('active');
				}
			});
		},
		update: function update(el) {
			var input = el.querySelector('input, textarea');
			var label = el.querySelector('label');

			if (!input || !label) return;

			if (input.value && input.value.trim() !== '') {
				label.classList.add('active');
			} else if (!(input.tagName === 'INPUT' && input.type === 'date')) {
				label.classList.remove('active');
			}
		}
	});
}

function _install(_Vue) {
	Vue = _Vue;
	extend(Vue);
}

var inputUI = function inputUI() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
};

inputUI.install = _install;
inputUI.version = '0.0.1';

/* harmony default export */ __webpack_exports__["a"] = (inputUI);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Vue = void 0;

function extend(Vue) {
	Vue.directive('selectUI', function (el, binding) {
		if (el.querySelector('.custom-select .selected').innerHTML.replace('<span class="icon-arrow-full-down"></span>', '').trim() !== '&nbsp;') {
			el.querySelector('label').classList.add('active');
		}

		el.querySelector('.custom-select .selected').addEventListener('click', function () {
			el.querySelector('label').classList.add('active');
		});
	});
}

function _install(_Vue) {
	Vue = _Vue;
	extend(Vue);
}

var selectUI = function selectUI() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
};

selectUI.install = _install;
selectUI.version = '0.0.1';

/* harmony default export */ __webpack_exports__["a"] = (selectUI);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_services_ResolveDate__ = __webpack_require__(115);



__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('select', {
	getMessage: function getMessage(field) {
		return 'Le champ ' + field + ' doit être rempli';
	},
	validate: function validate(value, isObject) {
		var test = isObject[0] ? value.type : value;
		return test !== null && test !== undefined && test.trim() !== '' && test.trim() !== '-';
	}
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('canbenullif', {
	getMessage: function getMessage(field) {
		return 'Le champ ' + field + ' doit être rempli';
	},
	validate: function validate(value, args) {
		return args[0] === 'true' ? true : value !== null && value !== undefined && value.trim() !== '';
	}
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('min_date', {
	getMessage: function getMessage(field) {
		return 'La ' + field + ' doit être supérieur à aujourd\'hui ou à la date de début';
	},
	validate: function validate(value, args) {
		if (value && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_services_ResolveDate__["a" /* resolveDate */])(value)) {
			console.log(value, args);
			return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_services_ResolveDate__["a" /* resolveDate */])(value).split('-').reverse().join('-') >= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_services_ResolveDate__["a" /* resolveDate */])(args[0]).split('-').reverse().join('-');
		} else {
			return false;
		}
	}
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clone */
/* unused harmony export cloneDeep */
/* unused harmony export arrayClone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueRobot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var clone = function clone(foo) {
	var bar = {};
	var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(foo);
	keys.forEach(function (key) {
		var value = foo[key];
		if (value !== null) {
			if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
				bar[key] = value instanceof Array ? arrayClone(value) : clone(value);
			} else {
				bar[key] = foo[key];
			}
		}
	});

	return bar;
};

var cloneDeep = function cloneDeep(foo) {
	return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(foo);
};

var arrayClone = function arrayClone(foo) {
	if (foo.length > 0) {
		return foo.map(function (item) {
			return clone(item);
		});
	} else {
		return [];
	}
};

var iRobot = {
	clone: clone,
	arrayClone: arrayClone,
	cloneDeep: cloneDeep
};

var VueRobot = {
	install: function install(Vue) {
		Vue.prototype.$iRobot = iRobot;
	}
};

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Main__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Profile__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ResetPassword__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Home_index__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Home_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Home_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Home_Contacts_index__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Home_Contacts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Home_Contacts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Home_Contacts_Table__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Home_Contacts_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Home_Contacts_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Home_Contacts_Client__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Home_Contacts_Client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Home_Contacts_Client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Home_Contacts_PatrimonialLandscape__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Home_Contacts_PatrimonialLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Home_Contacts_PatrimonialLandscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Home_Contacts_PatrimonialLandscapeUpdate__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Home_Contacts_PatrimonialLandscapeUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Home_Contacts_PatrimonialLandscapeUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Home_Contacts_Chat__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Home_Contacts_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Home_Contacts_Chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Home_Contacts_Investments__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Home_Contacts_Investments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Home_Contacts_Investments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_components_InvestmentsManual_InvestmentsManualForm__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_components_InvestmentsManual_InvestmentsManualForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__common_components_InvestmentsManual_InvestmentsManualForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_components_InvestmentsManual_InvestmentsManual__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_components_InvestmentsManual_InvestmentsManual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__common_components_InvestmentsManual_InvestmentsManual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Home_Activity__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Home_Activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Home_Activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Home_Board__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Home_Board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Home_Board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_store_Site_types__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Transactions_index__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Transactions_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_Transactions_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Transactions_MyTransactions_index__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Transactions_MyTransactions_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_Transactions_MyTransactions_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Transactions_MyTransactions_Display__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Transactions_MyTransactions_Display___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_Transactions_MyTransactions_Display__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Transactions_MyTransactions_Edit__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Transactions_MyTransactions_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_Transactions_MyTransactions_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Transactions_MyTransactions_Table__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Transactions_MyTransactions_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_Transactions_MyTransactions_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Transactions_Documents__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Transactions_Documents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_Transactions_Documents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Actualities_index__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Actualities_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_Actualities_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Actualities_Actualities__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Actualities_Actualities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_Actualities_Actualities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_components_article__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_components_article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__common_components_article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_components_Legal_index__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_components_Legal_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__common_components_Legal_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_components_Legal_CGU__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_components_Legal_CGU___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__common_components_Legal_CGU__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common_components_Legal_CGV__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common_components_Legal_CGV___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__common_components_Legal_CGV__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common_components_Legal_Confidentiality__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common_components_Legal_Confidentiality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__common_components_Legal_Confidentiality__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__common_components_Legal_Legals__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__common_components_Legal_Legals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__common_components_Legal_Legals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_Demo__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_Demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_Demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Transactions_MySubscriptions_index__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Transactions_MySubscriptions_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_Transactions_MySubscriptions_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Transactions_MySubscriptions_Table__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Transactions_MySubscriptions_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__views_Transactions_MySubscriptions_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Transactions_MySubscriptions_Display__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Transactions_MySubscriptions_Display___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__views_Transactions_MySubscriptions_Display__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_Transactions_MySubscriptions_Edit__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_Transactions_MySubscriptions_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__views_Transactions_MySubscriptions_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__common_components_NotFound__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__common_components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__common_components_NotFound__);

















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var myRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_4__views_Main___default.a,
		redirect: { name: 'Home' },
		children: [{
			path: 'home',
			component: __WEBPACK_IMPORTED_MODULE_7__views_Home_index___default.a,
			children: [{
				path: '',
				name: 'Home',
				redirect: { name: 'Board' }
			}, {
				path: 'board',
				name: 'Board',
				component: __WEBPACK_IMPORTED_MODULE_18__views_Home_Board___default.a
			}, {
				path: 'activity',
				name: 'Activity',
				component: __WEBPACK_IMPORTED_MODULE_17__views_Home_Activity___default.a
			}, {
				path: 'contacts',
				component: __WEBPACK_IMPORTED_MODULE_8__views_Home_Contacts_index___default.a,
				children: [{
					path: '',
					name: 'Contacts',
					component: __WEBPACK_IMPORTED_MODULE_9__views_Home_Contacts_Table___default.a
				}, {
					path: 'client/:clientId',
					name: 'Client',
					component: __WEBPACK_IMPORTED_MODULE_10__views_Home_Contacts_Client___default.a
				}, {
					path: 'client/:clientId/patrimonial-landscape',
					name: 'PatrimonialLandscape',
					component: __WEBPACK_IMPORTED_MODULE_11__views_Home_Contacts_PatrimonialLandscape___default.a
				}, {
					path: 'client/:clientId/patrimonial-landscape-udpate',
					name: 'PatrimonialLandscapeUpdate',
					component: __WEBPACK_IMPORTED_MODULE_12__views_Home_Contacts_PatrimonialLandscapeUpdate___default.a
				}, {
					path: 'client/:clientId/chat',
					name: 'ChatClient',
					component: __WEBPACK_IMPORTED_MODULE_13__views_Home_Contacts_Chat___default.a
				}, {
					path: 'client/:clientId/investments',
					name: 'InvestmentsClient',
					component: __WEBPACK_IMPORTED_MODULE_14__views_Home_Contacts_Investments___default.a
				}, {
					path: 'client/:clientId/investments-manual',
					name: 'InvestmentsManual',
					component: __WEBPACK_IMPORTED_MODULE_16__common_components_InvestmentsManual_InvestmentsManual___default.a
				}, {
					path: 'client/:clientId/investments-manual/add',
					name: 'InvestmentsManualAdd',
					component: __WEBPACK_IMPORTED_MODULE_15__common_components_InvestmentsManual_InvestmentsManualForm___default.a
				}, {
					path: 'client/:clientId/investments-manual/:id/edit',
					name: 'InvestmentsManualForm',
					component: __WEBPACK_IMPORTED_MODULE_15__common_components_InvestmentsManual_InvestmentsManualForm___default.a
				}]
			}]
		}, {
			path: 'transactions',
			component: __WEBPACK_IMPORTED_MODULE_20__views_Transactions_index___default.a,
			children: [{
				path: '',
				name: 'Transactions',
				redirect: { name: 'Documents' }
			}, {
				path: 'my-transactions',
				redirect: { name: 'TransactionsTable' },
				component: __WEBPACK_IMPORTED_MODULE_21__views_Transactions_MyTransactions_index___default.a,
				children: [{
					name: 'TransactionsTable',
					component: __WEBPACK_IMPORTED_MODULE_24__views_Transactions_MyTransactions_Table___default.a,
					path: ''
				}, {
					name: 'MyTransactionsAdd',
					component: __WEBPACK_IMPORTED_MODULE_23__views_Transactions_MyTransactions_Edit___default.a,
					path: 'add'
				}, {
					name: 'MyTransactionDisplay',
					component: __WEBPACK_IMPORTED_MODULE_22__views_Transactions_MyTransactions_Display___default.a,
					path: ':id'
				}, {
					name: 'MyTransactionsEdit',
					component: __WEBPACK_IMPORTED_MODULE_23__views_Transactions_MyTransactions_Edit___default.a,
					path: ':id/edit'
				}]
			}, {
				path: 'documents',
				name: 'Documents',
				component: __WEBPACK_IMPORTED_MODULE_25__views_Transactions_Documents___default.a
			}, {
				path: 'my-subscriptions',
				name: 'subscriptions',
				redirect: { name: 'SubscriptionsTable' },
				component: __WEBPACK_IMPORTED_MODULE_35__views_Transactions_MySubscriptions_index___default.a,
				children: [{
					name: 'SubscriptionsTable',
					component: __WEBPACK_IMPORTED_MODULE_36__views_Transactions_MySubscriptions_Table___default.a,
					path: ''
				}, {
					name: 'MySubscriptionsAdd',
					component: __WEBPACK_IMPORTED_MODULE_38__views_Transactions_MySubscriptions_Edit___default.a,
					path: 'add'
				}, {
					name: 'MySubscriptionDisplay',
					component: __WEBPACK_IMPORTED_MODULE_37__views_Transactions_MySubscriptions_Display___default.a,
					path: ':id'
				}, {
					name: 'MySubscriptionsEdit',
					component: __WEBPACK_IMPORTED_MODULE_38__views_Transactions_MySubscriptions_Edit___default.a,
					path: ':id/edit'
				}]
			}]
		}, {
			path: 'actualities',
			component: __WEBPACK_IMPORTED_MODULE_26__views_Actualities_index___default.a,
			redirectTo: { name: 'Actualities' },
			children: [{
				path: '',
				component: __WEBPACK_IMPORTED_MODULE_27__views_Actualities_Actualities___default.a,
				name: 'Actualities'
			}, {
				path: 'article/:id',
				component: __WEBPACK_IMPORTED_MODULE_28__common_components_article___default.a,
				name: 'Article'
			}]
		}, {
			path: 'profile',
			component: __WEBPACK_IMPORTED_MODULE_5__views_Profile___default.a,
			name: 'Profile'
		}]
	}, {
		path: '/login',
		component: __WEBPACK_IMPORTED_MODULE_3__views_Login___default.a,
		name: 'Login',
		meta: {
			requiresAuth: false
		}
	}, {
		path: '/404',
		component: __WEBPACK_IMPORTED_MODULE_39__common_components_NotFound___default.a,
		name: 'NotFound'
	}, {
		path: '/reset-password',
		component: __WEBPACK_IMPORTED_MODULE_3__views_Login___default.a,
		name: 'ResetPasswordEmailAsk',
		meta: {
			requiresAuth: false
		}
	}, {
		path: '/reset-password/:token',
		component: __WEBPACK_IMPORTED_MODULE_6__views_ResetPassword___default.a,
		name: 'ResetPassword',
		meta: {
			requiresAuth: false
		}
	}, {
		component: __WEBPACK_IMPORTED_MODULE_29__common_components_Legal_index___default.a,
		path: '/legal',
		children: [{
			path: 'cgu',
			component: __WEBPACK_IMPORTED_MODULE_30__common_components_Legal_CGU___default.a,
			name: 'Cgu'
		}, {
			path: 'cgv',
			component: __WEBPACK_IMPORTED_MODULE_31__common_components_Legal_CGV___default.a,
			name: 'Cgv'
		}, {
			path: 'legals',
			component: __WEBPACK_IMPORTED_MODULE_33__common_components_Legal_Legals___default.a,
			name: 'Legals'
		}, {
			path: 'confidentiality',
			component: __WEBPACK_IMPORTED_MODULE_32__common_components_Legal_Confidentiality___default.a,
			name: 'Confidentiality'
		}]
	}, {
		path: '/demo',
		component: __WEBPACK_IMPORTED_MODULE_34__views_Demo___default.a,
		name: 'Demo'
	}]
});

myRouter.beforeEach(function (to, from, next) {
	if (to.name === 'NotFound') {
		next();
		return;
	}
	getSite().then(function () {
		if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isTokenExpired) {
			__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOGOUT');
			next({ name: 'Login' });
		} else {
			if (typeof to.meta.requiresAuth !== 'undefined' && to.meta.requiresAuth === false && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
				next({ name: 'Main' });
			} else if ((typeof to.meta.requiresAuth === 'undefined' || to.meta.requiresAuth === true) && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
				next({ name: 'Login' });
			} else {
				next();
			}
		}
	}).catch(function () {
		if (from.name !== 'NotFound') {
			next({ name: 'NotFound' });
		} else {
			next();
		}
	});
});

function getSite() {
	return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_Site_types__["a" /* GET_CURRENT_SITE */]);
}

/* harmony default export */ __webpack_exports__["a"] = (myRouter);

/***/ }),
/* 431 */,
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(813)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(882)
__webpack_require__(881)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1152),
  /* scopeId */
  "data-v-7a0c4999",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(811)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1075),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_loader__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_loader__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		loader: __WEBPACK_IMPORTED_MODULE_0__common_components_loader___default.a
	},
	mounted: function mounted() {
		console.log('[Patrimoffice] v1.3.0');
	},

	watch: {
		$route: function $route(to, from) {
			this.$ga.page(to.fullPath);
		}
	}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RgpdCompany',
  methods: {
    close: function close() {
      this.$emit('close');
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'custom-multiselect',
	props: ['list', 'values', 'solo', 'object', 'getter'],
	data: function data() {
		return {
			selected: [],
			show: false
		};
	},
	mounted: function mounted() {
		if (this.values) {
			this.selected = this.values;
		}
	},

	methods: {
		isSelected: function isSelected(key) {
			return this.selected.indexOf(this.list[key]) !== -1;
		},
		setSelect: function setSelect(key) {
			if (this.selected.indexOf(this.list[key]) !== -1) {
				this.selected.splice(this.selected.indexOf(this.list[key]), 1);
			} else {
				this.selected.push(this.list[key]);
			}
			this.$emit('change', this.selected);
		},
		display: function display() {
			var _this = this;

			this.show = !this.show;
			if (this.show) {
				window.setTimeout(function () {
					window.addEventListener('click', _this.checkClick);
				}, 10);
			}
		},
		checkClick: function checkClick(e) {
			this.show = !this.show;
			window.removeEventListener('click', this.checkClick);
		},
		remove: function remove(e) {
			this.selected.splice(e, 1);
		},
		displayItem: function displayItem(item) {
			if (this.object) {
				return item[this.getter];
			} else {
				return item;
			}
		}
	},
	watch: {
		values: function values(data) {
			if (data) {
				this.selected = data;
			}
		}
	}
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'custom-select',
	props: ['value', 'items', 'selected', 'solo', 'object', 'getter', 'debug'],
	data: function data() {
		return {
			select: null,
			show: false,
			key: null
		};
	},
	mounted: function mounted() {
		if (this.object) {
			this.key = this.getter || 'type';
		}
		if (this.selected) {
			this.select = this.selected;
		} else {
			this.select = this.value || null;
		}

		if (this.debug) {
			console.log('test', this.items);
		}
	},

	methods: {
		setSelect: function setSelect(key) {
			this.select = this.items[key];
			this.show = false;
			this.$emit('change', this.items[key]);
			this.$emit('input', this.items[key]);
		},
		display: function display() {
			this.show = !this.show;
			if (this.show) {
				window.addEventListener('click', this.checkClick);
			}
		},
		checkClick: function checkClick(e) {
			this.show = false;
			window.removeEventListener('click', this.checkClick);
		},
		displayValue: function displayValue(item) {
			if (item) {
				if (this.object) {
					var splitKey = this.key.split('.');
					if (splitKey.length === 1) {
						return item[this.key];
					} else {
						return item[splitKey[0]][splitKey[1]];
					}
				} else {
					return item;
				}
			} else {
				return '-';
			}
		}
	},
	watch: {
		selected: function selected(value) {
			this.select = value;
		},
		value: function value(_value) {
			this.select = _value;
		}
	}
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'custom-select-user',
	props: ['value', 'items', 'disabled'],
	data: function data() {
		return {
			select: null,
			show: false,
			innerDisabled: false
		};
	},
	mounted: function mounted() {
		this.select = this.items[0];
		if (this.value) {
			this.select = this.value || this.items[0];
		}
		this.$emit('input', this.select);
		this.innerDisabled = this.disabled;
	},

	methods: {
		setSelect: function setSelect(key) {
			this.select = this.items[key];
			this.show = false;
			this.$emit('input', this.select);
		},
		display: function display() {
			if (!this.innerDisabled) {
				this.show = !this.show;
				if (this.show) {
					window.addEventListener('click', this.checkClick);
				}
			}
		},
		checkClick: function checkClick(e) {
			this.show = false;
			window.removeEventListener('click', this.checkClick);
		},
		getPicture: function getPicture(client) {
			if (client) {
				return client.media && client.media.file ? "https://api-preprod.patrimoffice.com/api/pictures/" + client.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
			} else {
				return null;
			}
		}
	},
	watch: {
		items: function items() {
			if (!this.select) this.select = this.items[0];this.$emit('input', this.select);
		},
		value: function value() {
			this.select = this.value;
		},
		disabled: function disabled() {
			if (this.disabled) {
				this.innerDisabled = true;
			}
		}
	}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'custom-toggle',
	props: ['value', 'values'],
	data: function data() {
		return {
			toggle: false,
			list: ['Oui', 'Non'],
			bool: true
		};
	},
	mounted: function mounted() {
		this.toggle = this.value;
		this.list = this.values || this.list;
		this.bool = this.list !== this.values;
		if (this.bool) {
			this.toggle = this.toggle ? 'Oui' : 'Non';
		}
	},

	methods: {
		setToggle: function setToggle(value) {
			if (this.bool) {
				this.$emit('change', value === 'Oui');
				this.$emit('input', value === 'Oui');
			} else {
				this.$emit('change', value);
				this.$emit('input', value);
			}
			this.toggle = value;
		},
		isActive: function isActive(value) {
			return this.toggle === value;
		}
	},
	watch: {
		value: function value(foo) {
			this.toggle = foo;
			if (this.bool) {
				this.toggle = this.toggle ? 'Oui' : 'Non';
			}
		}
	}
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_img_icon_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_img_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_assets_img_icon_svg__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'drag-and-drop',
	props: ['value'],
	data: function data() {
		return {
			isDragging: false,
			file: null,
			baseFile: __WEBPACK_IMPORTED_MODULE_1__common_assets_img_icon_svg___default.a
		};
	},
	mounted: function mounted() {
		window.addEventListener('dragover', this.drag);
		window.addEventListener('dragleave', this.undrag);
		window.addEventListener('drop', this.drop);
	},

	filters: {
		uppercase: function uppercase(value) {
			return value.split('.')[value.split('.').length - 1].toUpperCase();
		}
	},
	methods: {
		drop: function drop(e) {
			var _this = this;

			e.preventDefault();
			this.isDragging = false;
			var droppedFiles = e.dataTransfer.items || e.dataTransfer.files;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(droppedFiles).forEach(function (key) {
				_this.file = droppedFiles[key].getAsFile();
				_this.$emit('input', _this.file);
			});
		},
		drag: function drag(e) {
			e.preventDefault();
			this.isDragging = true;
		},
		undrag: function undrag(e) {
			e.preventDefault();
			this.isDragging = false;
		},
		fileInput: function fileInput() {
			this.$refs.master.lastChild.click();
		},
		setFile: function setFile(e) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).forEach(function (key) {
				_this2.file = e.target.files[key];
				_this2.$emit('input', _this2.file);
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('dragover', this.drag);
		window.removeEventListener('dragleave', this.undrag);
		window.removeEventListener('drop', this.drop);
	}
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'input-date',
	props: ['value'],
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			day: 0,
			days: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(31), function (d, i) {
				return i + 1;
			}),
			month: null,
			months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			year: null,
			years: [],
			dayForMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
		};
	},
	mounted: function mounted() {
		this.years = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(this.value.getFullYear() - 1999), function (d, i) {
			return 2000 + i;
		}).reverse();
		this.year = this.value.getFullYear();
		this.day = this.value.getDate();
		this.month = this.months[this.value.getMonth()];
	},

	methods: {
		setDays: function setDays() {
			var key = this.months.indexOf(this.month);
			var nbOfDay = this.dayForMonth[key];
			if (key === 1) {
				var year = this.year;
				var common = true;
				if (year % 4 === 0) {
					common = false;
					if (year % 100 === 0) {
						common = true;
						if (year % 400 === 0) {
							common = false;
						}
					}
				}

				nbOfDay = common ? 28 : 29;
			}

			this.days = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(nbOfDay), function (d, i) {
				return i + 1;
			});
			if (this.days.indexOf(this.day) === -1) this.day = this.days[this.days.length - 1];

			var month = this.months.indexOf(this.month) + 1;

			if (month < 10) {
				month = '0' + month;
			}

			var date = this.$moment(this.day + '/' + month + '/' + this.year, 'DD/MM/YYYY').toDate();

			this.$emit('change', date);
			this.$emit('input', date);
		}
	},
	watch: {
		month: function month() {
			this.setDays();
		},
		year: function year() {
			this.setDays();
		},
		day: function day() {
			this.setDays();
		}
	}
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'radio-box',
	props: {
		value: null,
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			val: false
		};
	},
	mounted: function mounted() {
		this.val = this.value;
	},

	watch: {
		value: function value() {
			this.val = this.value;
		}
	},
	methods: {
		change: function change() {
			if (this.disabled) {
				return;
			}

			this.val = !this.val;
			this.$emit('change', this.val);
			this.$emit('input', this.val);
		}
	}
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TextInput',
	props: {
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		rules: {
			type: [Object, String],
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		error: {
			type: String,
			default: ''
		},
		notLabel: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text',
			validator: function validator(value) {
				return ['url', 'text', 'password', 'tel', 'search', 'number', 'email', 'date'].includes(value);
			}
		},
		value: {
			type: null,
			default: ''
		}
	},
	data: function data() {
		return {
			innerValue: '',
			hasFocus: false
		};
	},
	computed: {
		hasValue: function hasValue() {
			return !!this.innerValue;
		}
	},
	watch: {
		innerValue: function innerValue(value) {
			if (value && !this.hasFocus) {
				this.$refs.input.focus();
				this.hasFocus = true;
			}

			this.$emit('input', value);
		},
		value: function value(val) {
			if (val !== this.innerValue) {
				this.innerValue = val;
			}
		}
	},
	created: function created() {
		if (this.value) {
			this.innerValue = this.value;
		}
	}
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_notif_bar__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_notif_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_notif_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_high_icon_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_high_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_img_high_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_down_icon_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_down_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_img_down_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_performance_stat__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_performance_stat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_components_performance_stat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_progress_bar_half_circle__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_progress_bar_half_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_components_progress_bar_half_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_section_table__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_section_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_components_section_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils_currency_helper__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mapbox_vue__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mapbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__mapbox_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		PerformanceStat: __WEBPACK_IMPORTED_MODULE_5__common_components_performance_stat___default.a,
		NotifBar: __WEBPACK_IMPORTED_MODULE_1__common_components_notif_bar___default.a,
		ProgressBarHalfCircle: __WEBPACK_IMPORTED_MODULE_6__common_components_progress_bar_half_circle___default.a,
		SectionTable: __WEBPACK_IMPORTED_MODULE_7__common_components_section_table___default.a,
		mapbox: __WEBPACK_IMPORTED_MODULE_9__mapbox_vue___default.a
	},
	filters: {
		format_currency: function format_currency(value, symbol) {
			return value ? value.toLocaleString() + ' ' + symbol : '';
		}
	},
	props: {
		investmentStats: {
			type: null,
			default: null
		}
	},
	data: function data() {
		return {
			good: __WEBPACK_IMPORTED_MODULE_2__common_assets_img_high_icon_svg___default.a,
			bad: __WEBPACK_IMPORTED_MODULE_3__common_assets_img_down_icon_svg___default.a,
			hidePerformance: false,
			mapboxToken: 'pk.eyJ1Ijoia2V2aW4tdCIsImEiOiJja2tlNHRkbmIwaGt3MnZueXc0ODhwdm1pIn0.RP7CZNTK2HeqQrpTie5uDQ',
			mapCenter: [2.3522, 48.8566],
			mapMarkers: [{
				lng: 2.3522,
				lat: 48.8566,
				popup: "<strong>Assurance Vie Cardif Elite</strong><br>Montant Total : 280 000€ </br><span class='text-green'>Perf : +14%</span>"
			}, {
				lng: -74.006,
				lat: 40.7128,
				popup: "<strong>Plan Epargne Retraite Cardif Elite Retraite</strong><br>Montant Total : 36 852€ </br><span class='text-green'>Perf : +27%</span>"
			}],
			globalPerf: [{
				key: 'since_registration_perf',
				title: 'Depuis la création du compte',
				value: '0 €',
				prog: 0
			}, {
				key: 'subscription_year_perf',
				title: 'Performance sur l’année d’abonnement en cours',
				value: '0 €',
				prog: 0
			}, {
				key: 'sum_net_income_distributed',
				title: 'Mes revenus perçus depuis que je suis client',
				value: '0 €',
				prog: 0
			}],
			arrayData: [{
				name: 'Global',
				key: 'global',
				color: '#3F51B5'
			}, {
				name: 'Financier',
				key: 'financial',
				color: '#FF4052',
				value: null,
				valueFormatted: null
			}, {
				name: 'Tangible',
				key: 'tangible',
				color: '#BB9267',
				value: null,
				valueFormatted: null
			}, {
				name: 'International',
				key: 'international',
				color: '#412B1B',
				value: null,
				valueFormatted: null
			}],
			arrayDataGlobal: {},
			selected: 0,
			distributionColumnDefs: null,
			distributionRowData: null,
			distributionTableOption: {
				headerHeight: 30,
				rowHeight: 50,
				localeText: {
					noRowsToShow: 'Pas de donnée pour le moment.'
				}
			}
		};
	},
	beforeMount: function beforeMount() {
		this.distributionColumnDefs = [{
			name: 'Produit',
			field: 'name',
			width: 340,
			cellRenderer: this.distributionNameCellRenderer
		}, { name: 'Montant versé net', field: 'subscription_amount', width: 160 }, { name: 'Montant actuel', field: 'value', width: 140 }, {
			name: 'Perf %',
			field: 'perf',
			width: 80,
			cellRenderer: this.distributionPerfCellRenderer
		}, { name: 'Poids', field: 'weight', width: 80 }, { name: 'Numéro de contrat', field: 'contract_number', width: 170 }, {
			name: 'Date de souscription',
			field: 'contract_subscription_date',
			width: 170
		}, { name: 'Type', field: 'contract_type', width: 130 }, {
			name: 'Revenu net distribué',
			field: 'net_income_distributed',
			width: 180
		}, { name: 'Parts', field: 'parts', width: 100 }, { name: 'Prix de la part', field: 'share_value', width: 230 }];
	},
	mounted: function mounted() {
		this.initializeArrayData();
		this.initializeDistributionRowData();
		this.initializeGlobalPerf();
	},

	methods: {
		formatCurrency: function formatCurrency(number) {
			var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (symbol) {
				return __WEBPACK_IMPORTED_MODULE_8__common_utils_currency_helper__["a" /* default */].formatCurrency(number, symbol);
			}

			return __WEBPACK_IMPORTED_MODULE_8__common_utils_currency_helper__["a" /* default */].formatCurrency(number, '€');
		},
		initializeGlobalPerf: function initializeGlobalPerf() {
			if (!this.investmentStats || Array.isArray(this.investmentStats)) {
				return;
			}

			this.hidePerformance = Boolean(this.investmentStats.hide_performance);

			for (var index in this.globalPerf) {
				var key = this.globalPerf[index].key;
				var stat = this.investmentStats[key];

				this.globalPerf[index].value = this.getCurrencyWithSymbol(stat && typeof stat.value !== 'undefined' ? stat.value : stat, '€');
				this.globalPerf[index].prog = stat && typeof stat.perf !== 'undefined' ? stat.perf : undefined;

				if (this.globalPerf[index].key === 'since_registration_perf' && typeof this.investmentStats['subscription_effect_date'] !== 'undefined' && this.investmentStats['subscription_effect_date']) {
					this.globalPerf[index].title += ' (' + this.$moment(this.investmentStats['subscription_effect_date'], 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') + ')';
				}

				if (this.globalPerf[index].key === 'sum_net_income_distributed') {
					this.globalPerf[index].prog = this.investmentStats.sum_net_income_distributed;
				}
			}
		},
		initializeDistributionRowData: function initializeDistributionRowData() {
			var _this = this;

			var rowData = [];
			for (var index in this.investmentStats.distributions) {
				var info = this.investmentStats.distributions[index];
				console.log('info', info);
				var data = {
					name: info.product_name,
					parts: info.contract_part_number,
					subscription_amount: this.formatCurrency(info.subscription_amount, info.contract_part_currency),
					subscription_price: this.formatCurrency(info.contract_subscription_value, info.contract_part_currency),
					net_amount_distributed: this.formatCurrency(info.net_amount_distributed, info.contract_part_currency),
					share_value: this.formatCurrency(info.contract_part_value, info.contract_part_currency),
					value: this.formatCurrency(info.contract_part_value * info.contract_part_number, info.contract_part_currency),
					weight: info.contract_part_weight + '%',
					perf: this.format_performance(info.perf) + '%',
					type: info.mission_type,
					contract_type: info.contract_type,
					net_income_distributed: this.formatCurrency(info.net_income_distributed, info.contract_part_currency),
					contract_number: info.contract_number,
					contract_subscription_date: info.contract_subscription_date
				};
				var dataFormatted = {
					data: data,
					childrenColumn: [{ name: 'Support', field: 'support_name', width: 280 }, { name: 'ISIN', field: 'isin', width: 150 }, { name: 'Parts', field: 'shares', width: 100 }, { name: 'Date de cours', field: 'course_date', width: 150 }, {
						name: 'Prix moyen acquis',
						field: 'average_price_acquired',
						width: 180
					}, { name: 'Prix de la part', field: 'share_value', width: 180 }, {
						name: 'Épargne constituée',
						field: 'incorporated_savings',
						width: 180
					}, { name: 'Perf %', field: 'perf', width: 80 }],
					childrenRows: typeof info.supports !== 'undefined' ? info.supports.map(function (support) {
						var supportData = {
							support_name: support.support_name,
							shares: support.shares,
							average_price_acquired: _this.getCurrencyWithSymbol(support.average_price_acquired, '€'),
							incorporated_savings: _this.getCurrencyWithSymbol(support.incorporated_savings, '€'),
							course_date: support.course_date,
							share_value: _this.getCurrencyWithSymbol(support.share_value, '€'),
							perf: _this.format_performance(support.perf) + '%',
							isin: support.isin
						};

						if (support.support_name.toLowerCase() === 'fonds general') {
							supportData.shares = '';
							supportData.perf = '';
						}
						return supportData;
					}) : [],
					deploy: false
				};
				rowData.push(dataFormatted);
			}

			this.distributionRowData = rowData;
		},
		format_performance: function format_performance(value) {
			if (!value) {
				return '0';
			}

			if (value === 0) {
				return value.toLocaleString();
			}

			return value > 0 ? '+' + value.toLocaleString() : value.toLocaleString();
		},
		getCurrencyWithSymbol: function getCurrencyWithSymbol(value, currencyType) {
			return value ? value.toLocaleString() + ' ' + currencyType : '';
		},
		initializeArrayData: function initializeArrayData() {
			var _this2 = this;

			this.arrayDataGlobal = this.arrayData.filter(function (elem) {
				return elem.name === 'Global';
			})[0];
			var arrayData = [];
			arrayData.push(this.arrayDataGlobal);

			var _loop = function _loop(index) {
				var category = _this2.investmentStats.categories[index];
				var data = _this2.arrayData.find(function (elem) {
					return elem.name === index;
				});

				if (!data) {
					return 'continue';
				}

				data.value = category.percent + '%';
				data.valueFormatted = category.percent.toLocaleString() + '%';

				arrayData.push(data);
			};

			for (var index in this.investmentStats.categories) {
				var _ret = _loop(index);

				if (_ret === 'continue') continue;
			}

			this.arrayData = arrayData;
		},

		getWithoutGlobalData: function getWithoutGlobalData(value) {
			return value.filter(function (elem) {
				return elem.name !== 'Global';
			});
		},
		selectTag: function selectTag(key) {
			this.selected = key;
		},
		isSelected: function isSelected(key) {
			return this.selected === key;
		},
		distributionPerfCellRenderer: function distributionPerfCellRenderer(params) {
			return '<span class="' + (params.value[0] === '-' ? 'text-red' : 'text-green') + '">' + params.value + '</span>';
		},
		distributionNameCellRenderer: function distributionNameCellRenderer(params) {
			return '<span>' + params.value + '</span>';
		},
		onMapLoaded: function onMapLoaded(map) {
			console.log('Mapbox loaded', map);
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		isEstate: 'isEstate',
		user: 'user'
	}), {
		distributionRowDataFiltered: function distributionRowDataFiltered() {
			var dataTypeSelected = this.arrayData[this.selected].name;

			if (dataTypeSelected === 'Global') {
				return this.distributionRowData;
			}

			return this.distributionRowData.filter(function (element) {
				return element.data.type === dataTypeSelected;
			});
		},
		distributionRowDataFilteredSliced: function distributionRowDataFilteredSliced() {
			var data = this.distributionRowDataFiltered;

			return data ? data.slice(0, 3) : data;
		},
		distributionColumnDefsFiltered: function distributionColumnDefsFiltered() {
			var dataTypeSelected = this.arrayData[this.selected].name;
			if (dataTypeSelected === 'Financier') {
				return this.distributionColumnDefs.filter(function (element) {
					return !['parts', 'share_value'].includes(element.field);
				});
			}

			if (dataTypeSelected === 'Global') {
				return this.distributionColumnDefs.filter(function (element) {
					return !['parts', 'share_value'].includes(element.field);
				});
			}

			if (dataTypeSelected === 'Tangible') {
				return this.distributionColumnDefs.filter(function (element) {
					return !['subscription_price'].includes(element.field);
				});
			}
			return this.distributionColumnDefs;
		},
		globalPerfComputed: function globalPerfComputed() {
			if (!this.hidePerformance) {
				return this.globalPerf;
			} else {
				return [this.globalPerf[2]];
			}
		}
	})
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_Form_TextInput__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_Form_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_Form_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditMain',
	components: {
		TextInput: __WEBPACK_IMPORTED_MODULE_0__common_components_Form_TextInput___default.a,
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a
	},
	props: {
		investmentProduct: {
			type: Object
		},
		clientId: {
			type: Number
		},
		kind: {
			type: String,
			default: 'cgpi'
		}
	},
	data: function data() {
		return {
			submitted: false,
			currencyList: __WEBPACK_IMPORTED_MODULE_1__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			contractTypes: ['Nue propriété', 'Pleine propriété'],
			productTypes: ['Financier', 'Tangible', 'International']
		};
	},
	mounted: function mounted() {},

	methods: {
		onSubmit: function onSubmit() {
			this.submitted = true;

			if (this.investmentProduct.id && this.investmentProduct.id > 0) {
				this.updateInvestmentProduct();
			} else {
				this.addInvestmentProduct();
			}
		},
		updateInvestmentProduct: function updateInvestmentProduct() {
			var _this = this;

			this.$store.dispatch('setInvestmentProduct', this.investmentProduct).then(function (result) {
				_this.$notify({
					type: 'success',
					group: 'default',
					title: 'Produit modifié',
					text: 'Le produit a bien été modifié !'
				});

				if (_this.isCgpi) {
					_this.$router.push({ name: 'InvestmentsManual', params: { id: _this.clientId.toString() } });
				} else {
					_this.$router.push({ name: 'InvestmentsManual', params: { kind: 'client' } });
				}
			}).catch(function (e) {
				_this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			}).finally(function () {
				_this.submitted = false;
			});
		},
		addInvestmentProduct: function addInvestmentProduct() {
			var _this2 = this;

			var clientId = void 0;
			if (!this.isCgpi) clientId = this.$store.getters['user'].id;else clientId = this.clientId;

			this.$store.dispatch('addInvestmentProduct', { clientId: clientId, investmentProduct: this.investmentProduct }).then(function (result) {
				_this2.$notify({
					type: 'success',
					group: 'default',
					title: 'Produit ajouté',
					text: 'Le produit a bien été ajouté !'
				});

				if (_this2.isCgpi) _this2.$router.push({ name: 'InvestmentsManual', params: { id: clientId } });else _this2.$router.push({ name: 'InvestmentsManual', params: { kind: 'client' } });
			}).catch(function (e) {
				_this2.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			}).finally(function () {
				_this2.submitted = false;
			});
		}
	},
	computed: {
		isFormValidated: function isFormValidated() {
			return true;
		},
		isFormLoading: function isFormLoading() {
			return this.submitted;
		},
		isCgpi: function isCgpi() {
			return this.kind === 'cgpi';
		}
	},
	watch: {
		'investmentProduct.share_price': function investmentProductShare_price(value) {
			if (value) {
				this.$refs.share_price.focus();
			}
		},
		'investmentProduct.subscription_price': function investmentProductSubscription_price(value) {
			if (value) {
				this.$refs.subscription_price.focus();
			}
		}
	}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_section_table__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_section_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_section_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'InvestmentsManual',
	components: { SectionTable: __WEBPACK_IMPORTED_MODULE_1__common_components_section_table___default.a },
	props: {
		kind: { type: String, default: 'cgpi' }
	},
	data: function data() {
		return {
			client: null,
			hover: false,
			cols: [{ name: 'Produit', field: 'name', width: 340 }, { name: 'Type de produit', field: 'product_type', width: 230 }, { name: 'Numéro de contrat', field: 'contract_number', width: 250 }, { name: 'Type de contrat', field: 'contract_type', width: 230 }, this.isCgpi ? { name: 'Source', field: 'source', width: 230 } : {}, { name: 'Mise à jour', field: 'updated_at', width: 230 }, {
				name: 'Actions',
				field: 'actions',
				width: 130,
				actions: [{
					name: 'edit',
					icon: 'icon-file-edit'
				}, {
					name: 'delete',
					icon: 'icon-file-trash'
				}]
			}],
			options: {},
			rows: []
		};
	},
	created: function created() {
		this.client = this.$store.getters.getClient(this.$route.params.clientId);
	},
	mounted: function mounted() {
		this.initializeClientProducts();
	},

	methods: {
		initializeClientProducts: function initializeClientProducts() {
			var _this = this;

			var clientId = void 0;

			clientId = this.$route.params.clientId;

			this.$store.dispatch('getClientInvestmentProducts', clientId).then(function () {
				_this.rows = [];

				for (var index in _this.investmentProducts) {
					var product = _this.investmentProducts[index];
					_this.initializeProductInRows(product);
				}
			});
		},
		initializeProductInRows: function initializeProductInRows(product) {
			this.rows.push({
				data: {
					id: product.id,
					name: product.product_name,
					product_type: product.product_type,
					contract_type: product.contract_type,
					net_income_distributed: this.getCurrencyWithSymbol(product.net_income_distributed, '€'),
					contract_number: product.contract_number,
					updated_at: product.updated_at,
					source: product.source_label
				}
			});
		},
		getCurrencyWithSymbol: function getCurrencyWithSymbol(value, currencyType) {
			return value ? value.toLocaleString() + ' ' + currencyType : '';
		},
		onActionItemClicked: function onActionItemClicked(_ref) {
			var row = _ref.row,
			    action = _ref.action;

			if (action.name === 'edit') {
				this.$router.push({ name: 'InvestmentsManualForm', params: { clientId: this.isCgpi ? this.$route.params.clientId : null, id: row.data.id, kind: this.kind } });
			} else if (action.name === 'delete') {
				this.deleteProductWithConfirmation(row.data);
			}
		},
		deleteProductWithConfirmation: function deleteProductWithConfirmation(product) {
			var _this2 = this;

			this.$swal.fire({
				title: 'Etes-vous sûr ?',
				text: 'Le produit "' + product.name + '" sera supprim\xE9.',
				icon: 'warning',
				confirmButtonColor: '#ff4052',
				showCancelButton: true,
				confirmButtonText: 'confirmer',
				cancelButtonText: 'Annuler'
			}).then(function (result) {
				if (result.value) {
					_this2.deleteProduct(product);
					_this2.initializeClientProducts();
				}
			});
		},
		deleteProduct: function deleteProduct(product) {
			var _this3 = this;

			this.$store.dispatch('deleteInvestmentProducts', product.id).then(function () {
				_this3.$notify({
					type: 'success',
					group: 'default',
					title: 'Produit supprimé',
					text: 'Le produit a bien été supprimé !'
				});
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		investmentProducts: 'investmentProducts'
	}), {
		isCgpi: function isCgpi() {
			return this.kind === 'cgpi';
		}
	})
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditForm_Main__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditForm_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EditForm_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'InvestmentsManualForm',
	components: {
		EditMain: __WEBPACK_IMPORTED_MODULE_0__EditForm_Main___default.a
	},
	props: {
		kind: { type: String, default: 'cgpi' }
	},
	data: function data() {
		return {
			client: null,
			investmentProduct: {}
		};
	},
	created: function created() {
		if (this.isCgpi) {
			this.client = this.$store.getters.getClient(this.$route.params.clientId);
		}
	},
	mounted: function mounted() {
		this.initializeInvestmentProduct();
	},


	methods: {
		initializeInvestmentProduct: function initializeInvestmentProduct() {
			var _this = this;

			if (!this.$route.params.id) {
				return;
			}

			this.$store.dispatch('getInvestmentProduct', this.$route.params.id).then(function (result) {
				_this.investmentProduct = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(result);
				_this.investmentProduct.subscription_date = _this.$moment(_this.investmentProduct.subscription_date, 'DD/MM/YYYY h:mm').format('YYYY-MM-DD');
			}).catch(function () {
				_this.$router.push({ name: '404' });
			});
		}
	},
	computed: {
		isCgpi: function isCgpi() {
			return this.kind === 'cgpi';
		}
	}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_header__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_footer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Logo_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Logo_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Legal',
	components: {
		myHeader: __WEBPACK_IMPORTED_MODULE_1__common_components_header___default.a,
		Logo: __WEBPACK_IMPORTED_MODULE_4__common_components_Logo_vue___default.a,
		myFooter: __WEBPACK_IMPORTED_MODULE_2__common_components_footer___default.a
	},
	data: function data() {
		return {
			logo: __WEBPACK_IMPORTED_MODULE_4__common_components_Logo_vue___default.a
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
		isUser: 'isAuthenticated',
		user: 'user'
	}), {
		menu: function menu() {
			if (this.user.role === 'ADVISOR') {
				return [{
					key: 0,
					name: '<span class="icon-nav-admin-stat"></span> Accueil',
					uri: 'Home'
				}, {
					key: 1,
					name: '<span class="icon-nav-operation"></span> Opérations',
					uri: 'Transactions'
				}, {
					key: 2,
					name: '<span class="icon-nav-actu"></span> Actualités',
					uri: 'Actualities'
				}];
			} else {
				return [{
					key: 0,
					name: '<span class="icon-nav-actu"></span> Actualités',
					uri: 'IndexActualities'
				}, {
					key: 2,
					name: '<span class="icon-nav-conseiller"></span> Conseiller',
					uri: 'Advisor'
				}, {
					key: 3,
					name: '<span class="icon-nav-docs"></span> Mes documents',
					uri: 'Documents'
				}];
			}
		}
	})
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_logo_patrim_svg__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_logo_patrim_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_img_logo_patrim_svg__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'logo',
	data: function data() {
		return {
			defaultLogo: __WEBPACK_IMPORTED_MODULE_2__common_assets_img_logo_patrim_svg___default.a
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		theme: 'currentTheme'
	}), {
		logo: function logo() {
			if (this.theme && this.theme.logo) {
				return "https://api-preprod.patrimoffice.com/" + 'api/office-asset/' + this.theme.logo.file;
			}
			return this.defaultLogo;
		}
	})
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'newMessage',
	props: ['data'],
	data: function data() {
		return {
			message: null
		};
	},
	mounted: function mounted() {
		console.log('Data New Message : ', this.data);
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		send: function send() {
			var _this = this;

			this.$validator.validate().then(function (validation) {
				if (validation) {
					_this.$store.dispatch('newMessage', {
						request: {
							title: null,
							body: _this.message,
							thread_id: _this.data.request.threadId,
							user_id: _this.data.request.userId
						},
						side: {
							id: _this.user.id,
							first_name: _this.user.firstname,
							last_name: _this.user.lastname
						}
					}).then(function () {
						_this.$emit('close');
					}).catch(function (error) {
						console.warn(error);
					});
				}
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'newMessage',
	props: ['data'],
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			title: null,
			body: null
		};
	},
	mounted: function mounted() {
		console.log(this.data);
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		send: function send() {
			var _this = this;

			this.$store.dispatch('newThread', {
				request: {
					title: this.title,
					body: this.body,
					user_id: this.data.id
				},
				user: {
					id: this.user.id,
					first_name: this.user.firstname,
					last_name: this.user.lastname
				}
			}).then(function () {
				_this.close();
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_services_ResolveDate__ = __webpack_require__(115);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ModalTakeAppointment',
	props: ['data'],
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a,
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a
	},
	data: function data() {
		return {
			typesOfAppointment: ['Visio Call', 'Appel Téléphonique', 'Rendez-vous physique'],
			typeOfAppointment: null,
			beginDate: null,
			beginHour: null,
			endDate: null,
			endHour: null,
			note: null,
			myuser: null,
			hoursPossible: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(24).keys())).map(function (item) {
				return ('00' + item).slice(-2);
			}),
			needSelectClient: false
		};
	},
	mounted: function mounted() {
		var rdv = this.data && this.data.rdv ? this.data.rdv : null;
		var client = this.data && !this.data.rdv ? this.data : null;

		if (rdv) {
			var typeMap = {
				'Rendez-vous': 'Rendez-vous physique',
				'Appel téléphonique': 'Appel Téléphonique',
				'Appel Téléphonique': 'Appel Téléphonique',
				'Visio Call': 'Visio Call'
			};
			this.typeOfAppointment = typeMap[rdv.type] || rdv.type;
			this.beginDate = this.$moment(rdv.hour.start).format('YYYY-MM-DD');
			this.beginHour = this.$moment(rdv.hour.start).format('HH');
			this.endDate = this.$moment(rdv.hour.end).format('YYYY-MM-DD');
			this.endHour = this.$moment(rdv.hour.end).format('HH');
			this.note = rdv.description || null;
			this.myuser = { id: rdv.clientId };
		} else if (client) {
			this.myuser = client;
		} else {
			this.needSelectClient = true;
		}
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		send: function send() {
			var _this = this;

			this.$validator.validate().then(function (validation) {
				if (validation) {
					var payload = {
						user_id: _this.myuser.id,
						advisor_id: _this.user.id,
						start_date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_services_ResolveDate__["a" /* resolveDate */])(_this.beginDate),
						end_date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_services_ResolveDate__["a" /* resolveDate */])(_this.endDate),
						start_time: _this.beginHour + ':00',
						end_time: _this.endHour + ':00',
						description: _this.note,
						type: _this.typeOfAppointment === 'Rendez-vous physique' ? 'Rendez-vous' : _this.typeOfAppointment
					};

					var rdv = _this.data && _this.data.rdv ? _this.data.rdv : null;
					var action = rdv ? _this.$store.dispatch('updateAppointment', { id: rdv.id, data: payload }) : _this.$store.dispatch('createAppointment', payload);

					action.then(function () {
						_this.$notify({
							type: 'success',
							group: 'default',
							title: rdv ? 'Rendez-vous modifié avec succès.' : 'Votre prise de rendez-vous a bien été enregistrée.',
							text: ''
						});
						_this.close();
					}).catch(function () {
						_this.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Veuillez vérifier les informations que vous avez renseignées'
						});
					});
				}
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		user: 'user',
		clients: 'getClients'
	}), {
		computedToday: function computedToday() {
			var d = new Date();
			return d.getFullYear() + '-' + ('00' + (d.getMonth() + 1)).slice(-2) + '-' + ('00' + (d.getDate() - 1)).slice(-2);
		}
	})
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AnnualRecipe',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			directIncome: { val: null, cur: 'EUR' },
			secondIncome: { val: null, cur: 'EUR' },
			currencies: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */]
		};
	},
	mounted: function mounted() {
		this.directIncome.val = this.estate.directIncome.val !== null ? this.estate.directIncome.val : null;
		this.directIncome.cur = this.estate.directIncome.cur !== null ? this.estate.directIncome.cur : null;
		this.secondIncome.val = this.estate.secondIncome.val !== null ? this.estate.secondIncome.val : null;
		this.secondIncome.cur = this.estate.secondIncome.cur !== null ? this.estate.secondIncome.cur : null;
	},

	methods: {
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.validate().then(function (validation) {
					if (validation) {
						_this.$store.dispatch('storePatrimonial', {
							name: 'ANNUAL_RECIPE',
							data: {
								directIncome: _this.directIncome,
								secondIncome: _this.secondIncome
							},
							fromStart: false
						}).then(function (result) {
							resolve(true);
						});
					}
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Loans__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);











var Loan = function Loan(type) {
	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Loan);

	this.type = type;
	this.value = null;
	this.monthlyPayment = null;
	this.currency = 'EUR';
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Credits',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle___default.a
	},
	data: function data() {
		return {
			currencies: __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			typeOfLoan: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Loans__["a" /* default */],
			isCredits: false,
			overallDebtPercentage: null,
			currentLoanType: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Loans__["a" /* default */][0],
			loans: []
		};
	},

	methods: {
		initializeCredits: function initializeCredits() {
			this.loans = this.$iRobot.arrayClone(this.estate.credits);
			this.isCredits = this.loans.length > 0;
		},
		addLoan: function addLoan() {
			this.loans = this.loans.concat(new Loan(this.currentLoanType));
		},
		removeLoan: function removeLoan(key) {
			this.loans.splice(key, 1);
		},
		validate: function validate() {
			return this.$validator.validate();
		},
		refreshDataSaved: function refreshDataSaved() {
			var _this = this;

			setTimeout(function () {
				_this.initializeCredits();
			}, 10000);
		},
		save: function save() {
			var _this2 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.validate().then(function (validation) {
					if (validation) {
						_this2.$store.dispatch('storePatrimonial', {
							name: 'CREDITS',
							data: {
								loans: _this2.loans,
								overallDebtPercentage: _this2.overallDebtPercentage
							},
							fromStart: false
						}).then(function () {
							resolve();
							_this2.refreshDataSaved();
						});
					}
				});
			});
		}
	},
	mounted: function mounted() {
		this.overallDebtPercentage = this.estate.overallDebtPercentage;
		console.log('estate', this.estate);
		this.initializeCredits();
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_LegalEstate__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_LegalEstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_LegalEstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_Rgpd__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_Rgpd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modal_Rgpd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'display',
	data: function data() {
		return {
			PERPcomputed: '',
			displayLegalEstate: false,
			displayRgpdModal: false,
			contentModalLegalEstate: __WEBPACK_IMPORTED_MODULE_2__modal_LegalEstate___default.a,
			contentModalRgpd: __WEBPACK_IMPORTED_MODULE_3__modal_Rgpd___default.a
		};
	},
	mounted: function mounted() {
		var _this = this;

		if (this.estate.retreat !== undefined) {
			if (this.estate.retreat.PERP) {
				this.estate.retreat.PERP.forEach(function (perp) {
					_this.PERPcomputed += perp + ', ';
				});
			}
		}
		this.PERPcomputed = this.PERPcomputed.substring(0, this.PERPcomputed.length - 2);
		if (this.PERPcomputed === '') {
			this.PERPcomputed = '-';
		}
	},

	methods: {
		downloadEstate: function downloadEstate() {
			var _this2 = this;

			if (!(this.estate && this.estate.updatedAt && !this.isForceCompleteProfile)) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1__services_Emma__["a" /* default */].get('api/estate/private/doc/' + this.estate.idUser).then(function (result) {
				var win = window.open("https://api-preprod.patrimoffice.com/" + result.data.file.substring(1, result.data.file.length));
				win.focus();

				if (_this2.isAnonymous) {
					_this2.$store.dispatch('setForceCompleteProfileAsTrue');
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		estate: 'estate',
		isAnonymous: 'isAnonymous',
		isForceCompleteProfile: 'isForceCompleteProfile'
	}), {
		birthdate: function birthdate() {
			var date = this.$moment(this.estate.birthdate, 'YYYY-MM-DD');
			return date.isValid() ? this.$moment().diff(this.estate.birthdate, 'years') + ' ans' : '-';
		},
		canDownload: function canDownload() {
			return this.estate && this.estate.updatedAt && !this.isForceCompleteProfile;
		}
	})
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Esg',
	components: {
		CustomToggle: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default.a
	},
	data: function data() {
		return {
			interestedBySustainability: false,
			acceptLowerPerformance: false,
			durabilite: [],
			durabilites: ['environnementaux', 'sociaux', 'gouvernance']
		};
	},
	mounted: function mounted() {
		if (this.estate && this.estate.esg) {
			this.interestedBySustainability = this.estate.esg.interestedBySustainability || false;
			this.acceptLowerPerformance = this.estate.esg.acceptLowerPerformance || false;
			this.durabilite = this.estate.esg.durabilite ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.esg.durabilite) : [];
		}
	},

	methods: {
		changeInterestedBySustainability: function changeInterestedBySustainability(value) {
			this.interestedBySustainability = value;
			if (!value) {
				this.durabilite = [];
			}
		},
		changeAcceptLowerPerformance: function changeAcceptLowerPerformance(value) {
			this.acceptLowerPerformance = value;
		},
		validate: function validate() {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				resolve(true);
			});
		},
		toggleTag: function toggleTag(value) {
			if (value !== 'Aucun' || this.durabilite.length === 0) {
				if (this.durabilite.indexOf(value) === -1) {
					this.durabilite.push(value);
				} else {
					this.durabilite.splice(this.durabilite.indexOf(value), 1);
				}
			}
			if (this.durabilite.length > 1) {
				var key = this.durabilite.indexOf('Aucun');
				if (key !== -1) {
					this.durabilite.splice(key, 1);
				}
			}
		},
		isActiveTag: function isActiveTag(value) {
			return this.durabilite.indexOf(value) !== -1;
		},
		isLocked: function isLocked(value) {
			if (value !== 'Aucun') return false;
			return this.durabilite.length > 0 && this.durabilite.indexOf(value) === -1;
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.$store.dispatch('storePatrimonial', {
					name: 'ESG',
					data: {
						interestedBySustainability: _this.interestedBySustainability,
						acceptLowerPerformance: _this.acceptLowerPerformance,
						durabilite: _this.durabilite
					},
					fromStart: false
				}).then(function () {
					resolve();
				}).catch(function (error) {
					reject(error);
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	})),
	watch: {
		'estate.esg': {
			handler: function handler() {
				if (this.estate && this.estate.esg) {
					this.interestedBySustainability = this.estate.esg.interestedBySustainability || false;
					this.acceptLowerPerformance = this.estate.esg.acceptLowerPerformance || false;
					this.durabilite = this.estate.esg.durabilite ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.esg.durabilite) : [];
				}
			},

			deep: true
		}
	}
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Rating__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Following',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			ratings: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Rating__["a" /* default */],
			conseilRate: 'Très important',
			nbContractCounselor: 0,
			nbPatrimonialCounselor: 0
		};
	},
	mounted: function mounted() {
		this.conseilRate = this.estate.follow.rate || 'Très important';
		this.nbContractCounselor = this.estate.follow.nbContractCounselor || 0;
		this.nbPatrimonialCounselor = this.estate.follow.nbPatrimonialCounselor || 0;
	},

	methods: {
		setPatrimonialCounselor: function setPatrimonialCounselor(value) {
			if (this.nbPatrimonialCounselor >= 0) {
				this.nbPatrimonialCounselor = this.nbPatrimonialCounselor + value;
				this.nbPatrimonialCounselor = this.nbPatrimonialCounselor > 0 ? this.nbPatrimonialCounselor : 0;
			}
		},
		setContractCounselor: function setContractCounselor(value) {
			if (this.nbContractCounselor >= 0) {
				this.nbContractCounselor = this.nbContractCounselor + value;
				this.nbContractCounselor = this.nbContractCounselor > 0 ? this.nbContractCounselor : 0;
			}
		},
		validate: function validate() {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				resolve(true);
			});
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.$store.dispatch('storePatrimonial', {
					name: 'FOLLOWING',
					data: {
						rate: _this.conseilRate,
						nbContractCounselor: _this.nbContractCounselor,
						nbPatrimonialCounselor: _this.nbPatrimonialCounselor
					},
					fromStart: false
				}).then(function () {
					resolve();
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ISF',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			amount: null,
			currency: 'EUR',
			currencies: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			file: null
		};
	},
	mounted: function mounted() {
		this.amount = this.estate.isf.amount || null;
		this.currency = this.estate.isf.cur || 'EUR';
	},

	methods: {
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this = this;

			if (this.file) this.$emit('fileupload', this.file);
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.validate().then(function (validation) {
					if (validation) {
						_this.$store.dispatch('storePatrimonial', {
							name: 'ISF',
							data: {
								amount: _this.amount,
								cur: _this.currency
							},
							fromStart: false
						}).then(function () {
							resolve();
						});
					}
				});
			});
		},
		fileInput: function fileInput() {
			document.getElementById('input-file').click();
		},
		setFile: function setFile(e) {
			console.log(e);
			this.file = e.target.files[0];
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		estate: 'estate',
		isAnonymous: 'isAnonymous'
	}))
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Influence',
	data: function data() {
		return {
			conselors: ['Votre entourage', 'La presse généraliste', 'La presse économique', 'Télévision radio', 'Publicité financière', 'Gestionnaire de patrimoine', 'Site spécialisé', 'Conseiller bancaire', 'Agent d\'assurance'],
			selectedConselors: [],
			motivation: null
		};
	},
	mounted: function mounted() {
		this.motivation = this.estate.influence.motivation || null;
		this.selectedConselors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.influence.conselors);
	},

	watch: {
		'estate.influence': {
			handler: function handler() {
				this.motivation = this.estate.influence.motivation || null;
				this.selectedConselors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.influence.conselors);
			},

			deep: true
		}
	},
	methods: {
		toggleTag: function toggleTag(value) {
			if (this.selectedConselors.indexOf(value) === -1) {
				this.selectedConselors.push(value);
			} else {
				this.selectedConselors.splice(this.selectedConselors.indexOf(value), 1);
			}
		},
		isActiveTag: function isActiveTag(value) {
			return this.selectedConselors.indexOf(value) !== -1;
		},
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.validate().then(function (validation) {
					if (validation) {
						_this.$store.dispatch('storePatrimonial', {
							name: 'INFLUENCE',
							data: {
								motivation: _this.motivation,
								conselors: _this.selectedConselors
							},
							fromStart: false
						}).then(function () {
							resolve();
						});
					}
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Knowledge',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			diplomas: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["a" /* Diploma */],
			levels: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["b" /* Level */],
			ages: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["c" /* Age */],
			countries: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["d" /* Country */],
			products: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["e" /* Product */],
			investedProducts: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["f" /* InvestedProduct */],
			managements: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Knowledge__["g" /* Management */],
			diploma: null,
			country: null,
			level: null,
			age: null,
			product: [],
			investedProduct: [],
			management: []
		};
	},
	mounted: function mounted() {
		this.diploma = this.estate.knowledge.diploma || this.diplomas[0];
		this.level = this.estate.knowledge.level || this.levels[0];
		this.age = this.estate.knowledge.age || this.ages[0];
		this.country = this.estate.knowledge.country || this.countries[0];
		this.product = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.knowledge.products) || [];
		this.investedProduct = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.knowledge.investedProducts) || [];
		this.management = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.knowledge.managements) || [];
	},

	methods: {
		toggleTag: function toggleTag(items, value) {
			if (value !== 'Aucun' || items.length === 0) {
				if (items.indexOf(value) === -1) {
					items.push(value);
				} else {
					items.splice(items.indexOf(value), 1);
				}
			}

			if (items.length > 1) {
				var key = items.indexOf('Aucun');
				if (key !== -1) {
					items.splice(key, 1);
				}
			}
		},
		isActiveTag: function isActiveTag(items, value) {
			return items.indexOf(value) !== -1;
		},
		isLocked: function isLocked(items, value) {
			if (value !== 'Aucun') return false;
			return items.length > 0 && items.indexOf(value) === -1;
		},
		validate: function validate() {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				resolve(true);
			});
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.$store.dispatch('storePatrimonial', {
					name: 'KNOWLEDGE',
					data: {
						diploma: _this.diploma,
						level: _this.level,
						age: _this.age,
						country: _this.country,
						products: _this.product,
						investedProducts: _this.investedProduct,
						managements: _this.management
					},
					fromStart: false
				}).then(function () {
					resolve();
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_YourInformations__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_YourInformations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_YourInformations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_YourHome__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_YourHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_YourHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_AnnualRecipe__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_AnnualRecipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_AnnualRecipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_RealEstate__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_RealEstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_RealEstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_MyPatrimonialLandscape_Savings__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_MyPatrimonialLandscape_Savings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_components_MyPatrimonialLandscape_Savings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_components_MyPatrimonialLandscape_SpendingNoTaxes__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_components_MyPatrimonialLandscape_SpendingNoTaxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_components_MyPatrimonialLandscape_SpendingNoTaxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_components_MyPatrimonialLandscape_Credits__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_components_MyPatrimonialLandscape_Credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_components_MyPatrimonialLandscape_Credits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_components_MyPatrimonialLandscape_Taxes__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_components_MyPatrimonialLandscape_Taxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_components_MyPatrimonialLandscape_Taxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_components_MyPatrimonialLandscape_ISF__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_components_MyPatrimonialLandscape_ISF___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_components_MyPatrimonialLandscape_ISF__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_components_MyPatrimonialLandscape_Retreat__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_components_MyPatrimonialLandscape_Retreat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_components_MyPatrimonialLandscape_Retreat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_components_MyPatrimonialLandscape_Influence__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_components_MyPatrimonialLandscape_Influence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__common_components_MyPatrimonialLandscape_Influence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_components_MyPatrimonialLandscape_Following__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_components_MyPatrimonialLandscape_Following___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_components_MyPatrimonialLandscape_Following__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_components_MyPatrimonialLandscape_Knowledge__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_components_MyPatrimonialLandscape_Knowledge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__common_components_MyPatrimonialLandscape_Knowledge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_components_MyPatrimonialLandscape_Perspective__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_components_MyPatrimonialLandscape_Perspective___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__common_components_MyPatrimonialLandscape_Perspective__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_components_MyPatrimonialLandscape_Profil__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_components_MyPatrimonialLandscape_Profil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_components_MyPatrimonialLandscape_Profil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components_MyPatrimonialLandscape_Signature__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components_MyPatrimonialLandscape_Signature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__common_components_MyPatrimonialLandscape_Signature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_components_MyPatrimonialLandscape_Esg__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_components_MyPatrimonialLandscape_Esg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__common_components_MyPatrimonialLandscape_Esg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_resources_Universign__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(6);

























/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'PatrimonialEstate',
	props: ['user'],
	data: function data() {
		return {
			drawComponent: true,
			signatureBtnAvailable: true,
			showAnonymousCtaModal: false,
			isAdvisor: "cgpi" === 'cgpi',
			menu: [{
				label: '<span class="icon-paysage-vous"></span> Vous',
				slug: 'you',
				name: 'YOU',
				children: [{ label: 'Vos informations', component: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_YourInformations___default.a, name: 'YOUR_INFORMATIONS' }, { label: 'Votre foyer', component: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_YourHome___default.a, name: 'YOUR_HOME' }]
			}, {
				label: '<span class="icon-paysage-rentree"></span> Avoirs & Rentrées',
				slug: 'assets-icome',
				children: [{ label: 'Vos revenus annuels', component: __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_AnnualRecipe___default.a, name: 'ANNUAL_RECIPE' }, { label: 'Immobilier', component: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_RealEstate___default.a, name: 'REAL_ESTATE' }, { label: 'Epargne', component: __WEBPACK_IMPORTED_MODULE_7__common_components_MyPatrimonialLandscape_Savings___default.a, name: 'SAVINGS' }]
			}, {
				label: '<span class="icon-paysage-sortis"></span> Sorties',
				slug: 'exits',
				children: [{ label: 'Dépenses hors impôts', component: __WEBPACK_IMPORTED_MODULE_8__common_components_MyPatrimonialLandscape_SpendingNoTaxes___default.a, name: 'SPENDING_NO_TAXES' }, { label: 'Crédit(s)', component: __WEBPACK_IMPORTED_MODULE_9__common_components_MyPatrimonialLandscape_Credits___default.a, name: 'CREDITS' }]
			}, {
				label: '<span class="icon-paysage-fiscalite"></span> Fiscalité',
				slug: 'fiscal',
				children: [{ label: 'Impôt sur le revenu', component: __WEBPACK_IMPORTED_MODULE_10__common_components_MyPatrimonialLandscape_Taxes___default.a, name: 'TAXES' }, { label: 'IFI (Impôt sur la Fortune Immobilière)', component: __WEBPACK_IMPORTED_MODULE_11__common_components_MyPatrimonialLandscape_ISF___default.a, name: 'ISF' }]
			}, {
				label: '<span class="icon-paysage-retraite"></span> Retraite',
				slug: 'retirement',
				children: [{ label: 'Vous', component: __WEBPACK_IMPORTED_MODULE_12__common_components_MyPatrimonialLandscape_Retreat___default.a, name: 'RETREAT' }]
			}, {
				label: '<span class="icon-paysage-profil"></span> Profil',
				slug: 'profil',
				children: [{ label: 'Influences', component: __WEBPACK_IMPORTED_MODULE_13__common_components_MyPatrimonialLandscape_Influence___default.a, name: 'INFLUENCE' }, { label: 'Suivi', component: __WEBPACK_IMPORTED_MODULE_14__common_components_MyPatrimonialLandscape_Following___default.a, name: 'FOLLOWING' }, { label: 'Connaissances', component: __WEBPACK_IMPORTED_MODULE_15__common_components_MyPatrimonialLandscape_Knowledge___default.a, name: 'KNOWLEDGE' }, { label: 'Objectifs d\'investissement', component: __WEBPACK_IMPORTED_MODULE_16__common_components_MyPatrimonialLandscape_Perspective___default.a, name: 'PERSPECTIVE' }, { label: 'ESG', component: __WEBPACK_IMPORTED_MODULE_19__common_components_MyPatrimonialLandscape_Esg___default.a, name: 'ESG' }, { label: 'Profil d\'investisseur', component: __WEBPACK_IMPORTED_MODULE_17__common_components_MyPatrimonialLandscape_Profil___default.a, name: 'PROFIL' }]
			}, {
				label: '<span class="icon-file-edit"></span> Signature',
				slug: 'signature',
				component: __WEBPACK_IMPORTED_MODULE_18__common_components_MyPatrimonialLandscape_Signature___default.a
			}],
			activeFirstLevel: 0,
			activeSecondLevel: 0
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$root.$on('signature-confirm-info', function (value) {
			_this.signatureBtnAvailable = value;
		});

		this.initPatrimonialData().then(function () {
			_this.setCurrentMenuFromUrlParam();
			_this.changeMenuSignatureLabelForAnonymous();
		});
	},

	methods: {
		initPatrimonialData: function initPatrimonialData() {
			return this.$store.dispatch('getPatrimonial', this.estate.idUser);
		},
		setCurrentMenuFromUrlParam: function setCurrentMenuFromUrlParam() {
			var _this2 = this;

			if (typeof this.$route.params.section === 'undefined') {
				return;
			}

			var menuIndex = this.menu.findIndex(function (element) {
				return typeof element.slug !== 'undefined' && element.slug === _this2.$route.params.section;
			});

			if (!menuIndex || menuIndex < 0) {
				return;
			}

			this.setActiveFirst(menuIndex);
		},
		changeMenuSignatureLabelForAnonymous: function changeMenuSignatureLabelForAnonymous() {
			if (!this.isAnonymous) {
				return;
			}

			var index = this.menu.findIndex(function (elem) {
				return typeof elem.label !== 'undefined' && elem.label.includes('Signature');
			});
			if (index <= -1) {
				return;
			}

			this.menu[index].label = '<span class="icon-file-edit"></span> Valider';
		},
		isActiveFirst: function isActiveFirst(key) {
			return this.activeFirstLevel === key;
		},
		isActiveSecond: function isActiveSecond(key) {
			return this.activeSecondLevel === key;
		},
		setActiveFirst: function setActiveFirst(key) {
			var _this3 = this;

			this.activeFirstLevel = key;

			if (typeof this.$route.query.sub_section === 'undefined') {
				this.activeSecondLevel = 0;
			} else {
				var index = this.menu[key].children.findIndex(function (element) {
					return typeof element.name !== 'undefined' && element.name === _this3.$route.query.sub_section;
				});
				this.activeSecondLevel = index;
			}

			this.updateCurrentUrl();
		},
		setActiveSecond: function setActiveSecond(key) {
			this.activeSecondLevel = key;
		},
		check: function check() {
			return this.$refs.currentComp.validate();
		},
		nextStep: function nextStep() {
			var _this4 = this;

			this.check().then(function (result) {
				if (result) {
					var firstLevel = _this4.menu[_this4.activeFirstLevel];
					var secondLevel = firstLevel.children ? firstLevel.children[_this4.activeSecondLevel] : null;
					if (secondLevel) {
						if (firstLevel.children.length > _this4.activeSecondLevel + 1) {
							_this4.activeSecondLevel = _this4.activeSecondLevel + 1;
						} else {
							if (_this4.menu.length > _this4.activeFirstLevel + 1) {
								_this4.activeFirstLevel = _this4.activeFirstLevel + 1;
								_this4.activeSecondLevel = 0;
							}
						}
					} else {
						_this4.activeFirstLevel = _this4.menu.length > _this4.activeFirstLevel + 1 ? _this4.activeFirstLevel + 1 : _this4.activeFirstLevel;
					}

					_this4.updateCurrentUrl();

					_this4.save();
				}
			});
		},
		updateCurrentUrl: function updateCurrentUrl() {
			if (typeof this.menu[this.activeFirstLevel].slug === 'undefined') {
				return;
			}

			this.$router.push({ name: 'PatrimonialLandscapeUpdate', params: { section: this.menu[this.activeFirstLevel].slug } });
		},
		previousStep: function previousStep() {
			var _this5 = this;

			this.check().then(function (result) {
				if (result) {
					var firstLevel = _this5.menu[_this5.activeFirstLevel];
					var secondLevel = firstLevel.children ? firstLevel.children[_this5.activeSecondLevel] : null;
					if (secondLevel) {
						if (_this5.activeSecondLevel > 0) {
							_this5.activeSecondLevel = _this5.activeSecondLevel - 1;
						} else {
							if (_this5.activeFirstLevel > 0) {
								_this5.activeFirstLevel = _this5.activeFirstLevel - 1;
								_this5.activeSecondLevel = _this5.menu[_this5.activeFirstLevel].children ? _this5.menu[_this5.activeFirstLevel].children.length - 1 : 0;
							}
						}
					} else {
						_this5.activeFirstLevel = _this5.activeFirstLevel > 0 ? _this5.activeFirstLevel - 1 : _this5.activeFirstLevel;
						_this5.activeSecondLevel = _this5.menu[_this5.activeFirstLevel].children ? _this5.menu[_this5.activeFirstLevel].children.length - 1 : 0;
					}
					_this5.updateCurrentUrl();
				}
			});
		},
		isSafari: function isSafari() {
			var isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
			var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome/') > -1;
			return isSafari && !isChrome;
		},
		sign: function sign() {
			var _this6 = this;

			if (!this.signatureBtnAvailable) {
				return;
			}

			this.check().then(function (result) {
				_this6.$store.dispatch('savePatrimonial', _this6.user.id).then(function () {
					_this6.$store.commit('LOADER_IN');
					__WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/estate/private/doc/' + _this6.user.id).then(function (result) {
						var idFile = result.data.file.split('/')[result.data.file.split('/').length - 1];
						__WEBPACK_IMPORTED_MODULE_20__common_resources_Universign__["a" /* default */].signPersonalEstate(idFile).then(function (result) {
							if (result.data.success) {
								if (false) {
									var win = window.open(result.data.signatureUrl);
									if (win) {
										win.focus();

										_this6.$router.push({ name: 'PatrimonialLandscape' });
									} else {
										_this6.$root.$emit('signature-popup-blocked');
									}
								} else {
									_this6.$notify({
										type: 'success',
										group: 'default',
										title: 'La demande de signature a bien été envoyée au client',
										text: ''
									});

									_this6.$router.push({ name: 'PatrimonialLandscape' });
								}
								_this6.$store.commit('LOADER_OUT');
							} else {
								_this6.$notify({
									type: 'error',
									group: 'default',
									title: 'Une erreur est survenue',
									text: result.data.error
								});
								_this6.$store.commit('LOADER_OUT');
							}
						}).catch(function (error) {
							console.log(error);
							_this6.$store.commit('LOADER_OUT');
						});
					}).catch(function (error) {
						_this6.$store.commit('LOADER_OUT');
						console.warn(error);
					});
				});
			}).catch(function (error) {
				_this6.$notify({
					type: 'error',
					group: 'default',
					title: error.message,
					text: null
				});
			});
		},
		addDocument: function addDocument(file) {
			this.$store.dispatch('addDocument', {
				user_id: this.user.id,
				category: 'justificatifs',
				type: file.type.replace('application/', ''),
				confidential: false,
				file: file,
				subcategory: null,
				signature_required: false,
				signature_token: null,
				original_name: file.name
			}).then(function () {
				console.log('document added avec success');
			}).catch(function (error) {
				console.log('Error from add document : ', error);
			});
		},
		save: function save() {
			var _this7 = this;

			this.check().then(function (result) {
				if (_this7.$refs.currentComp.save) {
					_this7.$refs.currentComp.save().then(function () {
						_this7.$store.dispatch('savePatrimonial', _this7.user.id).then(function () {
							_this7.$notify({
								type: 'success',
								group: 'default',
								title: 'Vos modifications ont bien été enregistrées',
								text: ''
							});
						});
					});
				} else {
					_this7.$store.dispatch('savePatrimonial', _this7.user.id).then(function () {
						_this7.$notify({
							type: 'success',
							group: 'default',
							title: 'Vos modifications ont bien été enregistrées',
							text: ''
						});
					});
				}
			});
		},
		resolveLabel: function resolveLabel(comp, primary) {
			var _this8 = this;

			var secondary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			var validated = false;
			if (secondary !== null) {
				validated = this.$store.getters.isValidated(comp.name);
			} else {
				if (comp.children) {
					var status = true;
					comp.children.forEach(function (child) {
						if (child.name !== 'PROFIL') {
							if (!_this8.$store.getters.isValidated(child.name)) {
								status = false;
							}
						}
					});
					validated = status;
				}
			}
			return validated ? comp.label + ' <img src="' + __WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg___default.a + '">' : comp.label;
		},
		downloadEstate: function downloadEstate() {
			var _this9 = this;

			if (!this.estate || !this.estate.updatedAt) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/estate/private/doc/' + this.estate.idUser).then(function (result) {
				var win = window.open("https://api-preprod.patrimoffice.com/" + result.data.file.substring(1, result.data.file.length));
				win.focus();
				_this9.showAnonymousCtaModal = _this9.isAnonymous;
				if (_this9.isAnonymous) {
					_this9.$root.$emit('show-anonymous-cta-modal', _this9.showAnonymousCtaModal);
					_this9.$store.dispatch('setForceCompleteProfileAsTrue');
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["a" /* mapGetters */])({
		estate: 'estate',
		isAnonymous: 'isAnonymous'
	}), {
		currentComponent: function currentComponent() {
			if (this.menu[this.activeFirstLevel].children) {
				if (this.activeSecondLevel !== -1) {
					return this.menu[this.activeFirstLevel].children[this.activeSecondLevel].component;
				} else {
					return this.menu[this.activeFirstLevel].component;
				}
			} else {
				return this.menu[this.activeFirstLevel].component;
			}
		}
	})
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Perspective',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			perspectives: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["a" /* Perspective */],
			objectives: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["b" /* Objective */],
			riskDegrees: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["c" /* RiskDegree */],
			risingMarkets: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["d" /* RisingMarket */],
			assetsEstimates: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["e" /* AssetsEstimate */],
			investmentsEstimates: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["f" /* InvestmentEstimate */],
			perspective: null,
			objective: [],
			riskDegree: null,
			risingMarket: null,
			assetsEstimate: null,
			investmentsEstimate: null
		};
	},
	mounted: function mounted() {
		this.perspective = this.estate.perspective.perspective || this.perspectives[0];
		this.objective = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.perspective.objective) || [];
		var tmpObjective = [];
		this.objective.forEach(function (objective) {
			if (__WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Perspective__["b" /* Objective */].indexOf(objective) !== -1) {
				tmpObjective.push(objective);
			}
		});
		this.objective = tmpObjective;
		this.riskDegree = this.estate.perspective.riskDegree || this.riskDegrees[0];
		this.risingMarket = this.estate.perspective.risingMarket || this.risingMarkets[0];
		this.assetsEstimate = this.estate.perspective.assetsEstimate || this.assetsEstimates[0];
		this.investmentsEstimate = this.estate.perspective.investmentsEstimate || this.investmentsEstimates[0];
	},

	methods: {
		toggleTag: function toggleTag(value) {
			if (this.objective.indexOf(value) === -1) {
				this.objective.push(value);
			} else {
				this.objective.splice(this.objective.indexOf(value), 1);
			}
		},
		isActiveTag: function isActiveTag(value) {
			return this.objective.indexOf(value) !== -1;
		},
		validate: function validate() {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				resolve(true);
			});
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.$store.dispatch('storePatrimonial', {
					name: 'PERSPECTIVE',
					data: {
						perspective: _this.perspective,
						objective: _this.objective,
						riskDegree: _this.riskDegree,
						risingMarket: _this.risingMarket,
						assetsEstimate: _this.assetsEstimate,
						investmentsEstimate: _this.investmentsEstimate
					},
					fromStart: false
				}).then(function () {
					resolve();
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_investor_star_svg__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_investor_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_img_investor_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assets_img_investor_disc_svg__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assets_img_investor_disc_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_assets_img_investor_disc_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_assets_img_investor_shield_svg__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_assets_img_investor_shield_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_assets_img_investor_shield_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_assets_img_investor_lightning_bolt_svg__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_assets_img_investor_lightning_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_assets_img_investor_lightning_bolt_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_resources_Estate__ = __webpack_require__(237);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Profil',
	props: ['user'],
	data: function data() {
		return {
			sync: false,
			profile: null
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$store.commit('LOADER_IN');
		this.$store.dispatch('savePatrimonial', this.user.id).then(function () {
			__WEBPACK_IMPORTED_MODULE_7__common_resources_Estate__["a" /* default */].getInvestisorProfil(_this.user.id).then(function (result) {
				_this.$store.commit('LOADER_OUT');
				_this.profile = result.data.investor_profile;
				_this.sync = true;
			}).catch(function (error) {
				_this.$store.commit('LOADER_OUT');
				console.warn(error.response);
			});
		});
	},

	methods: {
		validate: function validate() {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				resolve(true);
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}), {
		imgBtn: function imgBtn() {
			var img = null;
			switch (this.profile) {
				case 'Aguerri':
					img = __WEBPACK_IMPORTED_MODULE_3__common_assets_img_investor_star_svg___default.a;
					break;
				case 'Equilibré':
					img = __WEBPACK_IMPORTED_MODULE_4__common_assets_img_investor_disc_svg___default.a;
					break;
				case 'Prudent':
					img = __WEBPACK_IMPORTED_MODULE_5__common_assets_img_investor_shield_svg___default.a;
					break;
				case 'Dynamique':
					img = __WEBPACK_IMPORTED_MODULE_6__common_assets_img_investor_lightning_bolt_svg___default.a;
					break;
				default:
					return null;
			}

			return img;
		}
	})
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_PropertyTypes__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);











var RentalProperty = function RentalProperty() {
	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RentalProperty);

	this.value = null;
	this.ownership_type = __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_PropertyTypes__["a" /* default */][0];
	this.cur = 'EUR';
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'real-estate',
	components: {
		CustomToggle: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle___default.a,
		CustomSelect: __WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			currencies: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			propertyTypes: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_PropertyTypes__["a" /* default */],
			isRealEstate: false,
			realEstateValue: null,
			propertyType: null,
			realEstateCur: 'EUR',
			isSecondaryRealEstate: false,
			secondaryEstates: [],
			isRentingProperties: false,
			rentingProperties: [],
			isSCPI: false,
			scpi: {
				value: null,
				cur: 'EUR',
				type: null
			}
		};
	},
	mounted: function mounted() {
		this.initializeRealEstate();
	},

	methods: {
		initializeRealEstate: function initializeRealEstate() {
			this.propertyType = this.propertyTypes[0];
			this.secondaryPropertyType = this.propertyTypes[0];
			this.scpi.type = this.propertyTypes[0];

			if (this.estate.mainEstate.val) {
				this.isRealEstate = true;
				this.realEstateValue = this.estate.mainEstate.val;
				this.realEstateCur = this.estate.mainEstate.cur;
				this.propertyType = this.estate.mainEstate.type;
			}

			if (this.estate.rentalProperties.length > 0) {
				this.isRentingProperties = true;
				this.rentingProperties = this.$iRobot.arrayClone(this.estate.rentalProperties);
			}
			if (this.estate.secondaryEstates.length > 0) {
				this.isSecondaryRealEstate = true;
				this.secondaryEstates = this.$iRobot.arrayClone(this.estate.secondaryEstates);
			}

			if (this.estate.isSCPI) {
				this.isSCPI = true;
				this.scpi.value = this.estate.scpi.value;
				this.scpi.cur = this.estate.scpi.cur;
				this.scpi.type = this.estate.scpi.type;
			}
		},
		toggleMainRealEstate: function toggleMainRealEstate(value) {
			if (!value) {
				this.realEstateValue = null;
				this.realEstateCur = 'EUR';
				this.propertyType = this.propertyTypes[0];
			}
			this.isRealEstate = value;
		},
		addRentingProperty: function addRentingProperty() {
			this.rentingProperties = this.rentingProperties.concat([new RentalProperty()]);
		},
		toggleRentingProperties: function toggleRentingProperties(value) {
			this.isRentingProperties = value;
			if (value && this.rentingProperties.length === 0) {
				this.rentingProperties = [new RentalProperty()];
			}
			if (!value) {
				this.rentingProperties = [];
			}
		},
		removeRentingProperty: function removeRentingProperty(key) {
			this.rentingProperties.splice(key, 1);
		},
		addSecondaryEstate: function addSecondaryEstate() {
			this.secondaryEstates = this.secondaryEstates.concat([new RentalProperty()]);
		},
		toggleSecondaryEstates: function toggleSecondaryEstates(value) {
			this.isSecondaryRealEstate = value;
			if (value && this.secondaryEstates.length === 0) {
				this.secondaryEstates = [new RentalProperty()];
			}
			if (!value) {
				this.secondaryEstates = [];
			}
		},
		removeSecondaryEstate: function removeSecondaryEstate(key) {
			this.secondaryEstates.splice(key, 1);
		},
		toggleSCPI: function toggleSCPI(value) {
			this.isSCPI = value;
		},
		validate: function validate() {
			return this.$validator.validate();
		},
		refreshDataSaved: function refreshDataSaved() {
			var _this = this;

			setTimeout(function () {
				_this.initializeRealEstate();
			}, 10000);
		},
		save: function save() {
			var _this2 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.validate().then(function (validation) {
					if (validation) {
						_this2.$store.dispatch('storePatrimonial', {
							name: 'REAL_ESTATE',
							data: {
								mainEstate: {
									val: _this2.realEstateValue,
									cur: _this2.realEstateCur,
									type: _this2.propertyType
								},
								secondaryEstates: _this2.secondaryEstates,
								rentalProperties: _this2.rentingProperties,
								isSCPI: _this2.isSCPI,
								scpi: _this2.scpi
							},
							fromStart: false
						}).then(function () {
							resolve();
							_this2.refreshDataSaved();
						});
					}
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_RadioBox__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_RadioBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_RadioBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Months__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Retreat',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_5__common_components_Form_CustomToggle___default.a,
		RadioBox: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_RadioBox___default.a
	},
	data: function data() {
		return {
			month: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Months__["a" /* default */][0],
			months: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Months__["a" /* default */],
			yearOfRetreat: null,
			isPERP: false,
			PERPType: ['PERP', 'PERCO', 'Contrat TNS', 'Article 83', 'Autres'],
			activates: [],
			hasNotRetirement: false
		};
	},
	mounted: function mounted() {
		this.month = this.estate.retreat.month || null;
		this.yearOfRetreat = this.estate.retreat.year || null;
		this.hasNotRetirement = !this.estate.retreat.hasRetirement || false;
		this.activates = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.estate.retreat.PERP) || [];
		this.isPERP = this.activates.length > 0;
	},

	methods: {
		toggleTag: function toggleTag(value) {
			if (this.activates.indexOf(value) === -1) {
				this.activates.push(value);
			} else {
				this.activates.splice(this.activates.indexOf(value), 1);
			}
		},
		isActiveTag: function isActiveTag(value) {
			return this.activates.indexOf(value) !== -1;
		},
		validate: function validate() {
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				resolve(true);
			});
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.$store.dispatch('storePatrimonial', {
					name: 'RETREAT',
					data: {
						month: _this.month,
						year: _this.yearOfRetreat,
						PERP: _this.activates,
						hasRetirement: !_this.hasNotRetirement
					},
					fromStart: false
				}).then(function () {
					resolve();
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	})),
	watch: {
		hasNotRetirement: function hasNotRetirement(value) {
			if (value) {
				this.month = null;
				this.yearOfRetreat = null;
			}
		},
		isPERP: function isPERP(value) {
			if (!value) {
				this.activates = [];
			}
		}
	}
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Savings__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_MyPatrimonialLandscape_data_PropertyTypes__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);













var Saving = function Saving(saving) {
	var _this = this;

	var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Saving);

	this.type = saving.type;
	this.fields = {
		value: null,
		currency: 'EUR',
		position: position
	};
	saving.fields.forEach(function (field) {
		_this.fields[field] = '';
	});
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Savings',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomToggle___default.a
	},
	data: function data() {
		return {
			currencies: __WEBPACK_IMPORTED_MODULE_6__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			ownershipTypes: __WEBPACK_IMPORTED_MODULE_7__common_components_MyPatrimonialLandscape_data_PropertyTypes__["a" /* default */],
			isSavings: false,
			savingsData: __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Savings__["a" /* default */],
			typeToAdd: __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Savings__["a" /* default */][0],
			savingsRow: []
		};
	},
	mounted: function mounted() {
		console.log('SAVINGS - mounted');
		this.initializeSavings();
	},

	methods: {
		initializeSavings: function initializeSavings() {
			var _this2 = this;

			this.savingsRow = this.$iRobot.cloneDeep(this.estate.savings);
			this.isSavings = this.savingsRow.length > 0;
			this.savingsRow.forEach(function (saving, index) {
				if (saving.fields.opening_date) {
					saving.fields.opening_date = _this2.formatDate(saving.fields.opening_date);
				}

				if (saving.fields.position < 0) {
					saving.fields.position = index;
				}
			});
			console.log(this.savingsRow);
		},
		addSaving: function addSaving() {
			var position = this.savingsRow.length > 0 ? this.savingsRow[this.savingsRow.length - 1].fields.position + 1 : 0;
			this.savingsRow.push(new Saving(this.typeToAdd, position));
		},
		removeSaving: function removeSaving(key) {
			this.savingsRow.splice(key, 1);
		},
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this3 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this3.validate().then(function (validation) {
					if (validation) {
						var foo = _this3.isSavings ? _this3.savingsRow : [];
						_this3.$store.dispatch('storePatrimonial', {
							name: 'SAVINGS',
							data: foo,
							fromStart: false
						}).then(function () {
							resolve();
							_this3.refreshDataSaved();
						});
					}
				});
			});
		},
		refreshDataSaved: function refreshDataSaved() {
			this.initializeSavings();
		},
		formatDate: function formatDate(d) {
			if (d.indexOf(':') !== -1) {
				var d1 = d.split(' ');
				d1 = d1[0].split('/');
				d1 = d1.reverse().join('-');
				return d1;
			} else {
				return d;
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_UnlockSignaturePopupTutorial__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_UnlockSignaturePopupTutorial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_UnlockSignaturePopupTutorial__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Signature',
	components: {
		UnlockSignaturePopupTutorial: __WEBPACK_IMPORTED_MODULE_4__common_components_UnlockSignaturePopupTutorial___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle___default.a
	},
	methods: {
		validate: function validate() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (_this.isSign) {
					resolve(true);
				} else {
					reject(new Error('Vous devez signer le paysage patrimonial'));
				}
			});
		}
	},
	data: function data() {
		return {
			isSign: false,
			showAnonymousCtaModal: false,
			signaturePopupBlocked: false,
			showUnlockPopupTuto: false,
			isAdvisor: "cgpi" === 'cgpi'
		};
	},
	mounted: function mounted() {
		var _this2 = this;

		this.isSign = !this.isAnonymous;
		this.showAnonymousCtaModal = this.isForceCompleteProfile;
		this.$root.$on('show-anonymous-cta-modal', function (value) {
			_this2.showAnonymousCtaModal = value;
		});
		this.$root.$on('signature-popup-blocked', function () {
			_this2.signaturePopupBlocked = true;
		});
	},

	watch: {
		isSign: function isSign(value) {
			this.$root.$emit('signature-confirm-info', value);
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
		isAnonymous: 'isAnonymous',
		isForceCompleteProfile: 'isForceCompleteProfile'
	}))
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SpendingNoTaxes',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default.a
	},
	data: function data() {
		return {
			value: null,
			type: 'Mensuel',
			currency: 'EUR',
			currencies: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			periods: ['Mensuel', 'Annuel']
		};
	},
	mounted: function mounted() {
		this.value = this.estate.spendingNoTaxes.value || null;
		this.currency = this.estate.spendingNoTaxes.cur || 'EUR';
		this.type = this.estate.periodicity ? 'Mensuel' : 'Annuel';
	},

	methods: {
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.validate().then(function (validation) {
					if (validation) {
						_this.$store.dispatch('storePatrimonial', {
							name: 'SPENDING_NO_TAXES',
							data: {
								spending: {
									value: _this.value,
									cur: _this.currency
								},
								periodicity: _this.type === 'Mensuel'
							},
							fromStart: false
						}).then(function () {
							resolve();
						});
					}
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Country__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Taxes',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			amount: null,
			currency: 'EUR',
			currencies: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			file: null,
			nbFiscalParts: 1,
			countries: __WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Country__["a" /* default */],
			countryForTaxes: null
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.amount = this.estate.taxes.value || null;
		this.currency = this.estate.taxes.cur || 'EUR';
		this.nbFiscalParts = this.estate.taxes.nbFiscalParts || 1;

		var valueToCheck = this.estate.taxes.countryForTaxes || 'France';

		__WEBPACK_IMPORTED_MODULE_4__common_components_MyPatrimonialLandscape_data_Country__["a" /* default */].forEach(function (country) {
			if (country.type === valueToCheck) {
				_this.countryForTaxes = country;
			}
		});
	},

	methods: {
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this2 = this;

			if (this.file) this.$emit('fileupload', this.file);
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.validate().then(function (validation) {
					if (validation) {
						_this2.$emit('file', _this2.file);
						_this2.$store.dispatch('storePatrimonial', {
							name: 'TAXES',
							data: {
								value: _this2.amount,
								cur: _this2.currency,
								nbFiscalParts: _this2.nbFiscalParts,
								countryForTaxes: _this2.countryForTaxes.type
							},
							fromStart: false
						}).then(function () {
							resolve();
						});
					}
				});
			});
		},
		fileInput: function fileInput() {
			document.getElementById('input-file').click();
		},
		setFile: function setFile(e) {
			console.log(e);
			this.file = e.target.files[0];
		},
		parseAmount: function parseAmount() {
			if (!this.amount) {
				return;
			}
			this.amount = this.amount.toString().replace(',', '.');
		},
		parsePartFiscale: function parsePartFiscale() {
			if (!this.nbFiscalParts) {
				return;
			}

			this.nbFiscalParts = this.nbFiscalParts.toString().replace(',', '.');
		}
	},
	watch: {
		countryForTaxes: function countryForTaxes(val) {
			console.log(val);
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		user: 'user',
		estate: 'estate',
		isAnonymous: 'isAnonymous'
	})),
	beforeDestroy: function beforeDestroy() {
		this.save();
	}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









var Child = function Child() {
	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Child);

	this.firstname = null;
	this.lastname = null;
	this.dateOfBirth = null;
	this.type = null;
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'YourHome',
	components: {
		CustomToggle: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default.a,
		CustomSelect: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			typeChild: ['Enfant', 'Petit-enfant'],
			typeToAdd: null,
			listOfChild: [],
			isChilds: false
		};
	},
	mounted: function mounted() {
		this.initializeChildren();
	},

	methods: {
		initializeChildren: function initializeChildren() {
			this.typeToAdd = this.typeChild[0];
			this.listOfChild = this.estate.childs.length > 0 ? this.$iRobot.arrayClone(this.estate.childs) : [];
			if (this.listOfChild.length > 0) {
				this.isChilds = true;
				this.listOfChild.forEach(function (child) {
					child.dateOfBirth = child.dateOfBirth.toString().split('/').reverse().join('-');
				});
			}
		},
		validate: function validate() {
			return this.$validator.validate();
		},
		addChild: function addChild() {
			var foo = new Child();
			foo.type = this.typeToAdd;
			this.listOfChild = this.listOfChild.concat([foo]);
		},
		changeChilds: function changeChilds(value) {
			this.isChilds = value;
			if (!value) {
				this.listOfChild = [];
			}
		},
		removeChild: function removeChild(key) {
			this.listOfChild.splice(key, 1);
		},
		refreshDataSaved: function refreshDataSaved() {
			var _this = this;

			setTimeout(function () {
				_this.initializeChildren();
			}, 10000);
		},
		save: function save() {
			var _this2 = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.validate().then(function (validation) {
					if (validation) {
						_this2.$store.dispatch('storePatrimonial', {
							name: 'YOUR_HOME',
							data: _this2.listOfChild,
							fromStart: false
						}).then(function () {
							resolve();
							_this2.refreshDataSaved();
						});
					}
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_MyPatrimonialLandscape_data_CSP_js__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_MaritalStatus_js__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'YourInformations',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			birthdate: null,
			job: null,
			csp: null,
			maritalStatus: null,
			maritalStatusList: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_MaritalStatus_js__["a" /* default */],
			cspList: __WEBPACK_IMPORTED_MODULE_2__common_components_MyPatrimonialLandscape_data_CSP_js__["a" /* default */]
		};
	},
	mounted: function mounted() {
		this.birthdate = this.estate.birthdate ? this.estate.birthdate.toString().split('/').reverse().join('-') : null;
		this.job = this.estate.job;
		this.csp = this.estate.csp !== null ? this.estate.csp : this.cspList[0];
		this.maritalStatus = this.estate.maritalStatus !== null ? this.estate.maritalStatus : this.maritalStatusList[0];
	},

	methods: {
		validate: function validate() {
			return this.$validator.validate();
		},
		save: function save() {
			var _this = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this.validate().then(function (validation) {
					if (validation) {
						_this.$store.dispatch('storePatrimonial', {
							name: 'YOUR_INFORMATIONS',
							data: {
								birthdate: _this.birthdate,
								job: _this.job,
								csp: _this.csp,
								maritalStatus: _this.maritalStatus
							},
							fromStart: false
						}).then(function () {
							resolve();
						});
					}
				});
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.save();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'LegalEstate',
	methods: {
		close: function close() {
			this.$emit('close');
		}
	},
	data: function data() {
		return {};
	}
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Rgpd',
	methods: {
		close: function close() {
			this.$emit('close');
		}
	},
	data: function data() {
		return {};
	}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_Logo_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_Logo_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'not-found',
	components: { Logo: __WEBPACK_IMPORTED_MODULE_0__common_components_Logo_vue___default.a }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_tuto_unlock_popup_chrome_step_0_png__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_tuto_unlock_popup_chrome_step_0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_img_tuto_unlock_popup_chrome_step_0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_tuto_unlock_popup_chrome_step_1_png__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_tuto_unlock_popup_chrome_step_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_img_tuto_unlock_popup_chrome_step_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assets_img_tuto_unlock_popup_chrome_step_2_png__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assets_img_tuto_unlock_popup_chrome_step_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_assets_img_tuto_unlock_popup_chrome_step_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_assets_img_tuto_unlock_popup_firefox_step_0_png__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_assets_img_tuto_unlock_popup_firefox_step_0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_assets_img_tuto_unlock_popup_firefox_step_0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_assets_img_tuto_unlock_popup_firefox_step_1_png__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_assets_img_tuto_unlock_popup_firefox_step_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_assets_img_tuto_unlock_popup_firefox_step_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_assets_img_tuto_unlock_popup_firefox_step_2_png__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_assets_img_tuto_unlock_popup_firefox_step_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_assets_img_tuto_unlock_popup_firefox_step_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_assets_img_tuto_unlock_popup_safari_step_0_png__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_assets_img_tuto_unlock_popup_safari_step_0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_assets_img_tuto_unlock_popup_safari_step_0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_assets_img_tuto_unlock_popup_safari_step_1_png__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_assets_img_tuto_unlock_popup_safari_step_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_assets_img_tuto_unlock_popup_safari_step_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ua_parser_js__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ua_parser_js__);

















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'UnlockSignaturePopupTutorial',
	data: function data() {
		return {
			slides: [],
			chromeSlides: [{ key: 0, src: __WEBPACK_IMPORTED_MODULE_2__common_assets_img_tuto_unlock_popup_chrome_step_0_png___default.a }, { key: 1, src: __WEBPACK_IMPORTED_MODULE_3__common_assets_img_tuto_unlock_popup_chrome_step_1_png___default.a }, { key: 2, src: __WEBPACK_IMPORTED_MODULE_4__common_assets_img_tuto_unlock_popup_chrome_step_2_png___default.a }],
			firefoxSlides: [{ key: 0, src: __WEBPACK_IMPORTED_MODULE_5__common_assets_img_tuto_unlock_popup_firefox_step_0_png___default.a }, { key: 1, src: __WEBPACK_IMPORTED_MODULE_6__common_assets_img_tuto_unlock_popup_firefox_step_1_png___default.a }, { key: 2, src: __WEBPACK_IMPORTED_MODULE_7__common_assets_img_tuto_unlock_popup_firefox_step_2_png___default.a }],
			safariSlides: [{ key: 0, src: __WEBPACK_IMPORTED_MODULE_8__common_assets_img_tuto_unlock_popup_safari_step_0_png___default.a }, { key: 1, src: __WEBPACK_IMPORTED_MODULE_9__common_assets_img_tuto_unlock_popup_safari_step_1_png___default.a }],
			current: 0,
			tutorial: true,
			userAgentBrowser: null
		};
	},
	mounted: function mounted() {
		this.userAgentBrowser = new __WEBPACK_IMPORTED_MODULE_10_ua_parser_js___default.a().getBrowser();

		this.initializeSlides();
	},

	methods: {
		initializeSlides: function initializeSlides() {
			if (this.userAgentBrowser.name.includes('Chrome')) {
				this.slides = this.chromeSlides;
			} else if (this.userAgentBrowser.name.includes('Firefox')) {
				this.slides = this.firefoxSlides;
			} else if (this.userAgentBrowser.name.includes('Safari')) {
				this.slides = this.safariSlides;
			}
		},
		next: function next() {
			if (this.current + 1 > this.slides.length - 1) {
				this.current = 0;
			} else {
				this.current += 1;
			}
		},
		previous: function previous() {
			if (this.current - 1 < 0) {
				this.current = this.slides.length - 1;
			} else {
				this.current -= 1;
			}
		},
		setTutorial: function setTutorial() {
			this.tutorial = false;
			this.$emit('close');
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		currentSlide: function currentSlide() {
			return this.slides[this.current];
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ag-table',
	props: ['columns', 'rows', 'customOptions', 'addSearch'],
	components: {
		AgGridVue: __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__["AgGridVue"]
	},
	watch: {
		rows: {
			handler: function handler(newRows) {
				if (this.gridApi) {
					this.gridApi.setRowData(newRows);
				}
			},

			deep: true
		}
	},
	data: function data() {
		return {
			defaultOptions: {
				paginationPageSize: 10,
				suppressPaginationPanel: true,
				headerHeight: 50,
				rowHeight: 50,
				pagination: false,
				onRowClicked: this.onRowClicked,
				onCellClicked: this.onCellClicked,
				localeText: {
					noRowsToShow: 'Vous n\'avez encore aucun client'
				},
				onComponentStateChanged: this.afterReady,
				doesExternalFilterPass: this.doesExternalFilterPass,
				isExternalFilterPresent: this.isExternalFilterPresent
			},
			gridApi: null,
			search: '',
			gridOptions: null,
			showGrid: false
		};
	},

	methods: {
		onFilterTextBoxChanged: function onFilterTextBoxChanged() {
			this.gridApi.onFilterChanged();
		},
		isExternalFilterPresent: function isExternalFilterPresent() {
			return this.search !== '';
		},
		doesExternalFilterPass: function doesExternalFilterPass(node) {
			if (!this.search) return true;

			var searchLower = this.search.toLowerCase();
			var nodeData = node.data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(nodeData).some(function (value) {
				if (value === null || value === undefined) return false;
				return String(value).toLowerCase().includes(searchLower);
			});
		},
		afterReady: function afterReady() {
			var imgs = document.querySelectorAll('.ag-root-wrapper .ctn-profile-picture img');
			imgs.forEach(function (img) {
				var tmp = new Image();
				tmp.addEventListener('load', function () {
					img.classList.add(tmp.width > tmp.height ? 'landscape' : 'portrait');
					img.classList.remove(tmp.width > tmp.height ? 'portrait' : 'landscape');
				});
				tmp.src = img.src;
			});
		},
		rendering: function rendering() {
			var _this = this;

			return {
				deleteFormat: function deleteFormat(params) {
					return '<span class="icon-file-trash"></span>';
				},
				dateFormat: function dateFormat(params) {
					var foo = _this.$moment(params.value);
					if (!foo.isValid()) {
						return '<div class="custom-cell"><span class="light">-</span></div>';
					}
					return '<div class="custom-cell"><span class="bold">' + foo.format('DD MMMM YYYY') + '</span> <span class="light">' + foo.format('dddd') + '</span></div>';
				},
				shortDateFormat: function shortDateFormat(params) {
					var dateValue = typeof params.value !== 'undefined' ? _this.$moment(params.value).format('DD/MM/YYYY') : null;

					if (typeof params.data !== 'undefined' && typeof params.data.client_next_rdv !== 'undefined' && params.data.client_next_rdv !== null) {
						dateValue = params.data.client_next_rdv.start_date;
					}

					return '<div class="custom-cell no-upper light">' + (dateValue || '-') + '</div>';
				},
				rangeHourFormat: function rangeHourFormat(params) {
					var start = _this.$moment(params.value.start);
					var end = _this.$moment(params.value.end);
					return '<div class="custom-cell no-upper no-margin"><span class="light">de </span><span class="bold">' + start.format('H') + 'h </span><span class="light">\xE0 </span><span class="bold">' + end.format('H') + 'h</span></div>';
				},
				cabinetFormat: function cabinetFormat(params) {
					var _params$value = params.value,
					    text = _params$value.text,
					    color = _params$value.color;

					return '<div class="custom-cell no-margin"><span class="pastille" style="background-color: ' + color + ';"></span><span class="bold">' + text + '</span></div>';
				},
				typeActivityFormat: function typeActivityFormat(params) {
					var color = null;
					var label = null;
					if (params.value === 'Visio Call') {
						color = 'brown';
						label = params.value;
					} else if (params.value === 'Rendez-vous') {
						color = 'blue';
						label = 'Rendez-vous physique';
					} else if (params.value === 'Appel téléphonique') {
						color = 'red';
						label = params.value;
					}

					return '<div class="custom-cell no-margin"><span class="pastille ' + color + '"></span><span class="bold">' + label + '</span></div>';
				},
				statusAvailableFormat: function statusAvailableFormat(params) {
					var cssClass = '';
					if (params.value) {
						cssClass = 'active';
					}
					return '<div class="custom-cell no-margin">\n\t\t\t\t\t\t\t\t<div class="toggle-input ' + cssClass + '">\n\t\t\t\t\t\t\t\t\t<div class="button"></div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>';
				},
				statusActivityFormat: function statusActivityFormat(params) {
					var cssClass = null;
					var label = null;
					if (params.value === 'confirmed') {
						cssClass = 'green';
						label = 'Confirmé';
					} else if (params.value === 'waiting') {
						cssClass = 'orange';
						label = 'En attente';
					} else {
						label = '-';
					}

					return '<div class="custom-cell no-margin"><span class="bold ' + cssClass + '">' + label + '</span></div>';
				},
				roundImgFormat: function roundImgFormat(params) {
					var img = params.data.media && params.data.media.file ? "https://api-preprod.patrimoffice.com/api/pictures/" + params.data.media.file : "https://api-preprod.patrimoffice.com/" + 'assets/user.png';
					return '<div class="custom-cell ctn-profile-picture"><img src="' + img + '"></div>';
				},
				typeContactFormat: function typeContactFormat(params) {
					var label = params.value === 'client_subscriber' || params.value === 'Client' ? 'Abonné' : 'Prospect';
					return _this.rendering().lightFormat({ value: label });
				},
				lightFormat: function lightFormat(params) {
					return '<div class="custom-cell"><div class="light">' + (params.value || '-') + '</div></div>';
				},
				noUpperFormat: function noUpperFormat(params) {
					return '<div class="custom-cell no-upper">' + (params.value || '-') + '</div>';
				},
				currentTaskFormat: function currentTaskFormat(params) {
					var label = _this.taskResolver(params.value);
					return _this.rendering().lightFormat({ value: label });
				},
				arrayFormat: function arrayFormat(params) {
					return '<div class="custom-cell"><div class="light">' + params.value.length + '</div></div>';
				},
				bellCellFormat: function bellCellFormat(params) {
					var bell = null;
					if (params.value) {
						bell = params.value === 'warn' ? 'yellow' : 'red';
					} else {
						return '<div></div>';
					}

					return '<div class="custom-cell ' + bell + '"><span class="icon-alert"></span></div>';
				},
				compactNameFormat: function compactNameFormat(params) {
					return params.data.firstname + ' ' + params.data.lastname;
				},
				statusMissionFormat: function statusMissionFormat(params) {
					return _this.statusMissionResolver(params.value);
				}
			};
		},

		statusMissionResolver: function statusMissionResolver(value) {
			var foo = '<div class="custom-cell status-missions row ';
			switch (value) {
				case 'En Attente':
					foo += 'orange"><div class="ctn-icon"><span class="icon-alert"></span></div>';
					break;
				case 'Signé':
					foo += 'green"><div class="ctn-icon"></div>';
					break;
				case 'À envoyer':
					foo += 'grey"><div class="ctn-icon"><span class="icon-info"></span></div>';
			}
			return foo + '<div class="">' + value + '</div></div>';
		},
		taskResolver: function taskResolver(value) {
			var foo = null;
			switch (value) {
				case 'active_contract':
					foo = 'Contrat actif';
					break;
				case 'report_to_sign':
					foo = 'Compte rendu de mission à signer';
					break;
				case 'contract_check':
					foo = 'Contrat à valider';
					break;
				case 'heritage_landscape_to_complete':
					foo = 'Paysage Patrimonial à completer';
					break;
				case 'project_to_validate':
					foo = 'Projet d\'investissement à valider';
					break;
				default:
					foo = '-';
			}
			return foo;
		},
		onReady: function onReady(params) {
			this.showGrid = true;
			this.gridApi = params.api;
		},
		onRowClicked: function onRowClicked(e) {
			this.$emit('rowclick', e);
		},
		onCellClicked: function onCellClicked(e) {
			this.$emit('cellclick', e);
		}
	},
	computed: {
		paginationPageSize: {
			get: function get() {
				if (this.options && this.options.api) {
					return this.options.api.paginationGetPageSize();
				}
			},
			set: function set(newValue) {
				if (this.options && this.options.api) {
					this.options.api.paginationSetPageSize(newValue);
				}
			}
		},
		currentPage: {
			get: function get() {
				if (this.options && this.options.api) {
					var totalPages = this.options.api.paginationGetTotalPages();
					var pageIndex = this.options.api.paginationGetCurrentPage() + 1;
					if (pageIndex <= 0) {
						return 1;
					} else if (pageIndex > totalPages) {
						return totalPages;
					}
					return pageIndex;
				}
			},
			set: function set(newValue) {
				if (this.options && this.options.api) {
					var totalPages = this.options.api.paginationGetTotalPages();
					if (newValue <= totalPages && newValue > 0) {
						this.options.api.paginationGoToPage(newValue - 1);
					}
				}
			}
		},
		columnsComputed: function columnsComputed() {
			var _this2 = this;

			var foo = [];
			this.columns.forEach(function (column) {
				var cellRenderer = typeof column.cellRenderer !== 'undefined' ? column.cellRenderer : null;
				if (cellRenderer === null && typeof column.cellType !== 'undefined' && column.cellType) {
					cellRenderer = _this2.rendering()[column.cellType + 'Format'];
				}

				foo.push({
					headerName: column.name,
					field: column.field,
					cellRenderer: cellRenderer,
					valueFormatter: typeof column.valueFormatter !== 'undefined' ? column.valueFormatter : null
				});

				if (column.width) {
					foo[foo.length - 1].width = column.width;
				}

				if (column.cellClass) {
					foo[foo.length - 1].cellClass = column.cellClass;
				}
			});
			return foo;
		},
		options: function options() {
			if (this.customOptions) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.defaultOptions, this.customOptions);
			} else {
				return this.defaultOptions;
			}
		}
	}
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'my-article',
	data: function data() {
		return {
			article: {}
		};
	},
	mounted: function mounted() {
		this.article = this.$store.getters.getArticle(this.$route.params.id);
	},

	methods: {
		resolveTag: function resolveTag(tag) {
			if (typeof tag === 'number') {
				var gTag = this.tags.filter(function (t) {
					return t.wordpress_tag_id === tag;
				})[0];
				if (gTag) {
					return gTag.wordpress_tag_name;
				} else {
					return null;
				}
			} else {
				return tag.tags.wordpress_tag_name;
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		tags: 'tags'
	}))
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'baseModal',
	props: ['show', 'content', 'data', 'modalContentClass'],
	data: function data() {
		return {
			launch: false,
			realLaunch: false
		};
	},
	mounted: function mounted() {
		if (this.show) {
			this.launch = true;
			this.realLaunch = true;
		}
	},

	methods: {
		close: function close() {
			this.$emit('close');
		}
	},
	watch: {
		show: function show(value) {
			var _this = this;

			if (value) {
				this.realLaunch = true;
				window.setTimeout(function () {
					_this.launch = true;
				}, 10);
			} else {
				window.setTimeout(function () {
					_this.launch = false;
				}, 10);
				window.setTimeout(function () {
					_this.realLaunch = false;
				}, 510);
			}
		}
	}
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Modal_NewThread__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Modal_NewThread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Modal_NewThread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Modal_NewMessage__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Modal_NewMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Modal_NewMessage__);






/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['threads', 'title', 'isAdvisor'],
	data: function data() {
		return {
			currentThreadId: null,
			modalNewThread: __WEBPACK_IMPORTED_MODULE_2__common_components_Modal_NewThread___default.a,
			showNewThread: false,
			dataNewThread: null,
			modalNewMessage: __WEBPACK_IMPORTED_MODULE_3__common_components_Modal_NewMessage___default.a,
			showNewMessage: false,
			dataNewMessage: null
		};
	},

	filters: {
		arrayDisplay: function arrayDisplay(ar) {
			return ar ? ar.join(', ') : ' -';
		}
	},
	mounted: function mounted() {
		this.updateNewMessageData();
	},

	methods: {
		setCurrentThread: function setCurrentThread(id) {
			console.log(id);
			this.currentThreadId = id;
			this.updateNewMessageData();
		},
		emitNewThread: function emitNewThread() {
			var clientId = this.$route.params.clientId;
			this.dataNewThread = {
				id: clientId,
				isAdvisor: this.isAdvisor
			};
			this.showNewThread = true;
		},
		emitNewMessage: function emitNewMessage() {
			this.showNewMessage = true;
		},
		resolveImg: function resolveImg(u) {
			return u.media ? "https://api-preprod.patrimoffice.com/api/pictures/" + u.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
		},
		updateNewMessageData: function updateNewMessageData() {
			this.dataNewMessage = {
				isAdvisor: this.isAdvisor,
				request: {
					threadId: this.currentThread.id,
					userId: this.currentThread.client.id
				},
				side: {
					first_name: this.currentThread.client.first_name,
					last_name: this.currentThread.client.last_name
				}
			};
		},
		reverse: function reverse(d) {
			return this.$iRobot.arrayClone(d).reverse();
		}
	},
	watch: {
		threads: function threads() {
			this.updateNewMessageData();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}), {
		currentThread: function currentThread() {
			var _this = this;

			var current = { title: null, messages: [], client: { id: 0 } };
			this.threads.forEach(function (thread) {
				if (thread.id === _this.currentThreadId) {
					current = thread;
				}
			});

			return current;
		}
	})
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'my-footer',
	data: function data() {
		return {
			year: 0
		};
	},
	mounted: function mounted() {
		var date = new Date();
		this.year = date.getFullYear();
	}
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Logo_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Logo_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['menu'],
	name: 'my-header',
	components: { Logo: __WEBPACK_IMPORTED_MODULE_2__common_components_Logo_vue___default.a },
	data: function data() {
		return {
			notifs: [{
				key: 0
			}]
		};
	},

	methods: {
		setActive: function setActive() {
			this.$store.commit('OPEN_NOTIF');
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		count: 'countNotifs',
		user: 'user',
		theme: 'currentTheme'
	}), {
		picture: function picture() {
			return this.user.picture ? "https://api-preprod.patrimoffice.com/api/pictures/" + this.user.picture : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
		}
	})
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'loader',
	mounted: function mounted() {
		this.$store.commit('LOADER_OUT');
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		loader: 'isLoader'
	}))
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mapbox_gl__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mapbox_gl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mapbox_gl_dist_mapbox_gl_css__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mapbox_gl_dist_mapbox_gl_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mapbox_gl_dist_mapbox_gl_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_resources_investment__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Country__ = __webpack_require__(113);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'MapboxComponent',
	props: {
		accessToken: {
			type: String,
			required: true
		},
		center: {
			type: Array,
			default: function _default() {
				return [2.3522, 48.8566];
			} },
		zoom: {
			type: Number,
			default: 12
		},
		styleProp: {
			type: String,
			default: 'mapbox://styles/mapbox/satellite-v9'
		},
		markers: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		clientId: {
			type: Number,
			default: null
		}
	},
	data: function data() {
		return {
			map: null,
			mapMarkers: [],
			showCountryImages: false,
			countries: []
		};
	},
	mounted: function mounted() {
		this.loadClientCountries();
		this.initializeMap();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.map) {
			this.map.remove();
		}
	},

	watch: {
		markers: {
			handler: function handler(newMarkers) {
				this.updateMarkers(newMarkers);
			},

			deep: true
		},
		clientId: {
			handler: function handler(newClientId) {
				if (newClientId) {
					this.loadClientCountries();
				}
			}
		}
	},
	methods: {
		loadClientCountries: function loadClientCountries() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var response, iso2Codes;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;

								if (_this.clientId) {
									_context.next = 3;
									break;
								}

								return _context.abrupt('return');

							case 3:
								_context.next = 5;
								return __WEBPACK_IMPORTED_MODULE_4__common_resources_investment__["a" /* default */].getCountriesInvestmentProducts(_this.clientId);

							case 5:
								response = _context.sent;

								if (response.data && response.data.countries) {
									iso2Codes = response.data.countries;

									_this.countries = _this.buildCountriesFromISO2(iso2Codes);
								}
								_context.next = 12;
								break;

							case 9:
								_context.prev = 9;
								_context.t0 = _context['catch'](0);

								console.error('Erreur lors du chargement des pays du client:', _context.t0);

							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 9]]);
			}))();
		},
		buildCountriesFromISO2: function buildCountriesFromISO2(iso2Codes) {
			var countries = [];

			iso2Codes.forEach(function (iso2Code) {
				var country = __WEBPACK_IMPORTED_MODULE_5__common_components_MyPatrimonialLandscape_data_Country__["a" /* default */].find(function (c) {
					return c.ISO2 === iso2Code;
				});
				var svgFileName = country.type.toLowerCase();
				if (country && svgFileName) {
					try {
						countries.push({
							iso2: iso2Code,
							name: country.type,
							displayName: country.fr,
							image: __webpack_require__(1191)("./" + iso2Code + '.svg')
						});
					} catch (error) {
						console.warn('Image SVG non trouv\xE9e pour ' + country.type + ': ' + iso2Code + '.svg', error);
					}
				}
			});

			return countries;
		},
		initializeMap: function initializeMap() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.accessToken = this.accessToken;

			this.map = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.Map({
				container: this.$refs.mapContainer,
				style: this.styleProp,
				zoom: 1,
				projection: 'equirectangular',
				attributionControl: false,
				interactive: false
			});

			this.map.on('load', function () {
				_this2.map.resize();

				_this2.loadCountryImages();

				_this2.addSunLightLayer();

				_this2.$emit('map-loaded', _this2.map);
			});
		},
		loadCountryImages: function loadCountryImages() {
			var _this3 = this;

			setTimeout(function () {
				_this3.showCountryImages = true;
			}, 1000);
		},
		addSunLightLayer: function addSunLightLayer() {
			var _this4 = this;

			var now = new Date();
			var hours = now.getUTCHours();
			var minutes = now.getUTCMinutes();

			var sunLongitude = (hours - 12) * 15 + minutes / 60 * 15;

			this.map.addSource('sun-light', {
				type: 'geojson',
				data: {
					type: 'Feature',
					geometry: {
						type: 'Point',
						coordinates: [sunLongitude, 0]
					}
				}
			});

			this.map.addLayer({
				id: 'sun-glow',
				type: 'circle',
				source: 'sun-light',
				paint: {
					'circle-radius': {
						stops: [[0, 0], [20, 800]],
						base: 2
					},
					'circle-color': 'rgba(255, 220, 100, 0.1)',
					'circle-blur': 1,
					'circle-opacity': 0.3
				}
			});

			this.map.addLayer({
				id: 'night-overlay',
				type: 'background',
				paint: {
					'background-color': 'rgba(0, 0, 0, 0.4)',
					'background-opacity': 0.5
				}
			});

			this.sunInterval = setInterval(function () {
				var currentTime = new Date();
				var h = currentTime.getUTCHours();
				var m = currentTime.getUTCMinutes();
				var newSunLongitude = (h - 12) * 15 + m / 60 * 15;

				var source = _this4.map.getSource('sun-light');
				if (source) {
					source.setData({
						type: 'Feature',
						geometry: {
							type: 'Point',
							coordinates: [newSunLongitude, 0]
						}
					});
				}
			}, 60000);
		},
		flyTo: function flyTo(center) {
			var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.zoom;

			if (this.map) {
				this.map.flyTo({
					center: center,
					zoom: zoom
				});
			}
		},
		addMarker: function addMarker(lng, lat) {
			var popup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			var marker = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.Marker().setLngLat([lng, lat]);

			if (popup) {
				var popupInstance = new __WEBPACK_IMPORTED_MODULE_2_mapbox_gl___default.a.Popup({ offset: 25 }).setHTML(popup);
				marker.setPopup(popupInstance);
			}

			marker.addTo(this.map);
			this.mapMarkers.push(marker);
			return marker;
		}
	}
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'notif-bar',
	props: ['type', 'title', 'text'],
	data: function data() {
		return {
			autodestroy: false
		};
	}
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'NotificationPanel',
	mounted: function mounted() {
		this.$store.dispatch('fetchNotifications', this.user);
	},

	methods: {
		setActive: function setActive() {
			this.$store.commit('CLOSE_NOTIF');
		},
		goToAbo: function goToAbo() {
			this.$store.commit('CLOSE_NOTIF');
			this.$router.push({ name: 'MySubscriptions' });
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		notifications: 'notifications',
		user: 'user',
		open: 'open'
	}), {
		isClient: function isClient() {
			return this.user.role === 'CLIENT';
		},
		picture: function picture() {
			return this.user.picture ? "https://api-preprod.patrimoffice.com/api/pictures/" + this.user.picture : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
		}
	})
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_high_icon_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_high_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_img_high_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_img_down_icon_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_img_down_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_assets_img_down_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_driver_js__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_driver_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_driver_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_currency_helper__ = __webpack_require__(249);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'value', 'prog'],
  data: function data() {
    return {
      good: __WEBPACK_IMPORTED_MODULE_0__common_assets_img_high_icon_svg___default.a,
      bad: __WEBPACK_IMPORTED_MODULE_1__common_assets_img_down_icon_svg___default.a,
      driver: null
    };
  },
  mounted: function mounted() {
    this.driver = new __WEBPACK_IMPORTED_MODULE_2_driver_js___default.a({
      animation: true,
      opacity: 0,
      closeBtnText: 'Fermer',
      nextBtnText: 'Suivant',
      prevBtnText: 'Précédent',
      allowClose: true
    });
  },

  methods: {
    formatCurrency: function formatCurrency(number) {
      var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (symbol) {
        return __WEBPACK_IMPORTED_MODULE_3__common_utils_currency_helper__["a" /* default */].formatCurrency(number, symbol);
      }

      return __WEBPACK_IMPORTED_MODULE_3__common_utils_currency_helper__["a" /* default */].formatCurrency(number, "€");
    },
    toggleGlobalPerfHelpModal: function toggleGlobalPerfHelpModal() {
      this.driver.highlight({
        element: '#global-perf-help-modal',
        popover: {
          title: 'Performance globale',
          description: 'Vos revenus perçus (par exemple de parts de SCPI) sont désormais intégrés dans vos performances globales.'
        }
      });
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['value'],
	data: function data() {
		return {
			animationTimeout: null
		};
	},
	mounted: function mounted() {
		this.startAnimation();
	},
	activated: function activated() {
		this.startAnimation();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.animationTimeout) {
			clearTimeout(this.animationTimeout);
		}
	},

	watch: {
		value: function value() {
			this.startAnimation();
		}
	},
	methods: {
		startAnimation: function startAnimation() {
			var _this = this;

			if (this.animationTimeout) {
				clearTimeout(this.animationTimeout);
			}

			if (this.$refs.bar) {
				this.$refs.bar.style.transform = 'rotate(45deg)';
			}

			this.animationTimeout = setTimeout(function () {
				if (_this.$refs.bar) {
					var value = _this.value > 100 ? 100 : _this.value;
					if (value < 0) {
						value = 0;
					}
					var percent = 45 + value * 1.8;
					_this.$refs.bar.style.transform = 'rotate(' + percent + 'deg)';
				}
			}, 100);
		}
	},
	filters: {
		format_performance: function format_performance(value) {
			if (!value) {
				return '0';
			}

			if (value === 0) {
				return value.toLocaleString();
			}

			return value > 0 ? '+' + value.toLocaleString() : value.toLocaleString();
		}
	}
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['columns', 'rows', 'rowsStyle'],
	data: function data() {
		return {
			filter: {
				key: null,
				asc: true
			}
		};
	},

	methods: {
		deployRow: function deployRow(key) {
			for (var index in this.rows) {
				var row = this.rows[index];

				if (parseInt(index) === parseInt(key) && typeof row.childrenRows !== 'undefined' && row.childrenRows.length > 0) {
					row.deploy = !row.deploy;
				}
			}
		},
		setFilter: function setFilter(key) {
			if (this.filter.key === key) {
				this.filter.asc = !this.filter.asc;
			} else {
				this.filter = {
					key: key,
					asc: true
				};
			}
		},
		isFiltered: function isFiltered(key) {
			return key === this.filter.key ? this.filter.asc : false;
		},
		emitActionClick: function emitActionClick(row, action) {
			this.$emit('action-item-clicked', { row: row, action: action });
		}
	},
	computed: {
		computedRows: function computedRows() {
			var _this = this;

			var result = this.rows;
			if (this.filter.key !== null) {
				result = result.sort(function (a, b) {
					var value = _this.filter.asc ? a.data[_this.filter.key] > b.data[_this.filter.key] : a.data[_this.filter.key] < b.data[_this.filter.key];
					return value ? 1 : -1;
				});
			}
			return result;
		}
	}
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TileDocSelectable',
	props: ['doc'],
	data: function data() {
		return {
			baseFile: __WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg___default.a
		};
	},

	methods: {
		resolveReverseType: function resolveReverseType(t) {
			var value = null;
			switch (t) {
				case 'pdf':
					value = 'application/pdf';
					break;
				case 'txt':
					value = 'application/octet-stream';
					break;
				case 'doc':
					value = 'application/msword';
					break;
				case 'docx':
					value = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
					break;
				case 'xls':
					value = 'application/vnd.ms-excel';
					break;
				case 'xlsx':
					value = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
					break;
				default:
					value = false;
			}

			return value;
		},
		download: function download() {
			var win = window.open("https://api-preprod.patrimoffice.com/" + 'api/documents/' + this.doc.id);
			win.focus();
		}
	},
	filters: {
		uppercase: function uppercase(value) {
			return value.split('.')[value.split('.').length - 1].toUpperCase();
		}
	}
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TileDoc',
	props: ['doc'],
	data: function data() {
		return {
			baseFile: __WEBPACK_IMPORTED_MODULE_0__common_assets_img_icon_svg___default.a
		};
	},

	methods: {
		resolveReverseType: function resolveReverseType(t) {
			var value = null;
			switch (t) {
				case 'pdf':
					value = 'application/pdf';
					break;
				case 'txt':
					value = 'application/octet-stream';
					break;
				case 'doc':
					value = 'application/msword';
					break;
				case 'docx':
					value = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
					break;
				case 'xls':
					value = 'application/vnd.ms-excel';
					break;
				case 'xlsx':
					value = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
					break;
				default:
					value = false;
			}

			return value;
		},
		download: function download() {
			var win = window.open("https://api-preprod.patrimoffice.com/" + 'api/documents/' + this.doc.id);
			win.focus();
		}
	},
	filters: {
		uppercase: function uppercase(value) {
			return value.split('.')[value.split('.').length - 1].toUpperCase();
		}
	}
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'toggle-input',
	props: ['value'],
	data: function data() {
		return {
			custom: false
		};
	},
	mounted: function mounted() {
		this.custom = this.value;
	},

	methods: {
		changeValue: function changeValue() {
			this.custom = !this.custom;
			this.$emit('change', this.custom);
		}
	},
	watch: {
		value: function value(newVal) {
			this.custom = newVal;
		}
	}
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardCalendar_vue__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardCalendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CardCalendar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_user__ = __webpack_require__(50);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BoardCalendar',
    components: {
        CardCalendar: __WEBPACK_IMPORTED_MODULE_0__CardCalendar_vue___default.a
    },
    data: function data() {
        return {
            isDragging: false,
            startX: 0,
            scrollLeft: 0,
            calendar: [],
            isLoading: true,
            selectedDate: new Date()
        };
    },

    computed: {
        isToday: function isToday() {
            var today = new Date();
            return this.selectedDate.toDateString() === today.toDateString();
        },
        formattedDate: function formattedDate() {
            if (this.isToday) return "Aujourd'hui";
            return this.$moment(this.selectedDate).format('dddd D MMMM YYYY');
        },
        dateParam: function dateParam() {
            return this.$moment(this.selectedDate).format('YYYY-MM-DD');
        }
    },
    created: function created() {
        this.loadEvent();
    },

    methods: {
        parseDate: function parseDate(date) {
            date = date.split(' ');
            var d = date[0].split('/');
            d = d.concat(date[1].split(':'));
            return new Date(d[2], d[1] - 1, d[0], d[3], d[4]);
        },
        changeDate: function changeDate(offset) {
            var newDate = new Date(this.selectedDate);
            newDate.setDate(newDate.getDate() + offset);
            this.selectedDate = newDate;
            this.loadEvent();
        },
        goToToday: function goToToday() {
            this.selectedDate = new Date();
            this.loadEvent();
        },
        loadEvent: function loadEvent() {
            var _this = this;

            this.calendar = [];
            this.isLoading = true;
            var dateStr = this.isToday ? null : this.dateParam;
            __WEBPACK_IMPORTED_MODULE_1__resources_user__["a" /* default */].fetchCalendar(dateStr).then(function (result) {
                if (result.data.success) {
                    var parsedData = result.data.rdvs.map(function (rdv) {
                        return {
                            date: _this.parseDate(rdv.start_date),
                            hour: {
                                start: _this.parseDate(rdv.start_date),
                                end: _this.parseDate(rdv.end_date)
                            },
                            type: rdv.type,
                            customer: rdv.client.user.first_name + ' ' + rdv.client.user.last_name,
                            clientId: rdv.client.user.id,
                            clientPhone: rdv.client.user.phone || null,
                            clientEmail: rdv.client.user.email || null,
                            id: rdv.id,
                            description: rdv.description || null
                        };
                    });
                    _this.calendar = parsedData;
                }
            }).catch(function (error) {
                console.error('Erreur fetchAppointments:', error);
            }).finally(function () {
                _this.isLoading = false;
            });
        },
        handleMouseDown: function handleMouseDown(e) {
            this.isDragging = true;
            var slider = this.$refs.eventsContainer;
            this.startX = e.pageX - slider.offsetLeft;
            this.scrollLeft = slider.scrollLeft;
        },
        handleMouseLeave: function handleMouseLeave() {
            this.isDragging = false;
        },
        handleMouseUp: function handleMouseUp() {
            this.isDragging = false;
        },
        handleMouseMove: function handleMouseMove(e) {
            if (!this.isDragging) return;
            e.preventDefault();
            var slider = this.$refs.eventsContainer;
            var x = e.pageX - slider.offsetLeft;
            var walk = (x - this.startX) * 2;
            slider.scrollLeft = this.scrollLeft - walk;
        }
    }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_user_js__ = __webpack_require__(50);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BoardClientActions',
  components: {
    CardClient: __WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      clients: [],
      searchQuery: '',
      searchError: '',
      activeFilters: ['all'],
      hasSearched: false
    };
  },

  computed: {
    filteredClients: function filteredClients() {
      var _this = this;

      if (this.activeFilters.includes('all')) return this.clients;

      return this.clients.filter(function (client) {
        if (!client.actions || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(client.actions) !== 'object') return false;
        return _this.activeFilters.some(function (filterValue) {
          var option = FILTER_OPTIONS.find(function (f) {
            return f.value === filterValue;
          });
          return option && option.apiKey && client.actions[option.apiKey];
        });
      });
    }
  },
  created: function created() {
    this.loadClients();
  },

  methods: {
    loadClients: function loadClients() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__resources_user_js__["a" /* default */].getClientsForDashboard();

              case 4:
                response = _context.sent;

                if (response.status === 200) {
                  _this2.clients = response.data;
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.error('Erreur lors du chargement des clients:', _context.t0);

              case 11:
                _context.prev = 11;

                _this2.loading = false;
                return _context.finish(11);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 8, 11, 14]]);
      }))();
    },
    searchClient: function searchClient() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var query, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _this3.searchQuery.trim();

                if (query) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _this3.loading = true;
                _this3.searchError = '';
                _this3.hasSearched = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __WEBPACK_IMPORTED_MODULE_4__resources_user_js__["a" /* default */].searchClients(query);

              case 9:
                response = _context2.sent;

                if (response.status === 200) {
                  _this3.clients = response.data;
                }
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](6);

                _this3.searchError = _context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.error ? _context2.t0.response.data.error : 'Une erreur est survenue lors de la recherche.';

              case 16:
                _context2.prev = 16;

                _this3.loading = false;
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 13, 16, 19]]);
      }))();
    },
    removeClient: function removeClient(clientId) {
      this.clients = this.clients.filter(function (c) {
        return c.id !== clientId;
      });
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'BoardHeader'
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Forms_search_vue__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Forms_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Forms_search_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Board_BoardProspectSteps_vue__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Board_BoardProspectSteps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Board_BoardProspectSteps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BoardProspect',
  components: {
    SearchForm: __WEBPACK_IMPORTED_MODULE_0__components_Forms_search_vue___default.a,
    BoardProspectSteps: __WEBPACK_IMPORTED_MODULE_1__components_Board_BoardProspectSteps_vue___default.a
  },
  data: function data() {
    return {
      searchQuery: '',
      showAddContact: false,
      contentModal: __WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact___default.a,
      modalData: { defaultType: 'Prospect' }
    };
  },

  methods: {
    handleSearch: function handleSearch(query) {
      this.searchQuery = query;
    },
    handleClearSearch: function handleClearSearch() {
      this.searchQuery = '';
    },
    openAddContactModal: function openAddContactModal() {
      this.showAddContact = true;
    },
    closeAddContactModal: function closeAddContactModal() {
      this.showAddContact = false;
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_doc_svg__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_doc_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_doc_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_shield_svg__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_shield_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_shield_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_diag_svg__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_diag_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_diag_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_databases_svg__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_databases_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_databases_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_calendarV2_svg__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_calendarV2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_calendarV2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Board_CardProspect_vue__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Board_CardProspect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Board_CardProspect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resources_user_js__ = __webpack_require__(50);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BoardProspectSteps',
  components: {
    CardProspect: __WEBPACK_IMPORTED_MODULE_7__components_Board_CardProspect_vue___default.a
  },
  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      prospects: [],
      colProspect: [{
        name: 'Paysage Patrimonial',
        tagline: 'À compléter',
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_img_doc_svg___default.a,
        id: 'col_pp'
      }, {
        name: 'LCB-FT',
        tagline: 'Vérification',
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_img_shield_svg___default.a,
        id: 'col_lcbft'
      }, {
        name: 'Conseil',
        tagline: 'Lettres & rapports',
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_img_diag_svg___default.a,
        id: 'col_conseil'
      }, {
        name: 'Inscription Partenaire',
        tagline: 'Base de données',
        icon: __WEBPACK_IMPORTED_MODULE_5__assets_img_databases_svg___default.a,
        id: 'col_inscription_partenaire'
      }, {
        name: 'Abonnement',
        tagline: 'Date d\'effet',
        icon: __WEBPACK_IMPORTED_MODULE_6__assets_img_calendarV2_svg___default.a,
        id: 'col_abonnement'
      }]
    };
  },

  computed: {
    filteredProspects: function filteredProspects() {
      if (!this.searchQuery) {
        return this.prospects;
      }
      var query = this.searchQuery.toLowerCase();
      return this.prospects.filter(function (prospect) {
        var fullName = ('' + (prospect.fullName || '')).toLowerCase();
        return fullName.includes(query);
      });
    },
    prospectsByColumn: function prospectsByColumn() {
      var _this = this;

      var columns = {};
      this.colProspect.forEach(function (col) {
        columns[col.id] = _this.filteredProspects.filter(function (p) {
          return p.colonne === col.id;
        });
      });
      return columns;
    },
    totalProspectsDisplayed: function totalProspectsDisplayed() {
      return this.filteredProspects.length;
    }
  },
  created: function created() {
    this.loadProspect();
  },

  methods: {
    onToggleInscritPartenaire: function onToggleInscritPartenaire(userId, value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var prospect, name, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                prospect = _this2.prospects.find(function (p) {
                  return p.id === userId;
                });

                if (!value) {
                  _context.next = 9;
                  break;
                }

                name = prospect ? prospect.fullName : 'ce prospect';
                _context.next = 5;
                return _this2.$swal.fire({
                  title: 'Confirmation',
                  text: 'Avez-vous bien inscrit ' + name + ' dans la base de vos partenaires ?',
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#AF9376',
                  confirmButtonText: 'Confirmer',
                  cancelButtonText: 'Annuler'
                });

              case 5:
                result = _context.sent;

                if (result.value) {
                  _context.next = 9;
                  break;
                }

                if (prospect) {
                  prospect.partenaire_incription = false;
                }
                return _context.abrupt('return');

              case 9:
                _context.prev = 9;
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_8__resources_user_js__["a" /* default */].updateInscritPartenaire(userId, value);

              case 12:
                if (prospect) {
                  prospect.partenaire_incription = value;
                }
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);

                console.error('Erreur mise à jour inscription partenaire:', _context.t0);
                if (prospect) {
                  prospect.partenaire_incription = !value;
                }

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[9, 15]]);
      }))();
    },
    loadProspect: function loadProspect() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__resources_user_js__["a" /* default */].getProspectsForDashboard();

              case 4:
                response = _context2.sent;

                if (response.status === 200) {
                  _this3.prospects = response.data;
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.error('Erreur:', _context2.t0);

              case 11:
                _context2.prev = 11;

                _this3.loading = false;
                return _context2.finish(11);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 8, 11, 14]]);
      }))();
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_clock_svg__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_img_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_img_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_phone_svg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_phone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_phone_svg__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CardCalendar',
    props: ['item'],
    data: function data() {
        return {
            IconClock: __WEBPACK_IMPORTED_MODULE_0__common_assets_img_clock_svg___default.a,
            IconTel: __WEBPACK_IMPORTED_MODULE_1__assets_img_phone_svg___default.a
        };
    },

    methods: {
        getTypeBadgeClass: function getTypeBadgeClass(type) {
            switch (type) {
                case 'Visio Call':
                    return 'card-calendar__type-badge--visio';
                case 'Rendez-vous':
                    return 'card-calendar__type-badge--rdv';
                case 'Appel téléphonique':
                    return 'card-calendar__type-badge--phone';
                default:
                    return '';
            }
        }
    }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_user_svg__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_mail_svg__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_phone_svg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_phone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_phone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_calendar_svg__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resources_user__ = __webpack_require__(50);











var DATE_FORMAT = 'DD/MM/YYYY HH:mm';

var ACTION_CONFIG = {
  'birthday_client': { label: 'Anniversaire Client', cssClass: 'dashboard-action--birthday' },
  'anniversaire_paysage': { label: 'Anniversaire Paysage Patrimonial', cssClass: 'dashboard-action--paysage' },
  'renouvellement': { label: 'Renouvellement', cssClass: 'dashboard-action--renouvellement' },
  'versement_conditionnel': { label: 'Versement conditionnel', cssClass: 'dashboard-action--versement' },
  'versement_complementaire': { label: 'Versement complémentaire', cssClass: 'dashboard-action--versement' }
};

var API_KEY_MAPPING = {
  'birthday_client': 'birthday_client',
  'birthdate_pp': 'anniversaire_paysage',
  'renouvellement': 'renouvellement'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CardClient',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      imgUser: __WEBPACK_IMPORTED_MODULE_4__assets_img_user_svg___default.a,
      imgMail: __WEBPACK_IMPORTED_MODULE_5__assets_img_mail_svg___default.a,
      imgPhone: __WEBPACK_IMPORTED_MODULE_6__assets_img_phone_svg___default.a,
      imgCalendar: __WEBPACK_IMPORTED_MODULE_7__assets_img_calendar_svg___default.a,
      renewalLoading: false
    };
  },

  computed: {
    clientName: function clientName() {
      return this.user.fullName || 'Client';
    },
    clientEmail: function clientEmail() {
      return this.user.email || '';
    },
    clientPhone: function clientPhone() {
      return this.user.phone || '';
    },
    clientStatus: function clientStatus() {
      return this.user.status || 'Client';
    },
    actions: function actions() {
      var _this = this;

      var raw = this.user.actions;
      if (!raw || (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(raw)) !== 'object') return [];
      var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day');
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(raw).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            date = _ref2[1];

        return date;
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            date = _ref4[1];

        var anniversary = _this.getNextAnniversary(date, today);
        return {
          type: API_KEY_MAPPING[key] || key,
          date: anniversary.format('YYYY-MM-DD'),
          daysUntil: anniversary.diff(today, 'days')
        };
      });
    },
    daysSinceCreation: function daysSinceCreation() {
      if (!this.user.created_at) return 0;
      var createdDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.user.created_at, DATE_FORMAT);
      var days = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(createdDate, 'days');
      return this.formatDuration(days);
    },
    creationDate: function creationDate() {
      if (!this.user.created_at) return null;
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.user.created_at, DATE_FORMAT).format('DD/MM/YYYY');
    }
  },
  methods: {
    getNextAnniversary: function getNextAnniversary(date, today) {
      var anniversary = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, DATE_FORMAT).year(today.year());
      if (anniversary.isBefore(today, 'day')) {
        var nextYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, DATE_FORMAT).year(today.year() + 1);
        if (nextYear.diff(today, 'days') < today.diff(anniversary, 'days')) {
          anniversary = nextYear;
        }
      }
      return anniversary;
    },
    formatDuration: function formatDuration(days) {
      if (days < 1) return "aujourd'hui";
      if (days === 1) return '1 jour';
      if (days < 31) return days + ' jours';
      var months = Math.floor(days / 30);
      if (months === 1) return '1 mois';
      if (months < 12) return months + ' mois';
      var years = Math.floor(months / 12);
      if (years === 1) return '1 an';
      return years + ' ans';
    },
    formatDaysText: function formatDaysText(days) {
      if (days === 0) return "Aujourd'hui";
      var prefix = days < 0 ? 'il y a ' : 'dans ';
      return prefix + this.formatDuration(Math.abs(days));
    },
    getActionClass: function getActionClass(action) {
      var config = ACTION_CONFIG[action.type];
      return config ? config.cssClass : 'dashboard-action--default';
    },
    getActionLabel: function getActionLabel(action) {
      var config = ACTION_CONFIG[action.type];
      return config ? config.label : action.type;
    },
    onRenewalCheck: function onRenewalCheck() {
      var _this2 = this;

      this.renewalLoading = true;
      __WEBPACK_IMPORTED_MODULE_8__resources_user__["a" /* default */].updateContractRenewal(this.user.id).then(function () {
        _this2.$emit('renewal-updated', _this2.user.id);
      }).catch(function () {
        _this2.$notify({ type: 'error', text: 'Erreur lors de la mise à jour du renouvellement' });
      }).finally(function () {
        _this2.renewalLoading = false;
      });
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_user_svg__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_mail_svg__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_mail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_phone_svg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_phone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_phone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_calendar_svg__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_time_svg__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_time_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_time_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_doc_svg__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_doc_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_doc_svg__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CardProspect',
    props: ['user'],
    data: function data() {
        return {
            imgUser: __WEBPACK_IMPORTED_MODULE_1__assets_img_user_svg___default.a,
            imgMail: __WEBPACK_IMPORTED_MODULE_2__assets_img_mail_svg___default.a,
            imgPhone: __WEBPACK_IMPORTED_MODULE_3__assets_img_phone_svg___default.a,
            imgCalendar: __WEBPACK_IMPORTED_MODULE_4__assets_img_calendar_svg___default.a,
            imgTime: __WEBPACK_IMPORTED_MODULE_5__assets_img_time_svg___default.a,
            imgDoc: __WEBPACK_IMPORTED_MODULE_6__assets_img_doc_svg___default.a
        };
    },

    methods: {
        signatureStatus: function signatureStatus(value) {
            var statusMap = { false: 'A faire', ready: 'A signer', completed: 'Signé' };
            return statusMap[value] || 'A faire';
        },
        signatureClass: function signatureClass(value) {
            var classMap = { false: 'dashboard-badge--red', ready: 'dashboard-badge--orange', completed: 'dashboard-badge--green' };
            return classMap[value] || 'dashboard-badge--red';
        },
        formatDuration: function formatDuration(days) {
            if (days < 1) return "aujourd'hui";
            if (days === 1) return '1 jour';
            if (days < 31) return days + ' jours';
            var months = Math.floor(days / 30);
            if (months === 1) return '1 mois';
            if (months < 12) return months + ' mois';
            var years = Math.floor(months / 12);
            if (years === 1) return '1 an';
            return years + ' ans';
        }
    },
    computed: {
        statusPaysage: function statusPaysage() {
            if (this.user.pp_status) {
                return 'A signer';
            } else if (this.user.has_pp) {
                return 'En cours';
            } else {
                return 'A faire';
            }
        },
        statusPaysageClass: function statusPaysageClass() {
            return this.user.has_pp ? 'dashboard-badge--orange' : 'dashboard-badge--red';
        },
        daysSinceCreation: function daysSinceCreation() {
            if (!this.user.created_at) return 0;
            var createdDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.user.created_at, 'DD/MM/YYYY HH:mm');
            var days = __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(createdDate, 'days');
            return this.formatDuration(days);
        },
        creationDate: function creationDate() {
            if (!this.user.created_at) return null;
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.user.created_at, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY');
        },
        lettreMissionStatus: function lettreMissionStatus() {
            return this.signatureStatus(this.user.lettre_de_mission_signe);
        },
        lettreMissionClass: function lettreMissionClass() {
            return this.signatureClass(this.user.lettre_de_mission_signe);
        },
        rapportMissionStatus: function rapportMissionStatus() {
            return this.signatureStatus(this.user.rapport_mission_signe);
        },
        rapportMissionClass: function rapportMissionClass() {
            return this.signatureClass(this.user.rapport_mission_signe);
        }
    }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Justificatory',
	components: {
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a,
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			clients: [],
			docs: []
		};
	},
	mounted: function mounted() {
		this.clients = this.user.clients;
		this.currentClient = this.clients[0];
		this.fetchDocs();
	},

	methods: {
		setClient: function setClient(value) {
			this.selected = value.key;
		},
		fetchDocs: function fetchDocs() {
			var _this = this;

			this.docs = [];
			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/justificatifs/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	watch: {
		currentClient: function currentClient() {
			this.fetchDocs();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a,
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			clients: [],
			docs: []
		};
	},
	mounted: function mounted() {
		this.clients = this.user.clients;
		this.currentClient = this.clients[0];
	},

	methods: {
		setClient: function setClient(value) {
			this.selected = value.key;
		},
		fetchDocs: function fetchDocs() {
			var _this = this;

			this.docs = [];
			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/company-information/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	watch: {
		currentClient: function currentClient() {
			this.fetchDocs();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a,
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			clients: [],
			docs: []
		};
	},
	mounted: function mounted() {
		this.clients = this.user.clients;
		this.currentClient = this.clients[0];
		this.fetchDocs();
	},

	methods: {
		fetchDocs: function fetchDocs() {
			var _this = this;

			this.docs = [];
			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/lcb-ft/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	})),
	watch: {
		currentClient: function currentClient() {
			this.fetchDocs();
		}
	}
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			docs: []
		};
	}
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Operations',
	components: {
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a,
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			docs: [],
			missions: [],
			isLoadingDocs: false
		};
	},

	methods: {
		fetchDocs: function fetchDocs() {
			var _this = this;

			if (!this.currentClient || !this.currentClient.id) return;

			this.isLoadingDocs = true;
			this.docs = [];

			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/operations/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn('Erreur lors du fetch des documents :', error);
			}).finally(function () {
				_this.isLoadingDocs = false;
			});
		}
	},
	mounted: function mounted() {
		console.log('this.clients', this.client);
		if (this.clients.length > 0) {
			this.currentClient = this.clients[0];
		}
	},
	watch: {
		clients: function clients(newVal) {
			if (newVal && newVal.length > 0 && !this.currentClient) {
				this.currentClient = newVal[0];
			}
		},
		currentClient: function currentClient(newClient, oldClient) {
			var _this2 = this;

			if (!newClient || !newClient.id) return;
			if (oldClient && oldClient.id === newClient.id) return;

			this.$store.dispatch('getClient', newClient.id).then(function () {
				var client = _this2.clients.find(function (c) {
					return c.id === newClient.id;
				});
				_this2.missions = client ? client.missions : [];
			});
			this.fetchDocs();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		clients: 'getClients'
	}), {
		othersDocs: function othersDocs() {
			return this.docs.filter(function (item) {
				return !item.sub_category || item.sub_category === 'null';
			});
		},
		missionsWithDocuments: function missionsWithDocuments() {
			return this.missions.filter(function (mission) {
				return mission.documents && mission.documents.length > 0;
			});
		}
	})
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'PatrimonialDocuments',
	components: {
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a,
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			clients: [],
			docs: []
		};
	},
	mounted: function mounted() {
		this.clients = this.user.clients;
		this.currentClient = this.clients[0];
	},

	methods: {
		setClient: function setClient(value) {
			this.selected = value.key;
		},
		fetchDocs: function fetchDocs() {
			var _this = this;

			this.docs = [];
			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/personal-estate/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	watch: {
		currentClient: function currentClient() {
			this.fetchDocs();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_0__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			docs: null
		};
	},

	methods: {
		fetchDocs: function fetchDocs() {
			console.log('no need');
		}
	},
	mounted: function mounted() {
		this.docs = this.$store.getters.typeDocuments('private');
	}
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a,
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			clients: [],
			docs: []
		};
	},

	methods: {
		fetchDocs: function fetchDocs() {
			var _this = this;

			this.docs = [];
			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/autre/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	mounted: function mounted() {
		this.clients = this.user.clients;
		this.currentClient = this.clients[0];
		this.fetchDocs();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	})),
	watch: {
		currentClient: function currentClient() {
			this.fetchDocs();
		}
	}
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a,
		TileDoc: __WEBPACK_IMPORTED_MODULE_2__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			currentClient: null,
			clients: [],
			docs: []
		};
	},
	mounted: function mounted() {
		this.clients = this.user.clients;
		this.currentClient = this.clients[0];
	},

	methods: {
		setClient: function setClient(value) {
			this.selected = value.key;
		},
		fetchDocs: function fetchDocs() {
			var _this = this;

			this.docs = [];
			__WEBPACK_IMPORTED_MODULE_3__common_services_Emma__["a" /* default */].get('api/documents/subscriptions/' + this.currentClient.id).then(function (result) {
				if (result.data.success) {
					_this.docs = result.data.documents;
				}
			}).catch(function (error) {
				console.warn(error);
			});
		}
	},
	watch: {
		currentClient: function currentClient() {
			this.fetchDocs();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchForm',
  props: {
    placeholder: {
      type: String,
      default: 'Rechercher un prospect...'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchQuery: this.value
    };
  },

  watch: {
    value: function value(newValue) {
      this.searchQuery = newValue;
    },
    searchQuery: function searchQuery(newValue) {
      this.$emit('input', newValue);
      this.$emit('search', newValue);
    }
  },
  methods: {
    handleSubmit: function handleSubmit(e) {
      e.preventDefault();
      this.$emit('submit', this.searchQuery);
    },
    clearSearch: function clearSearch() {
      this.searchQuery = '';
      this.$emit('clear');
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);







__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* Validator */].extend('alpha_dash_spaces', {
	getMessage: function getMessage(field) {
		return 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces';
	},
	validate: function validate(value) {
		for (var i = 0; i < value.length; i++) {
			if ('abcdefghijklmnopqrstuvwxyzçéèêîïë -'.indexOf(value[i].toLowerCase()) === -1) {
				return false;
			}
		}
		return true;
	}
});

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AddContact',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a,
		CustomMultiselect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect___default.a
	},
	props: {
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	data: function data() {
		return {
			user: {
				firstname: null,
				lastname: null,
				phone: null,
				birthdate: null,
				email: null,
				origin: null,
				centerOfInterests: [],
				type: 'Client',
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				}
			},
			prospectTypes: ['Client', 'Prospect'],
			origins: ['Site web', 'Téléphone', 'Email', 'Salon', 'Réseau']
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		interests: 'tags'
	}), {
		defaultType: function defaultType() {
			return this.data && this.data.defaultType ? this.data.defaultType : 'Client';
		},
		selectedType: function selectedType() {
			return this.user.type || this.defaultType;
		},
		typeLabel: function typeLabel() {
			return this.selectedType === 'Prospect' ? 'prospect' : 'client';
		},
		typeLabelPlural: function typeLabelPlural() {
			return this.selectedType === 'Prospect' ? 'prospects' : 'clients';
		}
	}),
	mounted: function mounted() {
		this.user.origin = this.origins[0];
		if (this.data && this.data.defaultType) {
			this.user.type = this.data.defaultType;
		}
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		addContact: function addContact() {
			var _this = this;

			this.$validator.validate().then(function (validation) {
				if (validation) {
					_this.$store.dispatch('addClient', _this.user).then(function () {
						_this.$notify({
							type: 'success',
							group: 'default',
							title: 'Vous avez ajouté un nouveau contact',
							text: 'Il va recevoir un e-mail afin d\'activer son compte'
						});
						_this.$emit('close');
					}).catch(function (error) {
						_this.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue à l\'ajout du contact',
							text: error.message === 'Email is already in use.' ? 'Cette adresse e-mail est déjà utilisée' : 'Veuillez vérifier que les informations que vous avez renseignées sont correctes'
						});
					});
				}
			});
		}
	}
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_DragAndDrop__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_DragAndDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_DragAndDrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AddDocumentModal',
	props: ['data'],
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a,
		DragAndDrop: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_DragAndDrop___default.a,
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_4__common_components_Form_CustomSelectUser___default.a
	},
	data: function data() {
		return {
			type: 'Autres Documents',
			docTypeList: ['Autres Documents', 'Mes Justificatifs d\'identité', 'Opérations', 'Abonnements', 'Paysages patrimoniaux'],
			listOfJustificatifs: ['Carte d\'identité', 'Passeport', 'Titre de séjour', 'Permis de conduire'],
			typeOfJustificatif: null,
			name: null,
			file: null,
			fileRecto: null,
			fileVerso: null,
			docToAPI: {
				'Autres Documents': 'autre',
				'Mes Justificatifs d\'identité': 'justificatifs',
				'Opérations': 'operations',
				'Abonnements': 'subscriptions',
				'Paysages patrimoniaux': 'personal-estate'
			},
			confidential: false,
			client: null,
			clients: []
		};
	},
	mounted: function mounted() {
		this.clients = ['-'].concat(this.user.clients);
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		confirm: function confirm() {
			if (this.needTwoInput) {
				this.uploadDocument(this.fileRecto, '-recto');
				this.uploadDocument(this.fileVerso, '-verso');
			} else {
				this.uploadDocument(this.file, '');
			}
		},
		uploadDocument: function uploadDocument(file, suffixe) {
			var _this = this;

			var docType = this.resolveType(file.type);
			if (docType) {
				this.$store.dispatch('addDocument', {
					user_id: this.client !== '-' && this.client !== null ? this.client.id : this.user.id,
					category: this.docToAPI[this.type],
					type: docType,
					confidential: (this.type === 'Autres Documents' ? this.confidential : false) ? 1 : 0,
					file: file,
					subcategory: this.resolveSubCategory(),
					signature_required: false,
					signature_token: null,
					original_name: this.name + suffixe + '.' + docType
				}).then(function () {
					_this.$emit('close');
					_this.$notify({
						type: 'success',
						group: 'default',
						title: 'Document ajouté',
						text: ''
					});
				}).catch(function (error) {
					console.log('Error from add document : ', error);
					_this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez vérifier que votre document n\'est pas corrompu'
					});
				});
			} else {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Extension de fichier non reconnue',
					text: 'Les extensions autorisées sont : txt, pdf, doc, docx, xls, xslx'
				});
			}
		},
		resolveType: function resolveType(t) {
			var value = null;
			switch (t) {
				case 'application/pdf':
					value = 'pdf';
					break;
				case 'application/octet-stream':
					value = 'txt';
					break;
				case 'application/msword':
					value = 'doc';
					break;
				case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
					value = 'docx';
					break;
				case 'application/vnd.ms-excel':
					value = 'xls';
					break;
				case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
					value = 'xlsx';
					break;
				default:
					value = false;
			}

			return value;
		},
		resolveSubCategory: function resolveSubCategory() {
			if (this.type === 'Mes Justificatifs d\'identité') {
				return this.listOfJustificatifs.indexOf(this.typeOfJustificatif) + 1;
			} else {
				return null;
			}
		}
	},
	watch: {
		type: function type() {
			this.client = '-';
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}), {
		needTwoInput: function needTwoInput() {
			if (this.type === 'Mes Justificatifs d\'identité') {
				return this.typeOfJustificatif === 'Carte d\'identité' || this.typeOfJustificatif === 'Titre de séjour';
			} else {
				return false;
			}
		}
	})
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc_selectable_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc_selectable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc_selectable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Certified',
	props: ['data'],
	components: {
		TileDocSelectable: __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc_selectable_vue___default.a
	},
	data: function data() {
		return {
			docs: [],
			good: __WEBPACK_IMPORTED_MODULE_2__common_assets_img_good_svg___default.a,
			selected: [],
			idToUniversign: ['TYPE_ID_CARD', 'TYPE_PASSPORT', 'TYPE_TITRE_DE_SEJOUR', 'TYPE_DRIVE_LICENCE']
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.docs = [];
		__WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/documents/justificatifs/' + this.data.id).then(function (result) {
			if (result.data.success) {
				_this.docs = result.data.documents;
			}
		}).catch(function (error) {
			console.warn(error);
		});
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		send: function send() {
			var _this2 = this;

			if (this.selected.length > 0) {
				var userId = this.data.id;
				var documentsId = '';
				this.selected.forEach(function (key, index) {
					documentsId += (index !== 0 ? '_' : '') + _this2.docs[key].id;
				});

				var docType = parseInt(this.docs[this.selected[0]].sub_category) - 1;

				if (docType !== null) {
					this.$store.commit('LOADER_IN');
					__WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/universign/validation-account/' + userId + '/' + documentsId + '/' + docType).then(function (result) {
						_this2.$store.commit('LOADER_OUT');
						if (result.data.success) {
							_this2.$notify({
								type: 'success',
								group: 'default',
								title: 'Les documents ont pu être validé',
								text: ''
							});
							_this2.close();
						} else {
							_this2.$notify({
								type: 'error',
								group: 'default',
								title: 'Les documents n\'ont pas pu être validé',
								text: ''
							});
						}
					}).catch(function () {
						_this2.$store.commit('LOADER_OUT');
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Les documents n\'ont pas pu être validé',
							text: ''
						});
					});
				} else {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Ce fichier n\'est pas valide',
						text: ''
					});
				}
			} else {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Il faut selectionner au moins un fichier',
					text: ''
				});
			}
		},
		select: function select(key) {
			if (this.selected.indexOf(key) === -1) {
				this.selected.push(key);
			} else {
				this.selected.splice(this.selected.indexOf(key), 1);
			}
		},
		isSelected: function isSelected(key) {
			return this.selected.indexOf(key) !== -1;
		}
	}
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ChangePassword',
	methods: {
		close: function close() {
			this.$emit('close');
		},
		confirm: function confirm() {
			var _this = this;

			this.$validator.validate().then(function (validation) {
				if (validation && _this.newPassword1 === _this.newPassword2) {
					var data = new FormData();
					data.append('current_password', _this.password);
					data.append('plain_password[first]', _this.newPassword1);
					data.append('plain_password[second]', _this.newPassword2);
					console.log(data.get('current_password'));
					_this.$store.dispatch('editPassword', data).then(function (result) {
						_this.$notify({
							type: 'success',
							group: 'default',
							title: 'Votre mot de passe a été changé',
							text: ''
						});
						_this.$emit('close');
					}).catch(function (error) {
						console.warn(error);
						_this.$notify({
							type: 'error',
							group: 'default',
							title: 'Le changement de mot de passe a échoué',
							text: 'Vous vous êtes peut être trompé dans le mot de passe'
						});
					});
				}
			});
		}
	},
	data: function data() {
		return {
			password: null,
			newPassword1: null,
			newPassword2: null
		};
	}
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_CompanyInformation_modal_RgpdCompany__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_CompanyInformation_modal_RgpdCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_CompanyInformation_modal_RgpdCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_UnlockSignaturePopupTutorial__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_UnlockSignaturePopupTutorial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_components_UnlockSignaturePopupTutorial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_resources_Universign__ = __webpack_require__(114);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompanyInformation',
  props: ['data'],
  components: {
    CustomToggle: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomToggle___default.a,
    CustomSelect: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelect___default.a,
    UnlockSignaturePopupTutorial: __WEBPACK_IMPORTED_MODULE_5__common_components_UnlockSignaturePopupTutorial___default.a
  },
  data: function data() {
    return {
      isAdvisor: "cgpi" === 'cgpi',
      showRgpdModal: false,
      modalRgpd: __WEBPACK_IMPORTED_MODULE_4__common_components_CompanyInformation_modal_RgpdCompany___default.a,
      signaturePopupBlocked: false,
      showUnlockPopupTuto: false,
      taxRegimes: ['Impôt sur les sociétés', 'Impôt sur le revenu', 'TVA'],
      companyData: {
        companyName: '',
        registrationNumber: '',
        headquartersAddress: '',
        taxRegime: '',
        activities: '',
        managers: [''],
        beneficiaries: [''],
        documentsConfirmed: false,
        signatureConfirmed: false
      }
    };
  },
  mounted: function mounted() {
    this.loadCompanyData();
  },

  methods: {
    loadCompanyData: function loadCompanyData() {
      var _this = this;

      if (!this.data || !this.data.id) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].get('api/clients/' + this.data.id + '/company-information').then(function (result) {
        if (result.data && result.data.company) {
          var apiData = result.data.company;

          _this.companyData = {
            companyName: apiData.company_name || apiData.companyName || '',
            registrationNumber: apiData.registration_number || apiData.registrationNumber || '',
            headquartersAddress: apiData.headquarters_address || apiData.headquartersAddress || '',
            taxRegime: apiData.tax_regime || apiData.taxRegime || '',
            activities: apiData.activities || '',
            managers: apiData.managers || [''],
            beneficiaries: apiData.beneficiaries || [''],
            documentsConfirmed: apiData.documents_confirmed || apiData.documentsConfirmed || false,
            signatureConfirmed: apiData.signature_confirmed || apiData.signatureConfirmed || false
          };

          if (!_this.companyData.managers || _this.companyData.managers.length === 0) {
            _this.companyData.managers = [''];
          }
          if (!_this.companyData.beneficiaries || _this.companyData.beneficiaries.length === 0) {
            _this.companyData.beneficiaries = [''];
          }
        }
      }).catch(function (error) {
        console.warn('Error loading company data:', error);
      });
    },
    addManager: function addManager() {
      this.companyData.managers.push('');
    },
    removeManager: function removeManager(index) {
      this.companyData.managers.splice(index, 1);
    },
    addBeneficiary: function addBeneficiary() {
      this.companyData.beneficiaries.push('');
    },
    removeBeneficiary: function removeBeneficiary(index) {
      this.companyData.beneficiaries.splice(index, 1);
    },
    validateForm: function validateForm() {
      var errors = [];

      if (!this.companyData.companyName) {
        errors.push('Le nom de l\'entreprise est requis');
      }
      if (!this.companyData.registrationNumber) {
        errors.push('Le numéro d\'immatriculation est requis');
      }
      if (!this.companyData.headquartersAddress) {
        errors.push('L\'adresse du siège social est requise');
      }
      if (!this.companyData.taxRegime) {
        errors.push('Le régime fiscal est requis');
      }
      if (!this.companyData.activities) {
        errors.push('Les activités sont requises');
      }
      if (!this.companyData.managers.some(function (m) {
        return m && m.trim();
      })) {
        errors.push('Au moins un dirigeant est requis');
      }
      if (!this.companyData.beneficiaries.some(function (b) {
        return b && b.trim();
      })) {
        errors.push('Au moins un bénéficiaire effectif est requis');
      }
      if (!this.companyData.documentsConfirmed) {
        errors.push('Vous devez confirmer avoir transmis les documents');
      }

      if (errors.length > 0) {
        this.$notify({
          group: 'default',
          type: 'error',
          title: 'Validation',
          text: errors.join('<br>')
        });
        return false;
      }

      return true;
    },
    save: function save() {
      var _this2 = this;

      if (!this.validateForm()) {
        return;
      }

      var cleanedData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.companyData, {
        managers: this.companyData.managers.filter(function (m) {
          return m && m.trim();
        }),
        beneficiaries: this.companyData.beneficiaries.filter(function (b) {
          return b && b.trim();
        })
      });

      __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/clients/' + this.data.id + '/company-information', cleanedData).then(function () {
        _this2.$notify({
          group: 'default',
          type: 'success',
          title: 'Succès',
          text: 'Les informations de la société ont été sauvegardées'
        });
        _this2.$emit('close');
      }).catch(function (error) {
        _this2.$notify({
          group: 'default',
          type: 'error',
          title: 'Erreur',
          text: 'Erreur lors de la sauvegarde des informations'
        });
        console.error('Error saving company data:', error);
      });
    },
    signDocument: function signDocument() {
      var _this3 = this;

      if (!this.companyData.signatureConfirmed) {
        return;
      }

      if (!this.validateForm()) {
        return;
      }

      var cleanedData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.companyData, {
        managers: this.companyData.managers.filter(function (m) {
          return m && m.trim();
        }),
        beneficiaries: this.companyData.beneficiaries.filter(function (b) {
          return b && b.trim();
        })
      });

      __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/clients/' + this.data.id + '/company-information', cleanedData).then(function () {
        _this3.$store.commit('LOADER_IN');
        __WEBPACK_IMPORTED_MODULE_1__common_services_Emma__["a" /* default */].post('api/clients/' + _this3.data.id + '/company-information/document').then(function (result) {
          var idFile = result.data.file.split('/')[result.data.file.split('/').length - 1];

          __WEBPACK_IMPORTED_MODULE_6__common_resources_Universign__["a" /* default */].signCompanyInformation(idFile).then(function (result) {
            if (result.data.success) {
              if (false) {
                var win = window.open(result.data.signatureUrl);
                if (win) {
                  win.focus();
                  _this3.$emit('close');
                } else {
                  _this3.signaturePopupBlocked = true;
                }
              } else {
                _this3.$notify({
                  type: 'success',
                  group: 'default',
                  title: 'Demande de signature envoyée',
                  text: 'La demande de signature a bien été envoyée au client'
                });
                _this3.$emit('close');
              }
              _this3.$store.commit('LOADER_OUT');
            } else {
              _this3.$notify({
                type: 'error',
                group: 'default',
                title: 'Erreur',
                text: result.data.error || 'Une erreur est survenue lors de la signature'
              });
              _this3.$store.commit('LOADER_OUT');
            }
          }).catch(function (error) {
            _this3.$notify({
              type: 'error',
              group: 'default',
              title: 'Erreur',
              text: 'Erreur lors de la demande de signature'
            });
            console.error('Error signing company data:', error);
            _this3.$store.commit('LOADER_OUT');
          });
        }).catch(function (error) {
          _this3.$notify({
            type: 'error',
            group: 'default',
            title: 'Erreur',
            text: 'Erreur lors de la génération du document'
          });
          console.error('Error generating company document:', error);
          _this3.$store.commit('LOADER_OUT');
        });
      }).catch(function (error) {
        _this3.$notify({
          group: 'default',
          type: 'error',
          title: 'Erreur',
          text: 'Erreur lors de la sauvegarde des informations'
        });
        console.error('Error saving company data:', error);
      });
    },
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(97);








__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* Validator */].extend('alpha_dash_spaces', {
	getMessage: function getMessage(field) {
		return 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces';
	},
	validate: function validate(value) {
		for (var i = 0; i < value.length; i++) {
			if ('abcdefghijklmnopqrstuvwxyzçéèêîïë -'.indexOf(value[i].toLowerCase()) === -1) {
				return false;
			}
		}
		return true;
	}
});

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AddContact',
	props: ['data'],
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelect___default.a,
		CustomMultiselect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomMultiselect___default.a
	},
	data: function data() {
		return {
			user: {
				firstname: null,
				lastname: null,
				phone: null,
				email: null,
				origin: null,
				centerOfInterests: [],
				type: 'Client',
				birthdate: null,
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				}
			},
			prospectTypes: ['Client', 'Prospect'],
			origins: ['Site web', 'Téléphone', 'Email', 'Salon', 'Réseau']
		};
	},
	mounted: function mounted() {
		this.user.id = this.data.id;
		this.user.firstname = this.data.firstname;
		this.user.lastname = this.data.lastname;
		this.user.phone = this.data.phone;
		this.user.email = this.data.email;
		this.user.type = this.data.type === 'client_subscriber' ? 'Client' : 'Prospect';
		this.user.origin = this.data.source;
		this.user.centerOfInterests = this.data.center_of_interest.slice();
		var bd = this.data.birthdate;
		bd = bd.getDate() + '-' + ('00' + (bd.getMonth() + 1)).slice(-2) + '-' + bd.getFullYear();
		this.user.birthdate = bd.split('-').reverse().join('-');
		this.user.address = this.data.address;
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		addContact: function addContact() {
			var _this = this;

			this.$store.dispatch('editClient', this.user).then(function () {
				_this.$notify({
					type: 'success',
					group: 'default',
					title: 'Votre contact a bien été édité',
					text: ''
				});
				_this.$emit('close');
			}).catch(function () {
				_this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue à l\'édition du contact',
					text: 'Veuillez vérifier que les informations que vous avez renseignées sont correctes'
				});
			});
		},
		setNewCenterOfInterests: function setNewCenterOfInterests(values) {
			this.user.centerOfInterests = values;
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
		interests: 'tags'
	}))
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_data_Country__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_user__ = __webpack_require__(50);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'LCBCFT',
	components: {
		inputDate: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate___default.a,
		CustomSelect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default.a
	},
	data: function data() {
		return {
			date: new Date(),
			origin: null,
			origins: ['Sollicitation spontanée', 'Prospection', 'Recommendation'],
			remoteContractualization: false,
			professionalCategory: null,
			professionnalCategories: ['-', 'Profession artistique', 'Commerçants et assimilés', 'Profession libérale', 'Toute autre profession'],
			activityRisk: false,
			suspicionOfFraud: false,
			wasPJA: false,
			wasSomeonePJA: false,
			isVIP: false,
			country: null,
			secondCountry: null,
			fiscCountry: null,
			countryList: __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_data_Country__["a" /* default */],
			banqueCountry: null,
			banqueCountries: ['Union Européenne', 'OCDE Hors UE', 'Pays non coopératif', 'Hors UE'],
			penal: false,
			filling: true,
			score: 2,
			score_label: 'Vigilance normale',
			errorInForm: false
		};
	},
	mounted: function mounted() {
		this.origin = this.origins[0];
		this.professionalCategory = this.professionnalCategories[0];
		this.banqueCountry = this.banqueCountries[0];
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		sendScore: function sendScore() {
			var _this = this;

			this.errorInForm = false;
			this.$validator.validate().then(function (validation) {
				if (validation) {
					_this.$store.commit('LOADER_IN');
					__WEBPACK_IMPORTED_MODULE_4__resources_user__["a" /* default */].postLCBCFT({
						user_id: _this.$router.currentRoute.params.clientId,
						initial_contact_date: _this.$moment(_this.date).format('YYYY-MM-DD'),
						contact_origin: _this.origin,

						remote_contractualization: _this.remoteContractualization,
						professional_category: _this.professionalCategory,

						client_activity_risk: _this.activityRisk,

						tax_fraud_suspicion: _this.suspicionOfFraud,

						client_exposed: _this.wasPJA,

						client_family_exposed: _this.wasSomeonePJA,

						client_vip: _this.isVIP,
						client_main_nationality: _this.country.type,
						client_second_nationality: _this.secondCountry ? _this.secondCountry.type : null,
						tax_residence: _this.fiscCountry ? _this.fiscCountry.type : null,
						bank_deposit_country: _this.banqueCountry,

						penal_action: _this.penal
					}).then(function (result) {
						_this.$store.commit('LOADER_OUT');
						if (result.data.success) {
							_this.score = result.data.score;
							_this.score_label = result.data.label.split(' ')[1];
							_this.filling = false;
						} else {
							console.log('une erreur est survenue');
						}
					});
				} else {
					_this.errorInForm = true;
				}
			});
		},
		displayScore: function displayScore() {
			return ('00' + this.score.toString()).slice(-2);
		},
		resolveClass: function resolveClass() {
			var style = '';
			if (this.score < 3) {
				style = 'green';
			} else if (this.score < 7) {
				style = 'orange';
			} else {
				style = 'red';
			}

			return style;
		},
		end: function end() {
			var _this2 = this;

			this.$store.dispatch('sendLCBCFT', {
				user_id: this.$router.currentRoute.params.clientId,
				lcbft_completed: 1
			}).then(function () {
				_this2.$emit('close');
			}).catch(function (error) {
				console.log('Error : ', error);
			});
		}
	}
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ModalNewNote',
	props: ['data'],
	data: function data() {
		return {
			title: null,
			message: null
		};
	},
	mounted: function mounted() {
		if (this.data.note) {
			this.title = this.data.note.title;
			this.message = this.data.note.message;
		}
	},

	methods: {
		close: function close() {
			if (!this.data.isNew) {
				this.$store.dispatch('deleteNote', {
					clientId: this.data.clientId,
					note: {
						id: this.data.note.id
					}
				});
			}
			this.$emit('close');
		},
		procNote: function procNote() {
			if (this.data.isNew) {
				this.$store.dispatch('addNote', {
					clientId: this.data.clientId,
					note: {
						title: this.title,
						message: this.message
					}
				});
				this.$emit('close');
			} else {
				this.$store.dispatch('editNote', {
					clientId: this.data.clientId,
					note: {
						id: this.data.note.id,
						title: this.title,
						message: this.message
					}
				});
				this.$emit('close');
			}
		}
	},
	watch: {
		data: function data(value) {
			this.title = value.note.title;
			this.message = value.note.message;
		}
	}
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'PatrimonialConsistency',
	components: {
		inputDate: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_InputDate___default.a,
		CustomSelect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default.a,
		CustomToggle: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomToggle___default.a
	},
	data: function data() {
		return {
			date: new Date(),
			consistency: false,
			completeness: false,
			warningSent: false,
			errorInForm: false,
			errorMessage: ''
		};
	},
	mounted: function mounted() {
		console.log("modal estate", this.estate);
		this.completeness = this.estate.advisorCheck.advisorCompletenessCheck;
		this.consistency = this.estate.advisorCheck.advisorConsistencyCheck;
		this.warningSent = this.estate.advisorCheck.advisorWarningSentToClient;
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		sendForm: function sendForm() {
			var _this = this;

			this.errorInForm = false;
			__WEBPACK_IMPORTED_MODULE_4__common_services_Emma__["a" /* default */].post('api/estate/private/doc/sendmailcheckpaysage', {
				user_id: this.$router.currentRoute.params.clientId,
				date: this.date,
				consistency: this.consistency,
				completeness: this.completeness,
				warningSent: this.warningSent
			}).then(function (result) {
				_this.$emit('close');
			}).catch(function (error) {
				console.error('Erreur lors de l\'envoi:', error);
				console.error('Détails de l\'erreur:', {
					message: error.message,
					response: error.response
				});
				_this.errorInForm = true;
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}))
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'share-news',
	data: function data() {
		return {
			news: {
				title: null,
				link: null,
				link_image: null,
				body: null,
				selectedTags: []
			}
		};
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		isSelectedTag: function isSelectedTag(id) {
			var isSelected = false;
			this.news.selectedTags.forEach(function (tag) {
				if (tag.id === id) {
					isSelected = true;
				}
			});

			return isSelected;
		},
		selectTag: function selectTag(newTag) {
			var _this = this;

			var isFound = false;
			this.news.selectedTags.forEach(function (tag, key) {
				if (tag.id === newTag.id) {
					isFound = true;
					_this.news.selectedTags.splice(key, 1);
				}
			});
			if (!isFound && this.news.selectedTags.length < 3) this.news.selectedTags.push(newTag);
		},
		share: function share() {
			var _this2 = this;

			this.$validator.validate().then(function (validation) {
				if (validation) {
					_this2.$store.dispatch('shareNews', _this2.news).then(function () {
						_this2.$notify({
							type: 'success',
							group: 'default',
							title: 'Vous avez partagé un article',
							text: ''
						});
						_this2.close();
					}).catch(function () {
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Veuillez vérifier les informations que vous avez envoyées'
						});
					});
				}
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		tags: 'tags'
	}))
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ModalUnavailable',
	data: function data() {
		return {
			message: null
		};
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		save: function save() {
			var _this = this;

			this.$store.dispatch('setAvailable', {
				user_id: this.user.id,
				available: 0,
				ooo_message: this.message
			}).then(function () {
				_this.$notify({
					type: 'success',
					group: 'default',
					title: 'Votre disponibilité a été mise à jour',
					text: ''
				});
				_this.$emit('close');
			}).catch(function () {
				_this.$notify({
					type: 'error',
					group: 'default',
					title: 'Votre disponibilité n\'a pas pu être mise à jour',
					text: ''
				});
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		user: 'user'
	}))
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'timespanpicker',
	data: function data() {
		return {
			spans: [{ label: 'JOUR', value: 'day' }, { label: 'SEMAINE', value: 'week' }, { label: 'MOIS', value: 'month' }, { label: 'ANNÉE', value: 'year' }, { label: 'TOUS', value: 'all' }],
			selected: 4,
			display: false
		};
	},

	computed: {
		current: function current() {
			return this.spans[this.selected];
		}
	},
	methods: {
		setSelected: function setSelected(id) {
			this.selected = id;
			this.toggle();
			this.$emit('change', this.spans[this.selected].value);
		},
		toggle: function toggle() {
			this.display = !this.display;
		}
	}
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal_ShareNews__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal_ShareNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Modal_ShareNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Actualities',
	data: function data() {
		return {
			showModalShareNews: false,
			modalShareNews: __WEBPACK_IMPORTED_MODULE_1__components_Modal_ShareNews___default.a,
			newNews: [],
			restNews: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$store.dispatch('fetchAllNews').then(function () {
			_this.newNews = _this.news.slice(0, 4);
			_this.restNews = _this.news.slice(4);
		});
	},

	methods: {
		strip: function strip(s) {
			return s.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 120) + '...';
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		news: 'allNews',
		beforeMyNews: 'writtedNews'
	}), {
		myNews: function myNews() {
			return this.beforeMyNews || [];
		}
	})
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'IndexRouter'
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_notif_bar__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_notif_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_notif_bar__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Demo',
	components: {
		NotifBar: __WEBPACK_IMPORTED_MODULE_0__common_components_notif_bar___default.a
	},
	data: function data() {
		return {
			optionsSelect: ['foo', 'bar', 'baz'],
			icons: ['alert', 'arrow-back', 'clock', 'down-open-mini', 'left-open-mini', 'up-open-mini', 'right-open-mini', 'arrow-full-down', 'arrow-full-left', 'arrow-full-up', 'arrow-full-right', 'article-details', 'article-share', 'bandeau-alert', 'button-add', 'button-contact', 'button-download', 'button-diffusion', 'button-new-mission', 'button-rdv', 'button-relance', 'button-send', 'button-situation', 'button-warning', 'doc-lettre-mission', 'doc-cr-mission', 'doc-others', 'doc-paysage', 'doc-print', 'doc-private', 'doc-template', 'document-pdf', 'download-pdf', 'dynamique', 'eye', 'fiche-client-calandar', 'fiche-client-docs', 'fiche-client-history', 'fiche-client-info', 'fiche-client-note', 'fiche-client-paysage', 'file-edit', 'file-trash', 'form-close', 'form-plus', 'info-2', 'info', 'nav-actu', 'loupe', 'nav-admin-cabinets', 'nav-admin-clients', 'nav-admin-conseiller', 'nav-admin-encaissement', 'nav-admin-stat', 'nav-conseiller', 'nav-docs', 'nav-help', 'nav-notif', 'nav-operation', 'nav-placements', 'notif-article', 'notif-docs', 'operations-folder', 'paysage-entreprise-actionaire', 'paysage-entreprise-activite', 'paysage-entreprise-benef', 'paysage-entreprise-dirigeants', 'paysage-entreprise-docs', 'paysage-entreprise', 'paysage-fiscalite', 'paysage-profil', 'paysage-rentree', 'paysage-retraite', 'paysage-sortis', 'paysage-vous', 'social-fb', 'social-google', 'social-lkd', 'volet-notif'],
			components: {
				bar: {
					default: '<NotifBar type="default" title="Demo" text="Lorem ipsum..."></NotifBar>',
					danger: '<NotifBar type="danger" title="Demo" text="Lorem ipsum..."></NotifBar>',
					warn: '<NotifBar type="warn" title="Demo" text="Lorem ipsum..."></NotifBar>'
				}
			},
			select2: []
		};
	},

	methods: {
		generateIconName: function generateIconName(a) {
			return 'icon-' + a;
		},
		copyIcon: function copyIcon(key) {
			navigator.clipboard.writeText('<span class="' + this.generateIconName(this.icons[key]) + '"></span>');
		}
	}
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_user__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Modal_TakeAppointment__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Modal_TakeAppointment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Modal_TakeAppointment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_timespanpicker__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_timespanpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_timespanpicker__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Activity',
	components: {
		timespanpicker: __WEBPACK_IMPORTED_MODULE_3__components_timespanpicker___default.a
	},
	data: function data() {
		return {
			rowData: [],
			baseDate: new Date(),
			span: 'all',
			modalTakeAppointment: __WEBPACK_IMPORTED_MODULE_2__common_components_Modal_TakeAppointment___default.a,
			showTakeAppointment: false,
			rdvToEdit: null
		};
	},
	created: function created() {
		this.fetchAppointments();
	},

	methods: {
		fetchAppointments: function fetchAppointments() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__resources_user__["a" /* default */].fetchAppointments().then(function (result) {
				if (result.data.success) {
					console.log('result.data.rdvs', result.data.rdvs);
					var parsedData = result.data.rdvs.map(function (rdv) {
						return {
							date: _this.parseDate(rdv.start_date),
							hour: {
								start: _this.parseDate(rdv.start_date),
								end: _this.parseDate(rdv.end_date)
							},
							type: rdv.type,
							description: rdv.description || null,
							customer: rdv.client.user.first_name + ' ' + rdv.client.user.last_name,
							clientId: rdv.client.user.id,
							clientPhone: rdv.client.user.phone || null,
							clientEmail: rdv.client.user.email || null,
							id: rdv.id
						};
					});
					_this.rowData = parsedData;
				}
			}).catch(function (error) {
				console.error('Erreur fetchAppointments:', error);
			});
		},
		formatDay: function formatDay(date) {
			return this.$moment(date).format('ddd');
		},
		formatDate: function formatDate(date) {
			return this.$moment(date).format('DD MMM YYYY');
		},
		formatHour: function formatHour(date) {
			return this.$moment(date).format('HH:mm');
		},
		getTypeBadgeClass: function getTypeBadgeClass(type) {
			switch (type) {
				case 'Visio Call':
					return 'appointments-list__type-badge--visio';
				case 'Rendez-vous':
					return 'appointments-list__type-badge--rdv';
				case 'Appel téléphonique':
					return 'appointments-list__type-badge--phone';
				default:
					return '';
			}
		},
		setDate: function setDate(value) {
			switch (this.span) {
				case 'day':
					this.baseDate = new Date(this.baseDate.setDate(this.baseDate.getDate() + value));
					break;
				case 'week':
					this.baseDate = new Date(this.baseDate.setDate(this.baseDate.getDate() + 7 * value));
					break;
				case 'month':
					this.baseDate = new Date(this.baseDate.setMonth(this.baseDate.getMonth() + value));
					break;
				case 'year':
					this.baseDate = new Date(this.baseDate.setFullYear(this.baseDate.getFullYear() + value));
					break;
			}
		},
		setSpan: function setSpan(value) {
			this.span = value;
		},
		parseDate: function parseDate(date) {
			date = date.split(' ');
			var d = date[0].split('/');
			d = d.concat(date[1].split(':'));
			return new Date(d[2], d[1] - 1, d[0], d[3], d[4]);
		},
		deleteRdv: function deleteRdv(rdv) {
			var _this2 = this;

			if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
				this.$store.dispatch('removeAppointment', rdv.id).then(function () {
					_this2.fetchAppointments();
				});
			}
		},
		editRdv: function editRdv(rdv) {
			this.rdvToEdit = rdv;
			this.showTakeAppointment = true;
		},
		closeTakeAppointment: function closeTakeAppointment() {
			this.showTakeAppointment = false;
			this.rdvToEdit = null;
			this.fetchAppointments();
		}
	},
	computed: {
		rowDataFiltered: function rowDataFiltered() {
			var _this3 = this;

			var result = [];
			var tmp = null;
			var start = null;
			var end = null;

			switch (this.span) {
				case 'day':
					result = this.rowData.filter(function (row) {
						return row.date.getDate() === _this3.baseDate.getDate() && row.date.getMonth() === _this3.baseDate.getMonth() && row.date.getFullYear() === _this3.baseDate.getFullYear();
					});
					break;
				case 'week':
					tmp = new Date(this.baseDate);
					start = this.$moment(tmp.setDate(tmp.getDate() - tmp.getDay() + 1));
					end = this.$moment(tmp.setDate(tmp.getDate() + 7 - tmp.getDay()));
					result = this.rowData.filter(function (row) {
						return _this3.$moment(row.date) >= start && _this3.$moment(row.date) <= end;
					});
					break;
				case 'month':
					result = this.rowData.filter(function (row) {
						return row.date.getMonth() === _this3.baseDate.getMonth() && row.date.getFullYear() === _this3.baseDate.getFullYear();
					});
					break;
				case 'year':
					result = this.rowData.filter(function (row) {
						return row.date.getFullYear() === _this3.baseDate.getFullYear();
					});
					break;
				case 'all':
					result = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.rowData));
					break;
			}

			return result.sort(function (a, b) {
				return b.date - a.date;
			});
		},
		currentFilter: function currentFilter() {
			var value = null;
			var tmp = new Date(this.baseDate);
			switch (this.span) {
				case 'day':
					value = this.$moment(this.baseDate).format('DD MMMM YYYY');
					break;
				case 'week':
					var start = this.$moment(tmp.setDate(tmp.getDate() - tmp.getDay() + 1)).format('DD MMMM');
					var end = this.$moment(tmp.setDate(tmp.getDate() + 7 - tmp.getDay())).format('DD MMMM YYYY');
					value = 'du ' + start + ' au ' + end;
					break;
				case 'month':
					value = this.$moment(this.baseDate).format('MMMM YYYY');
					break;
				case 'year':
					value = this.$moment(this.baseDate).format('YYYY');
					break;
				case 'all':
					value = '';
			}

			return value;
		}
	}
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Board_BoardHeader_vue__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Board_BoardHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Board_BoardHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Board_BoardCalendar_vue__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Board_BoardCalendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Board_BoardCalendar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Board_BoardProspect_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Board_BoardProspect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Board_BoardProspect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Board_BoardClientActions_vue__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Board_BoardClientActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Board_BoardClientActions_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Board',
	components: {
		BoardHeader: __WEBPACK_IMPORTED_MODULE_0__components_Board_BoardHeader_vue___default.a,
		BoardCalendar: __WEBPACK_IMPORTED_MODULE_1__components_Board_BoardCalendar_vue___default.a,
		BoardProspect: __WEBPACK_IMPORTED_MODULE_2__components_Board_BoardProspect_vue___default.a,
		BoardClientActions: __WEBPACK_IMPORTED_MODULE_4__components_Board_BoardClientActions_vue___default.a,
		CardClient: __WEBPACK_IMPORTED_MODULE_3__components_Board_CardClient_vue___default.a
	},
	data: function data() {
		return {
			clients: [],
			calendar: []
		};
	}
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_chat__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_chat__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ChatClient',
	components: {
		Chat: __WEBPACK_IMPORTED_MODULE_0__common_components_chat___default.a
	},
	data: function data() {
		return {
			client: this.$store.getters.getClient(this.$route.params.clientId)
		};
	},
	mounted: function mounted() {
		this.$store.dispatch('getMessages');
	},

	computed: {
		threads: function threads() {
			return this.$store.getters.threadOfClient(this.$route.params.clientId).reverse();
		}
	}
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_NewNote__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_NewNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Modal_NewNote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal_EditContact__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal_EditContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Modal_EditContact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal_LCBCFT_vue__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal_LCBCFT_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Modal_LCBCFT_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal_PatrimonialConsistency_vue__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal_PatrimonialConsistency_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Modal_PatrimonialConsistency_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_Modal_TakeAppointment__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_components_Modal_TakeAppointment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_components_Modal_TakeAppointment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal_Certification__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal_Certification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Modal_Certification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modal_CompanyInformation__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modal_CompanyInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Modal_CompanyInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_services_Emma__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_components_tile_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_assets_img_good_svg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_assets_img_good_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_assets_img_good_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_components_MyPatrimonialLandscape_data_Country_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_assets_img_high_icon_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_assets_img_high_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_assets_img_high_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_assets_img_down_icon_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_assets_img_down_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__common_assets_img_down_icon_svg__);



















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Client',
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_11__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			id: this.$route.params.clientId,
			modalNewNote: __WEBPACK_IMPORTED_MODULE_3__components_Modal_NewNote___default.a,
			modalEditClient: __WEBPACK_IMPORTED_MODULE_4__components_Modal_EditContact___default.a,
			modalLCBCFT: __WEBPACK_IMPORTED_MODULE_5__components_Modal_LCBCFT_vue___default.a,
			modalPatrimonialConsistency: __WEBPACK_IMPORTED_MODULE_6__components_Modal_PatrimonialConsistency_vue___default.a,
			modalTakeAppointment: __WEBPACK_IMPORTED_MODULE_7__common_components_Modal_TakeAppointment___default.a,
			modalCertified: __WEBPACK_IMPORTED_MODULE_8__components_Modal_Certification___default.a,
			modalCompanyInformation: __WEBPACK_IMPORTED_MODULE_9__components_Modal_CompanyInformation___default.a,
			showEditClient: false,
			modals: {
				dataNote: {},
				newNote: false,
				editClient: false,
				lcbcft: false,
				takeAppointment: false,
				certified: false,
				patrimonialConsistency: false,
				companyInfo: false
			},
			lastDocuments: [],
			estateLoaded: false,
			good: __WEBPACK_IMPORTED_MODULE_12__common_assets_img_good_svg___default.a,
			highIcon: __WEBPACK_IMPORTED_MODULE_14__common_assets_img_high_icon_svg___default.a,
			downIcon: __WEBPACK_IMPORTED_MODULE_15__common_assets_img_down_icon_svg___default.a,
			countrySearch: '',
			selectedCountries: [],
			countries: __WEBPACK_IMPORTED_MODULE_13__common_components_MyPatrimonialLandscape_data_Country_js__["a" /* default */],
			companyInfo: null
		};
	},
	mounted: function mounted() {
		this.init();
	},

	methods: {
		init: function init() {
			var _this = this;

			this.$store.dispatch('getClient', this.id).then(function () {
				return _this.$store.dispatch('getPatrimonial', _this.id);
			}).then(function (result) {
				return __WEBPACK_IMPORTED_MODULE_10__common_services_Emma__["a" /* default */].get('api/clients/' + _this.id + '/countries-placement');
			}).then(function (result) {
				if (result.data && result.data.countries) {
					_this.selectedCountries = result.data.countries;
				}
			}).then(function () {
				return __WEBPACK_IMPORTED_MODULE_10__common_services_Emma__["a" /* default */].get('api/clients/' + _this.id + '/company-information');
			}).then(function (result) {
				if (result.data && result.data.company) {
					_this.companyInfo = result.data.company;
				}
			}).then(function () {
				return __WEBPACK_IMPORTED_MODULE_10__common_services_Emma__["a" /* default */].get('api/documents/operations/' + _this.id);
			}).then(function (result) {
				_this.lastDocuments = result.data.documents.sort(function (docA, docB) {
					return docA.id - docB.id;
				}).slice(0, 4);
				_this.estateLoaded = true;
			}).catch(function (error) {
				console.warn(error);
			});
		},
		launchNoteModal: function launchNoteModal(isNew) {
			var note = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			this.modals.dataNote = {
				clientId: this.id,
				isNew: isNew,
				note: {
					id: !isNew ? note.id : null,
					title: !isNew ? note.title : null,
					message: !isNew ? note.description : null
				}
			};
			this.modals.newNote = true;
		},
		sendRelance: function sendRelance() {
			__WEBPACK_IMPORTED_MODULE_10__common_services_Emma__["a" /* default */].get('api/clients/sendmail/privateestate/' + this.id).then(function (result) {
				console.log('Relance sent : ', result);
			});
		},
		classResolver: function classResolver(s) {
			if (s === 'Appel Téléphonique') {
				return 'red';
			} else if (s === 'Visio Call') {
				return 'brown';
			} else {
				return 'blue';
			}
		},
		dateResolver: function dateResolver(rdv) {
			var begin = this.parseDate(rdv.start_date);
			var end = this.parseDate(rdv.end_date);
			var days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
			var day = days[begin.getDay()];
			var months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
			var date = ('00' + begin.getDate()).slice(-2) + ' ' + months[begin.getMonth()] + ' ' + begin.getFullYear();
			return day + ' <span class="bold">' + date + '</span> de <span class="bold">' + begin.getHours() + 'h</span> à <span class="bold">' + end.getHours() + 'h</span>';
		},
		parseDate: function parseDate(date) {
			date = date.split(' ');
			var d = date[0].split('/');
			d = d.concat(date[1].split(':'));
			return new Date(d[2], d[1] - 1, d[0], d[3], d[4]);
		},
		getMissionDoc: function getMissionDoc(mission, type) {
			var doc = mission.documents.filter(function (doc) {
				return doc.sub_category === type;
			})[0];
			if (doc) {
				if (doc.universign_status !== 'completed') {
					return '<span class="orange"><span class="icon-alert"></span> En attente</span>';
				} else {
					return '<span class="green"><img src="' + this.good + '"> Sign\xE9</span>';
				}
			} else {
				return '<span class="grey"><span class="icon-info"></span> A envoyer</span>';
			}
		},
		computedAge: function computedAge(date) {
			var d = this.$moment(date);
			var t = this.$moment();
			return t.diff(d, 'years');
		},
		handleCloseCertified: function handleCloseCertified() {
			this.modals.certified = false;
			this.init();
		},
		handleCloseCompanyInfo: function handleCloseCompanyInfo() {
			this.modals.companyInfo = false;
			this.init();
		},
		saveSelectedCountries: function saveSelectedCountries() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_10__common_services_Emma__["a" /* default */].post('api/clients/' + this.id + '/countries-placement', {
				countries: this.selectedCountries
			}).then(function (result) {
				_this2.$notify({
					group: 'default',
					type: 'success',
					title: 'Succès',
					text: 'Pays enregistrés avec succès'
				});
			}).catch(function (error) {
				_this2.$notify({
					group: 'default',
					type: 'error',
					title: 'Erreur',
					text: 'Erreur lors de l\'enregistrement des pays'
				});
			});
		},
		formatManagers: function formatManagers(managers) {
			if (!managers || !Array.isArray(managers) || managers.length === 0) {
				return '-';
			}
			return managers.filter(function (m) {
				return m && m.trim();
			}).join(', ');
		},
		formatDocument: function formatDocument(bool) {
			return bool = true ? "Oui" : "Non";
		}
	},
	filters: {
		format_currency: function format_currency(value, symbol) {
			return value ? value.toLocaleString() + ' ' + symbol : '';
		},
		format_performance: function format_performance(value) {
			if (!value) {
				return '0';
			}

			if (value === 0) {
				return value;
			}

			return value > 0 ? '+' + value.toLocaleString() : value.toLocaleString();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		estate: 'estate'
	}), {
		client: function client() {
			return this.$store.getters.getClient(parseInt(this.id));
		},
		profilePicture: function profilePicture() {
			return this.client.media && this.client.media.file ? "https://api-preprod.patrimoffice.com/api/pictures/" + this.client.media.file : "https://api-preprod.patrimoffice.com/" + 'assets/user.png';
		},
		filteredCountries: function filteredCountries() {
			var _this3 = this;

			var countriesList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.countries));

			if (this.countrySearch) {
				var search = this.countrySearch.toLowerCase();
				countriesList = countriesList.filter(function (country) {
					return country.fr.toLowerCase().includes(search);
				});
			}

			countriesList.sort(function (a, b) {
				var aSelected = _this3.selectedCountries.includes(a.ISO2);
				var bSelected = _this3.selectedCountries.includes(b.ISO2);

				if (aSelected && !bSelected) return -1;
				if (!aSelected && bSelected) return 1;

				return a.fr.localeCompare(b.fr, 'fr');
			});

			return countriesList;
		}
	})
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_Investments_Synthesis_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_Investments_Synthesis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_Investments_Synthesis_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'InvestmentsClient',
	components: { Synthesis: __WEBPACK_IMPORTED_MODULE_0__common_components_Investments_Synthesis_vue___default.a },

	data: function data() {
		return {
			investmentStats: null
		};
	},

	computed: {
		clientId: function clientId() {
			return this.$route.params.clientId;
		},
		client: function client() {
			return this.$store.getters.getClient(this.clientId);
		}
	},
	mounted: function mounted() {
		var _this = this;

		if (!this.client) {
			this.$store.dispatch('getClient', this.clientId);
		}

		this.$store.dispatch('getClientInvestmentStats', this.clientId).then(function (investmentStats) {
			_this.investmentStats = investmentStats;
		});
	}
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_Display__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_Display___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_Display__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'PatrimonialLandscape',
	components: {
		display: __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_Display___default.a
	},
	data: function data() {
		return {
			client: this.$store.getters.getClient(this.$route.params.clientId)
		};
	}
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_PatrimonialLandscape__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_PatrimonialLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_PatrimonialLandscape__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'PatrimonialLandscapeUpdate',
	data: function data() {
		return {
			client: this.$store.getters.getClient(this.$route.params.clientId)
		};
	},

	components: {
		PatrimonialLandscape: __WEBPACK_IMPORTED_MODULE_0__common_components_MyPatrimonialLandscape_PatrimonialLandscape___default.a
	}
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Contacts',
	data: function data() {
		var _this = this;

		return {
			cols: [{ name: '', field: 'picture', cellType: 'roundImg', width: 60, cellClass: 'no-padding' }, { name: 'Nom Complet', field: 'name', cellType: 'compactName' }, { name: 'Type', field: 'type', cellType: 'typeContact', width: 140 }, { name: 'Téléphone', field: 'phone', cellType: 'light', width: 160 }, { name: 'Mail', field: 'email', cellType: 'noUpper', width: 300 }, { name: 'Tâche en cours', field: 'currentTask', cellType: 'currentTask' }, { name: 'Prochain RDV', field: 'nextAppointment', cellType: 'shortDate', width: 150 }],
			showAddContact: false,
			contentModal: __WEBPACK_IMPORTED_MODULE_2__components_Modal_AddContact___default.a,
			options: {
				onCellClicked: function onCellClicked(data) {
					_this.$router.push({ name: 'Client', params: { clientId: data.data.id } });
				}
			}
		};
	},
	mounted: function mounted() {
		this.$store.dispatch('getClients');
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		clients: 'getClients'
	}), {
		prospectInContacts: function prospectInContacts() {
			return this.clients.filter(function (contact) {
				return contact.type !== 'client_subscriber' && contact.type !== 'Client';
			}).length;
		}
	})
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Home',
	data: function data() {
		return {
			search: null,
			menu: [{
				key: 0,
				name: 'Tableau de Bord',
				uri: 'Board'
			}, {
				key: 1,
				name: 'Activité',
				uri: 'Activity'
			}, {
				key: 2,
				name: 'Contacts',
				uri: 'Contacts'
			}]
		};
	}
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_user__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Logo_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Logo_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Login',
	components: { Logo: __WEBPACK_IMPORTED_MODULE_3__common_components_Logo_vue___default.a },
	data: function data() {
		return {
			email: '',
			password: '',
			emailReset: '',
			login: true,
			hardLogin: true,
			loginusMaximus: true
		};
	},
	mounted: function mounted() {
		if (this.$route.name === 'ResetPasswordEmailAsk') {
			this.switchViewForth();
		}

		if (this.isUser) this.$router.push({ name: 'Home' });
	},

	watch: {
		$route: function $route(to, from) {
			if (to.name === 'ResetPasswordEmailAsk') {
				this.switchViewForth();
			} else {
				this.switchViewBack();
			}
		}
	},
	methods: {
		connect: function connect() {
			var _this = this;

			this.$validator.validate().then(function (validate) {
				if (validate) {
					_this.$store.dispatch('login', {
						email: _this.email,
						password: _this.password
					}).then(function () {
						_this.$router.push({ name: 'Home' });
					}).catch(function () {
						_this.$notify({
							type: 'error',
							group: 'default',
							title: 'Problème lors de la connexion',
							text: 'Mauvais login ou mot de passe'
						});
					});
				}
			});
		},
		resetPassword: function resetPassword() {
			var _this2 = this;

			this.$validator.validate().then(function (validate) {
				if (validate) {
					__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].resetPassword(_this2.emailReset).then(function (result) {
						if (result.data.success) {
							_this2.$notify({
								type: 'success',
								group: 'default',
								title: 'Mot de passe réinitialisé',
								text: 'Vous allez recevoir un email avec votre nouveau mot de passe'
							});
							_this2.switchViewBack();
						} else {
							_this2.$notify({
								type: 'error',
								group: 'default',
								title: 'Une erreur est survenue',
								text: 'Votre compte est désactivé, veuillez contacter votre administrateur'
							});
						}
					}).catch(function () {
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Il est possible que cette adresse n\'appartienne à aucun compte'
						});
					});
				}
			});
		},
		switchViewForth: function switchViewForth() {
			var _this3 = this;

			this.login = !this.login;
			window.setTimeout(function () {
				_this3.loginusMaximus = !_this3.loginusMaximus;
			}, 400);
			window.setTimeout(function () {
				_this3.hardLogin = !_this3.hardLogin;
			}, 500);
		},
		switchViewBack: function switchViewBack() {
			var _this4 = this;

			this.hardLogin = !this.hardLogin;
			window.setTimeout(function () {
				_this4.loginusMaximus = !_this4.loginusMaximus;
			}, 400);
			window.setTimeout(function () {
				_this4.login = !_this4.lgin;
			}, 500);
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		isUser: 'isUser'
	}))
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_header_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_components_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_components_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_notification_panel__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_notification_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_notification_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_footer_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_footer_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Hello',
	components: {
		myHeader: __WEBPACK_IMPORTED_MODULE_0__common_components_header_vue___default.a,
		NotificationPanel: __WEBPACK_IMPORTED_MODULE_1__common_components_notification_panel___default.a,
		myFooter: __WEBPACK_IMPORTED_MODULE_2__common_components_footer_vue___default.a
	},
	data: function data() {
		return {
			notifPanelActive: false,
			menu: [{
				key: 0,
				name: '<span class="icon-nav-admin-stat"></span> Accueil',
				uri: 'Home'
			}, {
				key: 1,
				name: '<span class="icon-nav-operation"></span> Opérations',
				uri: 'Transactions'
			}, {
				key: 2,
				name: '<span class="icon-nav-actu"></span> Actualités',
				uri: 'Actualities'
			}]
		};
	}
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_Unavailable__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_Unavailable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Modal_Unavailable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_ChangePassword__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Modal_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Profile',
	data: function data() {
		return {
			userM: {
				email: null,
				firstname: null,
				lastname: null,
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				},
				phone: null,
				picture: null,
				password: null,
				isAvailable: null
			},
			showUnavailable: false,
			displayChangePassword: false,
			contentModal: __WEBPACK_IMPORTED_MODULE_2__components_Modal_Unavailable___default.a,
			contentModalPassword: __WEBPACK_IMPORTED_MODULE_3__components_Modal_ChangePassword___default.a
		};
	},
	mounted: function mounted() {
		this.initUser();
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		user: 'user'
	})),
	methods: {
		initUser: function initUser() {
			console.log(this.user);
			this.userM = {
				email: this.user.email,
				firstname: this.user.firstname,
				lastname: this.user.lastname,
				address: {
					line: this.user.address.line,
					zip: this.user.address.zip,
					city: this.user.address.city,
					country: this.user.address.country
				},
				phone: this.user.phone,
				picture: this.user.picture ? "https://api-preprod.patrimoffice.com/api/pictures/" + this.user.picture : "https://api-preprod.patrimoffice.com/" + 'assets/user.png',
				password: null,
				newPassword1: null,
				newPassword2: null,
				isAvailable: this.user.available
			};
		},
		uploadNewPicture: function uploadNewPicture(value) {
			var _this = this;

			var preview = document.getElementById('userPicture');
			var file = value.path[0].files[0];
			var reader = new FileReader();

			reader.addEventListener('load', function () {
				preview.src = reader.result;
				_this.$store.dispatch('updateProfilePicture', reader.result);
			});

			if (file) {
				reader.readAsDataURL(file);
			}
		},
		procNewPicture: function procNewPicture() {
			document.getElementById('newPicture').click();
		},
		saveProfile: function saveProfile() {
			var _this2 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					var shouldLogout = _this2.user.email !== _this2.userM.email;
					_this2.$store.dispatch('saveProfile', _this2.userM).then(function () {
						_this2.$notify({
							type: 'success',
							group: 'default',
							title: 'Félicitations',
							text: shouldLogout ? 'Pour valider cette modification vous devrez vous authentifier à nouveau avec votre nouvel email et votre mot de passe actuel' : 'Les modifications ont été apporté à votre profile'
						});
						if (shouldLogout) {
							_this2.$store.dispatch('allClear');
							_this2.$router.push({ name: 'Login' });
						}
					}).catch(function (error) {
						var message = '';
						if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.response.data.errors).indexOf('email') !== -1) message = 'Cette adresse email est déjà utilisé';
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: message
						});
					});
				}
			});
		},
		setAvailable: function setAvailable(val) {
			var _this3 = this;

			this.userM.isAvailable = val;
			this.showUnavailable = !val;
			if (val) {
				this.$store.dispatch('setAvailable', {
					user_id: this.user.id,
					available: 1,
					ooo_message: ''
				}).then(function () {
					_this3.$notify({
						type: 'success',
						group: 'default',
						title: 'Votre disponibilité a été mise à jour',
						text: ''
					});
				}).catch(function () {
					_this3.$notify({
						type: 'error',
						group: 'default',
						title: 'Votre disponibilité n\'a pas pu être mise à jour',
						text: ''
					});
				});
			}
		},
		checkUnavailable: function checkUnavailable() {
			this.showUnavailable = false;
			if (this.user.available) {
				this.userM.isAvailable = this.user.available;
			}
		},
		logout: function logout() {
			var _this4 = this;

			this.$store.dispatch('logout').finally(function () {
				_this4.$router.push({ name: 'Login' });
			});
		}
	}
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			password: null,
			passwordConfirm: null,
			token: null,
			errorsame: null,
			isValidToken: true
		};
	},
	mounted: function mounted() {
		this.token = this.$route.params.token;
		this.checkValidToken();
	},

	methods: {
		checkValidToken: function checkValidToken() {
			var _this = this;

			this.$store.commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/resetting/check/' + this.token).then(function (result) {
				_this.$store.commit('LOADER_OUT');
				_this.isValidToken = result.data.success;
			}).catch(function () {
				_this.$store.commit('LOADER_OUT');
				_this.isValidToken = false;
			});
		},
		send: function send() {
			var _this2 = this;

			if (this.password && this.password === this.passwordConfirm) {
				var data = new FormData();
				data.append('plain_password[first]', this.password);
				data.append('plain_password[second]', this.passwordConfirm);
				__WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/resetting/reset/' + this.token, data).then(function (result) {
					if (result.data.success) {
						_this2.$notify({
							type: 'success',
							group: 'default',
							title: 'Le mot de passe a été correctement réinitialisé',
							text: 'Vous pouvez vous connecter avec votre nouveau mot de passe'
						});
						_this2.$router.push({ name: 'Login' });
					} else {
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Le mot de passe n\'a pas pu être réinitialisé',
							text: 'Le token a expiré'
						});
					}
				}).catch(function (error) {
					console.warn(error);
					_this2.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					});
				});
			} else {
				this.errorsame = true;
			}
		}
	}
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal_AddDocument__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal_AddDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Modal_AddDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Documents_Operations__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Documents_Operations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Documents_Operations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Documents_ModelsAndTemplates__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Documents_ModelsAndTemplates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Documents_ModelsAndTemplates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Documents_PrivateDocs__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Documents_PrivateDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Documents_PrivateDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Documents_SharedDocs__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Documents_SharedDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Documents_SharedDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Documents_ClientsJustificatory__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Documents_ClientsJustificatory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Documents_ClientsJustificatory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Documents_Patrimonial__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Documents_Patrimonial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Documents_Patrimonial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Documents_Lcbft__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Documents_Lcbft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Documents_Lcbft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Documents_Subscription__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Documents_Subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Documents_Subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Documents_CompanySignature__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Documents_CompanySignature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Documents_CompanySignature__);













/* harmony default export */ __webpack_exports__["default"] = ({
	mounted: function mounted() {
		this.$store.dispatch('fetchDocuments');
	},
	data: function data() {
		return {
			drawComponent: true,
			modalAddDocument: __WEBPACK_IMPORTED_MODULE_0__components_Modal_AddDocument___default.a,
			showAddDocument: false,
			menu: [{ label: '<span class="icon-doc-cr-mission"></span> Opérations', component: __WEBPACK_IMPORTED_MODULE_1__components_Documents_Operations___default.a }, { label: '<span class="icon-doc-others"></span> Justificatifs', component: __WEBPACK_IMPORTED_MODULE_5__components_Documents_ClientsJustificatory___default.a }, { label: '<span class="icon-doc-paysage"></span> Paysages patrimoniaux', component: __WEBPACK_IMPORTED_MODULE_6__components_Documents_Patrimonial___default.a }, { label: '<span class="icon-doc-subscription"></span> Abonnements', component: __WEBPACK_IMPORTED_MODULE_8__components_Documents_Subscription___default.a }, { label: '<span class="icon-doc-template"></span> Modèles de documents', component: __WEBPACK_IMPORTED_MODULE_2__components_Documents_ModelsAndTemplates___default.a }, { label: '<span class="icon-doc-template"></span> LCB-FT', component: __WEBPACK_IMPORTED_MODULE_7__components_Documents_Lcbft___default.a }, { label: '<span class="icon-doc-subscription"></span> Signature informations société', component: __WEBPACK_IMPORTED_MODULE_9__components_Documents_CompanySignature___default.a }, {
				label: '<span class="icon-doc-private"></span> Autres Documents',
				children: [{ label: 'Partagés avec le client', component: __WEBPACK_IMPORTED_MODULE_4__components_Documents_SharedDocs___default.a }, { label: 'Privés', component: __WEBPACK_IMPORTED_MODULE_3__components_Documents_PrivateDocs___default.a }]
			}],
			activeFirstLevel: 0,
			activeSecondLevel: 0
		};
	},

	methods: {
		resolveCloseAddDocument: function resolveCloseAddDocument() {
			this.showAddDocument = false;
			this.$refs.currentComp.fetchDocs();
		},
		isActiveFirst: function isActiveFirst(key) {
			return this.activeFirstLevel === key;
		},
		setActiveFirst: function setActiveFirst(key) {
			this.activeFirstLevel = key;
		},
		isActiveSecond: function isActiveSecond(key) {
			return this.activeSecondLevel === key;
		},
		setActiveSecond: function setActiveSecond(key) {
			this.activeSecondLevel = key;
		}
	},
	computed: {
		currentComponent: function currentComponent() {
			if (this.menu[this.activeFirstLevel].children) {
				if (this.activeSecondLevel !== -1) {
					return this.menu[this.activeFirstLevel].children[this.activeSecondLevel].component;
				} else {
					return this.menu[this.activeFirstLevel].component;
				}
			} else {
				return this.menu[this.activeFirstLevel].component;
			}
		}
	}
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditForm_Main__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditForm_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EditForm_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditForm_Docs__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditForm_Docs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EditForm_Docs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditForm_Actions__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditForm_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EditForm_Actions__);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		EditMain: __WEBPACK_IMPORTED_MODULE_0__EditForm_Main___default.a,
		EditDocs: __WEBPACK_IMPORTED_MODULE_1__EditForm_Docs___default.a,
		EditActions: __WEBPACK_IMPORTED_MODULE_2__EditForm_Actions___default.a
	},
	data: function data() {
		return {
			subscriptionExist: false,
			subscription: null
		};
	},
	mounted: function mounted() {
		this.checkForSubscription();
	},

	methods: {
		checkForSubscription: function checkForSubscription() {
			var _this = this;

			if (this.$route.name === 'MySubscriptionsEdit') {
				this.$store.dispatch('getSubscription', this.$route.params.id).then(function (result) {
					_this.subscription = _this.$store.getters.subscription(_this.$route.params.id);
					_this.name = _this.subscription.title;
					_this.subscriptionExist = true;
				}).catch(function (error) {
					console.log(error);
				});
			}
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.checkForSubscription();
		}
	}
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['subscription'],
	name: 'EditActions',
	components: {},
	data: function data() {
		return {
			canCancel: false
		};
	},
	mounted: function mounted() {
		this.canCancel = this.subscription.is_enabled;
	},

	methods: {
		cancelSubscription: function cancelSubscription() {
			var _this = this;

			if (!this.canCancel) {
				return;
			}

			this.$swal.fire({
				title: 'Etes-vous sûr ?',
				text: 'L\'abonnement du client sera annulé et les paiements arrêtés.',
				icon: 'warning',
				confirmButtonColor: '#ff4052',
				showCancelButton: true,
				confirmButtonText: 'confirmer',
				cancelButtonText: 'Annuler'
			}).then(function (result) {
				if (result.value) {
					_this.processCancelSubscription();
				}
			});
		},
		processCancelSubscription: function processCancelSubscription() {
			var _this2 = this;

			this.$store.dispatch('cancelSubscription', this.subscription).then(function (result) {
				_this2.canCancel = false;
				_this2.$notify({
					type: 'success',
					group: 'default',
					title: 'L\'abonnement a bien été annulé',
					text: ''
				});
			}).catch(function (e) {
				_this2.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			});
		}
	}
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditDocs',
	props: ['subscription'],
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			subscriptionContract: null
		};
	},
	mounted: function mounted() {
		this.initSubscriptionDocuments();
	},

	methods: {
		initSubscriptionDocuments: function initSubscriptionDocuments() {
			this.subscriptionContract = this.subscription.subcription_contract_document;
		},
		uploadSubscriptionContractFile: function uploadSubscriptionContractFile(e) {
			var _this = this;

			var file = e.target.files[0];
			var type = this.resolveType(file.type);
			if (type) {
				this.$store.dispatch('addDocument', {
					subscription_id: this.subscription.id,
					user_id: this.subscription.user.id,
					category: 'subscriptions',
					type: file.type.replace('application/', ''),
					file: file,
					subcategory: 'Contrat d\'abonnement',
					signature_required: true,
					signature_token: null,
					original_name: 'contract_abonnement_' + this.$moment().format('DD-MM-YYYY'),
					confidential: 0
				}).then(function () {
					_this.$emit('needToUpdate');
					_this.$notify({
						type: 'success',
						group: 'default',
						title: 'Contrat d\'abonnement ajouté avec succès',
						text: ''
					});
				}).catch(function () {
					_this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					});
				});
			}
		},
		canLoad: function canLoad(doc) {
			return !doc || !doc.universign_status || doc.universign_status === 'null' || doc.universign_status === undefined;
		},
		needForSign: function needForSign(doc) {
			return doc && (!doc.universign_status || doc.universign_status === 'null' || doc.universign_status === undefined);
		},
		procUpload: function procUpload(id) {
			document.getElementById(id).click();
		},
		resolveType: function resolveType(t) {
			var value = null;
			switch (t) {
				case 'application/pdf':
					value = 'pdf';
					break;
				case 'application/octet-stream':
					value = 'txt';
					break;
				case 'application/msword':
					value = 'doc';
					break;
				case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
					value = 'docx';
					break;
				case 'application/vnd.ms-excel':
					value = 'xls';
					break;
				case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
					value = 'xlsx';
					break;
				default:
					value = false;
			}

			return value;
		},
		askForSignature: function askForSignature(doc) {
			var _this2 = this;

			if (!this.hasIdentityCertificated) {
				return;
			}

			var func = __WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].signSubscriptionContract;
			var id = doc.id;

			func(id).then(function (result) {
				_this2.$notify({
					type: 'success',
					group: 'default',
					title: 'Demande de signature envoyé avec succès',
					text: 'Un mail a été envoyé à votre client'
				});
				_this2.$emit('needToUpdate');
			}).catch(function (error) {
				console.warn(error);
			});
		},
		callVerify: function callVerify(doc) {
			var _this3 = this;

			this.$store.commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].verify(doc.universign_transaction_id).then(function (result) {
				_this3.$store.commit('LOADER_OUT');
				if (result.data.success) {
					doc.universign_status = result.data.universign_status;
				}
			}).catch(function (error) {
				_this3.$store.commit('LOADER_OUT');
				console.warn(error);
			});
		},
		relaunchTransaction: function relaunchTransaction(doc) {
			var _this4 = this;

			this.$store.commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].relaunchTransaction(doc.universign_transaction_id).then(function (result) {
				_this4.$store.commit('LOADER_OUT');
				_this4.$notify({
					type: 'success',
					group: 'default',
					title: 'Mail de relance envoyé avec succès',
					text: ''
				});
			}).catch(function (error) {
				_this4.$store.commit('LOADER_OUT');
				_this4.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: ''
				});
				console.warn(error);
			});
		}
	},
	watch: {
		subscription: function subscription() {
			this.initSubscriptionDocuments();
		}
	},
	computed: {
		hasIdentityCertificated: function hasIdentityCertificated() {
			return this.subscription && this.subscription.user.certified === 1;
		}
	}
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelectUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditMain',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default.a,
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_CustomSelectUser___default.a
	},
	data: function data() {
		return {
			submitted: false,
			subscriptionExist: false,
			subscription: {
				payment_type: null,
				client: null,
				advisor: null,
				has_paid_first_charge: false
			},
			paymentTypesList: [{ name: 'automatic', label: 'Automatique' }]
		};
	},
	mounted: function mounted() {
		this.subscription.advisor = this.advisor;
		this.subscription.payment_type = this.paymentTypesList.filter(function (elem) {
			return elem.name === 'automatic';
		})[0];
		if (this.$route.name === 'MySubscriptionsEdit') {
			this.subscriptionExist = true;
			var subscription = this.$store.getters.subscription(this.$route.params.id);
			this.subscription = {
				id: subscription.id,
				effect_date: this.$moment(subscription.effect_date, 'DD/MM/YYYY h:mm').format('YYYY-MM-DD'),
				payment_type: { name: subscription.payment_type, label: subscription.payment_type_label },
				client: subscription.user,
				advisor: subscription.advisor,
				has_paid_first_charge: subscription.has_paid_first_charge
			};
		}
	},

	methods: {
		createSubscription: function createSubscription() {
			var _this = this;

			this.$store.dispatch('createSubscription', this.subscription).then(function (result) {
				_this.subscriptionExist = true;
				_this.$router.push({ name: 'MySubscriptionsEdit', params: { id: result.id } });
			}).catch(function (e) {
				_this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			});
		},
		patchSubscription: function patchSubscription() {
			var _this2 = this;

			this.$store.dispatch('patchSubscription', this.subscription).then(function (result) {
				_this2.$notify({
					type: 'success',
					group: 'default',
					title: 'L\'opération a bien été modifiée',
					text: ''
				});
			}).catch(function (e) {
				_this2.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			});
		},
		saveSubscription: function saveSubscription() {
			if (this.subscriptionExist) {
				this.patchSubscription();
			} else {
				this.createSubscription();
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
		advisor: 'user',
		clients: 'getClients'
	}), {
		isFormValidated: function isFormValidated() {
			var effectDate = this.$moment(this.subscription.effect_date, 'YYYY-MM-DD');

			return effectDate.isValid();
		},
		isFormLoading: function isFormLoading() {
			return this.submitted;
		},
		clientsFiltered: function clientsFiltered() {
			return this.clients.filter(function (client) {
				return typeof client.subscription === 'undefined' || !client.subscription;
			});
		}
	})
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TableSubscriptions',
	data: function data() {
		var _this = this;

		return {
			cols: [{ name: 'Client', field: 'client', cellType: 'light', width: 230 }, { name: 'Plan', field: 'plan', cellType: 'light', width: 220 }, { name: 'Prochain prélèvement', field: 'next_billing_date', cellType: 'date', width: 260 }, { name: 'Contrat', field: 'letter', cellType: 'statusMission', width: 220 }, { name: 'Statut', field: 'status', width: 350, cellRenderer: this.subscriptionStatusRenderer }],
			options: {
				onRowClicked: function onRowClicked(data) {
					_this.$router.push({ name: 'MySubscriptionsEdit', params: { id: data.data.id } });
				},
				localeText: {
					noRowsToShow: 'Vous n\'avez pas encore d\'abonnement'
				}
			}
		};
	},
	mounted: function mounted() {
		this.$store.dispatch('getSubscriptions');
	},

	methods: {
		subscriptionStatusRenderer: function subscriptionStatusRenderer(_ref) {
			var value = _ref.value;

			var foo = '<div class="custom-cell status-missions row ';
			switch (value.name) {
				case 'contract_waiting':
				case 'payment_method_waiting':
					foo += 'orange"><div class="ctn-icon"><span class="icon-alert"></span></div>';
					break;
				case 'enabled':
					foo += 'green"><div class="ctn-icon"></div>';
					break;
			}
			return foo + '<div class="">' + value.label + '</div></div>';
		},
		resolveDocs: function resolveDocs(subscription, type) {
			var doc = subscription.documents.filter(function (doc) {
				return doc.sub_category === type;
			})[0];
			if (doc) {
				if (doc.universign_status === 'ready') {
					return 'En Attente';
				} else if (doc.universign_status === 'completed') {
					return 'Signé';
				} else {
					return 'En Attente';
				}
			} else {
				return 'À envoyer';
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		computedTotal: function computedTotal() {
			var total = 0;
			this.subscriptions.forEach(function (operation) {
				total += operation.total_value;
			});

			return total;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		subscriptions: 'subscriptions'
	}), {
		computedRows: function computedRows() {
			var _this2 = this;

			var rows = [];
			this.subscriptions.forEach(function (subscription) {
				rows.push({
					id: subscription.id,
					client: subscription.user.first_name + ' ' + subscription.user.last_name,
					plan: subscription.plan.name,
					next_billing_date: _this2.$moment(subscription.next_billing_date, 'DD/MM/YYYY HH:mm'),
					letter: _this2.resolveDocs(subscription, 'Contrat d\'abonnement'),
					status: { label: subscription.status_label, name: subscription.status }
				});
			});

			return rows;
		}
	}),
	filters: {
		moneyFilter: function moneyFilter(value) {
			var val = value.toString();
			var result = '';
			var integer = val.split('.')[0].split('');
			var decimal = val.split('.')[1];
			while (integer.length > 3) {
				result = '.' + integer.splice(integer.length - 3, integer.length).join('') + result;
			}
			result = integer.join('') + result;
			result += ',' + (decimal || '00');

			return result;
		}
	}
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditForm_Main__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditForm_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EditForm_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditForm_Docs__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditForm_Docs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EditForm_Docs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditForm_ContractsAndSupports__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditForm_ContractsAndSupports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EditForm_ContractsAndSupports__);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		EditMain: __WEBPACK_IMPORTED_MODULE_0__EditForm_Main___default.a,
		EditDocs: __WEBPACK_IMPORTED_MODULE_1__EditForm_Docs___default.a,
		EditContractsAndSupports: __WEBPACK_IMPORTED_MODULE_2__EditForm_ContractsAndSupports___default.a
	},
	data: function data() {
		return {
			name: null,
			missionExist: false,
			operation: null
		};
	},
	mounted: function mounted() {
		this.checkForOperation();
	},

	methods: {
		checkForOperation: function checkForOperation() {
			var _this = this;

			if (this.$route.name === 'MyTransactionsEdit') {
				this.$store.dispatch('getOperation', this.$route.params.id).then(function (result) {
					_this.operation = _this.$store.getters.operation(_this.$route.params.id);
					_this.name = _this.operation.title;
					_this.missionExist = true;
				}).catch(function (error) {
					console.log(error);
				});
			}
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.checkForOperation();
		}
	}
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditContractsAndSupports',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default.a
	},
	data: function data() {
		return {
			operationTypeList: ['Financier', 'Tangible', 'International'],
			currencyList: __WEBPACK_IMPORTED_MODULE_3__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			operation: null,
			contracts: [],
			contractTypeToAdd: null,
			newContract: {
				name: null,
				number: null,
				type: null
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.operation = this.$store.getters.operation(this.$route.params.id);
		this.operation.mission_contract_products.forEach(function (product) {
			_this.resolveProduct(product);
		});
	},

	methods: {
		addContract: function addContract() {
			if (this.contractTypeToAdd !== 'Autre') {
				this.contracts.push({
					ref: this.contractTypeToAdd,
					supportToAdd: this.supportListOfContract(this.contractTypeToAdd.contract_products)[0],
					newSupport: {
						name: null,
						isin: null
					},
					supports: []
				});
			}
		},
		addContractToContractList: function addContractToContractList() {
			var _this2 = this;

			if (this.newContract.name.trim() !== '') {
				this.$store.dispatch('addContract', this.newContract).then(function () {
					_this2.newContract = { name: null, type: null, number: null };
					_this2.contractTypeToAdd = _this2.contractTypeList[_this2.contractTypeList.length - 2];
				});
			}
		},
		supportListOfContract: function supportListOfContract(list) {
			return list.concat([{ product: { name: 'Autre', full_name: 'Autre' } }]);
		},
		addToSupportlistOfContract: function addToSupportlistOfContract(contractKey) {
			var _this3 = this;

			this.$validator.validate().then(function (validation) {
				if (validation) {
					var contract = _this3.contracts[contractKey];
					var support = contract.newSupport;
					var id = contract.ref.id;
					_this3.$store.dispatch('addProduct', {
						product: support,
						contractId: id
					}).then(function () {
						contract.newSupport = { name: null, isin: null };
						var supportList = _this3.supportListOfContract(contract.ref.contract_products);
						contract.supportToAdd = supportList[supportList.length - 2];
					});
				}
			});
		},
		addSupportToContract: function addSupportToContract(key) {
			this.contracts[key].supports.push({
				ref: this.contracts[key].supportToAdd.product,
				price: 0,
				currency: 'EUR',
				part: 0,
				percent: 0,
				amountInvested: 0,
				contractNumber: this.contracts[key].ref.number,
				isAPI: false
			});
		},
		addProductToMission: function addProductToMission(contract, support) {
			var _this4 = this;

			this.$store.dispatch('addProductToMission', {
				mission_id: this.operation.id,
				contract_id: contract.ref.id,
				product_id: support.ref.id,
				amount: support.price,
				currency: support.currency,
				shares: support.part,
				percent: support.percent,
				amountInvested: support.amountInvested,
				contractNumber: support.contractNumber
			}).then(function (product) {
				_this4.resolveProduct(product);
				_this4.cancelProductFromMission(contract, support);
			});
		},
		cancelProductFromMission: function cancelProductFromMission(contract, support) {
			contract.supports.splice(contract.supports.indexOf(support), 1);
		},
		removeProductFromMission: function removeProductFromMission(contract, support) {
			this.$store.dispatch('removeProductFromMission', {
				operationId: this.operation.id,
				contract: contract,
				product: support
			}).then(function () {
				contract.supports.splice(contract.supports.indexOf(support), 1);
			}).catch(function (error) {
				console.log(error);
			});
		},
		editProductFromMission: function editProductFromMission(contract, support) {
			this.$store.dispatch('editProductFromMission', {
				operationId: this.operation.id,
				product: {
					id: support.id,
					mission_id: this.operation.id,
					contract_id: contract.ref.id,
					product_id: support.ref.id,
					amount: support.price,
					currency: support.currency,
					shares: support.part,
					percent: support.percent,
					amountInvested: support.amountInvested,
					contractNumber: support.contractNumber
				}
			});
		},
		resolveProduct: function resolveProduct(product) {
			var isContract = this.contracts.filter(function (contract) {
				return contract.ref.id === product.contract.id;
			}).length !== 0;
			var contract = isContract ? this.contracts.filter(function (contract) {
				return contract.ref.id === product.contract.id;
			})[0] : null;
			if (!isContract) {
				contract = {
					ref: product.contract,
					supportToAdd: this.supportListOfContract(product.contract.contract_products)[0],
					newSupport: {
						name: null,
						isin: null
					},
					supports: []
				};
				this.contracts.push(contract);
			}

			contract.supports.push({
				id: product.id,
				ref: product.product,
				price: product.amount,
				currency: product.currency,
				part: product.shares,
				percent: product.percent,
				amountInvested: product.amount_invested,
				contractNumber: product.contract_number,
				isAPI: true
			});
		},
		removeContract: function removeContract(key) {
			this.contracts.splice(key, 1);
		}
	},
	watch: {
		contractTypeList: function contractTypeList() {
			this.contractTypeToAdd = this.contractTypeList[0];
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		rawContractTypeList: 'getContractTypeList'
	}), {
		contractTypeList: function contractTypeList() {
			return this.rawContractTypeList.concat([{ name: 'Autre', full_name: 'Autre' }]);
		}
	})
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditDocs',
	props: ['operation'],
	components: {
		TileDoc: __WEBPACK_IMPORTED_MODULE_1__common_components_tile_doc___default.a
	},
	data: function data() {
		return {
			letterOfMission: null,
			rapportOfMission: null
		};
	},
	mounted: function mounted() {
		this.initOperationDocuments();
	},

	methods: {
		initOperationDocuments: function initOperationDocuments() {
			var _this = this;

			this.operation.documents.forEach(function (doc) {
				if (doc.sub_category === 'Lettre de mission') {
					if (_this.letterOfMission) {
						_this.letterOfMission = doc.id >= _this.letterOfMission.id ? doc : _this.letterOfMission;
					} else {
						_this.letterOfMission = doc;
					}
				} else if (doc.sub_category === 'Rapport de mission') {
					if (_this.rapportOfMission) {
						_this.rapportOfMission = doc.id >= _this.rapportOfMission.id ? doc : _this.rapportOfMission;
					} else {
						_this.rapportOfMission = doc;
					}
				}
			});
		},
		uploadLetterMissionFile: function uploadLetterMissionFile(e) {
			var _this2 = this;

			var file = e.target.files[0];
			var type = this.resolveType(file.type);
			if (type) {
				this.$store.dispatch('addDocument', {
					mission_id: this.operation.id,
					user_id: this.operation.client.user.id,
					category: 'operations',
					type: file.type.replace('application/', ''),
					file: file,
					subcategory: 'Lettre de mission',
					signature_required: true,
					signature_token: null,
					original_name: this.operation.title + '_lettre_de_mission',
					confidential: 0
				}).then(function () {
					_this2.$emit('needToUpdate');
					_this2.$notify({
						type: 'success',
						group: 'default',
						title: 'Lettre de mission ajouté avec succès',
						text: ''
					});
				}).catch(function () {
					_this2.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					});
				});
			}
		},
		canLoad: function canLoad(doc) {
			return !doc || doc.universign_status === 'null' || doc.universign_status === undefined;
		},
		needForSign: function needForSign(doc) {
			return doc && (doc.universign_status === 'null' || doc.universign_status === undefined);
		},
		uploadCRFile: function uploadCRFile(e) {
			var _this3 = this;

			var file = e.target.files[0];
			var type = this.resolveType(file.type);
			if (type) {
				this.$store.dispatch('addDocument', {
					mission_id: this.operation.id,
					user_id: this.operation.client.user.id,
					category: 'operations',
					type: file.type.replace('application/', ''),
					file: file,
					subcategory: 'Rapport de mission',
					signature_required: true,
					signature_token: null,
					original_name: this.operation.title + '_rapport_de_mission',
					confidential: 0
				}).then(function () {
					_this3.$emit('needToUpdate');
					_this3.$notify({
						type: 'success',
						group: 'default',
						title: 'Rapport de mission ajouté avec succès',
						text: ''
					});
				}).catch(function () {
					_this3.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					});
				});
			}
		},
		procUpload: function procUpload(id) {
			document.getElementById(id).click();
		},
		resolveType: function resolveType(t) {
			var value = null;
			switch (t) {
				case 'application/pdf':
					value = 'pdf';
					break;
				case 'application/octet-stream':
					value = 'txt';
					break;
				case 'application/msword':
					value = 'doc';
					break;
				case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
					value = 'docx';
					break;
				case 'application/vnd.ms-excel':
					value = 'xls';
					break;
				case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
					value = 'xlsx';
					break;
				default:
					value = false;
			}

			return value;
		},
		askForSignature: function askForSignature(doc) {
			var _this4 = this;

			var func = doc === this.letterOfMission ? __WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].signMissionLetter : __WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].signMissionReport;
			var id = doc.id;

			func(id).then(function (result) {
				_this4.$notify({
					type: 'success',
					group: 'default',
					title: 'Demande de signature envoyé avec succès',
					text: 'Un mail a été envoyé à votre client'
				});
				_this4.$emit('needToUpdate');
			}).catch(function (error) {
				console.warn(error);
			});
		},
		callVerify: function callVerify(doc) {
			var _this5 = this;

			this.$store.commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].verify(doc.universign_transaction_id).then(function (result) {
				_this5.$store.commit('LOADER_OUT');
				if (result.data.success) {
					doc.universign_status = result.data.universign_status;
				}
			}).catch(function (error) {
				_this5.$store.commit('LOADER_OUT');
				console.warn(error);
			});
		},
		relaunchTransaction: function relaunchTransaction(doc) {
			var _this6 = this;

			this.$store.commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_0__common_resources_Universign__["a" /* default */].relaunchTransaction(doc.universign_transaction_id).then(function (result) {
				_this6.$store.commit('LOADER_OUT');
				_this6.$notify({
					type: 'success',
					group: 'default',
					title: 'Mail de relance envoyé avec succès',
					text: ''
				});
			}).catch(function (error) {
				_this6.$store.commit('LOADER_OUT');
				_this6.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: ''
				});
				console.warn(error);
			});
		}
	},
	watch: {
		operation: function operation() {
			this.initOperationDocuments();
		}
	}
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_MyPatrimonialLandscape_data_Currency__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelectUser__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelectUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelectUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditMain',
	components: {
		CustomSelect: __WEBPACK_IMPORTED_MODULE_1__common_components_Form_CustomSelect___default.a,
		CustomSelectUser: __WEBPACK_IMPORTED_MODULE_3__common_components_Form_CustomSelectUser___default.a
	},
	data: function data() {
		return {
			currencyList: __WEBPACK_IMPORTED_MODULE_2__common_components_MyPatrimonialLandscape_data_Currency__["a" /* default */],
			missionExist: false,
			operation: {
				name: null,
				description: null,
				client: null,
				advisor: null,
				amount: {
					value: null,
					currency: 'EUR'
				},
				type: null,
				docs: {
					missionLetter: null,
					missionCR: null,
					contractSubscription: null
				},
				contracts: []
			},
			operationTypeList: ['Financier', 'Tangible', 'International']
		};
	},
	mounted: function mounted() {
		this.operation.advisor = this.advisor;
		this.$store.dispatch('getContracts');
		if (this.$route.name === 'MyTransactionsEdit') {
			this.missionExist = true;
			var o = this.$store.getters.operation(this.$route.params.id);
			this.operation = {
				id: this.$route.params.id,
				client: o.client.user,
				name: o.title,
				description: o.description,
				advisor: o.advisor.id,
				amount: {
					value: o.total_value,
					currency: o.currency
				},
				docs: {
					missionLetter: null,
					missionCR: null,
					contractSubscription: null
				},
				contracts: []
			};
		}
	},

	methods: {
		createOperation: function createOperation() {
			var _this = this;

			this.$store.dispatch('createOperation', this.operation).then(function (result) {
				_this.missionExist = true;
				_this.$router.push({ name: 'MyTransactionsEdit', params: { id: result.id } });
			}).catch(function (e) {
				_this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			});
		},
		patchOperation: function patchOperation() {
			var _this2 = this;

			this.$store.dispatch('patchOperation', this.operation).then(function (result) {
				_this2.$notify({
					type: 'success',
					group: 'default',
					title: 'L\'opération a bien été modifiée',
					text: ''
				});
			}).catch(function (e) {
				_this2.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				});
			});
		},
		saveOperation: function saveOperation() {
			if (this.missionExist) {
				this.patchOperation();
			} else {
				this.createOperation();
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		advisor: 'user',
		clients: 'getClients'
	}))
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TableOperations',
	data: function data() {
		var _this = this;

		return {
			cols: [{ name: 'Client', field: 'client', cellType: 'light', width: 130 }, { name: 'Nom', field: 'name', cellType: 'light', width: 220 }, { name: 'Date', field: 'date', cellType: 'date', width: 260 }, { name: 'Lettre de mission', field: 'letter', cellType: 'statusMission', width: 180 }, { name: 'Rapport de mission', field: 'cr', cellType: 'statusMission', width: 180 }, { name: 'Montant', field: 'amount', cellType: 'light', width: 160 }],
			options: {
				onRowClicked: function onRowClicked(data) {
					_this.$router.push({ name: 'MyTransactionsEdit', params: { id: data.data.id } });
				}
			}
		};
	},
	mounted: function mounted() {
		this.$store.dispatch('getOperations');
	},

	methods: {
		resolveDocs: function resolveDocs(mission, type) {
			var doc = mission.documents.filter(function (doc) {
				return doc.sub_category === type;
			})[0];
			if (doc) {
				if (doc.universign_status === 'ready') {
					return 'En Attente';
				} else if (doc.universign_status === 'completed') {
					return 'Signé';
				} else {
					return 'En Attente';
				}
			} else {
				return 'À envoyer';
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		computedTotal: function computedTotal() {
			var total = 0;
			this.operations.forEach(function (operation) {
				total += operation.total_value;
			});

			return total;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		operations: 'operations'
	}), {
		computedRows: function computedRows() {
			var _this2 = this;

			var rows = [];
			this.operations.forEach(function (operation) {
				rows.push({
					id: operation.id,
					client: operation.client.user.first_name + ' ' + operation.client.user.last_name,
					name: operation.title,
					date: _this2.$moment(operation.created_at, 'DD/MM/YYYY HH:mm'),
					letter: _this2.resolveDocs(operation, 'Lettre de mission'),
					cr: _this2.resolveDocs(operation, 'Rapport de mission'),
					amount: _this2.$options.filters.moneyFilter(operation.total_value) + ' ' + operation.currency
				});
			});
			return rows;
		}
	}),
	filters: {
		moneyFilter: function moneyFilter(value) {
			var val = value.toString();
			var result = '';
			var integer = val.split('.')[0].split('');
			var decimal = val.split('.')[1];
			while (integer.length > 3) {
				result = '.' + integer.splice(integer.length - 3, integer.length).join('') + result;
			}
			result = integer.join('') + result;
			result += ',' + (decimal || '00');

			return result;
		}
	}
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Transactions',
	data: function data() {
		return {
			search: null,
			menu: [{
				key: 0,
				name: 'Mes opérations',
				uri: 'TransactionsTable'
			}, {
				key: 1,
				name: 'Mes abonnements',
				uri: 'subscriptions'
			}, {
				key: 2,
				name: 'Documents',
				uri: 'Documents'
			}]
		};
	}
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CSP = ['Aucune', 'Agriculteurs exploitants', 'Artisans, commerçants et chefs d\'entreprise', 'Cadres et professions intellectuelles supérieures', 'Professions Intermédiaires', 'Employés', 'Ouvriers', 'Retraités', 'Autres personnes sans activité professionnelle'];

/* harmony default export */ __webpack_exports__["a"] = (CSP);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Diploma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Level; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Age; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Country; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Product; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return InvestedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Management; });
var Diploma = ['Aucun diplôme', 'Brevet des collèges', 'Diplôme Professionnel: CAP ou BEP', 'Baccalauréat', 'Licence, Bac +1 à 3', 'Master, Bac +4 à 5', 'École de commerce, école d\'ingénieur, doctorat'];

var Level = ['Novice', 'Plutôt expérimenté', 'Expérimenté', 'Très expérimenté'];

var Age = ['Entre 0 et 5 ans', 'Entre 6 et 10 ans', 'Entre 11 et 20 ans', 'Plus de 20 ans'];

var Country = ['Nettement meilleur', 'Un peu meilleur', 'A peu près le même', 'Un peu moins bon', 'Nettement moins bon'];

var Product = ['Placements monétaires/Livrets/autres placements de trésorerie', 'Fonds en euros', 'Obligations et/ou fonds obligataires', 'Actions et/ou fonds actions', 'OPCI et/ou SCPI', 'Produits structurés', 'Titres de créance et/ou parts et/ou actions de sociétés non côtées', 'Assurances-vie', 'Contrat de capitalisation', 'PEA', 'Compte-titres', 'Aucun'];

var InvestedProduct = ['Placements monétaires/Livrets/autres placements de trésorerie', 'Fonds en euros', 'Obligations et/ou fonds obligataires', 'Actions et/ou fonds actions', 'OPCI et/ou SCPI', 'Produits structurés', 'Titres de créance et/ou parts et/ou actions de sociétés non côtées', 'Assurances-vie', 'Contrat de capitalisation', 'PEA', 'Compte-titres', 'Aucun'];

var Management = ['Mandat de gestion', 'Gestion conseillée', 'Gestion libre'];

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Loan = ['Crédit immobillier', 'Autre crédit'];

/* harmony default export */ __webpack_exports__["a"] = (Loan);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MaritalStatus = ['Célibataire', 'Union libre', 'Marié(e)', 'Veuf/Veuve', 'Divorcé(e)', 'Pacsé(e)', 'Séparé(e)'];

/* harmony default export */ __webpack_exports__["a"] = (MaritalStatus);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

/* harmony default export */ __webpack_exports__["a"] = (Months);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Perspective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Objective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RiskDegree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RisingMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AssetsEstimate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return InvestmentEstimate; });
var Perspective = ['Entre 1 et 3 ans', 'Entre 3 et 5 ans', 'Entre 5 et 8 ans', 'Plus de 8 ans'];

var Objective = ['Protection et valorisation d’un capital existant', 'Recherche d’un complément de revenus immédiat ou différé', 'Préparation de votre transmission', 'Développer mon patrimoine'];

var RiskDegree = ['Faible risque de perte en capital > potentiel de rendement faible', 'Risque moyen de perte en capital > potentiel de rendement limité', 'Risque élevé de perte en capital > potentiel de rendement élevé', 'Risque important de perte en capital > potentiel de rendement très élevé'];

var RisingMarket = ['Entre 0% et 5%', 'Entre 5% et 10%', 'Entre 10% et 20%', 'Plus de 20%'];

var AssetsEstimate = ['A moins de 1 M€', 'Entre 1 et 2.5 M€', 'Entre 2,5 et 5 M€', 'A plus de 5 M€'];

var InvestmentEstimate = ['Moins de 10%', 'Entre 10% et 33%', 'Entre 33% et 50%', 'Plus de 50%'];

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Rating = ['Très important', 'Assez important', 'Peu important', 'Pas du tout important'];

/* harmony default export */ __webpack_exports__["a"] = (Rating);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Savings = [{
	type: 'Livrets Bancaires',
	fields: ['bank_name']
}, {
	type: 'Plan Epargne Logement (PEL)',
	fields: ['opening_date', 'ownership_type']
}, {
	type: 'Comptes à terme',
	fields: ['ownership_type']
}, {
	type: 'Autres liquidités',
	fields: ['ownership_type']
}, {
	type: 'Assurances vie',
	fields: ['opening_date', 'ownership_type', 'investment_name', 'bank_name']
}, {
	type: 'Plan Epargne en Action (PEA)',
	fields: ['opening_date', 'ownership_type', 'investment_name', 'bank_name']
}, {
	type: 'Contrats de capitalisation',
	fields: ['opening_date', 'ownership_type', 'investment_name', 'bank_name']
}, {
	type: 'PEP assurance vie',
	fields: ['opening_date', 'ownership_type', 'investment_name', 'bank_name']
}, {
	type: 'PEP bancaires',
	fields: ['opening_date', 'ownership_type', 'investment_name', 'bank_name']
}, {
	type: 'Comptes titres',
	fields: ['ownership_type', 'bank_name']
}, {
	type: 'PEE',
	fields: ['opening_date', 'ownership_type']
}, {
	type: 'PEA PME',
	fields: ['opening_date', 'ownership_type', 'bank_name']
}, {
	type: 'FIP',
	fields: ['ownership_type']
}, {
	type: 'FCPI',
	fields: ['ownership_type']
}, {
	type: 'SOFICA',
	fields: ['ownership_type']
}, {
	type: 'Contrats tontiniers',
	fields: ['ownership_type', 'ownership_type', 'investment_name', 'bank_name']
}, {
	type: 'Autres titres non côtés',
	fields: ['ownership_type']
}, {
	type: 'Autres valeurs mobilières',
	fields: ['ownership_type']
}, {
	type: 'Autres Épargnes',
	fields: ['ownership_type']
}];

/* harmony default export */ __webpack_exports__["a"] = (Savings);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NotifData = [{
	key: 0,
	date: new Date('2018', '6', '24', '16', '0'),
	type: 'article',
	text: 'Understanding Operating Systems',
	read: false,
	elementId: 1
}];

/* harmony default export */ __webpack_exports__["a"] = (NotifData);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var ChatResource = {
	getThreads: function getThreads() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/threads');
	},
	newThread: function newThread(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/messages', data);
	},
	newMessage: function newMessage(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/messages', data);
	},
	appointmentRequest: function appointmentRequest(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/appointment-request', data, 'application/json');
	}
};

/* harmony default export */ __webpack_exports__["a"] = (ChatResource);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var DocumentsResource = {
	getDocuments: function getDocuments() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/documents');
	},
	addDocument: function addDocument(document) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/add-document', document);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (DocumentsResource);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var NewsResource = {
	getAllNews: function getAllNews() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/news');
	},
	shareNews: function shareNews(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/news/share', data);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (NewsResource);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixtures_notifications__ = __webpack_require__(667);




var NotificationsResource = {
	getNotifications: function getNotifications(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var tmp = true;
			if (tmp) {
				resolve(__WEBPACK_IMPORTED_MODULE_1__fixtures_notifications__["a" /* default */]);
			} else {
				reject(new Error('Non'));
			}
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (NotificationsResource);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var PlansResource = {
	getPlans: function getPlans() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/plan');
	},
	getPlan: function getPlan(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/plan/' + id);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (PlansResource);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var SiteResource = {
	getCurrentSite: function getCurrentSite() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/office/current', false);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (SiteResource);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var SubscriptionsResource = {
	postSubscription: function postSubscription(subscription) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/subscription', subscription);
	},
	updateSubscription: function updateSubscription(id, subscription) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/subscription/' + id, subscription);
	},
	cancelSubscription: function cancelSubscription(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/subscription/' + id + '/cancel');
	},
	getSubscriptions: function getSubscriptions() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/subscription');
	},
	getSubscription: function getSubscription(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/subscription/' + id);
	},
	confirmPayment: function confirmPayment(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/subscription/confirm-payment', data);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionsResource);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(18);


var TransactionsResource = {
	postOperation: function postOperation(operation) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/mission/add', operation);
	},
	updateOperation: function updateOperation(id, operation) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/mission/add/' + id, operation);
	},
	getOperations: function getOperations() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/mission');
	},
	getOperation: function getOperation(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/mission/' + id);
	},
	getContracts: function getContracts() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/contract');
	},
	createContract: function createContract(contract) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/contract/add', contract);
	},
	getProducts: function getProducts() {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/product');
	},
	createProduct: function createProduct(product) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/product/add', product);
	},
	linkProductToContract: function linkProductToContract(contractId, productId) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/product-contract', {
			contract_id: contractId,
			product_id: productId
		});
	},
	addProductToMission: function addProductToMission(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/mission-contract-product', data);
	},
	editProductFromMission: function editProductFromMission(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/mission-contract-product', data);
	},
	removeProductFromMission: function removeProductFromMission(id) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/delete-mission-contract-product/' + id);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (TransactionsResource);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_resources_Chat__ = __webpack_require__(668);




var actions = {
	getMessages: function getMessages(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* CLEAR_THREAD */]);
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Chat__["a" /* default */].getThreads().then(function (result) {
				if (result.data.success) {
					result.data.threads.forEach(function (thread) {
						commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* NEW_THREAD */], thread);
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					if (result.data.error === 'No threads found.') {
						resolve();
					} else {
						reject(new Error('Dont know'));
					}
				}
			}).catch(function (e) {
				commit('LOADER_OUT');
				reject(e);
			});
		});
	},
	newThread: function newThread(_ref2, data) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Chat__["a" /* default */].newThread(data.request).then(function (result) {
				if (result.data.success) {
					var date = new Date();
					var stringDate = date.getDate() + '/' + computeMonth(date.getMonth()) + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* NEW_THREAD */], {
						id: result.data.thread_id,
						title: data.request.title,
						created_at: stringDate,
						client: {
							id: data.request.user_id
						},
						messages: [{
							user: data.user,
							body: data.request.body,
							created_at: stringDate
						}]
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('coucou'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	newMessage: function newMessage(_ref3, data) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Chat__["a" /* default */].newMessage(data.request).then(function (result) {
				if (result.data.success) {
					var date = new Date();
					var stringDate = date.getDate() + '/' + computeMonth(date.getMonth()) + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* NEW_MESSAGE */], {
						id: data.request.thread_id,
						message: {
							user: {
								id: data.request.user_id,
								first_name: data.side.first_name,
								last_name: data.side.last_name
							},
							body: data.request.body,
							created_at: stringDate
						}
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	sendAppointmentRequest: function sendAppointmentRequest(_ref4, data) {
		var commit = _ref4.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Chat__["a" /* default */].appointmentRequest(data.request).then(function (result) {
				if (result.data.success) {
					var date = new Date();
					var stringDate = date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* NEW_THREAD */], {
						id: result.data.thread_id,
						title: 'Nouvelle demande de RDV',
						created_at: stringDate,
						client: {
							id: data.side.user.id
						},
						messages: [{
							user: data.side.user,
							appointment_detail: data.request.appointment_detail,
							appointment_day: data.request.appointment_day,
							appointment_moment: data.request.appointment_moment,
							appointment_subject: data.request.appointment_subject,
							created_at: stringDate
						}]
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Un problème est survenu'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	}
};

var computeMonth = function computeMonth(n) {
	n = parseInt(n) + 1;
	return ('00' + n).slice(-2);
};

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	threads: function threads(state) {
		return state.threads;
	},
	thread: function thread(state) {
		return function (id) {
			return state.threads.filter(function (thread) {
				return thread.id === id;
			})[0];
		};
	},
	threadOfClient: function threadOfClient(state) {
		return function (id) {
			return state.threads.filter(function (thread) {
				return thread.client ? parseInt(thread.client.id) === parseInt(id) : false;
			});
		};
	}
};

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(679);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(239);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* CLEAR_THREAD */], function (state) {
	state.threads = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* NEW_THREAD */], function (state, thread) {
	state.threads.push(thread);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* NEW_MESSAGE */], function (state, data) {
	state.threads.forEach(function (thread) {
		if (thread.id === data.id) {
			thread.messages.push(data.message);
		}
	});
}), _mutations);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	threads: []
};

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_resources_Documents__ = __webpack_require__(669);





var resolveType = function resolveType(document) {
	var type = null;
	switch (document.category) {
		case 'personal-estate':
			type = 'personalEstate';
			break;
		case 'operations':
			type = 'myOperations';
			break;
		case 'justificatifs':
			type = 'justificatifs';
			break;
		case 'subscriptions':
			type = 'subscriptions';
			break;
		case 'autre':
			var tmp = document.confidential ? 'private' : 'shared';
			type = tmp;
			break;
		case 'private':
			type = 'private';
			break;
		case 'lcb-ft':
			type = 'lcbft';
			break;
	}

	return type;
};

var actions = {
	fetchDocuments: function fetchDocuments(_ref) {
		var commit = _ref.commit;

		commit('LOADER_IN');
		commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* CLEAR_DOCUMENTS */]);
		__WEBPACK_IMPORTED_MODULE_3__common_resources_Documents__["a" /* default */].getDocuments().then(function (result) {
			commit('LOADER_OUT');
			if (result.data.success) {
				result.data.documents.forEach(function (document) {
					commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* ADD_DOCUMENT */], {
						type: resolveType(document),
						document: document
					});
				});
			}
		});
	},
	addDocument: function addDocument(_ref2, data) {
		var commit = _ref2.commit;

		var form = new FormData();
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			getBase64File(data.file).then(function (base64) {
				data.file = base64;
				return data;
			}).then(function (data) {
				__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
					form.append(key, data[key]);
				});
				__WEBPACK_IMPORTED_MODULE_3__common_resources_Documents__["a" /* default */].addDocument(form).then(function (result) {
					if (result.data.success) {
						commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* ADD_DOCUMENT */], {
							type: resolveType(result.data.document),
							document: result.data.document
						});
						commit('LOADER_OUT');
						resolve(result.data.document);
					} else {
						commit('LOADER_OUT');
						reject(new Error('not a success'));
					}
				}).catch(function (error) {
					commit('LOADER_OUT');
					reject(error);
				});
			});
		});
	}
};

var getBase64File = function getBase64File(file) {
	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		var reader = new FileReader();
		reader.onload = function () {
			resolve(reader.result);
		};
		reader.onerror = function (error) {
			reject(error);
		};
		reader.readAsDataURL(file);
	});
};

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	documents: function documents(state) {
		return state.documents;
	},
	typeDocuments: function typeDocuments(state) {
		return function (type) {
			if (state.documents[type]) {
				return state.documents[type];
			} else {
				return state.documents.autre[type];
			}
		};
	}
};

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(684);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(240);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* CLEAR_DOCUMENTS */], function (state) {
	state.documents.myOperations = [];
	state.documents.personalEstate = [];
	state.documents.justificatifs = [];
	state.documents.lcbft = [];
	state.documents.subscriptions = [];
	state.documents.autre.shared = [];
	state.documents.autre.private = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* ADD_DOCUMENT */], function (state, data) {
	if (state.documents[data.type]) {
		state.documents[data.type].push(data.document);
	} else if (typeof state.documents.autre[data.type] !== 'undefined') {
		state.documents.autre[data.type].push(data.document);
	}
}), _mutations);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	documents: {
		myOperations: [],
		personalEstate: [],
		justificatifs: [],
		autre: {
			shared: [],
			private: []
		}
	}
};

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_resources_investment__ = __webpack_require__(238);




var actions = {
	getClientInvestmentProducts: function getClientInvestmentProducts(_ref, userId) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit('CLEAR');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_investment__["a" /* default */].getClientInvestmentProducts(userId).then(function (result) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_INVESTMENT_PRODUCTS */], result.data.investment_products);
				resolve();
			}).catch(function (error) {
				reject(error);
			}).finally(function () {
				commit('LOADER_OUT');
			});
		});
	},
	getInvestmentProduct: function getInvestmentProduct(_ref2, id) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit('CLEAR');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_investment__["a" /* default */].getInvestmentProduct(id).then(function (result) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_INVESTMENT_PRODUCT */], result.data.investment_product);
				resolve(result.data.investment_product);
			}).catch(function (error) {
				reject(error);
			}).finally(function () {
				commit('LOADER_OUT');
			});
		});
	},
	setInvestmentProduct: function setInvestmentProduct(_ref3, investmentProduct) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit('CLEAR');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_investment__["a" /* default */].updateInvestmentProduct(investmentProduct.id, investmentProduct).then(function (result) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_INVESTMENT_PRODUCT */], result.data.investment_product);
				resolve(result.data.investment_product);
			}).catch(function (error) {
				reject(error);
			}).finally(function () {
				commit('LOADER_OUT');
			});
		});
	},
	addInvestmentProduct: function addInvestmentProduct(_ref4, _ref5) {
		var commit = _ref4.commit;
		var clientId = _ref5.clientId,
		    investmentProduct = _ref5.investmentProduct;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit('CLEAR');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_investment__["a" /* default */].addInvestmentProduct(clientId, investmentProduct).then(function (result) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* ADD_INVESTMENT_PRODUCT */], result.data.investment_product);
				resolve(result.data.investment_product);
			}).catch(function (error) {
				reject(error);
			}).finally(function () {
				commit('LOADER_OUT');
			});
		});
	},
	deleteInvestmentProducts: function deleteInvestmentProducts(_ref6, id) {
		var commit = _ref6.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit('CLEAR');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_investment__["a" /* default */].deleteInvestmentProducts(id).then(function (result) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* DELETE_INVESTMENT_PRODUCT */], id);
				resolve();
			}).catch(function (error) {
				reject(error);
			}).finally(function () {
				commit('LOADER_OUT');
			});
		});
	}
};

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	investmentProducts: function investmentProducts(state) {
		return state.investment_products;
	}
};

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(689);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(241);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_INVESTMENT_PRODUCTS */], function (state, data) {
	state.investment_products = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_INVESTMENT_PRODUCT */], function (state, data) {
	var index = state.investment_products.findIndex(function (item) {
		return item.id === data.id;
	});

	if (index > -1) {
		state.investment_products[index] = data;
	} else {
		state.investment_products.push(data);
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* ADD_INVESTMENT_PRODUCT */], function (state, data) {
	state.investment_products.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* DELETE_INVESTMENT_PRODUCT */], function (state, id) {
	state.investment_products = state.investment_products.filter(function (product) {
		return product.id !== id;
	});
}), _mutations);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	investment_products: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_resources_News__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_authors_nicolas_jpg__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_img_authors_nicolas_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_img_authors_nicolas_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assets_img_authors_olivier_jpg__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assets_img_authors_olivier_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_assets_img_authors_olivier_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_assets_img_logo_short_png__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_assets_img_logo_short_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_assets_img_logo_short_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(96);








function getNewAuthorImage(authorInfo) {
	if (authorInfo.slug === 'olivier') {
		return __WEBPACK_IMPORTED_MODULE_4__common_assets_img_authors_olivier_jpg___default.a;
	} else if (authorInfo.slug === 'nicolas') {
		return __WEBPACK_IMPORTED_MODULE_3__common_assets_img_authors_nicolas_jpg___default.a;
	}

	if (typeof authorInfo.avatar_urls['96'] !== 'undefined') {
		return authorInfo.avatar_urls['96'];
	}

	return __WEBPACK_IMPORTED_MODULE_5__common_assets_img_logo_short_png___default.a;
}

var actions = {
	fetchAllNews: function fetchAllNews(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_1__common_resources_News__["a" /* default */].getAllNews().then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* CLEAR_ARTICLES */]);
					result.data.news.forEach(function (article) {
						var newsToAdd = {
							id: article.id,
							body: article.body,
							created_at: article.created_at,
							news_tags: article.news_tags,
							title: article.title,
							updated_at: article.updated_at,
							image: article.post_image_url,
							author: {
								name: article.user.first_name + ' ' + article.user.last_name,
								image: article.user.media ? "https://api-preprod.patrimoffice.com/api/pictures/" + article.user.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png'
							},
							link: article.post_url,
							size: 'small'
						};
						if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user.role === 'ADVISOR') {
							commit(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* ADD_MY_NEWS */], newsToAdd);
						} else {
							commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* ADD_ARTICLE */], newsToAdd);
						}
					});
					result.data.wp_news.forEach(function (article) {
						var newsToAdd = {
							id: article.id,
							body: article.content.rendered,
							created_at: article.date,
							news_tags: article.tags,
							title: article.title.rendered,
							updated_at: article.modified,
							image: article.better_featured_image ? article.better_featured_image.source_url : null,
							author: {
								name: article._embedded.author[0].name,
								image: getNewAuthorImage(article._embedded.author[0])
							},
							size: 'big'
						};

						if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user.role === 'ADVISOR') {
							commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* ADD_ARTICLE */], newsToAdd);
						} else {
							if (article.categories.indexOf(60) !== -1) {
								commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* ADD_ARTICLE */], newsToAdd);
							} else {
								commit(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* ADD_BANQUE */], newsToAdd);
							}
						}
					});
				}
				commit('LOADER_OUT');
				resolve();
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	shareNews: function shareNews(_ref2, news) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_1__common_resources_News__["a" /* default */].shareNews({
				title: news.title,
				body: news.body,
				post_url: news.link,
				post_image_url: news.link_image,
				date: new Date(),
				tags: news.selectedTags.map(function (tag) {
					return tag.id;
				})
			}).then(function (result) {
				if (result.data.success) {
					var article = result.data.article;
					var newsToAdd = {
						id: article.id,
						body: article.body,
						created_at: article.created_at,
						news_tags: article.news_tags,
						title: article.title,
						updated_at: article.updated_at,
						image: article.post_image_url,
						author: {
							name: article.user.first_name + ' ' + article.user.last_name,
							image: article.user.media ? "https://api-preprod.patrimoffice.com/api/pictures/" + article.user.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png'
						},
						link: article.post_url,
						size: 'small'
					};
					commit(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* ADD_MY_NEWS */], newsToAdd);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('je sais pas encore'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	}
};

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	myNews: function myNews(state) {
		var result = [];
		state.articles.forEach(function (article) {
			if (resolveUserTags(article, state.userTags)) {
				result.push(article);
			}
		});
		return result;
	},
	banqueNews: function banqueNews(state) {
		return state.banques;
	},
	allNews: function allNews(state) {
		return state.articles;
	},
	tags: function tags(state) {
		return state.tags;
	},
	getArticle: function getArticle(state) {
		return function (id) {
			var result = null;
			state.articles.forEach(function (article) {
				if (parseInt(article.id) === parseInt(id)) {
					result = article;
				}
			});

			if (!result) {
				state.banques.forEach(function (article) {
					if (parseInt(article.id) === parseInt(id)) {
						result = article;
					}
				});
			}

			return result;
		};
	},
	writtedNews: function writtedNews(state) {
		return state.myNews;
	}
};

var resolveUserTags = function resolveUserTags(article, userTags) {
	var shouldAdd = false;
	article.news_tags.forEach(function (articleTag) {
		var idToCheck = articleTag.tags ? articleTag.tags.id : articleTag;
		userTags.forEach(function (userTag) {
			if (idToCheck === (articleTag.tags ? userTag.id : userTag.wordpress_tag_id)) {
				shouldAdd = true;
			}
		});
	});

	return article.news_tags.length > 0 ? shouldAdd : false;
};

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(694);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(242);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* CLEAR_ARTICLES */], function (state) {
	state.articles = [];
	state.banques = [];
	state.myNews = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* CLEAR_TAGS */], function (state) {
	state.tags = [];
	state.userTags = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* ADD_ARTICLE */], function (state, data) {
	var t = new Date(data.created_at);
	if (t instanceof Date && !isNaN(t.getTime())) {
		data.created_at = new Date(data.created_at);
	} else {
		var d = data.created_at.substring(0, 10).split('/').reverse().concat(data.created_at.substring(10).split(':'));
		data.created_at = new Date(d[0], d[1], d[2], d[3], d[4]).toISOString();
	}
	var index = 0;
	state.articles.forEach(function (article, key) {
		if (data.created_at < article.created_at) {
			index = key + 1;
		}
	});
	state.articles.splice(index, 0, data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* ADD_BANQUE */], function (state, data) {
	state.banques.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* ADD_GENERAL_TAG */], function (state, data) {
	state.tags.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* ADD_USER_TAG */], function (state, data) {
	state.userTags.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* ADD_MY_NEWS */], function (state, data) {
	var t = new Date(data.created_at);
	if (t instanceof Date && !isNaN(t.getTime())) {
		data.created_at = new Date(data.created_at);
	} else {
		var d = data.created_at.substring(0, 10).split('/').reverse().concat(data.created_at.substring(10).split(':'));
		data.created_at = new Date(d[0], d[1], d[2], d[3], d[4]).toISOString();
	}
	var index = 0;
	state.articles.forEach(function (article, key) {
		if (data.created_at < article.created_at) {
			index = key + 1;
		}
	});
	state.myNews.splice(index, 0, data);
}), _mutations);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	articles: [],
	tags: [],
	userTags: [],
	banques: [],
	myNews: []
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_resources_Notifications__ = __webpack_require__(671);




var actions = {
	fetchNotifications: function fetchNotifications(_ref, user) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Notifications__["a" /* default */].getNotifications(user.id).then(function (notifications) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* FETCH_NOTIFICATIONS */], { notifications: notifications });
				resolve();
			}).catch(function (e) {
				reject(e);
			});
		});
	}
};

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	notifications: function notifications(state) {
		return state.notifications;
	},
	countNotifs: function countNotifs(state) {
		if (state.notifications !== null) {
			return state.notifications.length;
		} else {
			return 0;
		}
	},
	open: function open(state) {
		return state.open;
	}
};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(699);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(243);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* FETCH_NOTIFICATIONS */], function (state, _ref) {
	var notifications = _ref.notifications;

	state.notifications = notifications;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* OPEN_NOTIF */], function (state) {
	state.open = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLOSE_NOTIF */], function (state) {
	state.open = false;
}), _mutations);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	notifications: [],
	open: false
};

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_Estate__ = __webpack_require__(237);




var actions = {
	storePatrimonial: function storePatrimonial(_ref, request) {
		var commit = _ref.commit;

		console.log('data', request);
		var data = request.data;
		commit(__WEBPACK_IMPORTED_MODULE_1__types__[request.name], { data: data });
		if (!request.fromStart) {
			commit('VALIDATION', request.name);
		}
	},
	savePatrimonial: function savePatrimonial(_ref2, request) {
		var commit = _ref2.commit,
		    dispatch = _ref2.dispatch,
		    state = _ref2.state;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit(__WEBPACK_IMPORTED_MODULE_1__types__["SET_ID"], { data: { id: request } });
			__WEBPACK_IMPORTED_MODULE_2__resources_Estate__["a" /* default */].savePatrimonial(dispatch, state, request).then(function (response) {
				commit('FILL_ESTATE');
				commit('LOADER_OUT');
				resolve(response);
			}).catch(function (e) {
				commit('LOADER_OUT');
				reject(e);
			});
		});
	},
	getPatrimonial: function getPatrimonial(_ref3) {
		var state = _ref3.state,
		    dispatch = _ref3.dispatch,
		    commit = _ref3.commit;
		var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		commit(__WEBPACK_IMPORTED_MODULE_1__types__["CLEAR"]);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_Estate__["a" /* default */].getPatrimonial(dispatch, state, id).then(function () {
				commit('LOADER_OUT');
				resolve();
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	}
};

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	estate: function estate(state) {
		return state;
	},
	isValidated: function isValidated(state) {
		return function (name) {
			var result = false;
			state.validation.forEach(function (comp) {
				if (comp.name === name) {
					result = comp.status;
				}
			});
			return result;
		};
	}
};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(704);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(244);




var _mutations;




var clearState = function clearState(oldState, newState) {
  if (oldState !== null && oldState !== undefined) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(oldState).forEach(function (key) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(oldState[key]) === "object") {
        if (oldState[key] instanceof Array) {
          if (key !== "validation") {
            oldState[key] = [];
          } else {
            oldState[key].forEach(function (step) {
              step.status = false;
            });
          }
        } else {
          oldState[key] = clearState(oldState[key], newState[key]);
        }
      } else {
        if (key === "cur") {
          oldState[key] = "EUR";
        } else {
          oldState[key] = null;
        }
      }
    });
  }
  return oldState;
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["CLEAR"], function (state) {
  state = clearState(state, __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["SET_ID"], function (state, _ref) {
  var data = _ref.data;

  state.idUser = data.id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["UPDATED_AT"], function (state, _ref2) {
  var data = _ref2.data;

  state.updatedAt = data.updatedAt;
  state.completedAt = data.completedAt;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["VALIDATION"], function (state, data) {
  state.validation.forEach(function (validate) {
    if (validate.name === data) {
      validate.status = true;
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["YOUR_INFORMATIONS"], function (state, _ref3) {
  var data = _ref3.data;

  console.log("MUTATION YOUR_INFORMATIONS - data received:", data);
  console.log("MUTATION YOUR_INFORMATIONS - birthdate value:", data.birthdate);
  state.birthdate = data.birthdate;
  state.job = data.job;
  state.csp = data.csp;
  state.maritalStatus = data.maritalStatus;
  console.log("MUTATION YOUR_INFORMATIONS - state.birthdate after mutation:", state.birthdate);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["YOUR_HOME"], function (state, _ref4) {
  var data = _ref4.data;

  state.childs = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["ANNUAL_RECIPE"], function (state, _ref5) {
  var data = _ref5.data;

  state.directIncome = data.directIncome;
  state.secondIncome = data.secondIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["REAL_ESTATE"], function (state, _ref6) {
  var data = _ref6.data;

  state.mainEstate = data.mainEstate;
  state.secondaryEstates = data.secondaryEstates;
  state.rentalProperties = data.rentalProperties;
  state.isSCPI = data.isSCPI;
  state.scpi = data.scpi;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["SAVINGS"], function (state, _ref7) {
  var data = _ref7.data;

  state.savings = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["GFR"], function (state, _ref8) {
  var data = _ref8.data;

  state.gfr = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["SPENDING_NO_TAXES"], function (state, _ref9) {
  var data = _ref9.data;

  state.spendingNoTaxes = data.spending;
  state.periodicity = data.periodicity;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["CREDITS"], function (state, _ref10) {
  var data = _ref10.data;

  state.credits = data.loans;
  state.overallDebtPercentage = data.overallDebtPercentage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["TAXES"], function (state, _ref11) {
  var data = _ref11.data;

  state.taxes = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["ISF"], function (state, _ref12) {
  var data = _ref12.data;

  state.isf = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["RETREAT"], function (state, _ref13) {
  var data = _ref13.data;

  state.retreat = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["INFLUENCE"], function (state, _ref14) {
  var data = _ref14.data;

  state.influence = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["FOLLOWING"], function (state, _ref15) {
  var data = _ref15.data;

  state.follow = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["KNOWLEDGE"], function (state, _ref16) {
  var data = _ref16.data;

  state.knowledge = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["PERSPECTIVE"], function (state, _ref17) {
  var data = _ref17.data;

  state.perspective = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["ESG"], function (state, _ref18) {
  var data = _ref18.data;

  state.esg = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["TOTAL"], function (state, _ref19) {
  var data = _ref19.data;

  state.total = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["ADVISOR_CHECK"], function (state, _ref20) {
  var data = _ref20.data;

  console.log("updating advisor check", data);
  state.advisorCheck = data;
}), _mutations);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_resources_Plans__ = __webpack_require__(672);




var actions = {
	getPlans: function getPlans(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLEAR_PLANS */]);
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Plans__["a" /* default */].getPlans().then(function (result) {
				if (result.data.success) {
					result.data.plans.forEach(function (plan) {
						commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_PLAN */], plan);
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la récupération des plans'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	getPlan: function getPlan(_ref2, id) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Plans__["a" /* default */].getPlan(id).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_PLAN */], result.data.plans[0]);
					commit('LOADER_OUT');
					resolve(result.data.plans[0]);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la récupération du plan ' + id));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	}
};

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	plans: function plans(state) {
		return state.plans;
	},
	plan: function plan(state) {
		return function (id) {
			return state.plans.filter(function (o) {
				return parseInt(o.id) === parseInt(id);
			})[0];
		};
	}
};

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(708);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(246);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_PLAN */], function (state, plan) {
	state.plans.push(plan);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_PLAN */], function (state, plan) {
	state.plans = state.plans.map(function (op) {
		if (op.id !== plan.id) {
			return op;
		} else {
			return plan;
		}
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLEAR_PLANS */], function (state) {
	state.plans = [];
}), _mutations);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	plans: []
};

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_resources_Site__ = __webpack_require__(673);





var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* GET_CURRENT_SITE */], function (context) {
	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__common_resources_Site__["a" /* default */].getCurrentSite().then(function (_ref) {
			var data = _ref.data;

			context.commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_CURRENT_SITE */], data);
			resolve(data);
		}).catch(function (_ref2) {
			var response = _ref2.response;

			console.log(response);
			context.commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* CLEAR_CURRENT_SITE */]);
			reject(response.data);
		});
	});
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	currentSite: function currentSite(state) {
		return state.site;
	},
	currentTheme: function currentTheme(state) {
		return state.site ? state.site.theme : null;
	},
	cgpiHost: function cgpiHost(state) {
		return state.site.hosts.find(function (host) {
			return host.name === 'app_cgpi';
		});
	},
	clientHost: function clientHost(state) {
		return state.site.hosts.find(function (host) {
			return host.name === 'app_client';
		});
	}
};

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(713);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */]
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_theme_builder__ = __webpack_require__(725);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_CURRENT_SITE */], function (state, site) {
	state.site = site;
	__WEBPACK_IMPORTED_MODULE_2__common_utils_theme_builder__["a" /* default */].build(state.site.theme);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLEAR_CURRENT_SITE */], function (state) {
	state.site = null;
}), _mutations);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	site: null
};

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__ = __webpack_require__(674);




var actions = {
	getSubscriptions: function getSubscriptions(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLEAR_SUBSCRIPTIONS */]);
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__["a" /* default */].getSubscriptions().then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* LAST_PAYMENT_FAIL_INFO */], result.data.lastPaymentFailInfo);
					result.data.subscriptions.forEach(function (subscription) {
						commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_SUBSCRIPTION */], subscription);
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la récupération des abonnements'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	getSubscription: function getSubscription(_ref2, id) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__["a" /* default */].getSubscription(id).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_SUBSCRIPTION */], result.data.subscriptions[0]);
					commit('LOADER_OUT');
					resolve(result.data.subscriptions[0]);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la récupération de l\'abonnement ' + id));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	createSubscription: function createSubscription(_ref3, subscription) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__["a" /* default */].postSubscription({
				user_id: subscription.client.id,
				advisor_id: subscription.advisor.id,
				payment_type: subscription.payment_type.name,
				effect_date: subscription.effect_date,
				has_paid_first_charge: subscription.has_paid_first_charge
			}).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_SUBSCRIPTION */], result.data.subscription);
					commit('LOADER_OUT');
					resolve(result.data.subscription);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la création de l\'abonnement'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	patchSubscription: function patchSubscription(_ref4, subscription) {
		var commit = _ref4.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__["a" /* default */].updateSubscription(subscription.id, {
				user_id: subscription.client.id,
				advisor_id: subscription.advisor.id,
				payment_type: subscription.payment_type.name,
				effect_date: subscription.effect_date,
				has_paid_first_charge: subscription.has_paid_first_charge
			}).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_SUBSCRIPTION */], result.data.subscription);
					commit('LOADER_OUT');
					resolve(result.data.subscription);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la création de l\'abonnement'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	cancelSubscription: function cancelSubscription(_ref5, subscription) {
		var commit = _ref5.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__["a" /* default */].cancelSubscription(subscription.id).then(function (result) {
				if (result.data.success) {
					commit('LOADER_OUT');
					resolve({});
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant l\'annulation de l\'abonnement'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	confirmPayment: function confirmPayment(_ref6, data) {
		var commit = _ref6.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Subscriptions__["a" /* default */].confirmPayment(data);
		});
	}
};

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	subscriptions: function subscriptions(state) {
		return state.subscriptions;
	},
	subscription: function subscription(state) {
		return function (id) {
			return state.subscriptions.filter(function (o) {
				return parseInt(o.id) === parseInt(id);
			})[0];
		};
	},
	currentSubscription: function currentSubscription(state) {
		return state.subscriptions.length > 0 ? state.subscriptions[0] : null;
	},
	lastPaymentFailInfo: function lastPaymentFailInfo(state) {
		return state.lastPaymentFailInfo;
	}
};

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(718);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(247);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_SUBSCRIPTION */], function (state, subscription) {
	state.subscriptions.push(subscription);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_SUBSCRIPTION */], function (state, subscription) {
	state.subscriptions = state.subscriptions.map(function (op) {
		if (op.id !== subscription.id) {
			return op;
		} else {
			return subscription;
		}
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLEAR_SUBSCRIPTIONS */], function (state) {
	state.subscriptions = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* LAST_PAYMENT_FAIL_INFO */], function (state, info) {
	state.lastPaymentFailInfo = info;
}), _mutations);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	subscriptions: [],
	lastPaymentFailInfo: null
};

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__ = __webpack_require__(675);




var actions = {
	getOperations: function getOperations(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit(__WEBPACK_IMPORTED_MODULE_1__types__["e" /* CLEAR_OPERATIONS */]);
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].getOperations().then(function (result) {
				if (result.data.success) {
					result.data.missions.forEach(function (operation) {
						commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_OPERATION */], operation);
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la récupération des opérations'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	getOperation: function getOperation(_ref2, id) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].getOperation(id).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_OPERATION */], result.data.missions[0]);
					commit('LOADER_OUT');
					resolve(result.data.missions[0]);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la récupération de l\'opération ' + id));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	createOperation: function createOperation(_ref3, operation) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].postOperation({
				user_id: operation.client.id,
				advisor_id: operation.advisor.id,
				title: operation.name,
				contract_ref: operation.contract,
				total_value: operation.amount.value,
				currency: operation.amount.currency,
				type: operation.type,
				description: operation.description
			}).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_OPERATION */], result.data.mission);
					commit('LOADER_OUT');
					resolve(result.data.mission);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la création de l\'opération'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	patchOperation: function patchOperation(_ref4, operation) {
		var commit = _ref4.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].updateOperation(operation.id, {
				user_id: operation.client.id,
				advisor_id: operation.advisor.id,
				title: operation.name,
				contract_ref: operation.contract,
				total_value: operation.amount.value,
				currency: operation.amount.currency,
				type: operation.type,
				description: operation.description
			}).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_OPERATION */], result.data.mission);
					commit('LOADER_OUT');
					resolve(result.data.mission);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la création de l\'opération'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	getContracts: function getContracts(_ref5) {
		var commit = _ref5.commit;

		commit(__WEBPACK_IMPORTED_MODULE_1__types__["f" /* CLEAR_CONTRACTS */]);
		commit('LOADER_IN');
		__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].getContracts().then(function (result) {
			if (result.data.success) {
				commit('LOADER_OUT');
				result.data.contracts.forEach(function (contract) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* ADD_CONTRACT */], contract);
				});
			} else {
				commit('LOADER_OUT');
			}
		}).catch(function () {
			commit('LOADER_OUT');
		});
	},
	addContract: function addContract(_ref6, contract) {
		var commit = _ref6.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].createContract(contract).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* ADD_CONTRACT */], result.data.contract);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue à l\'ajout d\'un contrat'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(new Error(error));
			});
		});
	},
	addProduct: function addProduct(_ref7, data) {
		var commit = _ref7.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].createProduct(data.product).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* ADD_PRODUCT_TO_CONTRACT */], {
						product: result.data.product,
						contractId: data.contractId
					});
					return __WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].linkProductToContract(data.contractId, result.data.product.id);
				} else {
					commit('LOADER_OUT');
					reject(new Error('new Error while creating the product'));
				}
			}).then(function (result) {
				if (result.data.success) {
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('new Error while linking product to contract'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	addProductToMission: function addProductToMission(_ref8, data) {
		var commit = _ref8.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].addProductToMission(data).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["g" /* ADD_PRODUCT_TO_OPERATION */], result.data.mission_contract_product);
					commit('LOADER_OUT');
					resolve(result.data.mission_contract_product);
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue à l\'ajout du produit à la mission'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	editProductFromMission: function editProductFromMission(_ref9, data) {
		var commit = _ref9.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].editProductFromMission(data.product).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["h" /* EDIT_PRODUCT_FROM_MISSION */], result.data.mission_contract_product);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant l\'édition d\'un produit'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(new Error(error));
			});
		});
	},
	removeProductFromMission: function removeProductFromMission(_ref10, data) {
		var commit = _ref10.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__common_resources_Transactions__["a" /* default */].removeProductFromMission(data.product.id).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["i" /* REMOVE_PRODUCT_FROM_OPERATION */], data);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue pendant la suppression d\'un produit'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	}
};

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	operations: function operations(state) {
		return state.operations;
	},
	operation: function operation(state) {
		return function (id) {
			return state.operations.filter(function (o) {
				return parseInt(o.id) === parseInt(id);
			})[0];
		};
	},
	getContractTypeList: function getContractTypeList(state) {
		return state.contracts;
	},
	getProductTypeList: function getProductTypeList(state) {
		return state.products;
	}
};

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(723);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(248);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* ADD_OPERATION */], function (state, operation) {
	state.operations.push(operation);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* REPLACE_OPERATION */], function (state, operation) {
	state.operations = state.operations.map(function (op) {
		if (op.id !== operation.id) {
			return op;
		} else {
			return operation;
		}
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* ADD_PRODUCT_TO_CONTRACT */], function (state, data) {
	state.contracts.filter(function (contract) {
		return contract.id === data.contractId;
	})[0].contract_products.push({ product: data.product });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* ADD_CONTRACT */], function (state, contract) {
	state.contracts.push(contract);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* CLEAR_OPERATIONS */], function (state) {
	state.operations = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* CLEAR_CONTRACTS */], function (state) {
	state.contracts = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* ADD_PRODUCT_TO_OPERATION */], function (state, data) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["h" /* EDIT_PRODUCT_FROM_MISSION */], function (state, data) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["i" /* REMOVE_PRODUCT_FROM_OPERATION */], function (state, data) {
	var op = state.operations.filter(function (o) {
		return o.id === data.operationId;
	})[0];
	var keyOfProduct = null;
	op.mission_contract_products.forEach(function (mcp, key) {
		if (mcp.id === data.product.id) {
			keyOfProduct = key;
		}
	});

	op.mission_contract_products.splice(keyOfProduct, 1);
}), _mutations);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	operations: [],
	contracts: []
};

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ThemeBuilder = function () {
	function ThemeBuilder() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ThemeBuilder);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ThemeBuilder, [{
		key: 'createOrFindStyleElement',
		value: function createOrFindStyleElement() {
			var styleEl = document.querySelector('[data-from-template=true]');

			if (!styleEl) {
				styleEl = this.createStyleElement();
			}

			return styleEl.sheet;
		}
	}, {
		key: 'build',
		value: function build(theme) {
			this.theme = theme;
			this.stylesheet = this.createOrFindStyleElement();

			this.applyStylesheet();
		}
	}, {
		key: 'createStyleElement',
		value: function createStyleElement() {
			var styleEl = document.createElement('style');
			styleEl.setAttribute('data-from-template', 'true');

			styleEl.appendChild(document.createTextNode(''));
			document.head.appendChild(styleEl);

			return styleEl;
		}
	}, {
		key: 'computeStyleRules',
		value: function computeStyleRules() {
			var themeParams = this.theme.params;
			var stylesToInsert = ':root {';

			themeParams.forEach(function (param) {
				var cssProperty = '--' + param.param_name;
				stylesToInsert += cssProperty + ': ' + param.param_value + ' !important;';
			});

			stylesToInsert += '}';

			return stylesToInsert;
		}
	}, {
		key: 'applyStylesheet',
		value: function applyStylesheet() {
			var customStyleRules = this.computeStyleRules();

			this.stylesheet.insertRule(customStyleRules);
		}
	}]);

	return ThemeBuilder;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ThemeBuilder());

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_fr__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notification__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_directives_inputUI__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_directives_selectUI__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_components_baseModal__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__common_components_baseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_components_ag_table__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_components_ag_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_components_ag_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components_toggle_input__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components_toggle_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__common_components_toggle_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_components_Form_RadioBox__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_components_Form_RadioBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__common_components_Form_RadioBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_services_iRobot__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_directives_ImageDetect__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__node_modules_ag_grid_dist_styles_ag_grid_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__node_modules_ag_grid_dist_styles_ag_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__node_modules_ag_grid_dist_styles_ag_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__node_modules_ag_grid_dist_styles_ag_theme_balham_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__node_modules_ag_grid_dist_styles_ag_theme_balham_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__node_modules_ag_grid_dist_styles_ag_theme_balham_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sentry_browser__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sentry_integrations__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_sweetalert2__ = __webpack_require__(445);







__webpack_require__(122);


























window.$ = __WEBPACK_IMPORTED_MODULE_10_jquery___default.a;
window.jQuery = __WEBPACK_IMPORTED_MODULE_10_jquery___default.a;

if (['production', 'staging'].includes("development")) {
	__WEBPACK_IMPORTED_MODULE_24__sentry_browser__["a" /* init */]({
		dsn: 'https://3e55c20d3c254b9c833d7d23cf1d98f5@sentry.io/1846664',
		environment: "development",
		integrations: [new __WEBPACK_IMPORTED_MODULE_25__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["default"], attachProps: true, logErrors: true })]
	});
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__common_directives_inputUI__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__common_directives_selectUI__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].localize('fr', __WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_fr___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_moment___default.a, { moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('base-modal', __WEBPACK_IMPORTED_MODULE_16__common_components_baseModal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ag-table', __WEBPACK_IMPORTED_MODULE_17__common_components_ag_table___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('toggle-input', __WEBPACK_IMPORTED_MODULE_18__common_components_toggle_input___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('radio-box', __WEBPACK_IMPORTED_MODULE_19__common_components_Form_RadioBox___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20__common_services_iRobot__["a" /* VueRobot */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__common_directives_ImageDetect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
	id: 'UA-109825003-3',
	autoTracking: {
		screenview: true
	}
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_sweetalert2__["a" /* default */]);

__webpack_require__(428);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	template: '<App/>',
	components: {
		App: __WEBPACK_IMPORTED_MODULE_11__App___default.a,
		baseModal: __WEBPACK_IMPORTED_MODULE_16__common_components_baseModal___default.a,
		vSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a,
		Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
	},
	created: function created() {
		window.Vue = this;
	},
	store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */]
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	isLoader: function isLoader(state) {
		return state.loader;
	}
};

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(729);




/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */]
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(731);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* LOADER_IN */], function (state) {
	state.loader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* LOADER_OUT */], function (state) {
	state.loader = false;
}), _mutations);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	loader: false
};

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_OUT; });
var LOADER_IN = 'LOADER_IN';
var LOADER_OUT = 'LOADER_OUT';

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_user__ = __webpack_require__(50);




var resolveClient = function resolveClient(data, isMain) {
	var date = null;
	if (data.user.birthdate) {
		date = data.user.birthdate;
		date = date.split('-');
		date = new Date(date[2], date[1] - 1, date[0]);
	}

	return {
		isMain: isMain,
		id: data.user.id,
		email: data.user.email || null,
		type: data.type || null,
		firstname: data.user.first_name || null,
		lastname: data.user.last_name || null,
		full_name: data.user.full_name || null,
		birthdate: date,
		address: {
			line: data.user.address || null,
			zip: data.user.zipcode || null,
			country: data.user.country || null,
			city: data.user.city || null
		},
		phone: data.user.phone || null,
		notes: [],
		media: {
			file: data.user.media ? data.user.media.file : null
		},
		lcbft_completed: data.lcbft_completed,
		lcbft_last_updated: data.user.private_estate ? resolveDate(data.user.private_estate.updated_at) : null,
		center_of_interest: data.user.user_tags.map(function (tag) {
			return tag.tags;
		}),
		source: data.source,
		rdvs: [],
		missions: [],
		certified: resolveCertified(data.user.certified),
		isFillingPatrimonialEstate: data.user.private_estate ? !data.user.private_estate.completed : true,
		subscription: data.subscription,
		client_next_rdv: typeof data.user.client_next_rdv !== 'undefined' ? data.user.client_next_rdv : data.next_rdv
	};
};

var resolveDate = function resolveDate(d) {
	d = d.split(' ');
	d = d[0].split('/').concat(d[1].split(':'));
	return new Date(d[2], d[1] - 1, d[0], d[3], d[4]);
};

var resolveCertified = function resolveCertified(c) {
	if (c === 0) {
		return 'NOT CERTIFIED';
	} else if (c === 1) {
		return 'CERTIFIED';
	} else if (c === 2) {
		return 'PENDING';
	}
};

var actions = {
	login: function login(_ref, __user) {
		var commit = _ref.commit,
		    dispatch = _ref.dispatch;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].login(__user.email, __user.password).then(function (data) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* LOGIN */], data);
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* UPDATE_PROFILE */], data.user);
				var picture = data.picture;
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["e" /* PROFIL_PICTURE */], { image: picture });
				commit('CLEAR_TAGS');
				data.user.office.tags.forEach(function (tag) {
					commit('ADD_GENERAL_TAG', tag);
				});
			}).then(function () {
				dispatch('getClients');
				commit('LOADER_OUT');
				resolve();
			}).catch(function () {
				commit('LOADER_OUT');
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* LOGOUT */]);
				reject();
			});
		});
	},
	logout: function logout(_ref2) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].logout().then(function () {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* LOGOUT */]);
				resolve();
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getClients: function getClients(_ref3) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].getClients().then(function (result) {
				var clients = [];
				if (result.data.main_advisor) {
					result.data.main_advisor.forEach(function (client) {
						clients.push(resolveClient(client, true));
					});
				}
				if (result.data.second_advisor) {
					result.data.second_advisor.forEach(function (client) {
						clients.push(resolveClient(client, false));
					});
				}
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["f" /* GET_CLIENTS */], clients);
				commit('LOADER_OUT');
				resolve();
			}).catch(function (error) {
				commit('LOADER_OUT');
				console.warn(error);
				reject(error);
			});
		});
	},
	getClient: function getClient(_ref4, id) {
		var commit = _ref4.commit,
		    dispatch = _ref4.dispatch;

		var client = null;
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			commit('CLEAR');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].getClient(id).then(function (result) {
				if (result.data) {
					client = resolveClient(result.data.client);
					return __WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].fetchAppointmentsForClient(id);
				} else {
					commit('LOADER_OUT');
					reject(new Error(result.data.error));
				}
			}).then(function (result) {
				if (result.data.success) {
					client.rdvs = result.data.rdvs;
					return __WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].fetchNotes(id);
				} else {
					commit('LOADER_OUT');
					reject(new Error(result.data.error));
				}
			}).then(function (result) {
				if (result.data.success) {
					client.notes = result.data.notes;
					return __WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].fetchMissionsForClient(id);
				} else {
					commit('LOADER_OUT');
					reject(new Error(result.data.error));
				}
			}).then(function (result) {
				if (result.data.success) {
					client.missions = result.data.missions;
					if (client.certified === 'CERTIFIED') {
						commit(__WEBPACK_IMPORTED_MODULE_1__types__["g" /* UPDATE_CLIENT */], client);
						commit('LOADER_OUT');
						resolve();
					} else {
						return __WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].getCertificateLevel(id);
					}
				} else {
					commit('LOADER_OUT');
					reject(new Error(result.data.error));
				}
			}).then(function (result) {
				if (result && result.data && result.data.response && result.data.response.certificateLevel) {
					var level = result.data.response.certificateLevel;
					if (level === 'certified' || level === 'advanced') {
						client.certified = 'CERTIFIED';
					}
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["g" /* UPDATE_CLIENT */], client);
					commit('LOADER_OUT');
					resolve();
				}
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].getInvestmentStats(client.id).then(function (resp) {
					client.investment_stats = resp.data && resp.data.investment_stats ? resp.data.investment_stats : null;
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["g" /* UPDATE_CLIENT */], client);
					commit('LOADER_OUT');
					resolve();
				});
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	addClient: function addClient(_ref5, client) {
		var commit = _ref5.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].addClient(client).then(function (result) {
				if (result.data.success) {
					client['id'] = result.data.user.id;
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["h" /* ADD_CLIENT */], client);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error(result.data.error));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	editClient: function editClient(_ref6, client) {
		var commit = _ref6.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			console.log('Start edit client action');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].editClient(client).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["i" /* EDIT_CLIENT */], client);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Something went wrong'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	updateProfilePicture: function updateProfilePicture(_ref7, data) {
		var commit = _ref7.commit,
		    state = _ref7.state;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].updateProfilePicture(data, state.id).then(function (response) {
				commit('LOADER_OUT');
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["e" /* PROFIL_PICTURE */], response.data);
				resolve();
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	saveProfile: function saveProfile(_ref8, data) {
		var commit = _ref8.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].updateProfile(data).then(function () {
				commit('LOADER_OUT');
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* UPDATE_PROFILE */], data);
				resolve();
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	editPassword: function editPassword(_ref9, data) {
		var commit = _ref9.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			console.log('Received', data.getAll('current_password'));
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].editPassword(data).then(function (response) {
				commit('LOADER_OUT');
				if (response.status === 201) {
					resolve(response);
				} else {
					reject(new Error());
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	addNote: function addNote(_ref10, data) {
		var commit = _ref10.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].createNote({
				user_id: data.clientId,
				title: data.note.title,
				description: data.note.message
			}).then(function (result) {
				commit('LOADER_OUT');
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["j" /* ADD_NOTE */], {
						id: data.clientId,
						note: result.data.note
					});
					resolve();
				} else {
					reject();
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	editNote: function editNote(_ref11, data) {
		var commit = _ref11.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].updateNote(data.note.id, {
				title: data.note.title,
				description: data.note.message
			}).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["k" /* UPDATE_NOTE */], {
						id: data.clientId,
						note: result.data.note
					});
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject();
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	deleteNote: function deleteNote(_ref12, data) {
		var commit = _ref12.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].deleteNote(data.note.id).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["l" /* DELETE_NOTE */], data);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_IN');
					reject();
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	sendLCBCFT: function sendLCBCFT(_ref13, data) {
		var commit = _ref13.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].postLCBCFT(data).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["n" /* ADD_LCBCFT_TO_CLIENT */], data.user_id);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	sendMailCheckPaysage: function sendMailCheckPaysage(_ref14, data) {
		var commit = _ref14.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].postCheckPaysage(data).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["o" /* ADD_CHECK_PAYSAGE */], data.user_id);
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	setAvailable: function setAvailable(_ref15, data) {
		var commit = _ref15.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].setAvailable(data).then(function (result) {
				if (result.data.success) {
					commit(__WEBPACK_IMPORTED_MODULE_1__types__["p" /* SET_AVAILABLE */], { available: result.data.available !== 0, ooo_message: data.ooo_message });
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	createAppointment: function createAppointment(_ref16, data) {
		var commit = _ref16.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].createAppointment(data).then(function (result) {
				if (result.data.success) {
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject();
				}
			}).catch(function (error) {
				console.warn(error);
				commit('LOADER_OUT');
				reject();
			});
		});
	},
	updateAppointment: function updateAppointment(_ref17, _ref18) {
		var commit = _ref17.commit;
		var id = _ref18.id,
		    data = _ref18.data;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].updateAppointment(id, data).then(function (result) {
				if (result.data.success) {
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject();
				}
			}).catch(function (error) {
				console.warn(error);
				commit('LOADER_OUT');
				reject();
			});
		});
	},
	removeAppointment: function removeAppointment(_ref19, id) {
		var commit = _ref19.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].deleteAppointment(id).then(function (result) {
				if (result.data.success) {
					commit('LOADER_OUT');
					resolve();
				} else {
					commit('LOADER_OUT');
					reject();
				}
			}).catch(function (error) {
				commit('LOADER_OUT');
				reject(error);
			});
		});
	},
	getClientInvestmentStats: function getClientInvestmentStats(_ref20, id) {
		var commit = _ref20.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_2__resources_user__["a" /* default */].getInvestmentStats(id).then(function (response) {
				commit('LOADER_OUT');
				resolve(response.data.investment_stats);
			}).catch(function () {
				commit('LOADER_OUT');
				reject();
			});
		});
	}
};

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var getters = {
	isUser: function isUser(state) {
		return state.token !== null;
	},
	isAuthenticated: function isAuthenticated(state) {
		return state.token !== null;
	},
	offices: function offices(state) {
		return state ? state.offices : null;
	},
	user: function user(state) {
		return state;
	},
	getClients: function getClients(state) {
		return state.clients;
	},
	getClient: function getClient(state) {
		return function (id) {
			var clients = Array.isArray(state.clients) ? state.clients : [];
			var contact = clients.find(function (contact) {
				return contact && parseInt(contact.id) === parseInt(id);
			});
			return contact || null;
		};
	},
	isTokenExpired: function isTokenExpired(state) {
		return state.token_duration && __WEBPACK_IMPORTED_MODULE_0_moment___default()(state.token_duration) <= __WEBPACK_IMPORTED_MODULE_0_moment___default()();
	},
	isAnonymous: function isAnonymous(state) {
		return state.role === 'ANONYMOUS';
	},
	isEstate: function isEstate(state) {
		return state.isEstate;
	},
	isForceCompleteProfile: function isForceCompleteProfile(state) {
		return false;
	},
	tokenDuration: function tokenDuration(state) {
		return state.token_duration;
	},
	client_next_rdv: function client_next_rdv(state) {
		return typeof state.client_next_rdv !== 'undefined' ? state.client_next_rdv : null;
	}

};

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(735);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);




var _mutations;






var clearState = function clearState(oldState, newState) {
	if (oldState !== null && oldState !== undefined) {
		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(oldState).forEach(function (key) {
			if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(oldState[key]) === 'object') {
				if (oldState[key] instanceof Array) {
					oldState[key] = [];
				} else {
					oldState[key] = clearState(oldState[key], newState[key]);
				}
			} else {
				oldState[key] = newState[key];
			}
		});
	}
	return oldState;
};

var roleComputer = function roleComputer(roles) {
	if (roles.indexOf('ROLE_ANONYMOUS') !== -1) {
		return 'ANONYMOUS';
	} else if (roles.indexOf('ROLE_ADVISOR') !== -1) {
		return 'ADVISOR';
	} else {
		return 'CLIENT';
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* LOGIN */], function (state, data) {
	state.token = data.token;
	state.refresh = data.refresh_token;
	state.id = data.user.id;
	state.role = roleComputer(data.user.roles);
	state.available = data.user.available;
	state.ooo_message = data.user.ooo_message;

	state.token_duration = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add("1200", 'seconds').format();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* TOKEN */], function (state, data) {
	state.token = data.user.token;
	state.refresh = data.user.refresh_token;

	state.token_duration = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add("1200", 'seconds').format();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* LOGOUT */], function (state) {
	clearState(state, __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */]);
	state.token = null;
	window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_5__state__["a" /* STORAGE_KEY */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* UPDATE_PROFILE */], function (state, data) {
	state.firstname = data.firstname;
	state.lastname = data.lastname;
	state.email = data.email;
	state.address = {
		line: data.address.line,
		zip: data.address.zip,
		city: data.address.city,
		country: data.address.country
	};
	state.phone = data.phone;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* PROFIL_PICTURE */], function (state, data) {
	state.picture = data.image;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* GET_CLIENTS */], function (state, data) {
	state.clients = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["g" /* UPDATE_CLIENT */], function (state, data) {
	if (!data) {
		return;
	}

	var clients = (state.clients || []).filter(function (client) {
		return client;
	});
	var index = clients.findIndex(function (client) {
		return parseInt(client.id) === parseInt(data.id);
	});
	if (index === -1) {
		clients.push(data);
	} else {
		clients[index] = data;
	}
	state.clients = clients;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["h" /* ADD_CLIENT */], function (state, data) {
	state.clients.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["i" /* EDIT_CLIENT */], function (state, data) {
	state.clients.forEach(function (client, key) {
		if (client.id === data.id) {
			var c = state.clients[key];
			c.center_of_interest = data.centerOfInterests;
			c.email = data.email;
			c.firstname = data.firstname;
			c.phone = data.phone;
			c.lastname = data.lastname;
			c.type = data.type;
		}
	});

	state.clients = state.clients.slice();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["j" /* ADD_NOTE */], function (state, data) {
	var note = data.note;
	state.clients.filter(function (client) {
		return parseInt(client.id) === parseInt(data.id);
	})[0].notes.push(note);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["k" /* UPDATE_NOTE */], function (state, data) {
	var note = state.clients.filter(function (client) {
		return parseInt(client.id) === parseInt(data.id);
	})[0].notes.filter(function (note) {
		return parseInt(note.id) === parseInt(data.note.id);
	})[0];
	note.title = data.note.title;
	note.description = data.note.description;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["l" /* DELETE_NOTE */], function (state, data) {
	var client = state.clients.filter(function (client) {
		return parseInt(client.id) === parseInt(data.clientId);
	})[0];
	var note = client.notes.filter(function (note) {
		return parseInt(note.id) === parseInt(data.note.id);
	})[0];
	client.notes.splice(client.notes.indexOf(note), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["m" /* FILL_ESTATE */], function () {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["n" /* ADD_LCBCFT_TO_CLIENT */], function (state, data) {
	state.clients.forEach(function (client) {
		if (parseInt(client.id) === parseInt(data)) {
			client.lcbft_completed = true;
		}
	});

	state.clients = state.clients.slice();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["o" /* ADD_CHECK_PAYSAGE */], function (state, data) {
	state.clients.forEach(function (client) {
		if (parseInt(client.id) === parseInt(data)) {
			client.check_paysage_completed = true;
		}
	});
	state.clients = state.clients.slice();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["p" /* SET_AVAILABLE */], function (state, data) {
	state.available = data.available;
	state.ooo_message = data.ooo_message;
}), _mutations);

/***/ }),
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 271,
	"./af.js": 271,
	"./ar": 279,
	"./ar-dz": 272,
	"./ar-dz.js": 272,
	"./ar-kw": 273,
	"./ar-kw.js": 273,
	"./ar-ly": 274,
	"./ar-ly.js": 274,
	"./ar-ma": 275,
	"./ar-ma.js": 275,
	"./ar-ps": 276,
	"./ar-ps.js": 276,
	"./ar-sa": 277,
	"./ar-sa.js": 277,
	"./ar-tn": 278,
	"./ar-tn.js": 278,
	"./ar.js": 279,
	"./az": 280,
	"./az.js": 280,
	"./be": 281,
	"./be.js": 281,
	"./bg": 282,
	"./bg.js": 282,
	"./bm": 283,
	"./bm.js": 283,
	"./bn": 285,
	"./bn-bd": 284,
	"./bn-bd.js": 284,
	"./bn.js": 285,
	"./bo": 286,
	"./bo.js": 286,
	"./br": 287,
	"./br.js": 287,
	"./bs": 288,
	"./bs.js": 288,
	"./ca": 289,
	"./ca.js": 289,
	"./cs": 290,
	"./cs.js": 290,
	"./cv": 291,
	"./cv.js": 291,
	"./cy": 292,
	"./cy.js": 292,
	"./da": 293,
	"./da.js": 293,
	"./de": 296,
	"./de-at": 294,
	"./de-at.js": 294,
	"./de-ch": 295,
	"./de-ch.js": 295,
	"./de.js": 296,
	"./dv": 297,
	"./dv.js": 297,
	"./el": 298,
	"./el.js": 298,
	"./en-au": 299,
	"./en-au.js": 299,
	"./en-ca": 300,
	"./en-ca.js": 300,
	"./en-gb": 301,
	"./en-gb.js": 301,
	"./en-ie": 302,
	"./en-ie.js": 302,
	"./en-il": 303,
	"./en-il.js": 303,
	"./en-in": 304,
	"./en-in.js": 304,
	"./en-nz": 305,
	"./en-nz.js": 305,
	"./en-sg": 306,
	"./en-sg.js": 306,
	"./eo": 307,
	"./eo.js": 307,
	"./es": 311,
	"./es-do": 308,
	"./es-do.js": 308,
	"./es-mx": 309,
	"./es-mx.js": 309,
	"./es-us": 310,
	"./es-us.js": 310,
	"./es.js": 311,
	"./et": 312,
	"./et.js": 312,
	"./eu": 313,
	"./eu.js": 313,
	"./fa": 314,
	"./fa.js": 314,
	"./fi": 315,
	"./fi.js": 315,
	"./fil": 316,
	"./fil.js": 316,
	"./fo": 317,
	"./fo.js": 317,
	"./fr": 122,
	"./fr-ca": 318,
	"./fr-ca.js": 318,
	"./fr-ch": 319,
	"./fr-ch.js": 319,
	"./fr.js": 122,
	"./fy": 320,
	"./fy.js": 320,
	"./ga": 321,
	"./ga.js": 321,
	"./gd": 322,
	"./gd.js": 322,
	"./gl": 323,
	"./gl.js": 323,
	"./gom-deva": 324,
	"./gom-deva.js": 324,
	"./gom-latn": 325,
	"./gom-latn.js": 325,
	"./gu": 326,
	"./gu.js": 326,
	"./he": 327,
	"./he.js": 327,
	"./hi": 328,
	"./hi.js": 328,
	"./hr": 329,
	"./hr.js": 329,
	"./hu": 330,
	"./hu.js": 330,
	"./hy-am": 331,
	"./hy-am.js": 331,
	"./id": 332,
	"./id.js": 332,
	"./is": 333,
	"./is.js": 333,
	"./it": 335,
	"./it-ch": 334,
	"./it-ch.js": 334,
	"./it.js": 335,
	"./ja": 336,
	"./ja.js": 336,
	"./jv": 337,
	"./jv.js": 337,
	"./ka": 338,
	"./ka.js": 338,
	"./kk": 339,
	"./kk.js": 339,
	"./km": 340,
	"./km.js": 340,
	"./kn": 341,
	"./kn.js": 341,
	"./ko": 342,
	"./ko.js": 342,
	"./ku": 344,
	"./ku-kmr": 343,
	"./ku-kmr.js": 343,
	"./ku.js": 344,
	"./ky": 345,
	"./ky.js": 345,
	"./lb": 346,
	"./lb.js": 346,
	"./lo": 347,
	"./lo.js": 347,
	"./lt": 348,
	"./lt.js": 348,
	"./lv": 349,
	"./lv.js": 349,
	"./me": 350,
	"./me.js": 350,
	"./mi": 351,
	"./mi.js": 351,
	"./mk": 352,
	"./mk.js": 352,
	"./ml": 353,
	"./ml.js": 353,
	"./mn": 354,
	"./mn.js": 354,
	"./mr": 355,
	"./mr.js": 355,
	"./ms": 357,
	"./ms-my": 356,
	"./ms-my.js": 356,
	"./ms.js": 357,
	"./mt": 358,
	"./mt.js": 358,
	"./my": 359,
	"./my.js": 359,
	"./nb": 360,
	"./nb.js": 360,
	"./ne": 361,
	"./ne.js": 361,
	"./nl": 363,
	"./nl-be": 362,
	"./nl-be.js": 362,
	"./nl.js": 363,
	"./nn": 364,
	"./nn.js": 364,
	"./oc-lnc": 365,
	"./oc-lnc.js": 365,
	"./pa-in": 366,
	"./pa-in.js": 366,
	"./pl": 367,
	"./pl.js": 367,
	"./pt": 369,
	"./pt-br": 368,
	"./pt-br.js": 368,
	"./pt.js": 369,
	"./ro": 370,
	"./ro.js": 370,
	"./ru": 371,
	"./ru.js": 371,
	"./sd": 372,
	"./sd.js": 372,
	"./se": 373,
	"./se.js": 373,
	"./si": 374,
	"./si.js": 374,
	"./sk": 375,
	"./sk.js": 375,
	"./sl": 376,
	"./sl.js": 376,
	"./sq": 377,
	"./sq.js": 377,
	"./sr": 379,
	"./sr-cyrl": 378,
	"./sr-cyrl.js": 378,
	"./sr.js": 379,
	"./ss": 380,
	"./ss.js": 380,
	"./sv": 381,
	"./sv.js": 381,
	"./sw": 382,
	"./sw.js": 382,
	"./ta": 383,
	"./ta.js": 383,
	"./te": 384,
	"./te.js": 384,
	"./tet": 385,
	"./tet.js": 385,
	"./tg": 386,
	"./tg.js": 386,
	"./th": 387,
	"./th.js": 387,
	"./tk": 388,
	"./tk.js": 388,
	"./tl-ph": 389,
	"./tl-ph.js": 389,
	"./tlh": 390,
	"./tlh.js": 390,
	"./tr": 391,
	"./tr.js": 391,
	"./tzl": 392,
	"./tzl.js": 392,
	"./tzm": 394,
	"./tzm-latn": 393,
	"./tzm-latn.js": 393,
	"./tzm.js": 394,
	"./ug-cn": 395,
	"./ug-cn.js": 395,
	"./uk": 396,
	"./uk.js": 396,
	"./ur": 397,
	"./ur.js": 397,
	"./uz": 399,
	"./uz-latn": 398,
	"./uz-latn.js": 398,
	"./uz.js": 399,
	"./vi": 400,
	"./vi.js": 400,
	"./x-pseudo": 401,
	"./x-pseudo.js": 401,
	"./yo": 402,
	"./yo.js": 402,
	"./zh-cn": 403,
	"./zh-cn.js": 403,
	"./zh-hk": 404,
	"./zh-hk.js": 404,
	"./zh-mo": 405,
	"./zh-mo.js": 405,
	"./zh-tw": 406,
	"./zh-tw.js": 406
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 913;

/***/ }),
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjI0IgogICBoZWlnaHQ9IjI0IgogICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgIGZpbGw9Im5vbmUiCiAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogICBzdHJva2Utd2lkdGg9IjIiCiAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAgY2xhc3M9Imx1Y2lkZSBsdWNpZGUtY3JlZGl0LWNhcmQgdy00IGgtNCB0ZXh0LWluZm8iCiAgIHZlcnNpb249IjEuMSIKICAgaWQ9InN2ZzEiCiAgIHNvZGlwb2RpOmRvY25hbWU9ImNhbGVuZGFyVjIuc3ZnIgogICBpbmtzY2FwZTp2ZXJzaW9uPSIxLjQuMyAoMGQxNWY3NTA0MiwgMjAyNS0xMi0yNSkiCiAgIHhtbG5zOmlua3NjYXBlPSJodHRwOi8vd3d3Lmlua3NjYXBlLm9yZy9uYW1lc3BhY2VzL2lua3NjYXBlIgogICB4bWxuczpzb2RpcG9kaT0iaHR0cDovL3NvZGlwb2RpLnNvdXJjZWZvcmdlLm5ldC9EVEQvc29kaXBvZGktMC5kdGQiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMKICAgICBpZD0iZGVmczEiIC8+CiAgPHNvZGlwb2RpOm5hbWVkdmlldwogICAgIGlkPSJuYW1lZHZpZXcxIgogICAgIHBhZ2Vjb2xvcj0iI2ZmZmZmZiIKICAgICBib3JkZXJjb2xvcj0iIzAwMDAwMCIKICAgICBib3JkZXJvcGFjaXR5PSIwLjI1IgogICAgIGlua3NjYXBlOnNob3dwYWdlc2hhZG93PSIyIgogICAgIGlua3NjYXBlOnBhZ2VvcGFjaXR5PSIwLjAiCiAgICAgaW5rc2NhcGU6cGFnZWNoZWNrZXJib2FyZD0iMCIKICAgICBpbmtzY2FwZTpkZXNrY29sb3I9IiNkMWQxZDEiCiAgICAgaW5rc2NhcGU6em9vbT0iMzMuNSIKICAgICBpbmtzY2FwZTpjeD0iMTEuOTg1MDc1IgogICAgIGlua3NjYXBlOmN5PSIxMiIKICAgICBpbmtzY2FwZTp3aW5kb3ctd2lkdGg9IjE5MjAiCiAgICAgaW5rc2NhcGU6d2luZG93LWhlaWdodD0iMTAxMyIKICAgICBpbmtzY2FwZTp3aW5kb3cteD0iMCIKICAgICBpbmtzY2FwZTp3aW5kb3cteT0iMCIKICAgICBpbmtzY2FwZTp3aW5kb3ctbWF4aW1pemVkPSIxIgogICAgIGlua3NjYXBlOmN1cnJlbnQtbGF5ZXI9InN2ZzEiIC8+CiAgPHJlY3QKICAgICB3aWR0aD0iMjAiCiAgICAgaGVpZ2h0PSIxNCIKICAgICB4PSIyIgogICAgIHk9IjUiCiAgICAgcng9IjIiCiAgICAgaWQ9InJlY3QxIgogICAgIHN0eWxlPSJzdHJva2U6I2ZmZmZmZjtzdHJva2Utb3BhY2l0eToxIiAvPgogIDxsaW5lCiAgICAgeDE9IjIiCiAgICAgeDI9IjIyIgogICAgIHkxPSIxMCIKICAgICB5Mj0iMTAiCiAgICAgaWQ9ImxpbmUxIgogICAgIHN0eWxlPSJzdHJva2U6I2ZmZmZmZjtzdHJva2Utb3BhY2l0eToxIiAvPgo8L3N2Zz4K"

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjI0IgogICBoZWlnaHQ9IjI0IgogICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgIGZpbGw9Im5vbmUiCiAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogICBzdHJva2Utd2lkdGg9IjIiCiAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAgY2xhc3M9Imx1Y2lkZSBsdWNpZGUtbWVzc2FnZS1zcXVhcmUgdy00IGgtNCB0ZXh0LXB1cnBsZS01MDAiCiAgIHZlcnNpb249IjEuMSIKICAgaWQ9InN2ZzEiCiAgIHNvZGlwb2RpOmRvY25hbWU9ImRpYWcuc3ZnIgogICBpbmtzY2FwZTp2ZXJzaW9uPSIxLjQuMyAoMGQxNWY3NTA0MiwgMjAyNS0xMi0yNSkiCiAgIHhtbG5zOmlua3NjYXBlPSJodHRwOi8vd3d3Lmlua3NjYXBlLm9yZy9uYW1lc3BhY2VzL2lua3NjYXBlIgogICB4bWxuczpzb2RpcG9kaT0iaHR0cDovL3NvZGlwb2RpLnNvdXJjZWZvcmdlLm5ldC9EVEQvc29kaXBvZGktMC5kdGQiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMKICAgICBpZD0iZGVmczEiIC8+CiAgPHNvZGlwb2RpOm5hbWVkdmlldwogICAgIGlkPSJuYW1lZHZpZXcxIgogICAgIHBhZ2Vjb2xvcj0iI2ZmZmZmZiIKICAgICBib3JkZXJjb2xvcj0iIzAwMDAwMCIKICAgICBib3JkZXJvcGFjaXR5PSIwLjI1IgogICAgIGlua3NjYXBlOnNob3dwYWdlc2hhZG93PSIyIgogICAgIGlua3NjYXBlOnBhZ2VvcGFjaXR5PSIwLjAiCiAgICAgaW5rc2NhcGU6cGFnZWNoZWNrZXJib2FyZD0iMCIKICAgICBpbmtzY2FwZTpkZXNrY29sb3I9IiNkMWQxZDEiCiAgICAgaW5rc2NhcGU6em9vbT0iMzMuNSIKICAgICBpbmtzY2FwZTpjeD0iMTEuOTg1MDc1IgogICAgIGlua3NjYXBlOmN5PSIxMiIKICAgICBpbmtzY2FwZTp3aW5kb3ctd2lkdGg9IjE5MjAiCiAgICAgaW5rc2NhcGU6d2luZG93LWhlaWdodD0iMTAxMyIKICAgICBpbmtzY2FwZTp3aW5kb3cteD0iMCIKICAgICBpbmtzY2FwZTp3aW5kb3cteT0iMCIKICAgICBpbmtzY2FwZTp3aW5kb3ctbWF4aW1pemVkPSIxIgogICAgIGlua3NjYXBlOmN1cnJlbnQtbGF5ZXI9InN2ZzEiIC8+CiAgPHBhdGgKICAgICBkPSJNMjEgMTVhMiAyIDAgMCAxLTIgMkg3bC00IDRWNWEyIDIgMCAwIDEgMi0yaDE0YTIgMiAwIDAgMSAyIDJ6IgogICAgIGlkPSJwYXRoMSIKICAgICBzdHlsZT0ic3Ryb2tlOiNmZmZmZmY7c3Ryb2tlLW9wYWNpdHk6MSIgLz4KPC9zdmc+Cg=="

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNSAxMC43NTY0QzguMjYxNDIgMTAuNzU2NCAxMC41IDguNDYwNDQgMTAuNSA1LjYyODIxQzEwLjUgMi43OTU5OCA4LjI2MTQyIDAuNSA1LjUgMC41QzIuNzM4NTggMC41IDAuNSAyLjc5NTk4IDAuNSA1LjYyODIxQzAuNSA4LjQ2MDQ0IDIuNzM4NTggMTAuNzU2NCA1LjUgMTAuNzU2NFoiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjUwMDEyIDIuNTUxMjdWNS42MjgxOUw3LjUwMDEyIDYuNjUzODMiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AU.c8fd8f8.svg";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CH.637c971.svg";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DE.11f442a.svg";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/FI.39c830b.svg";

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/FR.04d69a9.svg";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GB.7a95a69.svg";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IE.3707578.svg";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/JP.909a519.svg";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LU.7dfddee.svg";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NL.e3879ef.svg";

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NO.ce81a2f.svg";

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/SE.b2bff56.svg";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/US.3dfd5a1.svg";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ZA.04671dd.svg";

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIGZpbGw9IiNGRjQwNTIiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI3LjUiIHI9IjIuMjUiIGZpbGw9IiNGRkYiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE1IDE4Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjQwNTIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQuMzMzIDE3LjMzMmEuMzUuMzUgMCAwIDEtLjQ0NC4wMy4zOTEuMzkxIDAgMCAxLS4xNTYtLjQxM2wxLjc0LTcuMDc4SC44NTVhLjM1Ny4zNTcgMCAwIDEtLjMzNC0uMjQ1LjM4My4zODMgMCAwIDEgLjEwNi0uNDExTDExLjExLjA4N2EuMzQ5LjM0OSAwIDAgMSAuNDIyIDBjLjEzLjA5LjE5My4yNTQuMTU2LjQxMkw5Ljk1IDcuNTVoNC42MTFjLjE1IDAgLjI4Mi4wOTguMzMzLjI0NC4wNTEuMTQ3LjAxLjMxMS0uMTA1LjQxMkw0LjMzMyAxNy4zMzJ6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEyIDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjQwNTIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYgMTVzNi0zIDYtNy41di02TDYgMCAwIDEuNXY2QzAgMTIgNiAxNSA2IDE1eiIvPgo8L3N2Zz4K"

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjQwNTIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQ3MiA0LjAwOGwzLjkyNS41NzRhLjguOCAwIDAgMSAuNDQyIDEuMzY0TDEyIDguNzEybC42NyAzLjkwNmEuOC44IDAgMCAxLTEuMTYuODQzTDggMTEuNjE2bC0zLjUxIDEuODQ1YS44LjggMCAwIDEtMS4xNi0uODQzTDQgOC43MTIgMS4xNiA1Ljk0NmEuOC44IDAgMCAxIC40NDMtMS4zNjRsMy45MjUtLjU3NEw3LjI4My40NTNhLjguOCAwIDAgMSAxLjQzNCAwbDEuNzU1IDMuNTU1eiIvPgo8L3N2Zz4K"

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmY0MDUyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxIj4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIKICAgICAgICAgICAgICAgIGJlZ2luPSIwcyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAyMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IgogICAgICAgICAgICAgICAgYmVnaW49IjBzIiBkdXI9IjEuOHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgPC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiCiAgICAgICAgICAgICAgICBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIKICAgICAgICAgICAgICAgIHZhbHVlcz0iMTsgMjAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIKICAgICAgICAgICAgICAgIGJlZ2luPSItMC45cyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAwIgogICAgICAgICAgICAgICAgY2FsY01vZGU9InNwbGluZSIKICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOyAxIgogICAgICAgICAgICAgICAga2V5U3BsaW5lcz0iMC4zLCAwLjYxLCAwLjM1NSwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgIDwvY2lyY2xlPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-patrim.d52ef96.svg";

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_short.4621ceb.png";

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-0.a3699a1.png";

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-1.f5af3ed.png";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-2.92ad883.png";

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-0.348e517.png";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-1.c0827bd.png";

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-2.3b9ca99.png";

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-0.29d66ca.png";

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-1.554e1a9.png";

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(840)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1105),
  /* scopeId */
  "data-v-3c995104",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(814)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  "data-v-1a6a48f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1139),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(894)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(885)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1155),
  /* scopeId */
  "data-v-7f1c2722",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1140),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(879)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(878)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(823)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(883)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(841)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(861)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1130),
  /* scopeId */
  "data-v-4f900a5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(906)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1183),
  /* scopeId */
  "data-v-e7febe34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(887)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1135),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(870)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1141),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(828)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1093),
  /* scopeId */
  "data-v-2aae3779",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(854)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1121),
  /* scopeId */
  "data-v-49c37038",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(901)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(829)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1094),
  /* scopeId */
  "data-v-2b9c2234",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1074),
  /* scopeId */
  "data-v-145584b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(875)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1146),
  /* scopeId */
  "data-v-6c78bbf8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(897)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1174),
  /* scopeId */
  "data-v-d29e715c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1070),
  /* scopeId */
  "data-v-11ff07af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(845)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(850)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1117),
  /* scopeId */
  "data-v-47677220",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(888)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1126),
  /* scopeId */
  "data-v-4c74f681",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(846)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(847)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(849)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1116),
  /* scopeId */
  "data-v-45962a2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(891)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1163),
  /* scopeId */
  "data-v-a9d97d5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(898)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1175),
  /* scopeId */
  "data-v-d5786398",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(896)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1173),
  /* scopeId */
  "data-v-ce01ca76",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(831)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(834)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1099),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(821)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(816)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1137),
  /* scopeId */
  "data-v-5d4c5748",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(815)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  "data-v-1bcc87c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(877)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1148),
  /* scopeId */
  "data-v-6fd996be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(899)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1176),
  /* scopeId */
  "data-v-d693bba4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(837)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1102),
  /* scopeId */
  "data-v-3a17db6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(865)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1134),
  /* scopeId */
  "data-v-5487ce6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(839)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1104),
  /* scopeId */
  "data-v-3a33de63",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(908)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1185),
  /* scopeId */
  "data-v-fb9c049e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(848)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(833)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1098),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(803)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(855)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1123),
  /* scopeId */
  "data-v-4a14f40f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(805)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1069),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(852)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(889)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(818)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1082),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(836)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1101),
  /* scopeId */
  "data-v-37beb558",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(825)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1090),
  /* scopeId */
  "data-v-28329184",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(900)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1177),
  /* scopeId */
  "data-v-d6afb4c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(903)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1180),
  /* scopeId */
  "data-v-ddf3350e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(812)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1076),
  /* scopeId */
  "data-v-1888767d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(830)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1095),
  /* scopeId */
  "data-v-2c400c18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(826)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1091),
  /* scopeId */
  "data-v-28d39b98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(800)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1064),
  /* scopeId */
  "data-v-04195bd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(872)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1143),
  /* scopeId */
  "data-v-66e589e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(838)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1103),
  /* scopeId */
  "data-v-3a337d98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(867)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1136),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(909)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1186),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(856)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1138),
  /* scopeId */
  "data-v-61ab06fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(827)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1092),
  /* scopeId */
  "data-v-28f6ca9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1132),
  /* scopeId */
  "data-v-50a9f398",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(824)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1089),
  /* scopeId */
  "data-v-269e1e02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(853)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1120),
  /* scopeId */
  "data-v-49b35f16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(860)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1129),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(905)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(907)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1184),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(893)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(820)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  "data-v-2446947b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(873)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1144),
  /* scopeId */
  "data-v-67a0fbdc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(835)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(809)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1073),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(819)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1083),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(895)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(871)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1142),
  /* scopeId */
  "data-v-66153359",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(876)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(843)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1108),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(832)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1097),
  /* scopeId */
  "data-v-30ef7219",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(801)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(874)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(858)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(892)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-patrimonial-landscape"
  }, [_c('h1', [_vm._v("Paysage Patrimonial de " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n\t\t\tComplétez votre paysage patrimonial étape par étape ou librement en naviguant par thématique. Cliquez sur \"Sauvegarder\" pour enregistrer votre saisie au fur et à mesure. Vous pourrez le reprendre à tout moment en vous reconnectant. La validation de votre paysage patrimonial sera effective qu'une fois l'étape de signature réalisée.\n\t\t")]), _vm._v(" "), _c('patrimonial-landscape', {
    attrs: {
      "user": _vm.client
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s((_vm.data.isNew) ? 'Ajouter une note' : 'Editer une note') + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\tAjouter une remarque ou un rappel sur un client\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('titre')
    }
  }, [_c('label', {
    attrs: {
      "for": "titre"
    }
  }, [_vm._v("Titre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "type": "text",
      "name": "titre"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('titre')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('titre')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-label ctn-textarea",
    class: {
      error: _vm.errors.has('note')
    }
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("Note")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "name": "note"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('note')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('note')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s((_vm.data.isNew) ? 'Annuler' : 'Supprimer'))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.procNote
    }
  }, [_vm._v("Sauvegarder")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tDocuments liés à l'opération\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, [_c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "tile-doc row"
  }, [_c('span', {
    staticClass: "icon-document-pdf"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tLettre de Mission\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((_vm.letterOfMission) ? _vm.letterOfMission.original_name + '.pdf' : 'Pas de fichier') + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "lmfile",
      "type": "file"
    },
    on: {
      "change": _vm.uploadLetterMissionFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-actions row"
  }, [(_vm.needForSign(_vm.letterOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.askForSignature(_vm.letterOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSoumettre une signature\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.canLoad(_vm.letterOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.procUpload('lmfile')
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v("\n\t\t\t\t\tCharger un fichier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.letterOfMission && !_vm.needForSign(_vm.letterOfMission)) ? _c('div', {
    staticClass: "status row"
  }, [_vm._v("\n\t\t\t\t\tAjouté le " + _vm._s(_vm.letterOfMission.universign_launch_date.split(' ')[0]) + "\n\t\t\t\t\t"), (_vm.letterOfMission.universign_status === 'completed') ? _c('span', {
    staticClass: "green inner-status"
  }, [_vm._v("Signé le " + _vm._s(_vm.letterOfMission.signature_date.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (_vm.letterOfMission.universign_status === 'ready') ? _c('span', {
    staticClass: "orange inner-status"
  }, [_vm._v("Signature en attente")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.letterOfMission) ? _c('div', {
    staticClass: "other-actions row"
  }, [(_vm.letterOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.callVerify(_vm.letterOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVérifier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.letterOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.relaunchTransaction(_vm.letterOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEnvoyer un mail de relance\n\t\t\t\t")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "tile-doc row"
  }, [_c('span', {
    staticClass: "icon-document-pdf"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tRapport de Mission\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((_vm.rapportOfMission) ? _vm.rapportOfMission.original_name + '.pdf' : 'Pas de fichier') + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "rmfile",
      "type": "file"
    },
    on: {
      "change": _vm.uploadCRFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-actions row"
  }, [(_vm.needForSign(_vm.rapportOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.askForSignature(_vm.rapportOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSoumettre une signature\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.canLoad(_vm.rapportOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.procUpload('rmfile')
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v("\n\t\t\t\t\tCharger un fichier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.rapportOfMission && !_vm.needForSign(_vm.rapportOfMission)) ? _c('div', {
    staticClass: "status row"
  }, [_vm._v("\n\t\t\t\t\tAjouté le " + _vm._s(_vm.rapportOfMission.universign_launch_date.split(' ')[0]) + "\n\t\t\t\t\t"), (_vm.rapportOfMission.universign_status === 'completed') ? _c('span', {
    staticClass: "green inner-status"
  }, [_vm._v("Signé le " + _vm._s(_vm.rapportOfMission.signature_date.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (_vm.rapportOfMission.universign_status === 'ready') ? _c('span', {
    staticClass: "orange inner-status"
  }, [_vm._v("Signature en attente")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.rapportOfMission) ? _c('div', {
    staticClass: "other-actions row"
  }, [(_vm.rapportOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.callVerify(_vm.rapportOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVérifier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.rapportOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.relaunchTransaction(_vm.rapportOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEnvoyer un mail de relance\n\t\t\t\t")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('logo')], 1)], 1), _vm._v(" "), _c('nav', {
    staticClass: "row"
  }, _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.key,
      staticClass: "menu-item",
      attrs: {
        "to": {
          name: item.uri
        },
        "id": 'head-menu-link-' + item.uri.toLowerCase()
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "manage row"
  }, [_c('router-link', {
    staticClass: "ctn-profil ctn-profile-picture",
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.picture,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-doc column",
    on: {
      "click": _vm.download
    }
  }, [_c('div', {
    staticClass: "ctn-icon-document"
  }, [_c('img', {
    attrs: {
      "src": _vm.baseFile,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "extension"
  }, [_vm._v("." + _vm._s(_vm._f("uppercase")(_vm.doc.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.doc.original_name) + "\n\t")]), _vm._v(" "), (_vm.doc.created_at) ? _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\tAjouté le " + _vm._s(_vm.doc.created_at) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('année de retraite')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Date estimée de votre départ en retraite")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.months,
      "selected": _vm.month
    },
    on: {
      "change": function($event) {
        _vm.month = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yearOfRetreat),
      expression: "yearOfRetreat"
    }],
    staticClass: "border-left",
    attrs: {
      "type": "text",
      "name": "année de retraite",
      "placeholder": "Année de retraite"
    },
    domProps: {
      "value": (_vm.yearOfRetreat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yearOfRetreat = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('radio-box', {
    model: {
      value: (_vm.hasNotRetirement),
      callback: function($$v) {
        _vm.hasNotRetirement = $$v
      },
      expression: "hasNotRetirement"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tJe ne sais pas\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tDétenez vous des plans d'épargne retraites ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isPERP
    },
    on: {
      "change": function($event) {
        _vm.isPERP = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.isPERP) ? _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.PERPType), function(perp, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(perp)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(perp)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(perp) + "\n\t\t\t")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card-client dashboard-card dashboard-card--bordered dashboard-card--hoverable"
  }, [_c('header', {
    staticClass: "dashboard-card__header"
  }, [_c('img', {
    staticClass: "dashboard-card__icon",
    attrs: {
      "src": _vm.imgUser,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dashboard-card__header-info"
  }, [_c('h4', {
    staticClass: "dashboard-card__name"
  }, [_vm._v(_vm._s(_vm.clientName))]), _vm._v(" "), _c('span', {
    staticClass: "dashboard-status dashboard-status--client"
  }, [_vm._v(_vm._s(_vm.clientStatus))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.user.id
        }
      }
    }
  }, [_c('svg', {
    staticClass: "dashboard-card__arrow",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])], 1), _vm._v(" "), _c('section', {
    staticClass: "dashboard-card__contact"
  }, [(_vm.clientEmail) ? _c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("mailto:" + _vm.clientEmail)
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgMail,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.clientEmail) + "\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.clientPhone) ? _c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("tel:" + _vm.clientPhone)
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPhone,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.clientPhone) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgCalendar,
      "alt": ""
    }
  }), _vm._v("\n\t\t\tClient depuis " + _vm._s(_vm.daysSinceCreation)), (_vm.creationDate) ? [_vm._v(" (le " + _vm._s(_vm.creationDate) + ")")] : _vm._e()], 2)]), _vm._v(" "), (_vm.actions && _vm.actions.length > 0) ? _c('footer', {
    staticClass: "card-client__actions"
  }, _vm._l((_vm.actions), function(action, index) {
    return _c('div', {
      key: index,
      staticClass: "dashboard-action",
      class: [_vm.getActionClass(action), {
        'dashboard-action--warning': action.daysUntil < 0
      }]
    }, [_c('img', {
      staticClass: "dashboard-action__icon",
      attrs: {
        "src": _vm.imgCalendar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dashboard-action__content"
    }, [_c('p', {
      staticClass: "dashboard-action__title"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getActionLabel(action)) + "\n\t\t\t\t\t"), (action.daysUntil < 0) ? _c('span', {
      staticClass: "dashboard-action__warning-badge"
    }, [_vm._v("En retard")]) : _vm._e()]), _vm._v(" "), (action.date) ? _c('p', {
      staticClass: "dashboard-action__date"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.formatDaysText(action.daysUntil)) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (action.type === 'renouvellement') ? _c('label', {
      staticClass: "dashboard-action__checkbox",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.renewalLoading
      },
      on: {
        "change": function($event) {
          return _vm.onRenewalCheck(action)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dashboard-action__checkbox-label"
    }, [_vm._v("Fait")])]) : _vm._e()])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select solo"
  }, [_c('div', {
    staticClass: "selected row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.display()
      }
    }
  }, [(_vm.select) ? _c('div', {
    staticClass: "content-select row"
  }, [(_vm.select.firstname || _vm.select.first_name) ? _c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.getPicture(_vm.select),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.select.firstname || _vm.select.first_name) ? _c('span', {
    attrs: {
      "title": (_vm.select.firstname || _vm.select.first_name) + ' ' + (_vm.select.lastname || _vm.select.last_name)
    }
  }, [_vm._v(_vm._s(_vm.select.firstname || _vm.select.first_name) + " " + _vm._s(_vm.select.lastname || _vm.select.last_name))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-else"
  }, [_vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), (!_vm.innerDisabled) ? _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(client, key) {
    return _c('div', {
      key: key,
      staticClass: "item row",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSelect(key)
        }
      }
    }, [(client !== '-') ? _c('div', {
      staticClass: "ctn-profile-picture"
    }, [_c('img', {
      directives: [{
        name: "img-detect",
        rawName: "v-img-detect"
      }],
      attrs: {
        "src": _vm.getPicture(client),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(client.firstname || '-') + " " + _vm._s(client.lastname))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-operation-form take-place"
  }, [_c('div', {
    staticClass: "white-box row title"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'SubscriptionsTable'
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), (_vm.subscriptionExist) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tModifier l'abonnement\n\t\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tNouvel abonnement\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('edit-main'), _vm._v(" "), (_vm.subscriptionExist) ? _c('div', {
    staticClass: "take-place"
  }, [_c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('edit-docs', {
    attrs: {
      "subscription": _vm.subscription
    },
    on: {
      "needToUpdate": _vm.checkForSubscription
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subscriptionExist) ? _c('div', {
    staticClass: "take-place"
  }, [_c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('edit-actions', {
    attrs: {
      "subscription": _vm.subscription
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuel est votre horizon d'investissements ? (1 réponse possible)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.perspectives,
      "selected": _vm.perspective
    },
    on: {
      "change": function($event) {
        _vm.perspective = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuels sont vos objectifs d'investissement prioritaires ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.objectives), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuel degrès de risque êtes-vous prêt à accepter pour atteindre vos objectifs ? (1 réponse possible)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.riskDegrees,
      "selected": _vm.riskDegree
    },
    on: {
      "change": function($event) {
        _vm.riskDegree = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tEn cas d'investissement sur les marchés financiers quel niveau de hausse aimeriez vous atteindre ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.risingMarkets,
      "selected": _vm.risingMarket
    },
    on: {
      "change": function($event) {
        _vm.risingMarket = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tSelon le paysage patrimonial que vous venez de décrire l'estimation de votre patrimoine global se situe ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.assetsEstimates,
      "selected": _vm.assetsEstimate
    },
    on: {
      "change": function($event) {
        _vm.assetsEstimate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tSi vous deviez effectuer un nouvel investissement, que représenterait ce montant au regard de votre patrimoine global ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.investmentsEstimates,
      "selected": _vm.investmentsEstimate
    },
    on: {
      "change": function($event) {
        _vm.investmentsEstimate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realLaunch),
      expression: "realLaunch"
    }],
    staticClass: "modal-container row",
    class: {
      activated: _vm.launch
    },
    on: {
      "mousedown": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-content",
    class: _vm.modalContentClass,
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.show) ? _c(_vm.content, {
    tag: "component",
    attrs: {
      "data": _vm.data
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('companyName')
    }
  }, [_c('label', {
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v("Nom de l'entreprise *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.companyName),
      expression: "companyData.companyName"
    }],
    attrs: {
      "type": "text",
      "name": "companyName"
    },
    domProps: {
      "value": (_vm.companyData.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "companyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('companyName')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('registrationNumber')
    }
  }, [_c('label', {
    attrs: {
      "for": "registrationNumber"
    }
  }, [_vm._v("Numéro d'immatriculation (SIREN/SIRET) *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.registrationNumber),
      expression: "companyData.registrationNumber"
    }],
    attrs: {
      "type": "text",
      "name": "registrationNumber"
    },
    domProps: {
      "value": (_vm.companyData.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "registrationNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('registrationNumber')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('registrationNumber')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('headquartersAddress')
    }
  }, [_c('label', {
    attrs: {
      "for": "headquartersAddress"
    }
  }, [_vm._v("Adresse du siège social *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.headquartersAddress),
      expression: "companyData.headquartersAddress"
    }],
    attrs: {
      "name": "headquartersAddress",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.companyData.headquartersAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "headquartersAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('headquartersAddress')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('headquartersAddress')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "taxRegime"
    }
  }, [_vm._v("Régime Fiscal *")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.taxRegimes,
      "selected": _vm.companyData.taxRegime,
      "solo": true
    },
    on: {
      "change": function($event) {
        _vm.companyData.taxRegime = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('activities')
    }
  }, [_c('label', {
    attrs: {
      "for": "activities"
    }
  }, [_vm._v("Activités *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.activities),
      expression: "companyData.activities"
    }],
    attrs: {
      "name": "activities",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.companyData.activities)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "activities", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('activities')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('activities')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dirigeant(s) *")]), _vm._v(" "), _vm._l((_vm.companyData.managers), function(manager, index) {
    return _c('div', {
      key: 'manager-' + index,
      staticClass: "dynamic-field-row"
    }, [_c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.companyData.managers[index]),
        expression: "companyData.managers[index]"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Nom et prénom du dirigeant"
      },
      domProps: {
        "value": (_vm.companyData.managers[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.companyData.managers, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.companyData.managers.length > 1) ? _c('button', {
      staticClass: "btn-icon btn-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeManager(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-trash"
    }, [_vm._v("x")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-gold btn-add-field",
    on: {
      "click": _vm.addManager
    }
  }, [_c('span', {
    staticClass: "icon-plus"
  }, [_vm._v("+")]), _vm._v(" Ajouter un dirigeant\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Bénéficiaires effectifs *")]), _vm._v(" "), _vm._l((_vm.companyData.beneficiaries), function(beneficiary, index) {
    return _c('div', {
      key: 'beneficiary-' + index,
      staticClass: "dynamic-field-row"
    }, [_c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.companyData.beneficiaries[index]),
        expression: "companyData.beneficiaries[index]"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Nom du bénéficiaire effectif"
      },
      domProps: {
        "value": (_vm.companyData.beneficiaries[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.companyData.beneficiaries, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.companyData.beneficiaries.length > 1) ? _c('button', {
      staticClass: "btn-icon btn-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeBeneficiary(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-trash"
    }, [_vm._v("x")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-gold btn-add-field",
    on: {
      "click": _vm.addBeneficiary
    }
  }, [_c('span', {
    staticClass: "icon-plus"
  }), _vm._v(" Ajouter un bénéficiaire effectif\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container documents-confirmation"
  }, [_c('p', {
    staticClass: "document-text"
  }, [_vm._v("\n          En tant que représentant légal je confirme avoir transmis les documents suivants :\n          une copie du K-bis de moins de 3 mois ou équivalent, Copie des statuts,\n          Dernier bilan/compte de résultat ou tout au moins un état financier.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-row row"
  }, [_c('custom-toggle', {
    attrs: {
      "value": _vm.companyData.documentsConfirmed
    },
    on: {
      "change": function($event) {
        _vm.companyData.documentsConfirmed = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-label"
  }, [_vm._v("Je confirme avoir transmis les documents")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container signature-confirmation"
  }, [_c('div', {
    staticClass: "label solo bold"
  }, [_vm._v("\n          Je confirme que les informations renseignées sont exactes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-row row"
  }, [_c('custom-toggle', {
    attrs: {
      "value": _vm.companyData.signatureConfirmed
    },
    on: {
      "change": function($event) {
        _vm.companyData.signatureConfirmed = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-label"
  }, [_vm._v("Je confirme l'exactitude des informations")])], 1), _vm._v(" "), (_vm.isAdvisor) ? _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n          En cliquant sur \"Demande de signature électronique\" un e-mail sera envoyé au client lui permettant de signer électroniquement les informations de la société que vous avez complété.\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAdvisor) ? _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n          En cliquant sur \"Signer\" vous allez être redirigé vers notre module de signature électronique afin de valider la saisie des informations de votre société.\n        ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.signaturePopupBlocked) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "alert-wrapper row"
  }, [_c('span', {
    staticClass: "icon icon-alert"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('div', {
    staticClass: "alert-content column"
  }, [_c('p', [_vm._v("\n                Votre navigateur a pu bloquer la fenêtre d'accès à la signature.\n                "), _c('br'), _vm._v("\n                C'est courant, cliquez sur le bouton à droite pour accéder au service de signature.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showUnlockPopupTuto = true
      }
    }
  }, [_vm._v("\n              Voir les instructions\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), (!_vm.companyData.documentsConfirmed || !_vm.companyData.signatureConfirmed) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Sauvegarder")]) : _c('div', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.companyData.signatureConfirmed
    },
    on: {
      "click": _vm.signDocument
    }
  }, [(_vm.isAdvisor) ? [_vm._v("Demande de signature électronique")] : [_vm._v("Signer")]], 2)])], 1)]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showRgpdModal,
      "content": _vm.modalRgpd
    },
    on: {
      "close": function($event) {
        _vm.showRgpdModal = false
      }
    }
  }), _vm._v(" "), (_vm.showUnlockPopupTuto) ? _c('unlock-signature-popup-tutorial', {
    on: {
      "close": function($event) {
        _vm.showUnlockPopupTuto = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n        Informations Société\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n        Complétez les informations de la société (personne morale)\n      ")])])])
}]}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phantom-container"
  }, [_c('notifications', {
    attrs: {
      "classes": "master-notifications",
      "position": "top left",
      "group": "default"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('loader')], 1)
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "master",
    staticClass: "drag-and-drop column",
    class: {
      dragging: _vm.isDragging
    },
    on: {
      "click": _vm.fileInput
    }
  }, [(!_vm.file) ? _c('span', {
    staticClass: "icon-form-plus"
  }) : _vm._e(), _vm._v(" "), (!_vm.file) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tDéposer votre fichier\n\t\t")]) : _c('div', {
    staticClass: "ctn-file column"
  }, [_c('div', {
    staticClass: "ctn-icon-document"
  }, [_c('img', {
    attrs: {
      "src": _vm.baseFile,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "extension"
  }, [_vm._v("." + _vm._s(_vm._f("uppercase")(_vm.file.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.file.name) + "\n\t\t\t")])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "input-file",
      "type": "file"
    },
    on: {
      "change": _vm.setFile
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-calendar dashboard-section--card"
  }, [_c('div', {
    staticClass: "board-calendar__header"
  }, [_c('h1', {
    staticClass: "dashboard-title"
  }, [_vm._v("Agenda")]), _vm._v(" "), _c('div', {
    staticClass: "board-calendar__nav"
  }, [_c('button', {
    staticClass: "board-calendar__nav-btn",
    attrs: {
      "title": "Jour précédent"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(-1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.5 15L7.5 10L12.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "board-calendar__date-label",
    class: {
      'board-calendar__date-label--today': _vm.isToday
    },
    attrs: {
      "title": _vm.isToday ? '' : 'Revenir à aujourd\'hui'
    },
    on: {
      "click": _vm.goToToday
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.formattedDate) + "\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "board-calendar__nav-btn",
    attrs: {
      "title": "Jour suivant"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]), _vm._v(" "), _c('div', {
    ref: "eventsContainer",
    staticClass: "board-calendar__events dashboard-scroll dashboard-scroll--draggable",
    on: {
      "mousedown": _vm.handleMouseDown,
      "mouseleave": _vm.handleMouseLeave,
      "mouseup": _vm.handleMouseUp,
      "mousemove": _vm.handleMouseMove
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "board-calendar__loader"
  }, [_c('span', {
    staticClass: "board-calendar__spinner"
  })]) : (_vm.calendar.length > 0) ? _vm._l((_vm.calendar), function(event) {
    return _c('div', {
      key: event.id,
      staticClass: "board-calendar__event"
    }, [_c('CardCalendar', {
      attrs: {
        "item": event
      }
    })], 1)
  }) : _c('div', {
    staticClass: "board-calendar__empty"
  }, [_c('p', [_vm._v("Aucun rendez-vous " + _vm._s(_vm.isToday ? "aujourd'hui" : 'ce jour'))])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar progress-bar-half-circle"
  }, [(_vm.value > 0) ? _c('div', {
    staticClass: "left back-done"
  }) : _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "back"
  })]), _vm._v(" "), (_vm.value >= 100) ? _c('div', {
    staticClass: "right back-done"
  }) : _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "barOverflow"
  }, [_c('div', {
    ref: "bar",
    staticClass: "bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "progress-bar-value"
  }, [_vm._v(_vm._s(_vm._f("format_performance")(_vm.value)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-text"
  }, [_vm._v("Performance")])])])
},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-table column"
  }, [_c('div', {
    staticClass: "header-array row"
  }, [_vm._l((_vm.columns), function(col, key) {
    return _c('div', {
      key: key,
      staticClass: "header-col row",
      style: ({
        width: col.width + 'px'
      }),
      on: {
        "click": function($event) {
          return _vm.setFilter(key)
        }
      }
    }, [_vm._v("\n        " + _vm._s(col.name) + "\n        "), _c('span', {
      staticClass: "arrow",
      class: {
        down: _vm.isFiltered(key)
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "deploy header-col row",
    staticStyle: {
      "width": "20px"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "body-array"
  }, _vm._l((_vm.computedRows), function(row, key) {
    return _c('div', {
      key: key,
      staticClass: "body-row column"
    }, [_c('div', {
      staticClass: "inner-row row start"
    }, [_vm._l((_vm.columns), function(col, colKey) {
      return _c('div', {
        key: colKey,
        staticClass: "body-cell",
        style: ({
          width: col.width + 'px'
        }),
        on: {
          "click": function($event) {
            return _vm.deployRow(key)
          }
        }
      }, [(typeof col.cellRenderer !== 'undefined' && col.cellRenderer) ? [_c('div', {
        domProps: {
          "innerHTML": _vm._s(col.cellRenderer({
            value: row.data[col.field]
          }))
        }
      })] : (col.field === 'actions') ? [_c('div', {
        staticClass: "body-row-actions"
      }, _vm._l((col.actions), function(action, index) {
        return _c('span', {
          key: index,
          staticClass: "action-item",
          on: {
            "click": function($event) {
              return _vm.emitActionClick(row, action)
            }
          }
        }, [(typeof col.actionRenderer === 'undefined' && !col.actionRenderer) ? _c('i', {
          class: action.icon
        }) : _c('span', {
          domProps: {
            "innerHTML": _vm._s(col.actionRenderer(action, row))
          }
        })])
      }), 0)] : [_vm._v(_vm._s(row.data[col.field]))]], 2)
    }), _vm._v(" "), _c('div', {
      staticClass: "deploy row body-cell",
      class: {
        active: _vm.rows[key].deploy
      },
      staticStyle: {
        "width": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.deployRow(key)
        }
      }
    }, [(typeof _vm.rows[key].childrenRows !== 'undefined' && _vm.rows[key].childrenRows.length > 0) ? _c('span', {
      staticClass: "icon-arrow-full-down"
    }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
      staticClass: "row-child",
      class: {
        active: _vm.rows[key].deploy
      }
    }, [_c('div', {
      staticClass: "header-child row"
    }, _vm._l((_vm.rows[key].childrenColumn), function(col, keyt) {
      return _c('div', {
        key: keyt,
        staticClass: "header-col bold",
        style: ({
          width: col.width + 'px'
        })
      }, [_vm._v("\n              " + _vm._s(col.name) + "\n            ")])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "body-child column"
    }, _vm._l((_vm.rows[key].childrenRows), function(childrenRow, childrenRowKey) {
      return _c('div', {
        key: childrenRowKey,
        staticClass: "row-body-child row"
      }, _vm._l((_vm.rows[key].childrenColumn), function(childrenColumn, childrenColumnKey) {
        return _c('div', {
          key: childrenColumnKey,
          staticClass: "cell-child",
          style: ({
            width: childrenColumn.width + 'px'
          })
        }, [_vm._v("\n                " + _vm._s(childrenRow[childrenColumn.field]) + "\n              ")])
      }), 0)
    }), 0)])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tActions\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, [_c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "ctn-actions row"
  }, [_c('div', {
    staticClass: "btn btn-red ctn-icon",
    class: {
      'btn-disabled': !_vm.canCancel
    },
    on: {
      "click": function($event) {
        return _vm.cancelSubscription()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tAnnuler l'abonnement\n\t\t\t\t")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "subview-container column"
  }, [_c('div', {
    staticClass: "profile-container"
  }, [_c('div', {
    staticClass: "header-part row"
  }, [_c('div', {
    staticClass: "ctn-profile-light row"
  }, [_c('div', {
    staticClass: "ctn-profile-picture ctn-profile-pic"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "id": "userPicture",
      "src": _vm.userM.picture,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-label"
  }, [_c('div', {
    staticClass: "ctn-name"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.lastname) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": _vm.procNewPicture
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tÉditer la photo\n\t\t\t\t\t\t\t"), _c('input', {
    attrs: {
      "id": "newPicture",
      "type": "file"
    },
    on: {
      "change": _vm.uploadNewPicture
    }
  })]), _vm._v(" "), (!_vm.userM.isAvailable) ? _c('div', {
    staticClass: "ctn-ooo"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user.ooo_message) + "\n\t\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-right column"
  }, [_c('div', {
    staticClass: "ctn-available row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\tDisponibilité\n\t\t\t\t\t\t")]), _vm._v(" "), _c('toggle-input', {
    attrs: {
      "value": _vm.userM.isAvailable
    },
    on: {
      "change": _vm.setAvailable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red small",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n\t\t\t\t\t\tDéconnexion\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-part row"
  }, [_c('div', {
    staticClass: "half edit-profile"
  }, [_c('form', {
    staticClass: "default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tInformations générales\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.email),
      expression: "userM.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.userM.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('prénom')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.firstname),
      expression: "userM.firstname"
    }],
    attrs: {
      "type": "text",
      "name": "prénom",
      "placeholder": "Prénom"
    },
    domProps: {
      "value": (_vm.userM.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('prénom')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('prénom')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('nom')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.lastname),
      expression: "userM.lastname"
    }],
    attrs: {
      "type": "text",
      "name": "nom",
      "placeholder": "Nom"
    },
    domProps: {
      "value": (_vm.userM.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('nom')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nom')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('adresse')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.address.line),
      expression: "userM.address.line"
    }],
    attrs: {
      "type": "text",
      "name": "adresse",
      "placeholder": "Adresse"
    },
    domProps: {
      "value": (_vm.userM.address.line)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM.address, "line", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('adresse')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('adresse')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('code postal')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|length:5'),
      expression: "'required|numeric|length:5'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.address.zip),
      expression: "userM.address.zip"
    }],
    attrs: {
      "type": "text",
      "name": "code postal",
      "placeholder": "Code Postal"
    },
    domProps: {
      "value": (_vm.userM.address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM.address, "zip", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('code postal')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('code postal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('ville')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.address.city),
      expression: "userM.address.city"
    }],
    attrs: {
      "type": "text",
      "name": "ville",
      "placeholder": "Ville"
    },
    domProps: {
      "value": (_vm.userM.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM.address, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('ville')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('ville')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('pays')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.address.country),
      expression: "userM.address.country"
    }],
    attrs: {
      "type": "text",
      "name": "pays",
      "placeholder": "Pays"
    },
    domProps: {
      "value": (_vm.userM.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM.address, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('pays')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('pays')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('téléphone')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.phone),
      expression: "userM.phone"
    }],
    attrs: {
      "type": "text",
      "name": "téléphone",
      "placeholder": "Téléphone"
    },
    domProps: {
      "value": (_vm.userM.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('téléphone')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('téléphone')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "half edit-password column"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tMot de passe\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.displayChangePassword = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tÉditer le mot de passe\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("\n\t\t\t\t\t\tSauvegarder\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showUnavailable,
      "content": _vm.contentModal
    },
    on: {
      "close": _vm.checkUnavailable
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.displayChangePassword,
      "content": _vm.contentModalPassword
    },
    on: {
      "close": function($event) {
        _vm.displayChangePassword = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item column",
    class: {
      red: (_vm.prog < 0)
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-values row"
  }, [(_vm.title !== 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.prog) + " %\n      ")]) : _vm._e(), _vm._v(" "), (_vm.title === 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.formatCurrency(_vm.prog)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "prog"
  }, [((_vm.prog >= 0)) ? _c('span', [_c('img', {
    attrs: {
      "src": _vm.good,
      "alt": ""
    }
  })]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.bad,
      "alt": ""
    }
  })])])]), _vm._v(" "), (_vm.title !== 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "inner-bar",
    style: ({
      width: Math.abs(_vm.prog) + '%'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.title === 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "dot",
    attrs: {
      "id": "global-perf-help-modal"
    },
    on: {
      "click": _vm.toggleGlobalPerfHelpModal
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-contact"
  }, [_c('div', {
    staticClass: "add-contact__header"
  }, [_c('div', {
    staticClass: "add-contact__header-left"
  }, [_c('h2', {
    staticClass: "add-contact__title"
  }, [_vm._v("Ajouter un " + _vm._s(_vm.typeLabel))]), _vm._v(" "), _c('span', {
    staticClass: "add-contact__subtitle"
  }, [_vm._v("Remplissez les informations du contact")])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__type-selector"
  }, _vm._l((_vm.prospectTypes), function(type) {
    return _c('button', {
      key: type,
      staticClass: "add-contact__type-btn",
      class: {
        'add-contact__type-btn--active': _vm.selectedType === type
      },
      on: {
        "click": function($event) {
          _vm.user.type = type
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(type) + "\n\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__body"
  }, [_c('form', {
    staticClass: "add-contact__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addContact.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "add-contact__section"
  }, [_c('div', {
    staticClass: "add-contact__section-header"
  }, [_c('svg', {
    staticClass: "add-contact__section-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "add-contact__section-title"
  }, [_vm._v("Identité")])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__grid add-contact__grid--2"
  }, [_c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('lastname')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Nom *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastname),
      expression: "user.lastname"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "text",
      "name": "lastname",
      "id": "lastname",
      "placeholder": "Dupont"
    },
    domProps: {
      "value": (_vm.user.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('lastname')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('lastname')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('firstname')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Prénom *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstname),
      expression: "user.firstname"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "text",
      "name": "firstname",
      "id": "firstname",
      "placeholder": "Jean"
    },
    domProps: {
      "value": (_vm.user.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('firstname')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('firstname')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__grid add-contact__grid--2"
  }, [_c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('date de naissance')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "birthdate"
    }
  }, [_vm._v("Date de naissance *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.birthdate),
      expression: "user.birthdate"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "date",
      "name": "date de naissance",
      "id": "birthdate"
    },
    domProps: {
      "value": (_vm.user.birthdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "birthdate", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('date de naissance')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('date de naissance')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__section"
  }, [_c('div', {
    staticClass: "add-contact__section-header"
  }, [_c('svg', {
    staticClass: "add-contact__section-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "add-contact__section-title"
  }, [_vm._v("Coordonnées")])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__grid add-contact__grid--2"
  }, [_c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Téléphone *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "tel",
      "name": "phone",
      "id": "phone",
      "placeholder": "06 12 34 56 78"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('phone')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('mail')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "mail"
    }
  }, [_vm._v("Adresse email *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "email",
      "name": "mail",
      "id": "mail",
      "placeholder": "jean.dupont@email.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('mail')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('mail')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__section"
  }, [_c('div', {
    staticClass: "add-contact__section-header"
  }, [_c('svg', {
    staticClass: "add-contact__section-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "10",
      "r": "3"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "add-contact__section-title"
  }, [_vm._v("Adresse")])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('address')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Adresse *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.line),
      expression: "user.address.line"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "text",
      "name": "address",
      "id": "address",
      "placeholder": "123 rue de la Paix"
    },
    domProps: {
      "value": (_vm.user.address.line)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "line", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('address')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__grid add-contact__grid--3"
  }, [_c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('zip')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Code postal *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.zip),
      expression: "user.address.zip"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "text",
      "name": "zip",
      "id": "zip",
      "placeholder": "75001"
    },
    domProps: {
      "value": (_vm.user.address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "zip", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('zip')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('city')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Ville *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.city),
      expression: "user.address.city"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": "Paris"
    },
    domProps: {
      "value": (_vm.user.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('city')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field",
    class: {
      'add-contact__field--error': _vm.errors.has('country')
    }
  }, [_c('label', {
    staticClass: "add-contact__label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Pays *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.country),
      expression: "user.address.country"
    }],
    staticClass: "add-contact__input",
    attrs: {
      "type": "text",
      "name": "country",
      "id": "country",
      "placeholder": "France"
    },
    domProps: {
      "value": (_vm.user.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('country')) ? _c('span', {
    staticClass: "add-contact__error"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__section"
  }, [_c('div', {
    staticClass: "add-contact__section-header"
  }, [_c('svg', {
    staticClass: "add-contact__section-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('rect', {
    attrs: {
      "x": "2",
      "y": "7",
      "width": "20",
      "height": "14",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "add-contact__section-title"
  }, [_vm._v("Informations commerciales")])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__grid add-contact__grid--2"
  }, [_c('div', {
    staticClass: "add-contact__field add-contact__field--select"
  }, [_c('label', {
    staticClass: "add-contact__label"
  }, [_vm._v("Origine du contact")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.origins,
      "selected": _vm.user.origin,
      "solo": true
    },
    on: {
      "change": function($event) {
        _vm.user.origin = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "add-contact__field add-contact__field--select"
  }, [_c('label', {
    staticClass: "add-contact__label"
  }, [_vm._v("Centres d'intérêts")]), _vm._v(" "), _c('custom-multiselect', {
    attrs: {
      "values": _vm.user.centerOfInterests,
      "list": _vm.interests,
      "object": true,
      "getter": 'wordpress_tag_name',
      "solo": true
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "add-contact__footer"
  }, [_c('button', {
    staticClass: "add-contact__btn add-contact__btn--cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n\t\t\t\t\t\tAnnuler\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "add-contact__btn add-contact__btn--submit",
    attrs: {
      "type": "submit"
    }
  }, [_c('svg', {
    staticClass: "add-contact__btn-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22 4 12 14.01 9 11.01"
    }
  })]), _vm._v("\n\t\t\t\t\t\tCréer le " + _vm._s(_vm.typeLabel) + "\n\t\t\t\t\t")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timespanpicker"
  }, [_c('div', {
    staticClass: "current bold",
    class: {
      active: _vm.display
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n  \t\t" + _vm._s(_vm.current.label) + "\n  \t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display),
      expression: "display"
    }],
    staticClass: "values"
  }, _vm._l((_vm.spans), function(span, id) {
    return _c('div', {
      key: id,
      staticClass: "value bold",
      on: {
        "click": function($event) {
          return _vm.setSelected(id)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(span.label) + "\n\t\t\t")])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_c('div', {
    staticClass: "legals-title"
  }, [_vm._v("\n\t\t\tPolitique de confidentialité\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "legals-body"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("L’utilisation des données personnelles par Patrimoffice est encadrée principalement par le Règlement européen 2016-679 dit « Règlement Général sur la Protection des Données » ou « RGPD » et la loi n° 78-17 du 6 janvier 1978 modifiée, dite loi « Informatique et Libertés ».")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Les informations recueillies sont enregistrées dans un fichier informatisé par Patrimoffice afin notamment de pouvoir proposer des produits et services de qualité personnalisés et adaptés à chaque situation patrimoniale, besoin et objectif recherché, se conformer à ses obligations légales et règlementaires et exercer son activité de conseil et de suivi au mieux des intérêts des clients. Elles sont conservées pendant la durée de la relation contractuelle et pendant 5 ans à l’issue de la relation et sont destinées aux établissements dépositaires ou compagnies d’assurance à partenaires de Patrimoffice, et le cas échéant à son prestataire de services informatiques. Ces données ne font l’objet d’aucune transmission à des organismes extérieurs notamment à des fins de prospection commerciale sans l’accord du client.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d’accès, d’opposition, d’effacement, de limitation du traitement, de portabilité des données vous concernant et les faire rectifier en contactant notre service de traitement des données à contact@patrimoffice.com. Vous pouvez également introduire une réclamation au sujet du traitement de vos données auprès de la CNIL.")])])])])
}]}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column ctn-patrimonial-landscape no-edit"
  }, [_c('div', {
    staticClass: "heading-sub-client row"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tLes derniers échanges avec " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname) + "\n\t\t\t")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('chat', {
    attrs: {
      "title": 'Messages',
      "isAdvisor": true,
      "threads": _vm.threads
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('br')])
}]}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctn-custom-label"
  }, [_c('label', [_vm._v("Type de document")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "selected": _vm.type,
      "solo": true,
      "items": _vm.docTypeList
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-form-element"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom du document")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-form-element margin"
  }, [((_vm.type !== 'Autres Documents' || (_vm.type === 'Autres Documents' && !_vm.confidential))) ? _c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-form-element margin"
  }, [(_vm.type === 'Mes Justificatifs d\'identité') ? _c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.listOfJustificatifs
    },
    model: {
      value: (_vm.typeOfJustificatif),
      callback: function($$v) {
        _vm.typeOfJustificatif = $$v
      },
      expression: "typeOfJustificatif"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.type === 'Autres Documents') ? _c('div', {
    staticClass: "check-container row"
  }, [_c('radio-box', {
    attrs: {
      "value": _vm.confidential
    },
    on: {
      "change": function($event) {
        _vm.confidential = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_vm._v("\n\t\t\t\t\tVoulez vous que votre document soit privé\n\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (!_vm.needTwoInput) ? _c('drag-and-drop', {
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.needTwoInput) ? _c('drag-and-drop', {
    model: {
      value: (_vm.fileRecto),
      callback: function($$v) {
        _vm.fileRecto = $$v
      },
      expression: "fileRecto"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.needTwoInput) ? _c('drag-and-drop', {
    model: {
      value: (_vm.fileVerso),
      callback: function($$v) {
        _vm.fileVerso = $$v
      },
      expression: "fileVerso"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Enregistrer")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-header-title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\tAjouter un document\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\tEnvoyez des documents à votre client\n\t\t\t")])])
}]}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal lcbcft",
    class: {
      high: _vm.filling
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.filling) ? _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tDate de mise en relation\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-date-input"
  }, [_c('input-date', {
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tOrigine de la relation client\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.origins,
      "solo": true
    },
    model: {
      value: (_vm.origin),
      callback: function($$v) {
        _vm.origin = $$v
      },
      expression: "origin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tOuverture à distance\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tVigilance accrue exigée lorsque le client ou son représentant légal n'est pas physiquement présent au fins de l'identification (Art. L.561-10 1° du code monétaire et financier)\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.remoteContractualization),
      callback: function($$v) {
        _vm.remoteContractualization = $$v
      },
      expression: "remoteContractualization"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tCatégorie professionnelle\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select'),
      expression: "'required|select'"
    }],
    attrs: {
      "name": "catégorie professionnelle",
      "items": _vm.professionnalCategories,
      "solo": true
    },
    model: {
      value: (_vm.professionalCategory),
      callback: function($$v) {
        _vm.professionalCategory = $$v
      },
      expression: "professionalCategory"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('catégorie professionnelle')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tActivité risquée\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tIl s'agit de savoir si l'activité du client est plus ou moins risquée au sens du risque de blanchiment/financement du terrorisme\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.activityRisk),
      callback: function($$v) {
        _vm.activityRisk = $$v
      },
      expression: "activityRisk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tSoupçon de fraude fiscale\n\t\t\t\t\t")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.suspicionOfFraud),
      callback: function($$v) {
        _vm.suspicionOfFraud = $$v
      },
      expression: "suspicionOfFraud"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tLe client exerce-t-il ou a-t-il exercé au cours des 12 derniers mois une fonction politique, juridictionnelle ou administrative importante ?\n\t\t\t\t\t")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.wasPJA),
      callback: function($$v) {
        _vm.wasPJA = $$v
      },
      expression: "wasPJA"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tLe client a-t-il un lien avec une personne de sa famille ou de son entourage qui exerce ou a exercé au cours des 12 derniers mois une fonction politique, juridictionnelle ou administrative importante ?\n\t\t\t\t\t")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.wasSomeonePJA),
      callback: function($$v) {
        _vm.wasSomeonePJA = $$v
      },
      expression: "wasSomeonePJA"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tClient VIP\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tUn VIP est un personnage publique important\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.isVIP),
      callback: function($$v) {
        _vm.isVIP = $$v
      },
      expression: "isVIP"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tNationalité (Nationalité principale)\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tChoix obligatoire\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select:true'),
      expression: "'required|select:true'"
    }],
    attrs: {
      "name": "nationalité",
      "items": _vm.countryList,
      "object": true,
      "solo": true
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nationalité')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tSeconde nationalité\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tChoix facultatif\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.countryList,
      "object": true,
      "solo": true
    },
    model: {
      value: (_vm.secondCountry),
      callback: function($$v) {
        _vm.secondCountry = $$v
      },
      expression: "secondCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tRésidence fiscale\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tChoix Obligatoire\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select:true'),
      expression: "'required|select:true'"
    }],
    attrs: {
      "name": "résidence fiscale",
      "items": _vm.countryList,
      "object": true,
      "solo": true
    },
    model: {
      value: (_vm.fiscCountry),
      callback: function($$v) {
        _vm.fiscCountry = $$v
      },
      expression: "fiscCountry"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('résidence fiscale')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tBanque dépositaire\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tPays non cooperatifs : Guatemala, Niue, Brunei, Iles Marshall, Iles Vierges britanniques,\u2028Jersey, Montserrat, Nauru, Botswana, Bermudes\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.banqueCountries,
      "solo": true
    },
    model: {
      value: (_vm.banqueCountry),
      callback: function($$v) {
        _vm.banqueCountry = $$v
      },
      expression: "banqueCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tPoursuite pénale\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.penal),
      callback: function($$v) {
        _vm.penal = $$v
      },
      expression: "penal"
    }
  })], 1), _vm._v(" "), (_vm.errorInForm) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("Une erreur est présente dans le formulaire")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.sendScore
    }
  }, [_vm._v("Calculer le score")])])])]) : _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-result-score row"
  }, [_c('div', {
    staticClass: "value",
    class: _vm.resolveClass()
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.displayScore()) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t\tVigilence "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.score_label))])]), _vm._v(" "), (_vm.score > 3) ? _c('div', {
    staticClass: "subname"
  }, [_vm._v("\n\t\t\t\t\t\t\tUne alerte va être envoyé aux Super Admin\n\t\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        _vm.filling = true
      }
    }
  }, [_vm._v("Revoir mes réponses")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.end
    }
  }, [_vm._v("Terminer")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n  \t\t\t\tQuestionnaire\n  \t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tLutte contre le blanchiment des capitaux "), _c('br'), _vm._v("\n\t\t\t\t\tet le financement du terrorisme\n\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sublink",
    attrs: {
      "href": "https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Info-Soupc%CC%A7on-Fraude-Fiscale.pdf",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-info-2"
  }), _vm._v(" Plus d'informations sur le soupçon de fraude fiscale")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sublink",
    attrs: {
      "href": "https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Infos-PPE.pdf",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-info-2"
  }), _vm._v(" Plus d'informations sur les PPE (Personnes Politiquement Exposées)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sublink",
    attrs: {
      "href": "https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Infos-PPE.pdf",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-info-2"
  }), _vm._v(" Plus d'informations sur les PPE (Personnes Politiquement Exposées)")])
}]}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column activity-container"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "ctn-day-picker row"
  }, [_c('timespanpicker', {
    on: {
      "change": _vm.setSpan
    }
  }), _vm._v(" "), (_vm.span !== 'all') ? [_c('div', {
    staticClass: "ctn-arrow",
    on: {
      "click": function($event) {
        return _vm.setDate(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-left-open-mini"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-arrow",
    on: {
      "click": function($event) {
        return _vm.setDate(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-right-open-mini"
  })])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.currentFilter) + "\n\t\t\t\t")])], 2), _vm._v(" "), _c('div', {
    staticClass: "ctn-plan-rdv",
    on: {
      "click": function($event) {
        _vm.showTakeAppointment = true
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "appointments-list"
  }, [_vm._m(1), _vm._v(" "), (_vm.rowDataFiltered.length === 0) ? _c('div', {
    staticClass: "appointments-list__empty"
  }, [_c('span', {
    staticClass: "icon-calendar"
  }), _vm._v(" "), _c('p', [_vm._v("Aucun rendez-vous prévu")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rowDataFiltered), function(rdv) {
    return _c('div', {
      key: rdv.id,
      staticClass: "appointments-list__item"
    }, [_c('div', {
      staticClass: "appointments-list__col appointments-list__col--date"
    }, [_c('span', {
      staticClass: "appointments-list__day"
    }, [_vm._v(_vm._s(_vm.formatDay(rdv.date)))]), _vm._v(" "), _c('span', {
      staticClass: "appointments-list__date-full"
    }, [_vm._v(_vm._s(_vm.formatDate(rdv.date)))])]), _vm._v(" "), _c('div', {
      staticClass: "appointments-list__col appointments-list__col--hour"
    }, [_c('span', {
      staticClass: "appointments-list__time"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.formatHour(rdv.hour.start)) + " - " + _vm._s(_vm.formatHour(rdv.hour.end)) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "appointments-list__col appointments-list__col--type"
    }, [_c('span', {
      staticClass: "appointments-list__type-badge",
      class: _vm.getTypeBadgeClass(rdv.type)
    }, [_c('span', {
      staticClass: "appointments-list__type-dot"
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(rdv.type) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "appointments-list__col appointments-list__col--customer"
    }, [_c('router-link', {
      staticClass: "appointments-list__customer-link",
      attrs: {
        "to": {
          name: 'Client',
          params: {
            clientId: rdv.clientId
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(rdv.customer) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
      staticClass: "appointments-list__col appointments-list__col--description"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(rdv.description) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "appointments-list__col appointments-list__col--contact"
    }, [_c('div', {
      staticClass: "appointments-list__contact-info"
    }, [(rdv.clientPhone) ? _c('a', {
      staticClass: "appointments-list__contact-pill appointments-list__contact-pill--phone",
      attrs: {
        "href": 'tel:' + rdv.clientPhone
      }
    }, [_c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(rdv.clientPhone))])]) : _vm._e(), _vm._v(" "), (rdv.clientEmail) ? _c('a', {
      staticClass: "appointments-list__contact-pill appointments-list__contact-pill--email",
      attrs: {
        "href": 'mailto:' + rdv.clientEmail
      }
    }, [_c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      }
    }), _vm._v(" "), _c('polyline', {
      attrs: {
        "points": "22,6 12,13 2,6"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(rdv.clientEmail))])]) : _vm._e(), _vm._v(" "), (!rdv.clientPhone && !rdv.clientEmail) ? _c('span', {
      staticClass: "appointments-list__no-contact"
    }, [_vm._v("-")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "appointments-list__col appointments-list__col--actions"
    }, [_c('button', {
      staticClass: "appointments-list__edit-btn",
      attrs: {
        "title": "Modifier le rendez-vous"
      },
      on: {
        "click": function($event) {
          return _vm.editRdv(rdv)
        }
      }
    }, [_c('span', {
      staticClass: "icon-file-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "appointments-list__delete-btn",
      attrs: {
        "title": "Supprimer le rendez-vous"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRdv(rdv)
        }
      }
    }, [_c('span', {
      staticClass: "icon-file-trash"
    })])])])
  })], 2), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showTakeAppointment,
      "content": _vm.modalTakeAppointment,
      "data": _vm.rdvToEdit ? {
        rdv: _vm.rdvToEdit
      } : null
    },
    on: {
      "close": _vm.closeTakeAppointment
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-red"
  }, [_c('span', {
    staticClass: "icon-button-rdv"
  }), _vm._v(" Planifier un RDV\n\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointments-list__header"
  }, [_c('span', {
    staticClass: "appointments-list__col appointments-list__col--date"
  }, [_vm._v("Date")]), _vm._v(" "), _c('span', {
    staticClass: "appointments-list__col appointments-list__col--hour"
  }, [_vm._v("Horaire")]), _vm._v(" "), _c('span', {
    staticClass: "appointments-list__col appointments-list__col--type"
  }, [_vm._v("Type")]), _vm._v(" "), _c('span', {
    staticClass: "appointments-list__col appointments-list__col--customer"
  }, [_vm._v("Client")]), _vm._v(" "), _c('span', {
    staticClass: "appointments-list__col appointments-list__col--description"
  }, [_vm._v("description")]), _vm._v(" "), _c('span', {
    staticClass: "appointments-list__col appointments-list__col--contact"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('span', {
    staticClass: "appointments-list__col appointments-list__col--actions"
  })])
}]}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('prénom')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("En matière de placement, les conseils d'un professionnel sont :")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.ratings,
      "selected": _vm.conseilRate
    },
    on: {
      "change": function($event) {
        _vm.conseilRate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tCombien d'interlocuteurs vous accompagnent sur vos contrats souscrits ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setContractCounselor(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-less"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setContractCounselor(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.nbContractCounselor) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tCombien d'interlocuteurs vous accompagnent sur l'ensemble de votre patrimoine ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setPatrimonialCounselor(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-less"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setPatrimonialCounselor(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.nbPatrimonialCounselor) + "\n\t\t\t")])])])])
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Quel est votre diplôme le plus élevé ?")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.diplomas,
      "selected": _vm.diploma
    },
    on: {
      "change": function($event) {
        _vm.diploma = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("En tant qu'investisseur, vous vous estimez : ")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.levels,
      "selected": _vm.level
    },
    on: {
      "change": function($event) {
        _vm.level = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Depuis quand effectuez-vous des placements financiers ?")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.ages,
      "selected": _vm.age
    },
    on: {
      "change": function($event) {
        _vm.age = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Le climat économique de votre pays dans 3 ans sera :")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.countries,
      "selected": _vm.country
    },
    on: {
      "change": function($event) {
        _vm.country = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuel type de produit connaissez-vous ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.products), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(_vm.product, tag),
        locked: _vm.isLocked(_vm.product, tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(_vm.product, tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tSur quels produits avez-vous investi ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.investedProducts), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(_vm.investedProduct, tag),
        locked: _vm.isLocked(_vm.investedProduct, tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(_vm.investedProduct, tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuels modes de gestion connaissez-vous ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.managements), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(_vm.management, tag),
        locked: _vm.isLocked(_vm.management, tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(_vm.management, tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container small row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', [_vm._v("Type Contact")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.prospectTypes,
      "selected": _vm.user.type
    },
    on: {
      "change": function($event) {
        _vm.user.type = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastname),
      expression: "user.lastname"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.user.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('firstname')
    }
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Prénom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstname),
      expression: "user.firstname"
    }],
    attrs: {
      "type": "text",
      "name": "firstname"
    },
    domProps: {
      "value": (_vm.user.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('firstname')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('firstname')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    attrs: {
      "type": "phone",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('phone')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('date de naissance')
    }
  }, [_c('label', {
    attrs: {
      "for": "date de naissance"
    }
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.birthdate),
      expression: "user.birthdate"
    }],
    attrs: {
      "type": "date",
      "name": "date de naissance"
    },
    domProps: {
      "value": (_vm.user.birthdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "birthdate", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('date de naissance')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('date de naissance')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('mail')
    }
  }, [_c('label', {
    attrs: {
      "for": "mail"
    }
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "mail",
      "name": "mail"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('mail')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('mail')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('address')
    }
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.line),
      expression: "user.address.line"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.user.address.line)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "line", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('address')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('zip')
    }
  }, [_c('label', {
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Code postal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.zip),
      expression: "user.address.zip"
    }],
    attrs: {
      "type": "text",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.user.address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "zip", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('zip')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('city')
    }
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Ville")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.city),
      expression: "user.address.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.user.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('city')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('country')
    }
  }, [_c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Pays")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address.country),
      expression: "user.address.country"
    }],
    attrs: {
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.user.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.address, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('country')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Origine du contact")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.origins,
      "selected": _vm.user.origin,
      "solo": true
    },
    on: {
      "change": function($event) {
        _vm.user.origin = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Centres d'intérêts")]), _vm._v(" "), _c('custom-multiselect', {
    attrs: {
      "values": _vm.user.centerOfInterests,
      "list": _vm.interests,
      "object": true,
      "getter": 'wordpress_tag_name',
      "solo": true
    },
    on: {
      "change": function($event) {
        return _vm.setNewCenterOfInterests($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.errors.has('origin')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('origin')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("Envoyer")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\tEditer un client\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tEditer les informations du client\n\t\t\t\t")])])
}]}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapbox-container"
  }, [_c('div', {
    staticClass: "mapbox-wrapper"
  }, [_c('div', {
    ref: "mapContainer",
    staticClass: "map"
  }), _vm._v(" "), (_vm.showCountryImages) ? _c('div', {
    staticClass: "map-dark-overlay"
  }) : _vm._e(), _vm._v(" "), (_vm.showCountryImages) ? _c('div', {
    staticClass: "country-images-overlay"
  }, _vm._l((_vm.countries), function(country) {
    return _c('div', {
      key: country.name,
      staticClass: "country-image-wrapper"
    }, [_c('div', {
      staticClass: "title_country"
    }, [_vm._v(" " + _vm._s(country.displayName))]), _vm._v(" "), _c('div', {
      staticClass: "tick_country"
    }, [_c('svg', {
      staticClass: "tick-svg",
      attrs: {
        "viewBox": "0 0 52 52"
      }
    }, [_c('circle', {
      staticClass: "tick-circle",
      attrs: {
        "cx": "26",
        "cy": "26",
        "r": "25",
        "fill": "white"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "tick-check",
      attrs: {
        "fill": "none",
        "d": "M14.1 27.2l7.1 7.2 16.7-16.8"
      }
    })])]), _vm._v(" "), _c('img', {
      staticClass: "country-image",
      style: (country.style),
      attrs: {
        "src": country.image,
        "alt": country.fr
      }
    })])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\tContrats et supports\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container with-add"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("type de contrat")]), _vm._v(" "), _c('div', {
    staticClass: "start row"
  }, [_c('custom-select', {
    attrs: {
      "object": true,
      "getter": 'full_name',
      "items": _vm.contractTypeList,
      "solo": true
    },
    model: {
      value: (_vm.contractTypeToAdd),
      callback: function($$v) {
        _vm.contractTypeToAdd = $$v
      },
      expression: "contractTypeToAdd"
    }
  }), _vm._v(" "), (_vm.contractTypeToAdd && _vm.contractTypeToAdd.name !== 'Autre') ? _c('div', {
    staticClass: "btn-plus",
    on: {
      "click": _vm.addContract
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contractTypeToAdd && _vm.contractTypeToAdd.name === 'Autre') ? _c('div', {
    staticClass: "add-support row start"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "contract name"
    }
  }, [_vm._v("Nouveau contrat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContract.name),
      expression: "newContract.name"
    }],
    attrs: {
      "type": "text",
      "name": "contract name"
    },
    domProps: {
      "value": (_vm.newContract.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newContract, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "contract name"
    }
  }, [_vm._v("Numéro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContract.number),
      expression: "newContract.number"
    }],
    attrs: {
      "type": "text",
      "name": "contract name"
    },
    domProps: {
      "value": (_vm.newContract.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newContract, "number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.operationTypeList
    },
    model: {
      value: (_vm.newContract.type),
      callback: function($$v) {
        _vm.$set(_vm.newContract, "type", $$v)
      },
      expression: "newContract.type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-plus",
    on: {
      "click": _vm.addContractToContractList
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-contracts"
  }, _vm._l((_vm.contracts), function(contract, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-contract"
    }, [_c('div', {
      staticClass: "ctn-top row"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(contract.ref.full_name))]), _vm._v(" "), (contract.supports.length === 0) ? _c('div', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.removeContract(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form-close"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ctn-supports"
    }, [_c('div', {
      staticClass: "form-elem-container with-add"
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("type de support")]), _vm._v(" "), _c('div', {
      staticClass: "row start"
    }, [_c('custom-select', {
      attrs: {
        "items": _vm.supportListOfContract(contract.ref.contract_products),
        "solo": true,
        "object": true,
        "getter": 'product.full_name'
      },
      model: {
        value: (contract.supportToAdd),
        callback: function($$v) {
          _vm.$set(contract, "supportToAdd", $$v)
        },
        expression: "contract.supportToAdd"
      }
    }), _vm._v(" "), (contract.supportToAdd.product.name !== 'Autre') ? _c('div', {
      staticClass: "btn-plus",
      on: {
        "click": function($event) {
          return _vm.addSupportToContract(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form-plus"
    })]) : _vm._e()], 1)]), _vm._v(" "), (contract.supportToAdd.product.name === 'Autre') ? _c('div', {
      staticClass: "add-support row start"
    }, [_c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom du nouveau support')
      }
    }, [_c('label', {
      attrs: {
        "for": "nom du nouveau support"
      }
    }, [_vm._v("Nouveau support")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (contract.newSupport.name),
        expression: "contract.newSupport.name"
      }],
      attrs: {
        "type": "text",
        "name": "nom du nouveau support"
      },
      domProps: {
        "value": (contract.newSupport.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contract.newSupport, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input ctn-label"
    }, [_c('label', {
      attrs: {
        "for": "isin"
      }
    }, [_vm._v("ISIN")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contract.newSupport.isin),
        expression: "contract.newSupport.isin"
      }],
      attrs: {
        "type": "text",
        "name": "isin"
      },
      domProps: {
        "value": (contract.newSupport.isin)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contract.newSupport, "isin", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "btn-plus",
      on: {
        "click": function($event) {
          return _vm.addToSupportlistOfContract(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form-plus"
    })])]) : _vm._e(), _vm._v(" "), (contract.supportToAdd.product.name === 'Autre') ? _c('div', {
      staticClass: "error-add-support error-message"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.errors.first('nom du nouveau support')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("\n\t\t\t\t\t\tSupports associés\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.contracts[key].supports), function(support, keyt) {
      return _c('div', {
        staticClass: "ctn-support row start"
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(support.ref.full_name))]), _vm._v(" "), _c('div', {
        staticClass: "duo-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Contrat N°")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.contractNumber),
          expression: "support.contractNumber"
        }],
        attrs: {
          "type": "text",
          "name": "contract"
        },
        domProps: {
          "value": (support.contractNumber)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "contractNumber", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "duo-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Pourcentage")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.percent),
          expression: "support.percent"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100",
          "step": "0.01",
          "name": "percent"
        },
        domProps: {
          "value": (support.percent)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "percent", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "tri-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Prix unitaire")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.price),
          expression: "support.price"
        }],
        attrs: {
          "type": "text",
          "name": "value"
        },
        domProps: {
          "value": (support.price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "price", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('custom-select', {
        attrs: {
          "items": _vm.currencyList
        },
        model: {
          value: (support.currency),
          callback: function($$v) {
            _vm.$set(support, "currency", $$v)
          },
          expression: "support.currency"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "duo-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Parts")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.part),
          expression: "support.part"
        }],
        attrs: {
          "type": "text",
          "name": "value"
        },
        domProps: {
          "value": (support.part)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "part", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "tri-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Montant investi")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.amountInvested),
          expression: "support.amountInvested"
        }],
        attrs: {
          "type": "text",
          "name": "value"
        },
        domProps: {
          "value": (support.amountInvested)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "amountInvested", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('custom-select', {
        attrs: {
          "items": _vm.currencyList
        },
        model: {
          value: (support.currency),
          callback: function($$v) {
            _vm.$set(support, "currency", $$v)
          },
          expression: "support.currency"
        }
      })], 1), _vm._v(" "), (!support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.addProductToMission(contract, support)
          }
        }
      }, [_vm._v("Ajouter")]) : _vm._e(), _vm._v(" "), (!support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.cancelProductFromMission(contract, support)
          }
        }
      }, [_vm._v("Annuler")]) : _vm._e(), _vm._v(" "), (support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.editProductFromMission(contract, support)
          }
        }
      }, [_vm._v("Editer")]) : _vm._e(), _vm._v(" "), (support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.removeProductFromMission(contract, support)
          }
        }
      }, [_vm._v("Supprimer")]) : _vm._e()])
    }), _vm._v(" "), (_vm.contracts[key].supports.length === 0) ? _c('div', {
      staticClass: "no-support"
    }, [_vm._v("\n\t\t\t\t\t\tAucun support associé\n\t\t\t\t\t")]) : _vm._e()], 2)])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-panel-container",
    class: {
      active: _vm.open
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('section', {
    staticClass: "notification-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "head row"
  }, [_c('span', {
    staticClass: "icon-volet-notif"
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tNotifications\n\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "close icon-form-close",
    on: {
      "click": _vm.setActive
    }
  })]), _vm._v(" "), (_vm.isClient) ? _c('div', {
    staticClass: "custom-notif ctn-free-trial notification"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVous disposez d'un essai gratuit\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\tJusqu'au 02/01/2019\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.goToAbo
    }
  }, [_vm._v("\n\t\t\t\tRenouveler maintenant\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-notif ctn-next-appointment notification"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVotre prochain rendez-vous\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\tLundi 04 Mars 2018 de 14h à 16h\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "advisor row"
  }, [_c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.picture,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-notifications"
  }, _vm._l((_vm.notifications), function(notification, key) {
    return _c('div', {
      key: key,
      staticClass: "notification"
    }, [(notification.type === 'article') ? _c('div', {
      staticClass: "head-notif row"
    }, [_c('span', {
      staticClass: "icon-notif-article"
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("Nouvel Article")]), _vm._v(" "), _c('div', {
      staticClass: "hour"
    }, [_vm._v(_vm._s(_vm._f("moment")(notification.date, 'HH[h]mm')))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "body-notif"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(notification.text) + "\n\t\t\t\t")])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\tAvec "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mr Pitois")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Points à aborder :")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Assurance vie / Immobilier")])])
}]}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "documents-layout ctn-patrimonial-landscape"
  }, [_c('article', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\tDocuments archivés\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "view-nav-template white-box row"
  }, [_c('div', {
    staticClass: "menu column"
  }, [_c('ul', {
    staticClass: "ctn-menu column"
  }, _vm._l((_vm.menu), function(item, key) {
    return _c('li', {
      key: key,
      staticClass: "item-main",
      class: {
        active: _vm.isActiveFirst(key)
      }
    }, [_c('div', {
      staticClass: "label",
      domProps: {
        "innerHTML": _vm._s(item.label)
      },
      on: {
        "click": function($event) {
          return _vm.setActiveFirst(key)
        }
      }
    }), _vm._v(" "), (item.children && _vm.isActiveFirst(key)) ? _c('ul', {
      staticClass: "ctn-second"
    }, _vm._l((item.children), function(child, keyt) {
      return _c('li', {
        key: keyt,
        staticClass: "item-second",
        class: {
          active: _vm.isActiveSecond(keyt)
        },
        domProps: {
          "innerHTML": _vm._s(child.label)
        },
        on: {
          "click": function($event) {
            return _vm.setActiveSecond(keyt)
          }
        }
      })
    }), 0) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "view column"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('div', {
    staticClass: "inner-title",
    domProps: {
      "innerHTML": _vm._s(_vm.menu[_vm.activeFirstLevel].label)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddDocument = true
      }
    }
  }, [_vm._v("Ajouter un document")])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-component"
  }, [(_vm.drawComponent) ? _c(_vm.currentComponent, {
    ref: "currentComp",
    tag: "component"
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "content": _vm.modalAddDocument,
      "show": _vm.showAddDocument
    },
    on: {
      "close": _vm.resolveCloseAddDocument
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "search-form",
    attrs: {
      "aria-label": "Formulaire de recherche",
      "novalidate": ""
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('div', {
    staticClass: "search-form__wrapper"
  }, [_c('svg', {
    staticClass: "search-form__icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m21 21-4.35-4.35"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-form__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "aria-label": "Champ de recherche"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.searchQuery) ? _c('button', {
    staticClass: "search-form__clear",
    attrs: {
      "type": "button",
      "aria-label": "Effacer la recherche"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-prospect"
  }, [_c('h2', {
    staticClass: "dashboard-title dashboard-title--medium"
  }, [_vm._v("Parcours prospects")]), _vm._v(" "), _c('div', {
    staticClass: "board-prospect__searchbar"
  }, [_c('SearchForm', {
    attrs: {
      "placeholder": "Rechercher un prospect..."
    },
    on: {
      "search": _vm.handleSearch,
      "clear": _vm.handleClearSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "dashboard-btn dashboard-btn--primary",
    on: {
      "click": _vm.openAddContactModal
    }
  }, [_vm._v("\n\t\t\tNouveau prospect\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "board-prospect__steps"
  }, [_c('BoardProspectSteps', {
    attrs: {
      "search-query": _vm.searchQuery
    }
  })], 1), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showAddContact,
      "content": _vm.contentModal,
      "data": _vm.modalData
    },
    on: {
      "close": _vm.closeAddContactModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('lien')
    }
  }, [_c('label', {
    attrs: {
      "for": "lien"
    }
  }, [_vm._v("Lien de l'article")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.news.link),
      expression: "news.link"
    }],
    attrs: {
      "type": "text",
      "name": "lien"
    },
    domProps: {
      "value": (_vm.news.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.news, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('lien')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('lien')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('titre')
    }
  }, [_c('label', {
    attrs: {
      "for": "titre"
    }
  }, [_vm._v("Titre de l'article")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.news.title),
      expression: "news.title"
    }],
    attrs: {
      "type": "text",
      "name": "titre"
    },
    domProps: {
      "value": (_vm.news.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.news, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('titre')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('titre')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('description')
    }
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.news.body),
      expression: "news.body"
    }],
    attrs: {
      "type": "text",
      "name": "description"
    },
    domProps: {
      "value": (_vm.news.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.news, "body", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('description')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('description')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('lien de l\'image')
    }
  }, [_c('label', {
    attrs: {
      "for": "lien de l\\'image"
    }
  }, [_vm._v("Lien de l'image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.news.link_image),
      expression: "news.link_image"
    }],
    attrs: {
      "type": "text",
      "name": "lien de l'image"
    },
    domProps: {
      "value": (_vm.news.link_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.news, "link_image", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('lien de l\'image')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('lien de l\'image')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags-selector"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tSélectionnez les tags correspondants à l'article (3 max)\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "tag",
      class: {
        active: _vm.isSelectedTag(tag.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(tag.wordpress_tag_name) + "\n\t\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.share
    }
  }, [_vm._v("Diffuser")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\tDiffuser un article\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\tPartager un article à vos clients\n\t\t\t")])])
}]}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card-calendar dashboard-card dashboard-card--bordered dashboard-card--hoverable"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.item.clientId
        }
      }
    }
  }, [_c('div', {
    staticClass: "card-calendar__wrapper"
  }, [_c('div', {
    staticClass: "card-calendar__time"
  }, [_c('img', {
    staticClass: "card-calendar__icon",
    attrs: {
      "src": _vm.IconClock,
      "alt": ""
    }
  }), _vm._v(" "), _c('time', {
    attrs: {
      "datetime": _vm.item.datetime || ''
    }
  }, [_vm._v(_vm._s(_vm.$moment(_vm.item.hour.start).format('HH:mm')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-calendar__content"
  }, [_c('div', {
    staticClass: "card-calendar__header"
  }, [_c('h4', {
    staticClass: "dashboard-card__name"
  }, [_vm._v(_vm._s(_vm.item.customer))]), _vm._v(" "), _c('span', {
    staticClass: "card-calendar__type-badge",
    class: _vm.getTypeBadgeClass(_vm.item.type)
  }, [_vm._v(_vm._s(_vm.item.type))])]), _vm._v(" "), _c('p', {
    staticClass: "card-calendar__subject"
  }, [_vm._v(_vm._s(_vm.item.description))])]), _vm._v(" "), _c('svg', {
    staticClass: "dashboard-card__arrow",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "body-modal"
  }, [_c('div', {
    staticClass: "title-gold"
  }, [_vm._v("\n      Informations Légales - Personne Morale\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fermer")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-standard"
  }, [_c('p', [_vm._v("Conformément aux principes de la loi du 6 janvier 1978 relative à l'informatique aux fichiers et aux libertés modifié par le décret n°2019-536 ainsi qu'au règlement général à la protection des données entrée en vigueur le 25 mai 2018 nous vous rappelons que la présente collecte d'information ainsi que leur exploitation sont effectuées dans votre intérêt et ont pour finalité de permettre au professionnel d'établir un profil de risque dans le but de fournir un conseil adapté à votre problématique.")]), _vm._v(" "), _c('p', [_vm._v("La qualité de son travail dépendra étroitement de la véracité, de l'exactitude et de l'exhaustivité de vos réponses à ce questionnaire.")]), _vm._v(" "), _c('p', [_vm._v("Si vous ne communiquez pas les informations requises, votre conseiller ne pourra pas poursuivre sa mission et devra s'abstenir de vous recommander les opérations, instruments et services relevant de son activité CIF.")]), _vm._v(" "), _c('p', [_vm._v("Il ne pourra vous fournir qu'une prestation d'information ou de recherche, une mission relevant d'un autre métier réglementé ou de la sphère non financière.")]), _vm._v(" "), _c('p', [_vm._v("Vous reconnaissez avoir connaissance des tarifs de votre conseiller, de ses méthodes de travail et avoir en votre possession sa fiche d'information légale ANACOFI.")]), _vm._v(" "), _c('p', [_vm._v("Votre conseiller s'est engagé au respect de règles de bonne conduite incluant le secret professionnel et la protection de vos données personnelles.")]), _vm._v(" "), _c('p', [_vm._v("Les informations recueillies sont enregistrées dans un fichier informatisé par Patrimoffice afin notamment de pouvoir proposer des produits et services de qualité personnalisés et adaptés à chaque situation patrimoniale, besoin et objectif recherché, se conformer à ses obligations légales et règlementaires et exercer son activité de conseil et de suivi au mieux des intérêts des clients. Elles sont conservées pendant la durée de la relation contractuelle et pendant 5 ans à l'issue de la relation et sont destinées aux établissements dépositaires ou compagnies d'assurance à partenaires de Patrimoffice, et le cas échéant à son prestataire de services informatiques. Ces données ne font l'objet d'aucune transmission à des organismes extérieurs notamment à des fins de prospection commerciale sans l'accord du client.")]), _vm._v(" "), _c('p', [_vm._v("Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès, d'opposition, d'effacement, de limitation du traitement, de portabilité des données vous concernant et les faire rectifier en contactant notre service de traitement des données à contact@patrimoffice.com. Vous pouvez également introduire une réclamation au sujet du traitement de vos données auprès de la CNIL.")]), _vm._v(" "), _c('div', {
    staticClass: "title-grey"
  }, [_vm._v("\n        Obligations spécifiques aux personnes morales\n      ")]), _vm._v(" "), _c('p', [_vm._v("Dans le cadre de la lutte contre le blanchiment de capitaux et le financement du terrorisme (LCB-FT), les informations relatives à la société, ses dirigeants et bénéficiaires effectifs sont obligatoires.")]), _vm._v(" "), _c('p', [_vm._v("Les documents justificatifs demandés (K-bis de moins de 3 mois, statuts, bilan/compte de résultat) sont nécessaires pour la conformité réglementaire et doivent être transmis avant toute opération d'investissement.")]), _vm._v(" "), _c('p', [_vm._v("Le représentant légal signataire certifie disposer des pouvoirs nécessaires pour engager la société et garantit l'exactitude des informations communiquées.")])])
}]}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-legals column"
  }, [(!_vm.isUser) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_c('logo')], 1) : _c('div', {
    staticClass: "ctn-header"
  }, [_c('my-header', {
    attrs: {
      "menu": _vm.menu,
      "notif": false,
      "help": true
    },
    on: {
      "notif-open": function($event) {
        _vm.notifPanelActive = true
      }
    }
  })], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.isUser) ? _c('my-footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-input-date row"
  }, [_c('custom-select', {
    attrs: {
      "items": _vm.days,
      "solo": true
    },
    model: {
      value: (_vm.day),
      callback: function($$v) {
        _vm.day = $$v
      },
      expression: "day"
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.months,
      "solo": true
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.years,
      "solo": true
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.autodestroy) ? _c('div', {
    staticClass: "notif-bar row",
    class: _vm.type
  }, [_c('div', {
    staticClass: "sprt"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.autodestroy = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-close"
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-icon"
  }, [_c('span', {
    staticClass: "icon-bandeau-alert"
  })])
}]}

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous une épargne ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isSavings
    },
    on: {
      "change": function($event) {
        _vm.isSavings = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.isSavings) ? _c('div', [_c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "object": true,
      "items": _vm.savingsData,
      "selected": _vm.typeToAdd
    },
    on: {
      "change": function($event) {
        _vm.typeToAdd = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addSaving
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-childrens"
  }, _vm._l((_vm.savingsRow), function(saving, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(saving.type) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeSaving(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('montant' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'montant' + (key + 1)
      }
    }, [_vm._v("Montant actuel")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.value),
        expression: "saving.fields.value"
      }],
      key: 'amount' + key,
      attrs: {
        "type": "text",
        "name": 'montant' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": saving.fields.currency
      },
      on: {
        "change": function($event) {
          saving.fields.currency = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('montant' + (key + 1))))])]), _vm._v(" "), (saving.fields.opening_date != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('date d\'ouverture' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'date d\'ouverture' + (key + 1)
      }
    }, [_vm._v("Date d'ouverture")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.opening_date),
        expression: "saving.fields.opening_date"
      }],
      key: 'opening' + key,
      attrs: {
        "type": "date",
        "name": 'date d\'ouverture' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.opening_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "opening_date", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('date d\'ouverture' + (key + 1))))])]) : _vm._e(), _vm._v(" "), (saving.fields.ownership_type != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label"
    }, [_c('label', [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.ownershipTypes
      },
      model: {
        value: (saving.fields.ownership_type),
        callback: function($$v) {
          _vm.$set(saving.fields, "ownership_type", $$v)
        },
        expression: "saving.fields.ownership_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    })]) : _vm._e(), _vm._v(" "), (saving.fields.investment_name != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom de l\'investissement' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "nom de l'investissement"
      }
    }, [_vm._v("Nom du contrat")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.investment_name),
        expression: "saving.fields.investment_name"
      }],
      key: 'investmentName' + key,
      attrs: {
        "type": "text",
        "name": 'nom de l\'investissement' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.investment_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "investment_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('nom de l\'investissement' + (key + 1))))])]) : _vm._e(), _vm._v(" "), (saving.fields.bank_name != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom de la banque' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "nom d la banque"
      }
    }, [_vm._v("Nom de l'établissement")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.bank_name),
        expression: "saving.fields.bank_name"
      }],
      key: 'bankName' + key,
      attrs: {
        "type": "text",
        "name": 'nom de la banque' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.bank_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "bank_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('nom de la banque' + (key + 1))))])]) : _vm._e()])
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-input",
    class: {
      active: _vm.custom
    },
    on: {
      "click": _vm.changeValue
    }
  }, [_c('div', {
    staticClass: "button"
  })])
},staticRenderFns: []}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tEtes-vous intéressé par des critères de durabilité ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.interestedBySustainability
    },
    on: {
      "change": function($event) {
        return _vm.changeInterestedBySustainability($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.interestedBySustainability) ? _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.durabilites), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(tag),
        locked: _vm.isLocked(tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tÊtes-vous prêt à accepter des performances moindres en cas d'investissements ESG ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.acceptLowerPerformance
    },
    on: {
      "change": function($event) {
        return _vm.changeAcceptLowerPerformance($event)
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tAvez vous des enfants ou petits enfants ?\n\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isChilds
    },
    on: {
      "change": function($event) {
        return _vm.changeChilds($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isChilds) ? _c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.typeChild,
      "selected": _vm.typeToAdd
    },
    on: {
      "change": function($event) {
        _vm.typeToAdd = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addChild
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isChilds) ? _c('div', {
    staticClass: "ctn-childrens"
  }, _vm._l((_vm.listOfChild), function(child, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(child.type) + " " + _vm._s(key + 1) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeChild(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('prénom' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "prénom"
      }
    }, [_vm._v("Prénom")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.firstname),
        expression: "child.firstname"
      }],
      key: 'childfn-' + key,
      attrs: {
        "type": "text",
        "name": 'prénom' + (key + 1)
      },
      domProps: {
        "value": (child.firstname)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "firstname", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('prénom' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "nom"
      }
    }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.lastname),
        expression: "child.lastname"
      }],
      key: 'childln-' + key,
      attrs: {
        "type": "text",
        "name": 'nom' + (key + 1)
      },
      domProps: {
        "value": (child.lastname)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "lastname", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('nom' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('date de naissance' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "date de naissance"
      }
    }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.dateOfBirth),
        expression: "child.dateOfBirth"
      }],
      key: 'childbd-' + key,
      attrs: {
        "type": "date",
        "name": 'date de naissance' + (key + 1)
      },
      domProps: {
        "value": (child.dateOfBirth)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "dateOfBirth", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('date de naissance' + (key + 1))))])])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('date de naissance')
    }
  }, [_c('label', {
    attrs: {
      "for": "date de naissance"
    }
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.birthdate),
      expression: "birthdate"
    }],
    attrs: {
      "type": "date",
      "name": "date de naissance"
    },
    domProps: {
      "value": (_vm.birthdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.birthdate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('date de naissance')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('métier')
    }
  }, [_c('label', {
    attrs: {
      "for": "métier"
    }
  }, [_vm._v("Métier *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.job),
      expression: "job"
    }],
    attrs: {
      "type": "text",
      "name": "métier"
    },
    domProps: {
      "value": (_vm.job)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.job = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('métier')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('catégorie professionnelle')
    }
  }, [_c('label', {
    attrs: {
      "for": "catégorie professionnelle"
    }
  }, [_vm._v("Catégorie Professionnelle")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select'),
      expression: "'required|select'"
    }],
    attrs: {
      "name": "catégorie professionnelle",
      "items": _vm.cspList,
      "selected": _vm.csp
    },
    on: {
      "change": function($event) {
        _vm.csp = $event
      }
    },
    model: {
      value: (_vm.csp),
      callback: function($$v) {
        _vm.csp = $$v
      },
      expression: "csp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('catégorie professionnelle')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('statut matrimonial')
    }
  }, [_c('label', {
    attrs: {
      "for": "catégorie professionnelle"
    }
  }, [_vm._v("Statut Matrimonial")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select'),
      expression: "'required|select'"
    }],
    attrs: {
      "name": "statut matrimonial",
      "items": _vm.maritalStatusList,
      "selected": _vm.maritalStatus
    },
    on: {
      "change": function($event) {
        _vm.maritalStatus = $event
      }
    },
    model: {
      value: (_vm.maritalStatus),
      callback: function($$v) {
        _vm.maritalStatus = $$v
      },
      expression: "maritalStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('statut matrimonial')))])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asterisk-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("\n\t\t\t\t* Votre profession actuelle ou métier exercé avant votre départ en retraite\n\t\t\t")])])
}]}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "body-modal"
  }, [_c('div', {
    staticClass: "title-gold"
  }, [_vm._v("\n\t\t\tVous avez émis le souhait d'obtenir une réponse d'un professinnel contrôlé exerçant une activité réglementée\n\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title-grey"
  }, [_vm._v("\n\t\t\tNouveau\n\t\t")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fermer")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-standard"
  }, [_c('p', [_vm._v("Conformément aux principes de la loi du 6 janvier 1978 relative à l’informatique aux fichiers et aux libertés nous vous rappelons que la présente collecte d’information ainsi que leur exploitation sont effectuées dans votre intérêt et ont pour finalité de permettre au professionnel de fournir un conseil adapté à votre problématique.")]), _vm._v(" "), _c('p', [_vm._v("La qualité de son travail dépendra étroitement de la véracité, de l’exactitude et de l’exhaustivité de vos réponses à ce questionnaire.")]), _vm._v(" "), _c('p', [_vm._v("Si vous ne communiquez pas les informations requises, votre conseiller ne pourra pas poursuivre sa mission et devra s’abstenir de vous recommander les opérations, instruments et services relevant de son activité CIF. Il ne pourra vous fournir qu’une prestation d’information ou de recherche, une mission relevant d’un autre métier réglementé ou de la sphère non financière.")]), _vm._v(" "), _c('p', [_vm._v("Votre conseiller s’est engagé au respect de règles de bonne conduite incluant le secret professionnel et la protection de vos données personnelles.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-standard"
  }, [_c('p', [_vm._v("Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé.")]), _vm._v(" "), _c('p', [_vm._v("Elles sont conservées pendant [durée_de_conservation] et sont destinées [destinataires_des_données]")]), _vm._v(" "), _c('p', [_vm._v("Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : [service_chargé_du_droit_d’acces : Nom, adresse électronique et/ou postale]")]), _vm._v(" "), _c('p', [_vm._v("Vous reconnaissez avoir connaissance des tarifs de votre conseiller, de ses méthodes de travail et avoir en votre possession sa fiche d’information légale ANACOFI-CIF.\"")])])
}]}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "top"
  }, [(_vm.isAnonymous && !_vm.showAnonymousCtaModal) ? _c('p', {
    staticClass: "msg-success"
  }, [_c('span', {
    staticClass: "icon-check"
  }), _vm._v(" Bravo ! vous venez de finaliser votre paysage patrimonial, vous pouvez maintenant le télécharger.\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isAnonymous || !_vm.showAnonymousCtaModal) ? [_c('div', {
    staticClass: "label solo bold"
  }, [_vm._v("\n            Je confirme que les informations renseignées sont exactes\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('custom-toggle', {
    attrs: {
      "value": _vm.isSign
    },
    on: {
      "change": function($event) {
        _vm.isSign = $event
      }
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.isAdvisor) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        En cliquant sur \"Demande de signature électronique\" un e-mail sera envoyé au client lui permettant de signer électroniquement le paysage patrimonial que vous avez completé\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.isAdvisor && !_vm.isAnonymous) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        En cliquant sur “Signer” vous allez être redirigé vers notre module de signature électronique afin de valider la saisie de votre paysage patrimonial.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isAnonymous && _vm.showAnonymousCtaModal) ? _c('div', {
    staticClass: "column text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "subtitle text-center"
  }, [_vm._v("\n          Ainsi que d'un essai gratuit d'un mois\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'AnonymousUpgrade'
      }
    }
  }, [_vm._v("\n          Compléter mon inscription "), _c('i', {
    staticClass: "icon-arrow-full-right"
  })])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.signaturePopupBlocked) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "alert-wrapper row"
  }, [_c('span', {
    staticClass: "icon icon-alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-content column"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tVotre navigateur a pu bloquer la fenêtre d’accès à la signature.\n\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tC'est courant, cliquez sur le bouton à droite pour accéder au service de signature.\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showUnlockPopupTuto = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir les instructions\n\t\t\t\t\t\t")])])]) : _vm._e()]), _vm._v(" "), (_vm.showUnlockPopupTuto) ? _c('unlock-signature-popup-tutorial', {
    on: {
      "close": function($event) {
        _vm.showUnlockPopupTuto = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Complétez votre inscription pour bénéficier"), _c('br'), _vm._v("\n          de toutes les fonctionnalités Patrimoffice\n        ")])
}]}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ctn-link row"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Cgu'
      }
    }
  }, [_vm._v("Conditions générales d'utilisation")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Conditions générales de vente")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Legals'
      }
    }
  }, [_vm._v("Mentions légales")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Confidentiality'
      }
    }
  }, [_vm._v("Politique de confidentialité")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t© " + _vm._s(_vm.year) + " Patrimoffice. Tous droits réservés.\n\t\t")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_vm._v("\n  \tDocuments Privés\n\t\t"), _c('div', {
    staticClass: "ctn-docs row"
  }, _vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "subview-container column client"
  }, [_c('notifications', {
    attrs: {
      "classes": "master-notifications",
      "position": "top left",
      "group": "default"
    }
  }), _vm._v(" "), (_vm.client.certified === 'NOT CERTIFIED') ? _c('div', {
    staticClass: "contentrow alone certified row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.certified = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-contact"
  }), _vm._v("\n\t\t\t\tLancer la vérification\n\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.client.certified === 'PENDING') ? _c('div', {
    staticClass: "contentrow alone certified row"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "half head-profil row"
  }, [_c('router-link', {
    staticClass: "btn btn-red small",
    attrs: {
      "to": {
        name: 'Contacts'
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.profilePicture,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-info-name column"
  }, [_c('div', {
    staticClass: "name bold row"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname) + " "), (_vm.client.certified === 'CERTIFIED') ? _c('img', {
    attrs: {
      "src": _vm.good,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subscribed"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s((_vm.client.type === 'client_subscriber') ? 'Client' : 'Prospect') + "\n\t\t\t\t\t")]), _vm._v(" "), (!_vm.client.lcbft_completed) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.lcbcft = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-warning"
  }), _vm._v("\n\t\t\t\t\t\tRemplir le formulaire LCB-FT\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta column"
  }, [_c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'ChatClient'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tConversations\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.takeAppointment = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-rdv"
  }), _vm._v("\n\t\t\t\t\t\tPlanifier un RDV\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "half notes"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        return _vm.launchNoteModal(true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNouvelle note\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding"
  }, [(!_vm.client.notes || _vm.client.notes.length === 0) ? _c('div', {
    staticClass: "no-notes empty"
  }, [_vm._v("\n\t\t\t\t\t\tPrenez quelques note sur votre client en cliquant sur « Nouvelle note »\n\t\t\t\t\t")]) : _c('div', {
    staticClass: "notes row"
  }, _vm._l((_vm.client.notes), function(note) {
    return _c('div', {
      staticClass: "note row",
      on: {
        "click": function($event) {
          return _vm.launchNoteModal(false, note)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(note.title) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(note.created_at.split(' ')[0]) + "\n\t\t\t\t\t\t\t")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow alone row"
  }, [(_vm.client.investment_stats && !Array.isArray(_vm.client.investment_stats)) ? [_c('div', {
    staticClass: "info-value row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tMontant investi\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("format_currency")(_vm.client.investment_stats.amount_invested, '€')) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "info-value row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tAvoirs\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("format_currency")(_vm.client.investment_stats.my_assets, '€')) + "\n\t\t\t\t")])]), _vm._v(" "), (!_vm.client.investment_stats.hide_performance) ? _c('div', {
    staticClass: "info-value row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tPerformance globale\n\t\t\t\t")]), _vm._v(" "), (_vm.client.investment_stats.global_performance) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("format_performance")(_vm.client.investment_stats.global_performance)) + "%\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [(_vm.client.investment_stats.global_performance >= 0) ? _c('img', {
    attrs: {
      "src": _vm.highIcon,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.downIcon,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-edit"
  }), _vm._v(" Agrégation manuelle\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'InvestmentsClient',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-situation"
  }), _vm._v(" Situation détaillée\n          ")])], 1)])] : [_c('div', {
    staticClass: "no-investments column"
  }, [_c('p', [_vm._v("\n          Votre client n'a pas encore investit\n        ")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-edit"
  }), _vm._v(" Agrégation manuelle\n          ")])], 1)])]], 2), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "half story"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "add row"
  }, [(_vm.client.lcbft_completed) ? _c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'MyTransactionsAdd'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNouvelle Opération\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'TransactionsTable'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir tout\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "boding"
  }, [(_vm.client.missions.length === 0) ? _c('div', {
    staticClass: "no-story empty"
  }, [_vm._v("\n\t\t\t\t\t\tAucune opérations enregistrée.\n\t\t\t\t\t\t"), (!_vm.client.lcbft_completed) ? _c('div', [_vm._v("\n\t\t\t\t\t\t\tRemplissez le formulaire LCBC-FT de votre client"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tavant de créer une nouvelle opérations\n\t\t\t\t\t\t")]) : _vm._e()]) : _c('div', {
    staticClass: "stories"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "stories-body column"
  }, _vm._l((_vm.client.missions), function(mission, key) {
    return _c('div', {
      key: key,
      staticClass: "stories-row row"
    }, [_c('div', {
      staticClass: "stories-column"
    }, [_vm._v(_vm._s(mission.title))]), _vm._v(" "), _c('div', {
      staticClass: "stories-column",
      domProps: {
        "innerHTML": _vm._s(_vm.getMissionDoc(mission, 'Lettre de mission'))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "stories-column",
      domProps: {
        "innerHTML": _vm._s(_vm.getMissionDoc(mission, 'Rapport de mission'))
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "stories-column",
      attrs: {
        "to": {
          name: 'MyTransactionsEdit',
          params: {
            id: mission.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "icon-eye"
    })])], 1)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "half docs column"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir tous les documents\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(_vm.lastDocuments.length === 0) ? _c('div', {
    staticClass: "no-docs empty"
  }, [_c('br'), _vm._v("Aucun documents disponibles"), _c('br'), _c('br')]) : _c('div', {
    staticClass: "docs row"
  }, _vm._l((_vm.lastDocuments), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "inner-row row"
  }, [_c('div', {
    staticClass: "half infos"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        _vm.modals.editClient = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" ID client ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" #" + _vm._s(_vm.client.id))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" Nom complet ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.client.birthdate, 'DD MMMM YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.phone || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.email || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse postal")]), _vm._v(" "), (_vm.client.address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.address.line || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Ville")]), _vm._v(" "), (_vm.client.address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.address.city || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Code postal")]), _vm._v(" "), (_vm.client.address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.address.zip || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column info tags"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Centres d'intérêts")]), _vm._v(" "), _c('div', {
    staticClass: "value row ctn-tags"
  }, _vm._l((_vm.client.center_of_interest), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag"
    }, [_vm._v("\n                  " + _vm._s(tag.wordpress_tag_name) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "half infos patrimoine column"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "add row"
  }, [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'PatrimonialLandscape',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tVoir\n\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(!_vm.estate.birthdate) ? _c('div', {
    staticClass: "no-patrimoine empty column"
  }, [_vm._v("\n\t\t\t\t\t\t\tVotre client doit remplir "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tson Paysage Patrimonial pour "), _c('br'), _vm._v("\n\t\t\t\t\t\t \tpouvoir commencer à investir.\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.sendRelance
    }
  }, [_c('span', {
    staticClass: "icon-button-relance"
  }), _vm._v("\n\t\t\t\t\t\t\t\tEnvoyer une relance\n\t\t\t\t\t\t\t")])]) : _c('div', {
    staticClass: "patrimoines take-place"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.patrimonialConsistency = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-warning"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\tVérification de la complétude et de la cohérence des informations fournies par le client\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.computedAge(_vm.estate.birthdate) + ' ans' || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Métier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.job || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CSP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.csp || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Enfants")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.childs.length) + " à charge")])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Revenu annuel")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.incomes || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Immobilier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.immobilier || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Epargne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.savings || '-'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-row row"
  }, [_c('div', {
    staticClass: "half column appointment"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(8), _vm._v(" "), (_vm.client.rdvs.length > 0) ? _c('div', {
    staticClass: "add"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "boding column row"
  }, [_vm._m(9), _vm._v(" "), (_vm.client.rdvs.length === 0) ? _c('div', {
    staticClass: "no-appointment empty row"
  }, [_vm._v("\n\t\t\t\t\t\t\tPlanifiez votre première rencontre en cliquant sur \"Planifier un RDV\"\n\t\t\t\t\t\t")]) : _c('div', {
    staticClass: "appointments column"
  }, _vm._l((_vm.client.rdvs), function(rdv) {
    return _c('div', {
      staticClass: "ctn-appointment"
    }, [_c('div', {
      staticClass: "appointment-head row"
    }, [_c('div', {
      staticClass: "pastille",
      class: _vm.classResolver(rdv.type)
    }), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(rdv.type))])]), _vm._v(" "), _c('div', {
      staticClass: "appointment-body row"
    }, [_c('div', {
      staticClass: "date",
      domProps: {
        "innerHTML": _vm._s(_vm.dateResolver(rdv))
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "half column flex-start"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.saveSelectedCountries
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEnregistrer\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding column row countries-form"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countrySearch),
      expression: "countrySearch"
    }],
    staticClass: "country-search-input",
    attrs: {
      "type": "text",
      "placeholder": "Rechercher un pays..."
    },
    domProps: {
      "value": (_vm.countrySearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.countrySearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "countries-list"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      key: country.ISO2,
      staticClass: "country-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCountries),
        expression: "selectedCountries"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'country-' + country.ISO2
      },
      domProps: {
        "value": country.ISO2,
        "checked": Array.isArray(_vm.selectedCountries) ? _vm._i(_vm.selectedCountries, country.ISO2) > -1 : (_vm.selectedCountries)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCountries,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = country.ISO2,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCountries = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCountries = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCountries = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'country-' + country.fr
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(country.fr) + "\n\t\t\t\t\t\t\t\t")])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "half infos company-info-section"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        _vm.modals.companyInfo = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir / Éditer\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(!_vm.companyInfo || !_vm.companyInfo.company_name) ? _c('div', {
    staticClass: "no-company-info empty column"
  }, [_vm._v("\n\t\t\t\t\t\tLes informations de la société"), _c('br'), _vm._v("\n\t\t\t\t\t\tdoivent être complétées pour"), _c('br'), _vm._v("\n\t\t\t\t\t\tles clients personnes morales.\n\t\t\t\t\t\t"), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.companyInfo = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-warning"
  }), _vm._v("\n\t\t\t\t\t\t\tCompléter les informations\n\t\t\t\t\t\t")])]) : _c('div', {
    staticClass: "company-infos take-place"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Société")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.company_name || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("N° immatriculation")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.registration_number || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Régime fiscal")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.tax_regime || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Activité(s)")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.activities || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Dirigeant(s)")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatManagers(_vm.companyInfo.managers) || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Bénéficiaire(s) effectif(s)")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatManagers(_vm.companyInfo.beneficiaries) || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" Documents transmis")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatDocument(_vm.companyInfo.documents_confirmed) || '-'))])])])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.newNote,
      "data": _vm.modals.dataNote,
      "content": _vm.modalNewNote
    },
    on: {
      "close": function($event) {
        _vm.modals.newNote = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.editClient,
      "data": _vm.client,
      "content": _vm.modalEditClient
    },
    on: {
      "close": function($event) {
        _vm.modals.editClient = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.lcbcft,
      "content": _vm.modalLCBCFT
    },
    on: {
      "close": function($event) {
        _vm.modals.lcbcft = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.patrimonialConsistency,
      "content": _vm.modalPatrimonialConsistency
    },
    on: {
      "close": function($event) {
        _vm.modals.patrimonialConsistency = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.takeAppointment,
      "data": _vm.client,
      "content": _vm.modalTakeAppointment
    },
    on: {
      "close": function($event) {
        _vm.modals.takeAppointment = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.certified,
      "data": _vm.client,
      "content": _vm.modalCertified
    },
    on: {
      "close": _vm.handleCloseCertified
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.companyInfo,
      "data": _vm.client,
      "content": _vm.modalCompanyInformation
    },
    on: {
      "close": _vm.handleCloseCompanyInfo
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content row"
  }, [_c('span', {
    staticClass: "icon-alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tIdentité non vérifiée\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t\tLa vérification d'identité est impérative pour la signature des documents de mission\n\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content row"
  }, [_c('span', {
    staticClass: "icon-alert orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tVérification d'identité en cours\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t\tLa vérification d'identité est impérative pour la signature des documents de mission\n\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-note"
  }), _vm._v("\n\t\t\t\t\t\tAjout de notes\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-history"
  }), _vm._v("\n\t\t\t\t\t\tHistorique\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stories-header row"
  }, [_c('div', {
    staticClass: "stories-column"
  }, [_vm._v("Nom")]), _vm._v(" "), _c('div', {
    staticClass: "stories-column"
  }, [_vm._v("Lettre de mission")]), _vm._v(" "), _c('div', {
    staticClass: "stories-column"
  }, [_vm._v("Compte rendu de mission")]), _vm._v(" "), _c('div', {
    staticClass: "stories-column"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-docs"
  }), _vm._v("\n\t\t\t\t\t\tDocuments récents\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-info"
  }), _vm._v("\n\t\t\t\t\t\t\tInformations\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-paysage"
  }), _vm._v("\n\t\t\t\t\t\t\tPaysage Patrimonial\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-calandar"
  }), _vm._v("\n\t\t\t\t\t\t\tRendez-vous\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next row"
  }, [_vm._v("\n\t\t\t\t\t\t\tProchain rendez-vous\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-calandar"
  }), _vm._v("\n\t\t\t\t\t\t\tOù sont ses placements ?\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-info"
  }), _vm._v("\n\t\t\t\t\t\tInformations Société\n\t\t\t\t\t")])
}]}

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [(!_vm.isAnonymous) ? [_c('div', {
    staticClass: "asterisk-container"
  }, [_vm._v("\n\t\t\tSi vous êtes assujetti à l’IFI (Impôt sur la Fortune Immobilière) et pour gagner du temps, vous pouvez télécharger directement votre dernière déclaration d’IFI\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row start"
  }, [_c('div', {
    staticClass: "btn btn-red ctn-icon light",
    on: {
      "click": _vm.fileInput
    }
  }, [_c('span', {
    staticClass: "icon-button-add"
  }), _vm._v("\n\t\t\t\tTélécharger\n\t\t\t\t"), _c('input', {
    attrs: {
      "id": "input-file",
      "type": "file"
    },
    on: {
      "change": _vm.setFile
    }
  })]), _vm._v(" "), (_vm.file) ? _c('div', {
    staticClass: "filename"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.file.name) + "\n\t\t\t")]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.currency
    },
    on: {
      "change": function($event) {
        _vm.currency = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column no-header",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-login"
  }), _vm._v(" "), _c('div', {
    staticClass: "login subscribe active maintenance"
  }, [_c('div', {
    staticClass: "w-100 text-center"
  }, [_c('logo')], 1), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('h1', [_vm._v("Page Introuvable")]), _vm._v(" "), _c('p', [_vm._v("La page que vous demandé est actuellement introuvable")])])
}]}

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-missions"
  }, [_vm._l((_vm.missionsWithDocuments), function(mission, key) {
    return _c('div', {
      key: key,
      staticClass: "mission"
    }, [_c('div', {
      staticClass: "mission-name"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(mission.title) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "ctn-docs row"
    }, _vm._l((mission.documents), function(doc, keyt) {
      return _c('tile-doc', {
        key: keyt,
        attrs: {
          "doc": doc
        }
      })
    }), 1), _vm._v(" "), (mission.documents.length === 0) ? _c('div', {
      staticClass: "no-docs"
    }, [_vm._v("\n\t\t\t\tPas de documents pour le moment\n\t\t\t")]) : _vm._e()])
  }), _vm._v(" "), (_vm.othersDocs && _vm.othersDocs.length > 0) ? _c('div', {
    staticClass: "mission"
  }, [_c('div', {
    staticClass: "mission-name"
  }, [_vm._v("\n\t\t\t\tAutres\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, _vm._l((_vm.othersDocs), function(doc, keyt) {
    return _c('tile-doc', {
      key: keyt,
      attrs: {
        "doc": doc
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.missions.length === 0) ? _c('div', {
    staticClass: "no-missions"
  }, [_vm._v("\n\t\t\tPas de missions pour le moment\n\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exchanges column"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "exchange-part row"
  }, [_c('div', {
    staticClass: "ctn-list-exchange column"
  }, [_c('div', {
    staticClass: "lists-exchange"
  }, [_vm._l((_vm.threads), function(thread, key) {
    return _c('div', {
      key: key,
      staticClass: "exchange",
      class: {
        active: thread === _vm.currentThread
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentThread(thread.id)
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(thread.created_at) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "subject"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(thread.title) + "\n\t\t\t\t\t")])])
  }), _vm._v(" "), (!_vm.threads.length) ? _c('div', {
    staticClass: "exchange"
  }, [_vm._v("\n\t\t\t\t\tIl n'y a pas encore de conversation.\n\t\t\t\t")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "exchange-content column"
  }, [_c('div', {
    staticClass: "content-head row"
  }, [_c('div', {
    staticClass: "subject"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.currentThread.title) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.emitNewThread
    }
  }, [_vm._v("\n\t\t\t\t\t\tNouveau message\n\t\t\t\t\t")]), _vm._v(" "), (_vm.currentThreadId) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.emitNewMessage
    }
  }, [_vm._v("\n\t\t\t\t\t\tRépondre\n\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-body"
  }, [_vm._l((_vm.currentThread.messages), function(message, key) {
    return _c('div', {
      key: key,
      staticClass: "message row"
    }, [_c('div', {
      staticClass: "ctn-profile-picture"
    }, [_c('img', {
      directives: [{
        name: "img-detect",
        rawName: "v-img-detect"
      }],
      attrs: {
        "src": _vm.resolveImg(message.user),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "body-message"
    }, [_c('div', {
      staticClass: "head-message row"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(message.created_at) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(message.user.first_name) + " " + _vm._s(message.user.last_name) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (message.body) ? _c('p', {
      staticClass: "inner-body-message"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(message.body) + "\n\t\t\t\t\t\t")]) : _c('p', {
      staticClass: "inner-body-message"
    }, [_c('span', [_vm._v(_vm._s(message.appointment_detail))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Jour(s) souhaités : " + _vm._s(_vm._f("arrayDisplay")(message.appointment_day)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Moment(s) de la journée souhaités : " + _vm._s(_vm._f("arrayDisplay")(message.appointment_moment)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Sujet(s) souhaités : " + _vm._s(_vm._f("arrayDisplay")(message.appointment_subject)))]), _c('br')])])])
  }), _vm._v(" "), (!_vm.currentThread.messages.length) ? _c('div', {
    staticClass: "take-place row"
  }, [_vm._v("\n\t\t\t\t\tIl n'y a aucun message\n\t\t\t\t")]) : _vm._e()], 2)])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showNewThread,
      "data": _vm.dataNewThread,
      "content": _vm.modalNewThread
    },
    on: {
      "close": function($event) {
        _vm.showNewThread = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showNewMessage,
      "data": _vm.dataNewMessage,
      "content": _vm.modalNewMessage
    },
    on: {
      "close": function($event) {
        _vm.showNewMessage = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [(!_vm.isAnonymous) ? [_c('div', {
    staticClass: "asterisk-container"
  }, [_vm._v("\n\t\t\tPour gagner du temps, vous pouvez télécharger directement votre dernier avis d’impôt sur le revenu\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row start"
  }, [_c('div', {
    staticClass: "btn btn-red ctn-icon light",
    on: {
      "click": _vm.fileInput
    }
  }, [_c('span', {
    staticClass: "icon-button-add"
  }), _vm._v("\n\t\t\t\tTélécharger\n\t\t\t\t"), _c('input', {
    attrs: {
      "id": "input-file",
      "type": "file"
    },
    on: {
      "change": _vm.setFile
    }
  })]), _vm._v(" "), (_vm.file) ? _c('div', {
    staticClass: "filename"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.file.name) + "\n\t\t\t")]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "keyup": _vm.parseAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.currency
    },
    on: {
      "change": function($event) {
        _vm.currency = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label row",
    class: {
      error: _vm.errors.has('nombre de parts')
    }
  }, [_c('label', {
    attrs: {
      "for": "nombre de parts"
    }
  }, [_vm._v("Nombre de parts fiscales de votre foyer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:1'),
      expression: "'decimal:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nbFiscalParts),
      expression: "nbFiscalParts"
    }],
    attrs: {
      "type": "text",
      "name": "nombre de parts"
    },
    domProps: {
      "value": (_vm.nbFiscalParts)
    },
    on: {
      "keyup": _vm.parsePartFiscale,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nbFiscalParts = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.errors.first('nombre de parts')) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('prénom')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Pays de rattachement fiscal")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "object": true,
      "items": _vm.countries,
      "selected": _vm.countryForTaxes
    },
    on: {
      "change": function($event) {
        _vm.countryForTaxes = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place master-transactions column"
  }, [_c('div', {
    staticClass: "white-box row ctn-transactions-reminder"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column labels"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t  \t\tVous avez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.operations.length) + " opération" + _vm._s((_vm.operations.length > 1) ? 's' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t  \tPour un total encours de "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("moneyFilter")(_vm.computedTotal)) + " €")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red ctn-icon",
    attrs: {
      "to": {
        name: 'MyTransactionsAdd'
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-new-mission"
  }), _vm._v("\n\t\t\tNouvelle opération\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\tOpérations d'investissements\n\t")]), _vm._v(" "), _c('keep-alive', [_c('ag-table', {
    attrs: {
      "rows": _vm.computedRows,
      "columns": _vm.cols,
      "customOptions": _vm.options
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-icon"
  }, [_c('span', {
    staticClass: "icon-operations-folder"
  })])
}]}

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place contacts-container column"
  }, [_c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "listing row"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.clients.length) + " client" + _vm._s((_vm.clients.length > 1) ? 's ' : ' ') + "\n\t\t\t")]), _vm._v(" "), (_vm.prospectInContacts > 0) ? _c('div', [_vm._v("\n\t\t\t\tdont " + _vm._s(_vm.prospectInContacts) + " prospect" + _vm._s((_vm.prospectInContacts > 1) ? 's' : '') + "\n\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddContact = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-contact"
  }), _vm._v(" Ajouter un contact\n\t\t\t")])])]), _vm._v(" "), _c('ag-table', {
    attrs: {
      "rows": _vm.clients,
      "columns": _vm.cols,
      "customOptions": _vm.options,
      "addSearch": true
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showAddContact,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddContact = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-patrimonial-landscape no-edit"
  }, [_c('div', {
    staticClass: "heading-sub-client row"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPaysage Patrimonial de " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname) + "\n\t\t\t")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('display')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('br')])
}]}

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\tNouveau message\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tRépondre à votre " + _vm._s((_vm.data.isAdvisor) ? 'client' : 'patrimofficer') + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui need-big"
  }, [_c('div', {
    staticClass: "form-elem-container in-modal"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-textarea ctn-label",
    class: {
      error: _vm.errors.has('body')
    }
  }, [_c('label', {
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "type": "text",
      "name": "body"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('body')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('body')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Envoyer")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tDISPLAY\n")])
},staticRenderFns: []}

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [_c('BoardHeader'), _vm._v(" "), _c('BoardCalendar'), _vm._v(" "), _c('BoardClientActions'), _vm._v(" "), _c('BoardProspect')], 1)
},staticRenderFns: []}

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('div', {
    staticClass: "ctn-docs row"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-prospect-steps"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "board-prospect-steps__loader"
  }, [_c('span', {
    staticClass: "board-prospect-steps__spinner"
  })]) : _c('div', {
    staticClass: "dashboard-kanban"
  }, _vm._l((_vm.colProspect), function(column) {
    return _c('div', {
      key: column.id,
      staticClass: "dashboard-kanban__column"
    }, [_c('header', {
      staticClass: "dashboard-kanban__header"
    }, [_c('img', {
      staticClass: "dashboard-card__icon dashboard-card__icon--small",
      attrs: {
        "src": column.icon,
        "alt": column.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dashboard-kanban__header-info"
    }, [_c('h3', {
      staticClass: "dashboard-kanban__title"
    }, [_vm._v(_vm._s(column.name))]), _vm._v(" "), _c('p', {
      staticClass: "dashboard-kanban__tagline"
    }, [_vm._v(_vm._s(column.tagline))])]), _vm._v(" "), _c('span', {
      staticClass: "dashboard-kanban__count"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.prospectsByColumn[column.id].length) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "dashboard-kanban__content"
    }, _vm._l((_vm.prospectsByColumn[column.id]), function(prospect) {
      return _c('CardProspect', {
        key: prospect.id,
        attrs: {
          "user": prospect
        },
        on: {
          "toggle-inscrit-partenaire": _vm.onToggleInscritPartenaire
        }
      })
    }), 1)])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tAvez-vous des crédits en cours ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isCredits
    },
    on: {
      "change": function($event) {
        _vm.isCredits = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.isCredits) ? _c('div', [_c('div', {
    staticClass: "form-elem-container ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tQuel est le pourcentage de votre taux d’endettement global selon vous ?\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-input"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.overallDebtPercentage),
      expression: "overallDebtPercentage"
    }],
    staticStyle: {
      "width": "150px",
      "border": "1px solid var(--input-grey)"
    },
    attrs: {
      "type": "text",
      "size": "10",
      "name": "overallDebtPercentage"
    },
    domProps: {
      "value": (_vm.overallDebtPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.overallDebtPercentage = $event.target.value
      }
    }
  }), _vm._v(" %\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-add-children ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tQuels sont vos crédits en cours ?\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "select-btn-container"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.typeOfLoan,
      "selected": _vm.currentLoanType
    },
    on: {
      "change": function($event) {
        _vm.currentLoanType = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addLoan
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-childrens"
  }, _vm._l((_vm.loans), function(child, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(child.type) + " " + _vm._s(key + 1) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeLoan(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('capital restant' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'capital restant' + (key + 1)
      }
    }, [_vm._v("Capital restant dû")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.value),
        expression: "child.value"
      }],
      key: 'amount' + key,
      attrs: {
        "type": "text",
        "name": 'capital restant' + (key + 1)
      },
      domProps: {
        "value": (child.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": child.currency
      },
      on: {
        "change": function($event) {
          child.currency = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('capital restant' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('mensualité' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'mensualité' + (key + 1)
      }
    }, [_vm._v("Mensualité")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.monthlyPayment),
        expression: "child.monthlyPayment"
      }],
      key: 'monthly' + key,
      attrs: {
        "type": "text",
        "name": 'mensualité' + (key + 1)
      },
      domProps: {
        "value": (child.monthlyPayment)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "monthlyPayment", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": child.currency
      },
      on: {
        "change": function($event) {
          child.currency = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('mensualité' + (key + 1))))])])])
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui need-big"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-textarea ctn-label column",
    class: {
      error: _vm.errors.has('message')
    }
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message d'absence")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "name": "message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('message')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.errors.first('message')) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Sauvegarder")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\tIndisponibilité\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\tAjouter un message d'absence pour vos clients\n\t\t")])])
}]}

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-doc column",
    on: {
      "click": _vm.download
    }
  }, [_c('div', {
    staticClass: "ctn-icon-document"
  }, [_c('img', {
    attrs: {
      "src": _vm.baseFile,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "extension"
  }, [_vm._v("." + _vm._s(_vm._f("uppercase")(_vm.doc.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.doc.original_name) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\tAjouté le " + _vm._s(_vm.doc.signature_date) + "\n\t")])])
},staticRenderFns: []}

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main demo-master"
  }, [_c('h1', [_vm._v("Demo Section")]), _vm._v(" "), _c('article', {
    staticClass: "content-demo"
  }, [_c('h2', [_vm._v("Icons")]), _vm._v(" "), _c('div', {
    staticClass: "content icons"
  }, _vm._l((_vm.icons), function(icon, key) {
    return _c('span', {
      class: _vm.generateIconName(icon),
      on: {
        "click": function($event) {
          return _vm.copyIcon(key)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "content-demo"
  }, [_c('h2', [_vm._v("Components")]), _vm._v(" "), _c('NotifBar', {
    attrs: {
      "type": "default",
      "title": "Demo",
      "text": "Lorem ipsum..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(" " + _vm._s(_vm.components.bar.default) + " ")]), _vm._v(" "), _c('NotifBar', {
    attrs: {
      "type": "warn",
      "title": "Demo",
      "text": "Lorem ipsum..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(" " + _vm._s(_vm.components.bar.warn) + " ")]), _vm._v(" "), _c('NotifBar', {
    attrs: {
      "type": "danger",
      "title": "Demo",
      "text": "Lorem ipsum..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(" " + _vm._s(_vm.components.bar.danger) + " ")])], 1), _vm._v(" "), _c('article', {
    staticClass: "content-demo"
  }, [_c('h2', [_vm._v("Form Kit")]), _vm._v(" "), _c('form', {
    staticClass: "form-ui default-form-ui",
    attrs: {
      "no-validate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    }
  })]), _vm._v(" "), (_vm.errors.has('name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-icon",
    class: {
      error: _vm.errors.has('search')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Recherche"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-loupe"
  })]), _vm._v(" "), (_vm.errors.has('search')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('search')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-icon",
    class: {
      error: _vm.errors.has('search2')
    }
  }, [_c('label', {
    attrs: {
      "for": "search2"
    }
  }, [_vm._v("Recherche")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "search2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-loupe"
  })]), _vm._v(" "), (_vm.errors.has('search2')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('search2')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Mon select")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.optionsSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "select2"
    }
  }, [_vm._v("Mon multi-select")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "",
      "multiple": true,
      "options": _vm.optionsSelect
    },
    model: {
      value: (_vm.select2),
      callback: function($$v) {
        _vm.select2 = $$v
      },
      expression: "select2"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.error || _vm.errors.has(_vm.name)
    }
  }, [(!_vm.notLabel) ? _c('label', {
    attrs: {
      "for": _vm.name
    },
    on: {
      "click": function($event) {
        return _vm.$refs.input.focus()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label || _vm.name))]), _vm._v(" "), (_vm.rules.includes('required')) ? _c('span', {
    staticClass: "label-required"
  }, [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "input",
    staticClass: "input",
    class: {
      'has-value': _vm.hasValue,
      'is-danger': _vm.error || _vm.errors.first(_vm.name)
    },
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "v-validate": _vm.rules,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.innerValue) ? _vm._i(_vm.innerValue, null) > -1 : (_vm.innerValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.innerValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.innerValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.innerValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerValue = $$c
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "input",
    staticClass: "input",
    class: {
      'has-value': _vm.hasValue,
      'is-danger': _vm.error || _vm.errors.first(_vm.name)
    },
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "v-validate": _vm.rules,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.innerValue, null)
    },
    on: {
      "change": function($event) {
        _vm.innerValue = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "input",
    staticClass: "input",
    class: {
      'has-value': _vm.hasValue,
      'is-danger': _vm.error || _vm.errors.first(_vm.name)
    },
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "v-validate": _vm.rules,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.innerValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.error || _vm.errors.has(_vm.name)) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error || _vm.errors.first(_vm.name)))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column"
  }, [_c('div', {
    staticClass: "take-place from-start column"
  }, [_c('div', {
    staticClass: "heading-sub-client-container"
  }, [_c('div', {
    staticClass: "heading-sub-client row start"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "level take-place"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Agrégation manuel de "), _c('span', [_vm._v(_vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('router-link', {
    staticClass: "btn btn-red ctn-icon",
    attrs: {
      "to": {
        name: 'InvestmentsManualAdd'
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-new-mission"
  }), _vm._v("\n\t\t\t\t\t\t\tNouveau produit\n\t\t\t\t\t\t")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "master-investments master-investments-manual"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\tProduits\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-several row"
  }, [_c('div', {
    staticClass: "white-box with-tags with-array take-place"
  }, [_c('div', {
    staticClass: "ctn-table ctn-section-table row"
  }, [_c('section-table', {
    attrs: {
      "columns": _vm.cols,
      "rows": _vm.rows
    },
    on: {
      "action-item-clicked": _vm.onActionItemClicked
    }
  })], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-nav-template patrimonial-landscape white-box row"
  }, [_c('div', {
    staticClass: "menu column"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-title column"
  }, [_c('div', {
    staticClass: "label row"
  }, [_vm._v("\n\t\t\t\t\t\tPaysage Patrimonial\n\t\t\t\t\t")]), _vm._v(" "), (_vm.estate) ? _c('div', {
    staticClass: "subtitle"
  }, [(_vm.estate.completedAt) ? [_vm._v("\n              Signé le " + _vm._s(_vm.estate.completedAt) + "\n            ")] : (!_vm.isAnonymous) ? [_vm._v("\n              Non signé\n            ")] : _vm._e()], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "view column"
  }, [_c('div', {
    staticClass: "head row"
  }, [(_vm.estate && _vm.estate.updatedAt) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tMise à jour du " + _vm._s(_vm.estate.updatedAt) + "\n\t\t\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tPas de paysage patrimonial existant\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [(!_vm.isAnonymous) ? _c('button', {
    staticClass: "btn btn-gold",
    class: {
      'btn-disabled': !_vm.canDownload
    },
    attrs: {
      "disabled": !_vm.canDownload
    },
    on: {
      "click": function($event) {
        return _vm.downloadEstate()
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v(" Télécharger mon Paysage Patrimonial\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "tag": "button",
      "to": {
        name: 'PatrimonialLandscapeUpdate'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tMettre à jour\n\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-component"
  }, [_c('div', {
    staticClass: "ctn-tile row"
  }, [_c('div', {
    staticClass: "tile column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Métier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.job || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CSP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.csp || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Statut")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.maritalStatus || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Revenu annuel")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.incomes || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Immobilier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.immobilier || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Epargne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.savings || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Hors impots")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.spendingNoTaxes.value || '-') + " " + _vm._s((_vm.estate.spendingNoTaxes.value) ? _vm.estate.spendingNoTaxes.cur : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Crédit")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.loans || '-'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tile row"
  }, [_c('div', {
    staticClass: "tile column"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Impôt sur le revenu")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.taxes.value || '-') + " " + _vm._s((_vm.estate.taxes.value) ? _vm.estate.taxes.cur : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Déclaration ISF")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.isf.amount || '-') + " " + _vm._s((_vm.estate.taxes.value) ? _vm.estate.isf.cur : ''))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Départ retraite")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.retreat.month || '-') + " " + _vm._s(_vm.estate.retreat.year))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("PERP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.PERPcomputed))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Suivi")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.follow.rate || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Connaissance")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.knowledge.level || '-'))])])])])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.displayLegalEstate,
      "content": _vm.contentModalLegalEstate
    },
    on: {
      "close": function($event) {
        _vm.displayLegalEstate = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.displayRgpdModal,
      "content": _vm.contentModalRgpd
    },
    on: {
      "close": function($event) {
        _vm.displayRgpdModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Vous")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-vous"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Avoirs & Rentrées")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-rentree"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sorties")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-sortis"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fiscalité")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-fiscalite"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Retraite")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-retraite"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Profil")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-profil"
  })])
}]}

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label no-border",
    class: {
      error: _vm.errors.has('client')
    }
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('custom-select-user', {
    attrs: {
      "items": _vm.clientsFiltered,
      "disabled": _vm.subscriptionExist
    },
    model: {
      value: (_vm.subscription.client),
      callback: function($$v) {
        _vm.$set(_vm.subscription, "client", $$v)
      },
      expression: "subscription.client"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('client')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block"
  }, [_c('div', {}, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('effect_date')
    }
  }, [_c('label', {
    attrs: {
      "for": "effect_date"
    }
  }, [_vm._v("Date d'effet du contrat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription.effect_date),
      expression: "subscription.effect_date"
    }],
    attrs: {
      "type": "date",
      "name": "name",
      "readonly": _vm.subscriptionExist && !!_vm.subscription.effect_date
    },
    domProps: {
      "value": (_vm.subscription.effect_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription, "effect_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('effect_date')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('effect_date')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "check-container row start"
  }, [_c('radio-box', {
    attrs: {
      "value": _vm.subscription.has_paid_first_charge,
      "disabled": _vm.subscriptionExist
    },
    on: {
      "change": function($event) {
        _vm.subscription.has_paid_first_charge = $event
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v(" Le client a déjà payé le premier honoraire (1.000 € hors taxes)")])], 1)])]), _vm._v(" "), (!_vm.subscriptionExist) ? _c('div', {
    staticClass: "ctn-cta row start"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'SubscriptionsTable'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-gold"
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.isFormValidated || _vm.isFormLoading
    },
    on: {
      "click": _vm.saveSubscription
    }
  }, [_vm._v("\n\t\t\tEnregistrer\n\t\t")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal lcbcft"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tDate de signature du questionnaire client\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-date-input"
  }, [_c('input-date', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "date"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tCohérence des informations\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.consistency),
      callback: function($$v) {
        _vm.consistency = $$v
      },
      expression: "consistency"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tComplétude des données\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.completeness),
      callback: function($$v) {
        _vm.completeness = $$v
      },
      expression: "completeness"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tAvertissement envoyé au client\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.warningSent),
      callback: function($$v) {
        _vm.warningSent = $$v
      },
      expression: "warningSent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.sendForm
    }
  }, [_vm._v("Valider")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n  \t\t\t\tQuestionnaire\n  \t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tVérification de la cohérence des informations du Paysage Patrimonial\n\t\t\t\t")])])])
}]}

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column no-header",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-login"
  }), _vm._v(" "), _c('div', {
    staticClass: "login forgot-password reset-password active"
  }, [(_vm.isValidToken) ? _c('div', {
    staticClass: "top"
  }, [_c('h2', [_vm._v("Réinitialiser le mot de passe")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVeuillez saisir un nouveau mot de passe\n\t\t\t")])]) : _vm._e(), _vm._v(" "), (!_vm.isValidToken) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'ResetPasswordEmailAsk'
        })
      }
    }
  }, [_vm._v("\n\t\t\t\t\tRéinitialisation mon mot de passe\n\t\t\t\t")])])]) : _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('nouveau mot de passe')
    }
  }, [_c('label', {
    attrs: {
      "for": "nouveau mot de passe"
    }
  }, [_vm._v("Nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "nouveau mot de passe"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "change": function($event) {
        _vm.errorsame = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('nouveau mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nouveau mot de passe')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('confirmation du mot de passe')
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmation du mot de passe"
    }
  }, [_vm._v("Confirmation du mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm"
    }],
    attrs: {
      "type": "password",
      "name": "confirmation du mot de passe"
    },
    domProps: {
      "value": (_vm.passwordConfirm)
    },
    on: {
      "change": function($event) {
        _vm.errorsame = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('confirmation du mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmation du mot de passe')))]) : _vm._e(), _vm._v(" "), (_vm.errorsame) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("Les mots de passe doivent correspondre")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("\n\t\t\t\t\tValider\n\t\t\t\t")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\tPour des raisons de sécurité la réinitialisation de votre mot passe est valable 24h00."), _c('br'), _vm._v("\n\t\tMerci de bien vouloir demander à nouveau la réinitialisation de votre mot de passe.\n\t\t")])
}]}

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom de l'opération")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operation.name),
      expression: "operation.name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.operation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operation, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label no-border",
    class: {
      error: _vm.errors.has('client')
    }
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('custom-select-user', {
    attrs: {
      "items": _vm.clients,
      "disabled": _vm.missionExist
    },
    model: {
      value: (_vm.operation.client),
      callback: function($$v) {
        _vm.$set(_vm.operation, "client", $$v)
      },
      expression: "operation.client"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('client')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('contrat')
    }
  }, [_c('label', {
    attrs: {
      "for": "contrat"
    }
  }, [_vm._v("ID Client")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "ref_client",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.operation.client ? '#' + _vm.operation.client.id : ''
    }
  })]), _vm._v(" "), (_vm.errors.has('contrat')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('contrat')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('montant')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operation.amount.value),
      expression: "operation.amount.value"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.operation.amount.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operation.amount, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.operation.amount.currency),
      callback: function($$v) {
        _vm.$set(_vm.operation.amount, "currency", $$v)
      },
      expression: "operation.amount.currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('montant')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('montant')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-textarea",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operation.description),
      expression: "operation.description"
    }],
    attrs: {
      "name": "description"
    },
    domProps: {
      "value": (_vm.operation.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operation, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row start"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'TransactionsTable'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-gold"
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.saveOperation
    }
  }, [_vm._v("\n\t\t\tEnregistrer\n\t\t")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tEn fonction des réponses que vous avez renseigné, voici le profil qui vous correspond le mieux :\n\t\t")]), _vm._v(" "), (_vm.sync) ? _c('div', {
    staticClass: "badge"
  }, [(_vm.profile) ? _c('div', {
    staticClass: "btn btn-white no-click"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgBtn,
      "alt": ""
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.profile) + "\n\t\t\t")]) : _c('div', [_vm._v("\n\t\t\t\tAucune réponse renseigné, veuillez sauvegarder et réessayer à nouveau\n\t\t\t")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place master-transactions column"
  }, [_c('div', {
    staticClass: "white-box row ctn-transactions-reminder"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column labels"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t  \t\tVous avez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.subscriptions.length) + " abonnement" + _vm._s((_vm.subscriptions.length > 1) ? 's' : ''))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red ctn-icon",
    attrs: {
      "to": {
        name: 'MySubscriptionsAdd'
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-new-mission"
  }), _vm._v("\n\t\t\tNouvel abonnement\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\tAbonnements\n\t")]), _vm._v(" "), _c('ag-table', {
    attrs: {
      "rows": _vm.computedRows,
      "columns": _vm.cols,
      "customOptions": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-icon"
  }, [_c('span', {
    staticClass: "icon-operations-folder"
  })])
}]}

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-client-actions"
  }, [_c('header', {
    staticClass: "board-client-actions__header"
  }, [_c('h2', {
    staticClass: "dashboard-title dashboard-title--medium"
  }, [_vm._v("Vos clients")]), _vm._v(" "), _c('div', {
    staticClass: "board-client-actions__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "board-client-actions__search-input search-form__input",
    attrs: {
      "id": "search_clients",
      "type": "text",
      "placeholder": "Quels clients cherchez-vous ?"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchClient.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "board-client-actions__search-btn",
    on: {
      "click": _vm.searchClient
    }
  }, [_vm._v("\n\t\t\t\tRechercher\n\t\t\t")])])]), _vm._v(" "), (_vm.searchError) ? _c('div', {
    staticClass: "board-client-actions__error"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.searchError) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "dashboard-loading"
  }, [_vm._v("\n\t\tChargement...\n\t")]) : (_vm.hasSearched && _vm.filteredClients.length === 0) ? _c('div', {
    staticClass: "dashboard-empty"
  }, [_vm._v("\n\t\tAucun client trouvé\n\t")]) : _c('div', {
    staticClass: "dashboard-grid dashboard-grid--auto-fill"
  }, _vm._l((_vm.filteredClients), function(client) {
    return _c('CardClient', {
      key: client.id,
      attrs: {
        "user": client
      },
      on: {
        "renewal-updated": _vm.removeClient
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_vm._v("\n\t\t\tCGV Works\n\t\t")])])
}]}

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_c('div', {
    staticClass: "legals-title"
  }, [_vm._v("\n\t\t\t\tConditions Générales d'Utilisation\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "legals-body"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("Patrimoffice exerce en qualité de Conseil en Investissements Financiers (CIF).")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("La règlementation (article 325-3 du règlement général de l’AMF) prévoit pour les CIF l’obligation de remettre à son Client un Document d’Entrée en Relation (DER), avant la signature d’une lettre de mission.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Les informations communiquées dans ce DER sont des informations légales et réglementaires obligatoires qui permettent au Client d’avoir une vision du périmètre d’activités de la société, et des conditions d’exercice des différents métiers exercés par le gestionnaire de patrimoine.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Ce document est en accès libre sur notre site et peut être téléchargé "), _c('a', {
    attrs: {
      "href": "https://www.patrimoffice.com/document-entree-en-relation/"
    }
  }, [_vm._v("ici")]), _vm._v(".")])])])])
}]}

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointment-modal"
  }, [_c('header', {
    staticClass: "appointment-modal__header"
  }, [_c('div', {
    staticClass: "appointment-modal__title-group"
  }, [_c('h2', {
    staticClass: "appointment-modal__title"
  }, [_vm._v(_vm._s(_vm.data && _vm.data.rdv ? 'Modifier le rendez-vous' : 'Planifier un rendez-vous'))]), _vm._v(" "), _c('p', {
    staticClass: "appointment-modal__subtitle"
  }, [_vm._v(_vm._s(_vm.data && _vm.data.rdv ? 'Modifiez les informations du rendez-vous' : 'Planifiez un rendez-vous avec votre client'))])]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__type-field"
  }, [_c('label', {
    staticClass: "appointment-modal__label appointment-modal__label--required"
  }, [_vm._v("\n\t\t\t\tType de rendez-vous\n\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select'),
      expression: "'required|select'"
    }],
    class: {
      'appointment-modal__select--error': _vm.errors.has('type')
    },
    attrs: {
      "items": _vm.typesOfAppointment,
      "name": "type",
      "solo": true
    },
    model: {
      value: (_vm.typeOfAppointment),
      callback: function($$v) {
        _vm.typeOfAppointment = $$v
      },
      expression: "typeOfAppointment"
    }
  }), _vm._v(" "), (_vm.errors.has('type')) ? _c('span', {
    staticClass: "appointment-modal__error"
  }, [_vm._v("\n\t\t\t\tVeuillez sélectionner un type de rendez-vous\n\t\t\t")]) : _vm._e()], 1)]), _vm._v(" "), _c('form', {
    staticClass: "appointment-modal__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.send.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "appointment-modal__section"
  }, [_c('h3', {
    staticClass: "appointment-modal__section-title"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.667 2.667H3.333C2.597 2.667 2 3.264 2 4v9.333c0 .737.597 1.334 1.333 1.334h9.334c.736 0 1.333-.597 1.333-1.334V4c0-.736-.597-1.333-1.333-1.333z",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.667 1.333v2.667M5.333 1.333v2.667M2 6.667h12",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n\t\t\t\tDébut du rendez-vous\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__row"
  }, [_c('div', {
    staticClass: "appointment-modal__field"
  }, [_c('label', {
    staticClass: "appointment-modal__label appointment-modal__label--required"
  }, [_vm._v("Date de début")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__input-wrapper",
    class: {
      'appointment-modal__input-wrapper--error': _vm.errors.has('Date de début')
    }
  }, [_c('input', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_date:' + _vm.computedToday),
      expression: "'required|min_date:' + computedToday"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.beginDate),
      expression: "beginDate"
    }],
    staticClass: "appointment-modal__input",
    attrs: {
      "type": "date",
      "name": "Date de début",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.beginDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beginDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('Date de début')) ? _c('span', {
    staticClass: "appointment-modal__error"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.errors.first('Date de début')) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__field"
  }, [_c('label', {
    staticClass: "appointment-modal__label appointment-modal__label--required"
  }, [_vm._v("Heure de début")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__input-wrapper",
    class: {
      'appointment-modal__input-wrapper--error': _vm.errors.has('Heure de début')
    }
  }, [_c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select'),
      expression: "'required|select'"
    }],
    attrs: {
      "name": "Heure de début",
      "items": _vm.hoursPossible
    },
    model: {
      value: (_vm.beginHour),
      callback: function($$v) {
        _vm.beginHour = $$v
      },
      expression: "beginHour"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('Heure de début')) ? _c('span', {
    staticClass: "appointment-modal__error"
  }, [_vm._v("\n\t\t\t\t\t\tVeuillez sélectionner une heure\n\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__section"
  }, [_c('h3', {
    staticClass: "appointment-modal__section-title"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.667 2.667H3.333C2.597 2.667 2 3.264 2 4v9.333c0 .737.597 1.334 1.333 1.334h9.334c.736 0 1.333-.597 1.333-1.334V4c0-.736-.597-1.333-1.333-1.333z",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.667 1.333v2.667M5.333 1.333v2.667M2 6.667h12",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n\t\t\t\tFin du rendez-vous\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__row"
  }, [_c('div', {
    staticClass: "appointment-modal__field"
  }, [_c('label', {
    staticClass: "appointment-modal__label appointment-modal__label--required"
  }, [_vm._v("Date de fin")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__input-wrapper",
    class: {
      'appointment-modal__input-wrapper--error': _vm.errors.has('Date de fin')
    }
  }, [_c('input', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "appointment-modal__input",
    attrs: {
      "type": "date",
      "name": "Date de fin",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('Date de fin')) ? _c('span', {
    staticClass: "appointment-modal__error"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.errors.first('Date de fin')) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__field"
  }, [_c('label', {
    staticClass: "appointment-modal__label appointment-modal__label--required"
  }, [_vm._v("Heure de fin")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__input-wrapper",
    class: {
      'appointment-modal__input-wrapper--error': _vm.errors.has('Heure de fin')
    }
  }, [_c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select|min_value:' + (parseInt(_vm.beginHour, 10) + 1)),
      expression: "'required|select|min_value:' + (parseInt(beginHour, 10) + 1)"
    }],
    attrs: {
      "name": "Heure de fin",
      "items": _vm.hoursPossible
    },
    model: {
      value: (_vm.endHour),
      callback: function($$v) {
        _vm.endHour = $$v
      },
      expression: "endHour"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('Heure de fin')) ? _c('span', {
    staticClass: "appointment-modal__error"
  }, [_vm._v("\n\t\t\t\t\t\tVeuillez sélectionner une heure valide\n\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__section"
  }, [_c('h3', {
    staticClass: "appointment-modal__section-title"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 10l-4-4-4 4-4-4",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n\t\t\t\tInformations complémentaires\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__field appointment-modal__field--full"
  }, [_c('label', {
    staticClass: "appointment-modal__label"
  }, [_vm._v("Note (optionnel)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "appointment-modal__textarea",
    attrs: {
      "placeholder": "Ajoutez une note pour ce rendez-vous...",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.needSelectClient) ? _c('div', {
    staticClass: "appointment-modal__section"
  }, [_c('h3', {
    staticClass: "appointment-modal__section-title"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.333 14v-1.333A2.667 2.667 0 0010.667 10H5.333a2.667 2.667 0 00-2.666 2.667V14M8 7.333A2.667 2.667 0 108 2a2.667 2.667 0 000 5.333z",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n\t\t\t\tClient\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-modal__field appointment-modal__field--full"
  }, [_c('label', {
    staticClass: "appointment-modal__label appointment-modal__label--required"
  }, [_vm._v("Sélectionner un client")]), _vm._v(" "), _c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.myuser),
      callback: function($$v) {
        _vm.myuser = $$v
      },
      expression: "myuser"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "appointment-modal__footer"
  }, [_c('button', {
    staticClass: "appointment-modal__btn appointment-modal__btn--secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n\t\t\t\tAnnuler\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "appointment-modal__btn appointment-modal__btn--primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\tEnregistrer\n\t\t\t")])])])])
},staticRenderFns: []}

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "take-place column activity-container"
  }, [(_vm.addSearch) ? _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label form-ui default-form-ui"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Rechercher")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "search",
      "name": "name"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.onFilterTextBoxChanged()
      }]
    }
  })]) : _vm._e(), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "table-custom column",
    attrs: {
      "gridReady": _vm.onReady,
      "gridOptions": _vm.options,
      "columnDefs": _vm.columnsComputed,
      "rowData": _vm.rows,
      "enableSorting": true
    }
  }), _vm._v(" "), (_vm.showGrid && _vm.options.pagination) ? _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', [_vm._v("Montrer "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paginationPageSize),
      expression: "paginationPageSize"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paginationPageSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paginationPageSize = $event.target.value
      }
    }
  }), _vm._v(" éléments par page")]), _vm._v(" "), _c('div', [_vm._v("Page "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    staticClass: "input-page",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_c('div', {
    staticClass: "legals-title"
  }, [_vm._v("\n\t\t\tMentions Légales\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "legals-body"
  }, [_c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Éditeur du site internet")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Ce site internet est édité par la société Patrimoffice, Société par Actions Simplifiée (SAS) au capital de 1.800,00 € entièrement libéré (SIREN : 829 888 122 R.C.S. Paris). Son siège social est au 7 avenue Ingres, 75016 Paris.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Numéro de TVA intracommunautaire : FR07829888122.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Mail de contact : contact@patrimoffice.com.")]), _vm._v(" "), _c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Directeur de la publication")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Olivier Potellet.")]), _vm._v(" "), _c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Hébergement")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Le site patrimoffice.com est hébergé par la société Amazon Web Services, Inc., dont le siège social est situé P.O. Box 81226 Seattle, WA 98108-1226 (https://aws.amazon.com).")]), _vm._v(" "), _c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Propriété intellectuelle")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Ce site internet et l'ensemble de ses contenus, tels que notamment, sans que cette liste ne soit limitative, les textes, informations, documentations, documents sonores, photographies, dessins, plans, marques, progiciels, logiciels, données, bases de données, charte graphique, visuels, avatars, et plus généralement tout élément apparaissant sur le site internet, sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive de Patrimoffice.")])])])])
}]}

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select",
    class: {
      solo: _vm.solo
    }
  }, [_c('div', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.display()
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.displayValue(_vm.select)) + "\n\t\t"), _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  })]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(item, eq) {
    return _c('div', {
      key: eq,
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSelect(eq)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.displayValue(item)) + "\n\t\t")])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "ctn-big-block"
  }, [_c('text-input', {
    attrs: {
      "name": "product",
      "label": "Produit"
    },
    model: {
      value: (_vm.investmentProduct.product_name),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "product_name", $$v)
      },
      expression: "investmentProduct.product_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('text-input', {
    attrs: {
      "name": "subscription_date",
      "label": "Date de souscription",
      "type": "date"
    },
    model: {
      value: (_vm.investmentProduct.subscription_date),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "subscription_date", $$v)
      },
      expression: "investmentProduct.subscription_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('product_type')
    }
  }, [_c('label', {
    attrs: {
      "for": "product_type"
    }
  }, [_vm._v("Type de produit")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.productTypes
    },
    model: {
      value: (_vm.investmentProduct.product_type),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "product_type", $$v)
      },
      expression: "investmentProduct.product_type"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('product_type')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('product_type')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('text-input', {
    attrs: {
      "name": "contract_number",
      "label": "Numéro de contrat"
    },
    model: {
      value: (_vm.investmentProduct.contract_number),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "contract_number", $$v)
      },
      expression: "investmentProduct.contract_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('contract_type')
    }
  }, [_c('label', {
    attrs: {
      "for": "contract_type"
    }
  }, [_vm._v("Type de contrat")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.contractTypes
    },
    model: {
      value: (_vm.investmentProduct.contract_type),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "contract_type", $$v)
      },
      expression: "investmentProduct.contract_type"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('contract_type')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('contract_type')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('text-input', {
    attrs: {
      "name": "shares_number",
      "label": "Parts",
      "type": "number"
    },
    model: {
      value: (_vm.investmentProduct.shares_number),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "shares_number", $$v)
      },
      expression: "investmentProduct.shares_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('shares_number')
    }
  }, [_c('label', {
    class: {
      'active': _vm.investmentProduct.share_price_currency
    },
    attrs: {
      "for": "shares_number"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tPrix de la part\n\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.share_price),
      expression: "investmentProduct.share_price"
    }],
    ref: "share_price",
    attrs: {
      "type": "number",
      "name": "share_price"
    },
    domProps: {
      "value": (_vm.investmentProduct.share_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "share_price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.share_price_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "share_price_currency", $$v)
      },
      expression: "investmentProduct.share_price_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('share_price')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('share_price')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('net_income_distributed')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "net_income_distributed"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRevenu net distribué\n\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.net_income_distributed),
      expression: "investmentProduct.net_income_distributed"
    }],
    ref: "net_amount_distributed",
    attrs: {
      "type": "number",
      "name": "net_income_distributed"
    },
    domProps: {
      "value": (_vm.investmentProduct.net_income_distributed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "net_income_distributed", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.net_income_distributed_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "net_income_distributed_currency", $$v)
      },
      expression: "investmentProduct.net_income_distributed_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('net_income_distributed')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('net_income_distributed')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('subscription_price')
    }
  }, [_c('label', {
    attrs: {
      "for": "subscription_price"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tPrix d'achat de la part\n\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.subscription_price),
      expression: "investmentProduct.subscription_price"
    }],
    ref: "subscription_price",
    attrs: {
      "type": "number",
      "name": "subscription_price"
    },
    domProps: {
      "value": (_vm.investmentProduct.subscription_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "subscription_price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.share_price_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "share_price_currency", $$v)
      },
      expression: "investmentProduct.share_price_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('subscription_price')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('subscription_price')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row",
    staticStyle: {
      "justify-content": "left"
    }
  }, [_c('div', {
    staticClass: "left inner-duo",
    staticStyle: {
      "width": "calc(50% - 0.5rem)"
    }
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('income_since_anniversary')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "income_since_anniversary"
    }
  }, [_vm._v("\n\t\t\t\t\t\tRevenus depuis la date d'anniversaire\n\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.income_since_anniversary),
      expression: "investmentProduct.income_since_anniversary"
    }],
    ref: "income_since_anniversary",
    attrs: {
      "type": "number",
      "name": "income_since_anniversary"
    },
    domProps: {
      "value": (_vm.investmentProduct.income_since_anniversary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "income_since_anniversary", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.share_price_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "share_price_currency", $$v)
      },
      expression: "investmentProduct.share_price_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('income_since_anniversary')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('income_since_anniversary')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row start"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: {
          clientId: _vm.clientId,
          kind: _vm.isCgpi ? 'cgpi' : 'client'
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-gold"
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.isFormValidated || _vm.isFormLoading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\tEnregistrer\n\t\t")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select multi",
    class: {
      solo: _vm.solo
    }
  }, [_c('div', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        return _vm.display()
      }
    }
  }, [(_vm.selected.length > 0) ? _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.selected), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(key)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.displayItem(tag)) + " "), _vm._m(0, true)])
  }), 0) : _c('div', {
    staticClass: "no-tags"
  }, [_vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  })]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.list), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "item",
      class: {
        active: _vm.isSelected(key)
      },
      on: {
        "click": function($event) {
          return _vm.setSelect(key)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.displayItem(item)) + "\n\t\t")])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "delete row"
  }, [_c('span', [_vm._v("x")])])
}]}

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-operation-form take-place"
  }, [_c('div', {
    staticClass: "white-box row title"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'TransactionsTable'
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), (_vm.missionExist) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.name) + "\n\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tNouvelle opération\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('edit-main'), _vm._v(" "), (_vm.missionExist) ? _c('div', {
    staticClass: "take-place"
  }, [_c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('edit-docs', {
    attrs: {
      "operation": _vm.operation
    },
    on: {
      "needToUpdate": _vm.checkForOperation
    }
  }), _vm._v(" "), _c('edit-contracts-and-supports')], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-nav-template patrimonial-landscape white-box row"
  }, [_c('div', {
    staticClass: "menu column"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "ctn-menu column"
  }, _vm._l((_vm.menu), function(item, key) {
    return _c('li', {
      key: key,
      staticClass: "item-main",
      class: {
        active: _vm.isActiveFirst(key)
      },
      attrs: {
        "id": typeof _vm.menu[key].slug !== 'undefined' ? 'menu-link-' + _vm.menu[key].slug : ''
      }
    }, [_c('div', {
      staticClass: "label",
      domProps: {
        "innerHTML": _vm._s(_vm.resolveLabel(item, key))
      },
      on: {
        "click": function($event) {
          return _vm.setActiveFirst(key)
        }
      }
    }), _vm._v(" "), (item.children && _vm.isActiveFirst(key)) ? _c('ul', {
      staticClass: "ctn-second"
    }, _vm._l((item.children), function(child, keyt) {
      return _c('li', {
        key: keyt,
        staticClass: "item-second",
        class: {
          active: _vm.isActiveSecond(keyt)
        },
        on: {
          "click": function($event) {
            return _vm.setActiveSecond(keyt)
          }
        }
      }, [_c('div', {
        staticClass: "label",
        domProps: {
          "innerHTML": _vm._s(_vm.resolveLabel(child, key, keyt))
        }
      })])
    }), 0) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.activeFirstLevel < 6) ? _c('div', {
    staticClass: "btn btn-red",
    attrs: {
      "id": "saveBtn"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Sauvegarder\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view column",
    attrs: {
      "id": typeof _vm.menu[this.activeFirstLevel].slug !== 'undefined' ? 'menu-view-' + _vm.menu[this.activeFirstLevel].slug : ''
    }
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.menu[_vm.activeFirstLevel].label)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-component"
  }, [(_vm.menu[_vm.activeFirstLevel].children) ? _c('div', {
    staticClass: "title-component",
    domProps: {
      "innerHTML": _vm._s(_vm.menu[_vm.activeFirstLevel].children[_vm.activeSecondLevel].label)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.drawComponent) ? _c(_vm.currentComponent, {
    ref: "currentComp",
    tag: "component",
    attrs: {
      "user": _vm.user
    },
    on: {
      "fileupload": _vm.addDocument
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "step row",
    attrs: {
      "id": "step-change-buttons"
    }
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.previousStep
    }
  }, [_vm._v("\n          Précédent\n        ")]), _vm._v(" "), (_vm.activeFirstLevel < 6) ? _c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n          Suivant\n        ")]) : [(_vm.isAnonymous) ? _c('button', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.signatureBtnAvailable || _vm.showAnonymousCtaModal
    },
    attrs: {
      "id": "downloadEstateBtn"
    },
    on: {
      "click": _vm.downloadEstate
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v(" Télécharger mon Paysage Patrimonial\n          ")]) : _c('div', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.signatureBtnAvailable
    },
    attrs: {
      "id": "signBtn"
    },
    on: {
      "click": _vm.sign
    }
  }, [(_vm.isAdvisor) ? [_vm._v("Demande de signature électronique")] : [_vm._v("Signer")]], 2)]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon-eye"
  }), _vm._v("\n        Paysage Patrimonial\n      ")])
}]}

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three",
    class: {
      error: _vm.errors.has('revenu d\'activité')
    }
  }, [_c('label', {
    attrs: {
      "for": "prénom"
    }
  }, [_vm._v("Revenu(s)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.directIncome.val),
      expression: "directIncome.val"
    }],
    attrs: {
      "type": "text",
      "name": "revenu d'activité"
    },
    domProps: {
      "value": (_vm.directIncome.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.directIncome, "val", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.directIncome.cur
    },
    on: {
      "change": function($event) {
        _vm.directIncome.cur = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('revenu d\'activité')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three",
    class: {
      error: _vm.errors.has('pensions et rentes')
    }
  }, [_c('label', {
    attrs: {
      "for": "pensions et rentes"
    }
  }, [_vm._v("Pensions et rentes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.secondIncome.val),
      expression: "secondIncome.val"
    }],
    attrs: {
      "type": "text",
      "name": "pensions et rentes"
    },
    domProps: {
      "value": (_vm.secondIncome.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.secondIncome, "val", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.secondIncome.cur
    },
    on: {
      "change": function($event) {
        _vm.secondIncome.cur = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('pensions et rentes')))])])])])
},staticRenderFns: []}

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.currency
    },
    on: {
      "change": function($event) {
        _vm.currency = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "label input-like small"
  }, [_vm._v("\n\t\t\t\tPériodicité\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.type,
      "values": _vm.periods
    },
    on: {
      "change": function($event) {
        _vm.type = $event
      }
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asterisk-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("\n\t\t\tQuel est le montant que vous estimez nécessaire pour maintenir votre équilibre de vie ? (facultatif)\n\t\t")])])
}]}

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('p', [_vm._v("Documents Partagés")]), _c('br'), _vm._v(" "), _c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-toggle row"
  }, [_c('div', {
    staticClass: "toggle-part left",
    class: {
      active: _vm.isActive(_vm.list[0])
    },
    on: {
      "click": function($event) {
        return _vm.setToggle(_vm.list[0])
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.list[0]) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-part right",
    class: {
      active: _vm.isActive(_vm.list[1])
    },
    on: {
      "click": function($event) {
        return _vm.setToggle(_vm.list[1])
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.list[1]) + "\n\t\t")])])
},staticRenderFns: []}

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "body-modal"
  }, [_c('div', {
    staticClass: "title-gold"
  }, [_vm._v("\n\t\t\tVous avez émis le souhait d'obtenir une réponse d'un professionnel contrôlé exerçant une activité réglementée\n\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fermer")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-standard"
  }, [_c('p', [_vm._v("Conformément aux principes de la loi du 6 janvier 1978 relative à l’informatique aux fichiers et aux libertés modifié par le décret n°2019-536 ainsi qu’au règlement général à la protection des données entrée en vigueur le 25 mai 2018 nous vous rappelons que la présente collecte d’information ainsi que leur exploitation sont effectuées dans votre intérêt et ont pour finalité de permettre au professionnel d’établir un profil de risque dans le but  de fournir un conseil adapté à votre problématique.")]), _vm._v(" "), _c('p', [_vm._v("La qualité de son travail dépendra étroitement de la véracité, de l’exactitude et de l’exhaustivité de vos réponses à ce questionnaire.")]), _vm._v(" "), _c('p', [_vm._v("Si vous ne communiquez pas les informations requises, votre conseiller ne pourra pas poursuivre sa mission et devra s’abstenir de vous recommander les opérations, instruments et services relevant de son activité CIF.")]), _vm._v(" "), _c('p', [_vm._v("Il ne pourra vous fournir qu’une prestation d’information ou de recherche, une mission relevant d’un autre métier réglementé ou de la sphère non financière.")]), _c('p'), _c('p', [_vm._v("Vous reconnaissez avoir connaissance des tarifs de votre conseiller, de ses méthodes de travail et avoir en votre possession sa fiche d’information légale ANACOFI.")]), _vm._v(" "), _c('p', [_vm._v("Votre conseiller s’est engagé au respect de règles de bonne conduite incluant le secret professionnel et la protection de vos données personnelles.")]), _vm._v(" "), _c('p', [_vm._v("Les informations recueillies sont enregistrées dans un fichier informatisé par Patrimoffice afin notamment de pouvoir proposer des produits et services de qualité personnalisés et adaptés à chaque situation patrimoniale, besoin et objectif recherché, se conformer à ses obligations légales et règlementaires et exercer son activité de conseil et de suivi au mieux des intérêts des clients. Elles sont conservées pendant la durée de la relation contractuelle et pendant 5 ans à l’issue de la relation et sont destinées aux établissements dépositaires ou compagnies d’assurance à partenaires de Patrimoffice, et le cas échéant à son prestataire de services informatiques. Ces données ne font l’objet d’aucune transmission à des organismes extérieurs notamment à des fins de prospection commerciale sans l’accord du client.")]), _vm._v(" "), _c('p', [_vm._v("Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d’accès, d’opposition, d’effacement, de limitation du traitement, de portabilité des données vous concernant et les faire rectifier en contactant notre service de traitement des données à contact@patrimoffice.com. Vous pouvez également introduire une réclamation au sujet du traitement de vos données auprès de la CNIL.")])])
}]}

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tDISPLAY\n")])
},staticRenderFns: []}

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-operation-form take-place"
  }, [_c('div', {
    staticClass: "white-box row title"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: _vm.isCgpi ? {
          clientId: _vm.client.id
        } : {
          kind: 'client'
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), (this.$route.params.id) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tModifier le produit\n\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tAjouter un produit\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('edit-main', {
    attrs: {
      "client-id": _vm.client ? _vm.client.id : null,
      "investmentProduct": _vm.investmentProduct,
      "kind": _vm.kind
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column"
  }, [_c('div', {
    staticClass: "take-place from-start column"
  }, [_c('div', {
    staticClass: "heading-sub-client-container"
  }, [_c('div', {
    staticClass: "heading-sub-client row start"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.clientId
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Détails de la situation de "), (_vm.client) ? _c('span', [_vm._v(_vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.investmentStats) ? _c('synthesis', {
    attrs: {
      "investment-stats": _vm.investmentStats
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-nav row"
  }, [_c('nav', _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.key,
      staticClass: "item",
      attrs: {
        "to": {
          name: item.uri
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t")])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "sub-page center column"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column",
    attrs: {
      "id": "app"
    }
  }, [_c('my-header', {
    attrs: {
      "menu": _vm.menu
    },
    on: {
      "notif-open": function($event) {
        _vm.notifPanelActive = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page column"
  }, [_c('router-view')], 1), _vm._v(" "), _c('my-footer'), _vm._v(" "), _c('notification-panel')], 1)
},staticRenderFns: []}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-investments"
  }, [_c('div', {
    staticClass: "group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row white-box"
  }, [_c('div', {
    staticClass: "global-perfs"
  }, [_c('div', {
    staticClass: "item column"
  }, [_c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "flex items-between align-baseline"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("Montant investi : ")]), _vm._v(" "), _c('div', {
    staticClass: "encour"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.investmentStats.amount_invested)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-between align-baseline"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("Encours :")]), _vm._v(" "), _c('div', {
    staticClass: "encour"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.investmentStats.my_assets)))])])])]), _vm._v(" "), _vm._l((_vm.globalPerfComputed), function(item, key) {
    return ((key != 2) || ((key == 2) && (item.prog != 0))) ? _c('performance-stat', {
      key: key,
      attrs: {
        "title": item.title,
        "value": item.value,
        "prog": item.prog
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('mapbox', {
    attrs: {
      "access-token": _vm.mapboxToken,
      "center": _vm.mapCenter,
      "zoom": 1,
      "style-prop": "mapbox://styles/mapbox/satellite-v9",
      "markers": _vm.mapMarkers,
      "client-id": parseInt(this.$route.params.clientId ? this.$route.params.clientId : this.user.id)
    },
    on: {
      "map-loaded": _vm.onMapLoaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\tEncours & Répartition\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-several row"
  }, [_c('div', {
    staticClass: "white-box with-tags with-array"
  }, [_c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.arrayData), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag row",
      class: {
        selected: _vm.isSelected(key)
      },
      on: {
        "click": function($event) {
          return _vm.selectTag(key)
        }
      }
    }, [_c('div', {
      staticClass: "square",
      style: ({
        backgroundColor: tag.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(tag.valueFormatted))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ctn-table ctn-section-table row"
  }, [_c('section-table', {
    attrs: {
      "columns": _vm.distributionColumnDefsFiltered,
      "rows": _vm.distributionRowDataFiltered
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "white-box column with-tags with-stats"
  }, [_c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.getWithoutGlobalData(_vm.arrayData)), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag row"
    }, [_c('div', {
      staticClass: "square",
      style: ({
        backgroundColor: tag.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(tag.valueFormatted))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-bars row"
  }, _vm._l((_vm.getWithoutGlobalData(_vm.arrayData)), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "bar",
      style: ({
        width: tag.value,
        backgroundColor: tag.color
      })
    }, [_vm._v(_vm._s(tag.valueFormatted))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "resume-stat"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "title-muted"
  }, [_vm._v("Encours")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-values row"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n                    " + _vm._s(_vm.formatCurrency(_vm.investmentStats.my_assets)) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "prog"
  }, [(_vm.investmentStats.global_performance >= 0) ? _c('span', [_c('img', {
    attrs: {
      "src": _vm.good,
      "alt": ""
    }
  })]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.bad,
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column perf-mini"
  }, [_c('ul', _vm._l((_vm.distributionRowDataFilteredSliced), function(distribution, key) {
    return _c('li', {
      key: key
    }, [_c('span', {
      staticClass: "key"
    }, [_vm._v(_vm._s(distribution.data.name.slice(0, 5)))]), _vm._v(" "), _c('span', {
      staticClass: "value",
      class: {
        'text-green': distribution.data.perf[0] !== '-',
        'text-red': distribution.data.perf[0] === '-'
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(distribution.data.perf) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "column perf-progress-bar"
  }, [_c('progress-bar-half-circle', {
    attrs: {
      "value": _vm.globalPerfComputed[0].prog
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tPerformance Globale\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\tOù sont mes placements ?\n\t\t\t\t\t\t")])])
}]}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tDocuments liés à l'abonnement\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, [_c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "tile-doc row"
  }, [_c('span', {
    staticClass: "icon-document-pdf"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tContrat d'abonnement\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((_vm.subscriptionContract) ? _vm.subscriptionContract.original_name : 'Pas de fichier') + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "lmfile",
      "type": "file"
    },
    on: {
      "change": _vm.uploadSubscriptionContractFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-actions row"
  }, [(_vm.needForSign(_vm.subscriptionContract)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    class: {
      'btn-disabled': !_vm.hasIdentityCertificated
    },
    on: {
      "click": function($event) {
        return _vm.askForSignature(_vm.subscriptionContract)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSoumettre une signature\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.canLoad(_vm.subscriptionContract)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.procUpload('lmfile')
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v("\n\t\t\t\t\tCharger un fichier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.subscriptionContract && !_vm.needForSign(_vm.subscriptionContract) && _vm.subscriptionContract.universign_launch_date) ? _c('div', {
    staticClass: "status row"
  }, [_vm._v("\n\t\t\t\t\tAjouté le " + _vm._s(_vm.subscriptionContract.universign_launch_date.split(' ')[0]) + "\n\t\t\t\t\t"), (_vm.subscriptionContract.universign_status === 'completed') ? _c('span', {
    staticClass: "green inner-status"
  }, [_vm._v("Signé le " + _vm._s(_vm.subscriptionContract.signature_date.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (_vm.subscriptionContract.universign_status === 'ready') ? _c('span', {
    staticClass: "orange inner-status"
  }, [_vm._v("Signature en attente")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasIdentityCertificated),
      expression: "!hasIdentityCertificated"
    }],
    staticClass: "text-red"
  }, [_c('br'), _c('small', [_c('i', {
    staticClass: "icon-bandeau-alert"
  }), _vm._v(" L'identité du client doit être vérifiée avant de lui soumettre une signature.\n\t\t\t\t\t\t"), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.subscription.user.id
        }
      }
    }
  }, [_vm._v("Vérifier son identité")])], 1)]), _vm._v(" "), (_vm.subscriptionContract) ? _c('div', {
    staticClass: "other-actions row"
  }, [(_vm.subscriptionContract.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.callVerify(_vm.subscriptionContract)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVérifier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.subscriptionContract.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.relaunchTransaction(_vm.subscriptionContract)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEnvoyer un mail de relance\n\t\t\t\t")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loader) ? _c('div', {
    staticClass: "loader-container"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-image"
  }, [_c('img', {
    staticClass: "color-filter",
    attrs: {
      "src": __webpack_require__(946),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous une résidence principale ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isRealEstate
    },
    on: {
      "change": function($event) {
        return _vm.toggleMainRealEstate($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isRealEstate) ? _c('div', [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three",
    class: {
      error: _vm.errors.has('montant estimé')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant estimé"
    }
  }, [_vm._v("Montant actuel estimé")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.realEstateValue),
      expression: "realEstateValue"
    }],
    key: 'main',
    attrs: {
      "type": "text",
      "name": "montant estimé"
    },
    domProps: {
      "value": (_vm.realEstateValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realEstateValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": 'EUR'
    },
    on: {
      "change": function($event) {
        _vm.realEstateCur = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('montant estimé')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "catégorie professionnelle"
    }
  }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "selected": _vm.propertyType
    },
    on: {
      "change": function($event) {
        _vm.propertyType = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous une résidence secondaire ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isSecondaryRealEstate
    },
    on: {
      "change": function($event) {
        return _vm.toggleSecondaryEstates($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isSecondaryRealEstate) ? _c('div', {
    staticClass: "ctn-childrens"
  }, [_vm._l((_vm.secondaryEstates), function(property, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\tRésidence Secondaire " + _vm._s(key + 1) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeSecondaryEstate(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('montant estimé ' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'montant estimé' + (key + 1)
      }
    }, [_vm._v("Montant actuel estimé")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (property.value),
        expression: "property.value"
      }],
      key: 'secondary-' + key,
      attrs: {
        "type": "text",
        "name": 'montant estimé ' + (key + 1)
      },
      domProps: {
        "value": (property.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": property.cur
      },
      on: {
        "change": function($event) {
          property.cur = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('montant estimé ' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label"
    }, [_c('label', {
      attrs: {
        "for": "catégorie professionnelle"
      }
    }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.propertyTypes,
        "selected": property.ownership_type
      },
      on: {
        "change": function($event) {
          property.ownership_type = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": _vm.addSecondaryEstate
    }
  }, [_vm._v("\n\t\t\t\tAjouter une autre résidence secondaire\n\t\t\t")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row custom-margin"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous des biens locatifs ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isRentingProperties
    },
    on: {
      "change": function($event) {
        return _vm.toggleRentingProperties($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isRentingProperties) ? _c('div', {
    staticClass: "ctn-childrens"
  }, [_vm._l((_vm.rentingProperties), function(property, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\tBien locatif " + _vm._s('2-' + (key + 1)) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeRentingProperty(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('montant estimé 2-' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'montant estimé 2-' + (key + 1)
      }
    }, [_vm._v("Montant actuel estimé")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (property.value),
        expression: "property.value"
      }],
      key: 'renting-' + key,
      attrs: {
        "type": "text",
        "name": 'montant estimé 2-' + (key + 1)
      },
      domProps: {
        "value": (property.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": property.cur
      },
      on: {
        "change": function($event) {
          property.cur = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('montant estimé 2-' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label"
    }, [_c('label', {
      attrs: {
        "for": "catégorie professionnelle"
      }
    }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.propertyTypes,
        "selected": property.ownership_type
      },
      on: {
        "change": function($event) {
          property.ownership_type = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": _vm.addRentingProperty
    }
  }, [_vm._v("\n\t\t\t\tAjouter un autre bien locatif\n\t\t\t")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row custom-margin"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tDétenez-vous des parts de scpi ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isSCPI
    },
    on: {
      "change": function($event) {
        return _vm.toggleSCPI($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isSCPI) ? _c('div', {
    staticClass: "ctn-childrens"
  }, [_c('div', {
    staticClass: "ctn-cihldren"
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three",
    class: {
      error: _vm.errors.has('montant estimé')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant estimé"
    }
  }, [_vm._v("Montant estimé")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.scpi.value),
      expression: "scpi.value"
    }],
    key: 'scpi',
    attrs: {
      "type": "text",
      "name": 'montant estimé'
    },
    domProps: {
      "value": (_vm.scpi.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scpi, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.scpi.cur
    },
    on: {
      "change": function($event) {
        _vm.scpi.cur = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('montant estimé')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "catégorie professionnelle"
    }
  }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "selected": _vm.scpi.type
    },
    on: {
      "change": function($event) {
        _vm.scpi.type = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('section', {
    staticClass: "sub-main take-place column actualities master-article"
  }, [_c('div', {
    staticClass: "cover column"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.article.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content column"
  }, [_c('div', {
    staticClass: "tags row"
  }, _vm._l((_vm.article.news_tags), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag"
    }, [_vm._v("\n            " + _vm._s(_vm.resolveTag(tag)) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.article.title)
    }
  }), _vm._v(" "), (_vm.article.author) ? _c('div', {
    staticClass: "author column"
  }, [_c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.article.author.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t\tRédigé par " + _vm._s(_vm.article.author.name) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t\t\tle " + _vm._s(_vm._f("moment")(_vm.article.updated_at, 'DD MMMM YYYY')) + "\n\t\t\t\t\t\t")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-article"
  }, [_c('div', {
    staticClass: "item",
    domProps: {
      "innerHTML": _vm._s(_vm.article.body)
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "board-header",
    attrs: {
      "role": "banner",
      "aria-label": "Header dashboard"
    }
  }, [_c('h1', {
    staticClass: "dashboard-title"
  }, [_vm._v("Tableau de bord")]), _vm._v(" "), _c('span', {
    staticClass: "dashboard-subtitle"
  }, [_vm._v("Gérez vos prospects et suivez vos clients.")])])
}]}

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-docs row"
  }, _vm._l((_vm.docs), function(doc, key) {
    return _c('div', {
      key: key,
      staticClass: "doc",
      on: {
        "click": function($event) {
          return _vm.select(key)
        }
      }
    }, [_c('div', {
      staticClass: "select",
      class: {
        active: _vm.isSelected(key)
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.good,
        "alt": ""
      }
    })]), _vm._v(" "), _c('tile-doc-selectable', {
      attrs: {
        "doc": doc
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "footer-certified row"
  }, [(_vm.docs.length === 0) ? _c('div', {
    staticClass: "side"
  }, [_vm._v("\n                      Aucun document justificatif enregistré\n                  ")]) : _c('router-link', {
    staticClass: "side link",
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_vm._v("\n                      Gérer les documents\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), (_vm.docs.length > 0) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Envoyer")]) : _vm._e(), _vm._v(" "), (_vm.docs.length === 0) ? _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_vm._v("Ajouter un document")]) : _vm._e()], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n                  Vérification d'identité\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n                  Sélectionnez le documents à vérifier\n              ")])])])
}]}

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuand vous pensez à votre paysage patrimonial, qu'est-ce qui vous tient le plus à coeur ?\n\t\t")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.motivation),
      expression: "motivation"
    }],
    class: {
      error: _vm.errors.has('motivation')
    },
    attrs: {
      "name": "motivation",
      "placeholder": "Ex : Protéger votre conjoint(e), accompagner un enfant handicapé, préparer un tour du monde"
    },
    domProps: {
      "value": (_vm.motivation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.errors.first('motivation')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tAuprès de qui prenez-vous conseil ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.conselors), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-box",
    class: {
      'disabled': _vm.disabled
    },
    on: {
      "click": _vm.change
    }
  }, [_c('div', {
    staticClass: "content",
    class: {
      active: _vm.val,
      'disabled': _vm.disabled
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('mot de passe actuel')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("mot de passe actuel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "mot de passe actuel"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('mot de passe actuel')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('mot de passe actuel')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('nouveau mot de passe')
    }
  }, [_c('label', {
    attrs: {
      "for": "newPassword1"
    }
  }, [_vm._v("nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    attrs: {
      "type": "password",
      "name": "nouveau mot de passe"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('nouveau mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nouveau mot de passe')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('confirmation du nouveau mot de passe')
    }
  }, [_c('label', {
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("confirmation du nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    attrs: {
      "type": "password",
      "name": "confirmation du nouveau mot de passe"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('confirmation du nouveau mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmation du nouveau mot de passe')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Sauvegarder")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\tEditer le mot de passe\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\tModifier votre mot de passe pour plus de sécurité\n\t\t")])])
}]}

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tutorial) ? _c('section', {
    staticClass: "ctn-tutorial row"
  }, [_c('div', {
    staticClass: "inner-tuto white-box column"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\tFenêtre d’accès à la signature bloquée\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVotre navigateur " + _vm._s(_vm.userAgentBrowser.name) + " a bloqué la fenêtre d’accès à la signature.\n\t\t\t\tVoici les instructions à suivre afin de débloquer la fenêtre d’accès.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "master-slider column"
  }, [_c('div', {
    staticClass: "inner-slider row"
  }, [_c('div', {
    staticClass: "control-arrow",
    on: {
      "click": _vm.previous
    }
  }, [_c('span', {
    staticClass: "left icon-left-open-mini"
  })]), _vm._v(" "), _c('div', {
    staticClass: "slides"
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentSlide.src,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-arrow",
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    staticClass: "right icon-right-open-mini"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "controls row"
  }, _vm._l((_vm.slides), function(slide, key) {
    return _c('div', {
      key: key,
      staticClass: "round-control",
      class: {
        active: key === _vm.current
      },
      on: {
        "click": function($event) {
          _vm.current = key
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.setTutorial
    }
  }, [(_vm.current === (_vm.slides.length - 1)) ? _c('span', [_vm._v("Finir le tutoriel")]) : _c('span', [_vm._v("Passer le tutoriel")])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-nav row"
  }, [_c('nav', _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.key,
      staticClass: "item",
      attrs: {
        "to": {
          name: item.uri
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "sub-page row"
  }, [_c('keep-alive', {
    attrs: {
      "include": "Board"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\tNouveau message\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tCommencez une discussion avec votre " + _vm._s((_vm.data.isAdvisor) ? 'client' : 'patrimofficer') + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui need-big"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('title')
    }
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Titre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('title')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container in-modal"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-textarea ctn-label",
    class: {
      error: _vm.errors.has('body')
    }
  }, [_c('label', {
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    attrs: {
      "type": "text",
      "name": "body"
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('body')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('body')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Envoyer")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column no-header",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-login"
  }), _vm._v(" "), (_vm.hardLogin) ? _c('div', {
    staticClass: "login login-form",
    class: {
      active: _vm.login
    }
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('logo')], 1), _vm._v(" "), _c('form', {
    staticClass: "form-ui column",
    attrs: {
      "novalidate": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.connect.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Votre e-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "data-vv-validate-on": "blur",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('password')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('password')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-password-reset link",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'ResetPasswordEmailAsk'
        })
      }
    }
  }, [_vm._v("\n\t\t\t\tMot de passe oublié ?\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.connect
    }
  }, [_vm._v("\n\t\t\t\t\tConnexion\n\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (!_vm.loginusMaximus) ? _c('div', {
    staticClass: "login forgot-password",
    class: {
      active: !_vm.hardLogin
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email oublié')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Votre e-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.emailReset),
      expression: "emailReset"
    }],
    attrs: {
      "data-vv-validate-on": "blur",
      "type": "email",
      "name": "email oublié"
    },
    domProps: {
      "value": (_vm.emailReset)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPassword.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailReset = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email oublié')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email oublié')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n\t\t\t\t\t\tEnvoyer\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-password-reset link",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Login'
        })
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tRetour à la connexion\n\t\t\t\t\t")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('h2', [_vm._v("Mot de passe oublié")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tVeuillez entrer votre adresse-email pour obtenir un nouveau mot de passe\n\t\t\t\t")])])
}]}

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card-prospect dashboard-card dashboard-card--bordered dashboard-card--hoverable"
  }, [_c('header', {
    staticClass: "dashboard-card__header"
  }, [_c('img', {
    staticClass: "dashboard-card__icon",
    attrs: {
      "src": _vm.imgUser,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dashboard-card__header-info"
  }, [_c('h4', {
    staticClass: "dashboard-card__name"
  }, [_vm._v(_vm._s(_vm.user.fullName))]), _vm._v(" "), _c('span', {
    staticClass: "dashboard-status dashboard-status--prospect"
  }, [_vm._v("Prospect")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.user.id
        }
      }
    }
  }, [_c('svg', {
    staticClass: "dashboard-card__arrow",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])], 1), _vm._v(" "), _c('section', {
    staticClass: "dashboard-card__contact"
  }, [_c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("mailto:" + (_vm.user.email))
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgMail,
      "alt": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.user.email) + "\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("tel:" + (_vm.user.phone))
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPhone,
      "alt": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.user.phone) + "\n                ")])]), _vm._v(" "), _c('footer', {
    staticClass: "dashboard-card__footer"
  }, [(_vm.user.colonne === 'col_pp') ? _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgTime,
      "alt": ""
    }
  }), _vm._v("\n                    Paysage : "), _c('span', {
    staticClass: "dashboard-badge",
    class: _vm.statusPaysageClass
  }, [_vm._v(_vm._s(_vm.statusPaysage))])]) : _vm._e(), _vm._v(" "), (_vm.user.colonne === 'col_conseil') ? _c('div', {
    staticClass: "card-prospect__mission"
  }, [_c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgDoc,
      "alt": ""
    }
  }), _vm._v("\n                        Lettre de mission : "), _c('span', {
    staticClass: "dashboard-badge",
    class: _vm.lettreMissionClass
  }, [_vm._v(_vm._s(_vm.lettreMissionStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgDoc,
      "alt": ""
    }
  }), _vm._v("\n                        Rapport de mission "), _c('span', {
    staticClass: "dashboard-badge",
    class: _vm.rapportMissionClass
  }, [_vm._v(_vm._s(_vm.rapportMissionStatus))])])]) : _vm._e(), _vm._v(" "), (_vm.user.colonne === 'col_inscription_partenaire') ? _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('label', {
    staticClass: "card-prospect__toggle"
  }, [_c('span', {
    staticClass: "card-prospect__toggle-track",
    class: {
      'card-prospect__toggle-track--active': _vm.user.partenaire_incription
    }
  }, [_c('span', {
    staticClass: "card-prospect__toggle-thumb"
  })]), _vm._v(" "), _c('input', {
    staticClass: "card-prospect__toggle-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.user.partenaire_incription
    },
    on: {
      "change": function($event) {
        return _vm.$emit('toggle-inscrit-partenaire', _vm.user.id, $event.target.checked)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-prospect__toggle-label"
  }, [_vm._v("Inscrit dans la base partenaire")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgCalendar,
      "alt": ""
    }
  }), _vm._v("\n                    Créé il y a environ " + _vm._s(_vm.daysSinceCreation)), (_vm.creationDate) ? [_vm._v(" (le " + _vm._s(_vm.creationDate) + ")")] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-main take-place column actualities"
  }, [_c('div', {
    staticClass: "ctn-layout column"
  }, [_c('div', {
    staticClass: "menu-actu row"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showModalShareNews = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-diffusion"
  }), _vm._v("\n\t\t\t\t\tDiffuser un article\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "actualities-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\tLes derniers articles de Patrimoffice\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-main-articles row"
  }, _vm._l((_vm.newNews), function(article, key) {
    return _c('router-link', {
      key: key,
      staticClass: "article-main",
      attrs: {
        "to": {
          name: 'Article',
          params: {
            id: article.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "ctn-cover"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-article"
    }, [_c('div', {
      staticClass: "head-article row"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "icon-clock"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(article.updated_at, 'DD/MM/YY')) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "icon-paysage-vous"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(article.author.name) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "title-article"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(article.title) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "ctn-tags row"
    }, _vm._l((article.tags), function(tag, keyt) {
      return _c('div', {
        key: keyt,
        staticClass: "tag"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t\t\t\t\t")])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "ctn-description",
      domProps: {
        "innerHTML": _vm._s(_vm.strip(article.body))
      }
    })])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles-container row"
  }, [_c('div', {
    staticClass: "ctn-small-articles-part"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tTous les articles de Patrimoffice\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles"
  }, _vm._l((_vm.restNews), function(article, key) {
    return _c('div', {
      key: key,
      staticClass: "small-article row"
    }, [_c('div', {
      staticClass: "ctn-cover"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ctn-title column"
    }, [_c('div', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "header-article row"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "icon-clock"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(article.updated_at, 'DD/MM/YY')) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "icon-paysage-vous"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(article.author.name) + "\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "ctn-cta"
    }, [_c('router-link', {
      staticClass: "btn btn-gold",
      attrs: {
        "to": {
          name: 'Article',
          params: {
            id: article.id
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tVoir l'article\n\t\t\t\t\t\t\t\t\t")])], 1)])
  }), 0), _vm._v(" "), (_vm.restNews.length === 0) ? _c('div', {
    staticClass: "no-article"
  }, [_vm._v("\n\t\t\t\t\t\t\tPas encore d'articles partagés\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles-part"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tLes derniers articles partagés\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-small-articles"
  }, [_vm._l((_vm.myNews), function(article, key) {
    return _c('div', {
      key: key,
      staticClass: "small-article row"
    }, [_c('div', {
      staticClass: "ctn-cover"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ctn-title column"
    }, [_c('div', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "header-article row"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "icon-clock"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(article.updated_at, 'DD/MM/YY H:m')) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "icon-paysage-vous"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(article.author.name) + "\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "ctn-cta"
    }, [_c('a', {
      staticClass: "btn btn-gold",
      attrs: {
        "href": article.link,
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tVoir l'article\n\t\t\t\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.myNews.length === 0) ? _c('div', {
    staticClass: "no-article"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPas encore d'articles partagés\n\t\t\t\t\t\t\t")]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showModalShareNews,
      "content": _vm.modalShareNews
    },
    on: {
      "close": function($event) {
        _vm.showModalShareNews = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AU.svg": 928,
	"./CH.svg": 929,
	"./DE.svg": 930,
	"./FI.svg": 931,
	"./FR.svg": 932,
	"./GB.svg": 933,
	"./IE.svg": 934,
	"./JP.svg": 935,
	"./LU.svg": 936,
	"./NL.svg": 937,
	"./NO.svg": 938,
	"./SE.svg": 939,
	"./US.svg": 940,
	"./ZA.svg": 941
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1191;

/***/ })
],[726]);


// WEBPACK FOOTER //
// static/js/app.2538c2ab3aaa368d7bec.js